//Do not remove this const descriptions = [
  const descriptions = [
  
  
    {
      product_name: "lucky_koi",
      product_id: "4399026733122",
      product_text: "Mesmerizing and mystical lucky koi fish practically dance off your canvas in this fluid and stirring piece. Splish, splosh, splash! Lily pads and flowers embrace, guiding these majestic fish through the sparkling water."
    },
    {
      product_name: "confetti_the_cat",
      product_id: "4399025291330",
      product_text: "Meow! This handsome kitty with white whiskers and a confetti of color bespeckling its face is a joy to recreate and bring to life. Although full of color, this cat is very realistic, appealing to most as a diamond painting."
    },
    {
      product_name: "dreams_of_elysium",
      product_id: "4399016804418",
      product_text: "Step into a fairytale setting bursting with the vibrant and youthful colors of spring. You can almost hear the chatter of wildlife that whips and weaves out of sight as you stroll across a majestic bridge and into Elysium."
    },
    {
      product_name: "fine_soft_day",
      product_id: "4399009988674",
      product_text: "How alive the gardens feel after a rain! You can practically see the flowers blooming before your eyes, and the gentle stream is bubbling in delight. From a fine soft day, evening now begins to set in at this country cottage, and the fires are lit."
    },
    {
      product_name: "reverie",
      product_id: "4399016083522",
      product_text: "Lose yourself in a magical reverie as evening sets in across the valley. Walk by the wildflowers and out onto a still, peaceful lake to feast your eyes upon the moonlit snowy peaks of the mountains ahead. Breathe in that clean air as the first stars break through the pink and purple sky."
    },
    {
      product_name: "tawny_owl",
      product_id: "4399029256258",
      product_text: "A bright, bold, and bejeweled tawny owl captures a look of realism with a cute and colorful cartoonish pop. The final effect melts your heart and makes you smile."
    },
    {
      product_name: "when_september_ends",
      product_id: "1597154426946",
      product_text: "A picturesque autumnal day. When September ends, the days are still bright and blue while the trees proudly pop pinks, reds, and deep oranges. Light and passing rains transform a regular sidewalk into an ocean of color to glide across."
    },
    {
      product_name: "lily_lagoon",
      product_id: "4399027126338",
      product_text: "Zoom in and get close up with nature, enjoying the fine detail created in smooth, artistic strokes. Lily Lagoon holds a brilliant purple lily in court, beautifully contrasted by vibrant greens and blues and complemented with the yellows of young buds."
    },
    {
      product_name: "vibrant_roses",
      product_id: "4399020638274",
      product_text: "A dreamy, soft depiction of three beautifully rendered roses, artfully detailed with white to accentuate their delicacy and splendor. Vibrant leaves in deep blues make the flowers pop even further, drawing you in and engulfing you in their rich splendor."
    },
    {
      product_name: "forgotten_memories",
      product_id: "4399018737730",
      product_text: "With sunlight streaming through the trees, an overgrown and forgotten yet majestic iron bench from memories long ago is placed in the spotlight. Enjoy the array of colors found in the spring flowers at your feet and the bright leaves from above."
    },
    {
      product_name: "flamingo_falls",
      product_id: "4399019720770",
      product_text: "When we think of flamingos, we think of cotton candy pink, and here, you aren’t disappointed. Offset by a deep, vibrant blue of a waterfall and pool and complemented by popping blossoms in the distance, the flamingo holds court in this dreamy scene."
    },
    {
      product_name: "contemplation",
      product_id: "4399013888066",
      product_text: "This cozy bench is waiting for you in solitude, inviting you to a moment of contemplation. Allow the calm, still waters of the pond to ease your mind as the sunlight warms your face through the glowing, orange leaves of a tree."
    },
    {
      product_name: "yoshi_the_shiba",
      product_id: "4399028863042",
      product_text: "This gorgeous depiction of Yoshi the Shiba Inu has been brightly recreated by Sandra Trubin and is just perfect for a diamond painting. The bright colors and clear features allow for a fun journey where you can watch this cute puppy come alive before your eyes!"
    },
    {
      product_name: "exuberance",
      product_id: "1597137813570",
      product_text: "The skeleton of a tree holds court as a party of color carries on all around. In the background, more trees, bare and broken, stand defiant against the bright exuberance, like soldiers bravely standing their ground as shrapnel falls around them."
    },
    {
      product_name: "the_winter_cabin",
      product_id: "4399019884610",
      product_text: "Smooth and dreamy purples and blues embrace a winter cabin that stands alone, save for a giant winter pine speckled with the remnants of a snowfall dance. From the mountains in the distance to the delicate flowers in the foreground, you are taken on a reflective, watery ride of wintery melt and icy dreams."
    },
    {
      product_name: "a_bridge_to_cross",
      product_id: "4399017951298",
      product_text: "In the distance, there is nothing but a bridge to cross, with the river stretching far and wide on either side. Colorful trees hug the sturdy path and line the way for you to follow."
    },
    {
      product_name: "dreamcatcher",
      product_id: "4399017427010",
      product_text: "Imagine stumbling across this extravagant dreamcatcher hung purposefully in the woods. Allow your thoughts and wishes to hang here also as you wander the colorful path toward the unknown."
    },
    {
      product_name: "first_winter",
      product_id: "4399021686850",
      product_text: "A baby deer stands ready and willing to take on its first winter, its soft, brown eyes brimming with determination. Long streaks in the background of the winter are skeletons of trees, and coupled with the soft fluffing of snow on the ground, show the contrasts and diversity that winter has to bring."
    },
    {
      product_name: "autumn_waters",
      product_id: "4399019294786",
      product_text: "The oak trees turn orange and pink as the autumn waters feed the calm yet swollen river. Warm hues take precedence here, although you can feel the temperatures beginning to drop as the seasons turn and nature concedes."
    },
    {
      product_name: "grumpy_cat_van_gogh_limited_edition",
      product_id: "1597161209922",
      product_text: "Thick brushstrokes inspired by Van Gogh recreate the internet sensation ‘Grumpy Cat’ like never before. Background swirls of blue complement this cat’s stunning eyes. Don’t let the cat fool you, this painting is a whole lot of fun!"
    },
    {
      product_name: "rainbow_falls",
      product_id: "1597311615042",
      product_text: "A waterfall cascades down exposed rock, where cave pools are hinted at in the depths of the water below. A forest of trees lets through a little light, but just wait for Rainbow Falls once the darkness breaks!"
    },
    {
      product_name: "peaceful_evening",
      product_id: "4399008579650",
      product_text: "There’s nothing quite like a peaceful evening where the lawns are mowed, the hedges are trimmed, and the cute cottage stands warm and welcoming against a setting sun. Come on in and enjoy a cup of tea with your feet against the blissful fire."
    },
    {
      product_name: "lion_kingdom",
      product_id: "4399027585090",
      product_text: "Warm, bright colors pop against this dominating face of the king of the jungle. This lion’s eyes draw you in and it’s difficult to pull away. Enjoy working through this diamond painting and bringing this lion to life!"
    },
    {
      product_name: "scarlet_macaw",
      product_id: "4399028731970",
      product_text: "Famous for their rainbow display, a scarlet macaw is your painting of choice if you’re looking for color and vibrancy. A fantastic dance for your eyes, bringing you from one space to another, the clean lines of this parrot will keep you captivated for hours."
    },
    {
      product_name: "bunny_friends_forever",
      product_id: "4399024504898",
      product_text: "A gorgeous baby bunny coupled with a whimsical hummingbird - can it get any cuter? Enjoy the artistic lines and swirls with your painting before catching the bunny’s eye and simply melting inside."
    },
    {
      product_name: "rainbow_stallion",
      product_id: "4399021326402",
      product_text: "A simply stunning portrayal of a stallion’s force silhouetted against a forest of rainbows, from both above and below. A multitude of different colors held in the leaves is reflected against a pond, doubling the effect of this eye-catching piece."
    },
    {
      product_name: "freddy_the_frog",
      product_id: "4399028535362",
      product_text: "Definite, clean lines paint a picture of Freddy the frog for you to enjoy. He sits on a dark green lily pad, and brightly contrasted with orange, this lime-green frog is both cute and captivating."
    },
    {
      product_name: "mischievous_wolf_grin",
      product_id: "4399030009922",
      product_text: "Lock eyes with this mischievous wolf and you’ll find it difficult to look away. The cute grin she wears makes it hard for you not to smile. Coupled with the spectacular colors on display in her thick coat and beyond, you will be enchanted for hours."
    },
    {
      product_name: "tiger_trance",
      product_id: "4399029649474",
      product_text: "If it isn’t the eyes and the intensity of that stare, it’s the swirls in their markings that hypnotize in this tiger trance. Coupled with the spectacular colors within the coat, you’ll find yourself enchanted for hours."
    },
    {
      product_name: "winston_the_frenchie",
      product_id: "4399026307138",
      product_text: "Sir Winston Charles, otherwise known as Winston the Frenchie, is an Instagram and YouTube sensation. His adorable smiling face has been captured in this colorful depiction, making for a fun-filled experience."
    },
    {
      product_name: "deer_in_the_moonlight",
      product_id: "4399025979458",
      product_text: "A white moon in the background surrounds the stately face of this majestic creature. A deer with enormous horns creates curves and balance in this bright, colorful piece."
    },
    {
      product_name: "eleanor_the_elephant",
      product_id: "4399026241602",
      product_text: "Realistic yet with splashes of every hue to spark the imagination and entertain, Eleanor the elephant holds your attention and invokes timeless elegance and power in her gaze."
    },
    {
      product_name: "sunset_sail",
      product_id: "4399022276674",
      product_text: "A beautiful artistic piece using an unusual method to create a crackled appearance of the final scene. As sunset deepens over the sea, darkness encroaches, where the silhouette of a sailboat stands boldly atop the vibrantly-lit sea."
    },
    {
      product_name: "breath_of_dawn",
      product_id: "4399002288194",
      product_text: "The pink stillness of dawn breathes life into this quietly breathtaking image, when the coldness of the night is only just starting to give way. You can almost see your breath fog before you, misting your view of this watery, moving piece."
    },
    {
      product_name: "winters_song",
      product_id: "4399021162562",
      product_text: "With winter comes harsh, savage songs sung by all who bear witness to the crisp stillness that descends. Moving purples and yellows dominate the sky and are reflected by the frozen pond, where skeletal soldiers of trees and tough, bristled bushes endure this frozen, icy landscape."
    },
    {
      product_name: "panda_snacks",
      product_id: "4399028076610",
      product_text: "Yum, yum! A fluffy panda, with deep fingerfuls of fur, is munching on their favorite snack: bamboo! Blues and yellows bring depth to this beautiful panda’s face, while the brighter background colors allow it to truly pop."
    },
    {
      product_name: "libertys_light_trial",
      product_id: "4606948999234",
      product_text: "A single star on a blue background and the unmistakable stripes of the majestic American flag adorn the roof and tower of this humble yet proud lighthouse. Set on a rocky outcrop, stairs lead from the shore to the door."
    },
    {
      product_name: "over_the_rainbow_trial",
      product_id: "4399033679938",
      product_text: "A breathtaking rainbow of colors adorns this realistically altered photo of a rose. From the fresh growth of petals just emerging from the depths of the flower to those now drying and curling at the edges, this picture of perfection is simply absorbing."
    },
    {
      product_name: "twisted_blossom_trial",
      product_id: "4399033516098",
      product_text: "A gnarled and twisted blossom adds a haunting element of depth to this otherwise cheerful and bright pink-hued sunset over a lake. Complete with a lone swan, carving a line atop the still waters, there is detail and beauty in every inch of this piece."
    },
    {
      product_name: "butterfly_orchid_fantasy_trial",
      product_id: "4399032139842",
      product_text: "Both butterfly and orchid appear as a single being, defined only by their distinct colors in this masterful piece. Allowing us to rediscover the unity in nature, as well as its detail and precision, is both enjoyable to recreate and comforting to the eye."
    },
    {
      product_name: "cottage_on_the_water",
      product_id: "4697568444482",
      product_text: "This cottage on the water is a delightful ensemble of paving stones, roses, and quaint cottage windows. The water can lap at your toes as you sit at the path’s edge to soak in the old English charm. "
    },
    {
      product_name: "english_garden_with_trellis",
      product_id: "4697568739394",
      product_text: "Light and airy, the cloudless blue sky allows you to see far and wide through the English garden and to the village and hills beyond. Take a walk through the rose-laden archway to sit in your own private courtyard, where you can enjoy the sights and smells of this glorious setting."
    },
    {
      product_name: "patio_for_two",
      product_id: "4697569755202",
      product_text: "Ding ding! Ring the bell for more tea! Out in the sun, chairs are waiting, but a path through the grass leads to a quaint gazebo, nestled in the garden blooms. Take your pick from where to enjoy the view across the water and hills beyond on this patio for two. "
    },
    {
      product_name: "patio_with_baskets",
      product_id: "4697569984578",
      product_text: "Old English charm that takes your breath away. A place of pure tranquility, this patio with enough cozy white wicker armchairs to spoil you for choice invites you to take in the scene beyond. Hanging and placed pot plants in bloom bring the beauty of the outdoors in with you, but feast your eyes upon the meadows, still ponds, and blooming bushes."
    },
    {
      product_name: "patio_with_flowers",
      product_id: "4697570181186",
      product_text: "Here on this patio with flowers, everything is at your fingertips. Chance upon a book that takes your fancy, pick at a selection of fine fruits, or curl up with a blanket and a tea and watch the bright and soft day pass before your eyes in this calm and peaceful setting. "
    },
    {
      product_name: "sunflowers",
      product_id: "4697570639938",
      product_text: "Nothing says summer like a vase full of sunflowers. This traditional painting is brought alive by the theme of summer, featuring ripe, fresh fruits, a sunhat, and blooming droplets of white and blue for an array of color that’s sure to brighten anyone’s day. "
    },
    {
      product_name: "the_good_life",
      product_id: "4697570934850",
      product_text: "This is the good life. After a pleasant afternoon of picking choice flowers from the vast selection on offer in this lakeside garden, you’re invited to take a load off and cool down with a long drink. The dove cove draws the eye as you peer through the archway of bright blue flowers."
    },
    {
      product_name: "wine_on_the_window",
      product_id: "4697571328066",
      product_text: "White or red? The choice is yours. You’re perched high here, looking out of the window and across fields and farms, from one village to the next. There’s a real feeling of serenity and solitude here, so sit back and take it all in, one sip at a time."
    },
    {
      product_name: "burano_e_i_colori",
      product_id: "4696690491458",
      product_text: "The vivid colors of house and home are reflected back at you from the rippling waters of the canal. With boats tied at each side and the bridge well worn, you know this small city is brimming with life, although at this moment, only peaceful solitude is to be found."
    },
    {
      product_name: "i_entrata_al_borgo",
      product_id: "4696689606722",
      product_text: "The aged and muted colors of yesteryear allow us to take a step back in time in this European historic village. With sparks of color drawing the eye thanks to the pots of flowers dotted across the path, up stairs, and on balconies, there’s a skip in your step as you walk the warm stones of the path through town."
    },
    {
      product_name: "i_vasi_dietro_la_grata",
      product_id: "4696689836098",
      product_text: "Imagine turning a corner and chancing upon this spectacular little front door grotto. Pots and vases line every inch of space, marking the home for a brilliant display of life in an otherwise whitewashed and sun-bleached landscape. The archway of leaves over the wooden door is an especially lovely touch."
    },
    {
      product_name: "laltra_porta_rossa_al_tramonto",
      product_id: "4696697962562",
      product_text: "Rich, ruby-red flowers adorn the building walls, threatening to come in through the green-cased windows several stories up. Take a walk up the gentle steps into town to discover more bursts of life that take over the European styled village with ease. "
    },
    {
      product_name: "la_porta_rossa_sulla_salita",
      product_id: "4696697110594",
      product_text: "It’s another warm and bright day in this traditional Italian town. Climbers hang from every window and creep around doors - the only life seen in the stillness of the day’s lazy heat."
    },
    {
      product_name: "le_scale_tra_le_case",
      product_id: "4696685477954",
      product_text: "Roughly translating to ‘the stairs between the houses’, you are taken on a journey here from house to house, level to level, and color to color, the light blue doors prominent against the terracotta orange and fading light in the sky."
    },
    {
      product_name: "santorini_a_colori",
      product_id: "4696690393154",
      product_text: "Santorini in color. A beautiful sight, this island is home to whitewashed, cubiform buildings that reflect the intensity of the sun. Splashes of color about the buildings are an opportunity for expression and joyousness, and this is exactly what you will find here."
    },
    {
      product_name: "un_soggiorno_a_venezia",
      product_id: "4696689770562",
      product_text: "Come and enjoy a stay in Venice; your room awaits! Peek out the balcony to see the canal right at your feet and the houses towering up on either side. A place like no other, enjoy this cultural depiction artfully recreated."
    },
    {
      product_name: "bohemian_peacock",
      product_id: "4697580077122",
      product_text: "Is there a better way to say ‘you’re amazing’? Bright, bold, and fun colors are always found in the beautiful peacock with cute heart and flower details, adding that finishing touch."
    },
    {
      product_name: "bunny_basket",
      product_id: "4697576669250",
      product_text: "A cute and colorful Easter surprise awaits here, as the sweetest cartoon baby bunny and their little chick friends bring a basket of colored eggs for all to enjoy. The bright tulips in the background add to the vibrant seasonal energy."
    },
    {
      product_name: "country_mailbox",
      product_id: "4697578078274",
      product_text: "Is it a postbox or a birdhouse? It’s difficult to tell with this country mailbox. Owned by typically proud and patriotic folk, the mailbox is painted as a flag, and colorful birds of all species will delight as you work through this painting."
    },
    {
      product_name: "dream_big",
      product_id: "4697581092930",
      product_text: "With an important message that we all need to heed, the whimsical and bohemian vibe complements this dreamcatcher. With butterflies and stars and mandalas creeping in from the sides, there’s nothing more to do but dream big. "
    },
    {
      product_name: "follow_your_heart",
      product_id: "4697580470338",
      product_text: "North, south, east, or west? When you’re told to follow your heart, love is in every direction! Bright and cute colors will keep you smiling as you work through this piece."
    },
    {
      product_name: "lighthouse_cottage",
      product_id: "4697578864706",
      product_text: "What a quaint lighthouse cottage sitting here by the sea. Complete with a white picket fence, cat on the doorstep, and colorful flowers creeping over the stone walls and across the path, if it wasn’t for the seagulls, you could be mistaken for being in the countryside!"
    },
    {
      product_name: "penguin_trio",
      product_id: "4697577652290",
      product_text: "Season’s Greetings. This penguin trio seems to be busy decorating their tree, hanging stars and decorations as the snowflakes fall around them. Being so up close and personal brings more warmth to the setting, making for a fun choice for artists of all ages."
    },
    {
      product_name: "pot_puppy",
      product_id: "4697577488450",
      product_text: "There won&#x27;t be much more work done in the garden now with a puppy on the loose! There’s certainly a lot of activity going on, with a bright display of flowers, butterflies, and even a sweet hummingbird!"
    },
    {
      product_name: "pumpkin_pals",
      product_id: "4697579257922",
      product_text: "Who said Halloween had to be scary? Cute black kittens play around a smiling pumpkin carving, surrounded by other seasonal fruits and flowers. The fall colors are always breathtaking, and during this season, we can begin enjoying these together."
    },
    {
      product_name: "rustic_fence",
      product_id: "4697578602562",
      product_text: "A rustic fence is almost swallowed by a vibrant and colorful cottage garden full of flowers, butterflies, and birds. The setting sun in the background complements the colors nicely and allows the bright shades of bird feathers to really pop."
    },
    {
      product_name: "spread_your_wings",
      product_id: "4697580896322",
      product_text: "Welcome, come on over and spread your wings. A dark and night-like background allows the beautiful wreath of pink flowers to stand out, encasing two beautiful hummingbirds that inspire you to soar."
    },
    {
      product_name: "starshine_snowman",
      product_id: "4697575915586",
      product_text: "Such a cherry face on this rotund and jolly snowman brings goodwill and happiness to all during the holidays. A falling star for luck, mistletoe for love, and is it snowing? Nothing could be more perfect."
    },
    {
      product_name: "distant_dreams",
      product_id: "4696742854722",
      product_text: "A lighthouse is featured in the distance as waves crash out onto the rocks. But these are all distant dreams here at a beachside villa, grand and whitewashed against the salt air. If you wish to dip your toes into the sea, cross the grassy, flower-bespeckled dunes and soft sand when the tide comes in again."
    },
    {
      product_name: "lighting_the_way",
      product_id: "4696749441090",
      product_text: "A turbulent sky casts a final splash of light over waves as they slip up to shore. The lighthouse and cottage are already aglow, lighting the way for any wayward sailors."
    },
    {
      product_name: "poetic_light",
      product_id: "4696763400258",
      product_text: "This lighthouse, built in stone, shines out through the dimming light of day, casting an eerie glow on the sands and salt below. The lighthouse keeper enjoys the best of both worlds, with fresh green grass and the gentle sound of the wind in the trees to enjoy alongside the lapping of the sea at his doorstep."
    },
    {
      product_name: "rhapsody_in_blue",
      product_id: "4696757567554",
      product_text: "A unique take on the traditional still life, this table and shelf are full of humble trinkets and necessities for the avid gardener. Pots, birdhouses, trowels, and the unmistakable influence of a patriotic American, this is a rhapsody in red, white, and blue."
    },
    {
      product_name: "seasons_greetings",
      product_id: "4696760778818",
      product_text: "The claws of winter can have a deathly grasp, stripping trees of life and throwing the landscape into a cold, icy embrace. But nothing can dampen the Christmas spirit, so season’s greetings from a father and son snowman, smiling brightly through this cold, frozen night!"
    },
    {
      product_name: "smooth_sailing",
      product_id: "4696746426434",
      product_text: "It’s smooth sailing here where waves glide gently up onto shore. Still, the lighthouse is vast and bright in the setting sun, and there’s even a low slung chair waiting for you to sit and watch the boats sail by."
    },
    {
      product_name: "sweet_surrender",
      product_id: "4696751636546",
      product_text: "A well-kept and stately lighthouse sits proudly high up on a cliff, overlooking building clouds out to sea. What is to come one can only surrender to, but at least you can find safety here."
    },
    {
      product_name: "the_boat_house",
      product_id: "4696764874818",
      product_text: "Moody colors dominate this scene as the boat house sits, weathered and well-used, back off the encroaching waves of the tide. Plentiful herbs and flowers hug the fences and paths, softening the otherwise wood-littered space."
    },
    {
      product_name: "ancient_heart",
      product_id: "4696705105986",
      product_text: "A Mayan-style headdress adorns a fierce, dark-eyed beauty as she sits in front of a temple. The bright color of the setting sun adds contrast to the natural hues of greens. Strong and powerful, this painting is both absorbing and mystifying."
    },
    {
      product_name: "angel_wings",
      product_id: "4696707563586",
      product_text: "A golden-haired cherub of a princess, with soft cheeks blushed the shade of her gown and a heart at her throat, sits atop the clouds, as pure as they come."
    },
    {
      product_name: "angel_cake",
      product_id: "4696709529666",
      product_text: "With a stunning color choice of lilac and tangerine, a heart-lipped beauty stands with her furry friend and a cake for all. Her doe eyes seem to be able to look straight through you while simultaneously drawing you in."
    },
    {
      product_name: "jasmine",
      product_id: "4696713494594",
      product_text: "Jasmine is soft-eyed and stunning, but with a hint of sadness - an angel who has seen more than you know. Her thick, blue fishtail braid hangs down to her waist, matching her star-spangled dress, with more stars as her crown."
    },
    {
      product_name: "kindred_spirit",
      product_id: "4696720408642",
      product_text: "Spend a dreamy day on the farm with this freckled and red-haired farm girl - a kindred spirit to many. When not picking bunches of wildflowers or working the fields, you’ll find her with a nose in her book or watching the clouds roll by."
    }, 
    {
      product_name: "mary_poppins_jolly_holiday",
      product_id: "4696722243650",
      product_text: "Here sits Mary Poppins atop what else but a merry-go-round horse, proudly free of its circular prison. Swirls and whorls of flowers at their feet bring your eye up and out toward the mystical night and the comforting sway of trees."
    },  
    {
      product_name: "miss_turf_ace",
      product_id: "4696716476482",
      product_text: "Cute and sassy, Miss Turf Ace knows how to look after herself and her land. With her trusty pooch aboard, she cruises around, tending to all she comes across."
    }, 
    {
      product_name: "patience",
      product_id: "4696718377026",
      product_text: "This feather-lashed mermaid exudes calm and patience as she poses aloft out of the water with a sleeping dove in hand. Curling limbs of trees against a dark blue sky bring a magical tone to this soft and sweet scene."
    },
    {
      product_name: "seraphina",
      product_id: "4696715591746",
      product_text: "This mystical witch and her white-whiskered black cat have been enjoying some seasonal merriment, carving Halloween snowmen out of pumpkins of all shapes and sizes. A wicked princess, Seraphina is both sweet and scary."
    },  
    {
      product_name: "spring_beauty",
      product_id: "4696729059394",
      product_text: "Kissed by blooming flowers and lovingly caressed by butterflies, this spring beauty shines brightly, with turquoise wings that complement her gown of roses as she sits among the vibrant blossoms of springtime."
    },  
    {
      product_name: "twisted_blossom_large",
      product_id: "1597150167106",
      product_text: "A gnarled and twisted blossom adds a haunting element of depth to this otherwise cheerful and bright pink-hued sunset over a lake. Complete with a lone swan, carving a line atop the still waters, there is detail and beauty in every inch of this piece."
    },  
    {
      product_name: "over_the_rainbow_large",
      product_id: "4697583026242",
      product_text: "A breathtaking rainbow of colors adorns this realistically altered photo of a rose. From the fresh growth of petals just emerging from the depths of the flower to those now drying and curling at the edges, this picture of perfection is simply absorbing."
    },   
    {
      product_name: "twisted_blossom",
      product_id: "4707306733634",
      product_text: "A gnarled and twisted blossom adds a haunting element of depth to this otherwise cheerful and bright pink-hued sunset over a lake. Complete with a lone swan, carving a line atop the still waters, there is detail and beauty in every inch of this piece."
    },   
    {
      product_name: "over_the_rainbow",
      product_id: "4707303948354",
      product_text: "A breathtaking rainbow of colors adorns this realistically altered photo of a rose. From the fresh growth of petals just emerging from the depths of the flower to those now drying and curling at the edges, this picture of perfection is simply absorbing."
    },  
    {
      product_name: "libertys_light",
      product_id: "4707304538178",
      product_text: "A single star on a blue background and the unmistakable stripes of the majestic American flag adorn the roof and tower of this humble yet proud lighthouse. Set on a rocky outcrop, stairs lead from the shore to the door."
    },      
    {
      product_name: "butterfly_orchid_fantasy",
      product_id: "4707306176578",
      product_text: "Both butterfly and orchid appear as a single being, defined only by their distinct colors in this masterful piece. Allowing us to rediscover the unity in nature, as well as its detail and precision, is both enjoyable to recreate and comforting to the eye."
    },  
    {
      product_name: "sumatran_tiger",
      product_id: "4398999830594",
      product_text: "Realistic, powerful, and engaging, this Sumatran tiger is sure to turn heads as it lounges across your canvas. The slightly muted colors create a mystical look that complements the impressive energy this beast possesses."
    },
    {
      product_name: "portals_of_the_past",
      product_id: "4399005171778",
      product_text: "Set back among shadowed and misty trees, Roman columns frame unknown portals of the past. You are drawn into the bright and barely perceivable entranceway and beyond, past the gently rippling pond of lily pads bathed in late evening light."
    },
    {
      product_name: "perseverance",
      product_id: "6539078041666",
      product_text: "Slightly whitewashed edges focus your gaze at the center of this masterpiece. Here sits a young yet fully opened lilac-colored rose that holds your attention as the flower stares straight at you. Other blooms facing gently away allow your eyes to take in the whole magnificent bouquet."
    },  
    {
      product_name: "under_the_rainbow",
      product_id: "6539079188546",
      product_text: "This painting has it all, from mountains to beaches, birds flying in the sky to schools of fish in the water. Intricate detail is found where scores of life flourish in the vibrant coral. And all this is happening under a rainbow!"
    },   
    {
      product_name: "the_old_waterway_cottage",
      product_id: "6539084955714",
      product_text: "An angled bridge over a gentle stream is slowly engulfed by creeping waterside flowers of all colors. Join the resident cat and take a walk up the paved path toward the stately old waterway cottage, well maintained and well-loved in a setting deserving of its beauty."
    }, 
    {
      product_name: "hazel",
      product_id: "6539082498114",
      product_text: "Hazel is a witch who simply radiates an electrifying energy. Her lime-green and red hair flies out behind her as she walks forward with all the confidence a young woman of her power would possess. She isn’t complete without her black cat and pentagram, a Halloween pumpkin bag finishing the look."
    },  
    {
      product_name: "owls",
      product_id: "6539087020098",
      product_text: "These owls exude a bohemian benevolence, patterns and swirls adorning their bodies as they peek inquisitively out of the painting and straight into your heart. The muted, natural watercolors suit the softer atmosphere, where the gentle hint of a landscape can be seen in the background."
    },
    {
      product_name: "pirate_princess",
      product_id: "6539077058626",
      product_text: "Set against a background of baby blue and rose petals, this pirate princess has a delicate charm to her face. Holding a space-age laser gun and sporting black wings, this beauty shows that there are always two sides to a person."
    },
    {
      product_name: "elation",
      product_id: "6539087544386",
      product_text: "Rays of light burst through a canopy of trees, shining a spotlight on the life below. The color choice here itself creates a burst of elation to all who view it; pinks, purples, reds, and yellows are further brightened by the magical white rays beaming down."
    },
    {
      product_name: "monarch_madness",
      product_id: "6539086364738",
      product_text: "Just as monarchs are in real life, these radiant and brightly-colored butterflies are of an eye-popping beauty. Behold this monarch madness, where colorful patterns and flowers swamp these orange beauties."
    },
    {
      product_name: "small_town_usa",
      product_id: "6539085316162",
      product_text: "Dusk has been brought on early by a receding shower of rain, not seen in the sky but given away by the mirrored lights of lamps and home. This small town USA sets a slower pace, but is still bustling with activity with cars aplenty and occupied homes lining the street."
    },
    {
      product_name: "realm_of_the_queen",
      product_id: "6539080499266",
      product_text: "This unbalanced scene showcases both the vastness of the sea and the intense diversity that can be found within it. One side is busy with colorful coral, the other is a deep and cavernous blue. Tying the entire piece together is a glorious tropical fish heading straight for us!"
    },
    {
      product_name: "purple_tulips",
      product_id: "6539078402114",
      product_text: "This close_up depiction of a garden thick with purple tulips really allows you to marvel at the detail found in nature, from the deep and dynamic color of each petal to the delicate fragility of the whole flower, artistically shown through confident strokes by this talented artist."
    },
    {
      product_name: "luna_lovegood",
      product_id: "6539081482306",
      product_text: "Loony Lovegood has never looked more beautiful. As she stares deeply back at you, one can only wonder what she can see. There is certainly no underestimating this witch, whatever one might think of her radish earrings and unusual glasses."
    },
    {
      product_name: "end_of_the_rainbow",
      product_id: "6539087708226",
      product_text: "Have you ever wondered what lies at the end of the rainbow? We love how a smattering of flowers absorbs the colors of this rainbow in this rich and regal painting. A sparkling river provides a safe haven for a doe and her fawn as sun-dappled leaves offer depth."
    },
    {
      product_name: "pine_forest_cabin",
      product_id: "6539084202050",
      product_text: "This pine cabin home is rich in fine detail, which makes ordinary objects seem lustrous and lifelike. The color detail in the grass allows you to feel the intensity of the shadows brought forth by the towering and lavishly_barked trees. Bursts of meadow flowers bring you over the quaint bridge and toward the grand villa itself."
    },
    {
      product_name: "the_mixed_bouquet",
      product_id: "6539087085634",
      product_text: "This mixed bouquet is a quirky arrangement of realistic followers and abstract patterns all set in warm oranges, greens, and blues. A few butterflies and dragonflies add movement to an otherwise still image that is nevertheless full of life."
    },
    {
      product_name: "victorian_mansion_grounds",
      product_id: "6539084693570",
      product_text: "Towering brilliance simply takes one’s breath away as you marvel at the Victorian mansion grounds. Crisp hedges and pots of color frame a gushing fountain - one which a black cat walks past with apparent disdain. A lady sits and admires the view, her back to the grandeur that is the mansion itself."
    },
    {
      product_name: "harley",
      product_id: "6539081285698",
      product_text: "Harley Quinn, with the Joker perched on her arm, gazes off into the distance with her brilliant and deep blue eyes. Her long blonde hair is tipped with red and black and pulled up into pigtails, a signature heart adorning her left cheek."
    }, 
    {
      product_name: "sunflower_dreaming",
      product_id: "6539077812290",
      product_text: "The magnificence of a sunflower never fails to impress, and this bouquet of timeless favourites is no exception. Placed in an outdoor setting for a more natural feel, roses and calla lilies also feature in this dreamy sunflower piece."
    },  
    {
      product_name: "tropical_dream",
      product_id: "6539084136514",
      product_text: "As a golden sun sets in the center of this engrossing painting, your eye wanders, constantly finding new beauty to behold. Whether in the detail of the chairs and material, the copious potted flowers adding sparks of color, or the cat lounging at your feet, there is always more to see here."
    }, 
    {
      product_name: "garden_bird_trio",
      product_id: "6539086659650",
      product_text: "A comforting blend of both abstract design and realism, flowers morph into pleasing shapes and patterns in this unique garden bird trio. Everyone will find something different from this piece, but all can agree on the stunning appearance of the three little birds that are perched about."
    }, 
    {
      product_name: "alpine_spring",
      product_id: "6539088134210",
      product_text: "A meadow in the mountain is flush with the brief yet brilliant life that is present only in the Alpine spring. Color is aplenty with an array of hardy varieties out among the green grass, which sits high up amid the cold and desolate mountains."
    }, 
    {
      product_name: "creating_yourself",
      product_id: "6539076599874",
      product_text: "This piece is a whimsical blend of dainty beauty and steampunk quirk. Creating yourself is about the perfection of self-identity, and this blonde beauty is adorning her leg with a floral tattoo. Bounding around her are masked bunnies, further adding to the atmosphere."
    },  
    {
      product_name: "fandango",
      product_id: "6539079680066",
      product_text: "Dive deep below the sea and discover what plays in its depths. Colorful coral provides a sanctuary for schools of fanciful fish - can you spot them all? There’s no missing the curious gaze of that sea turtle!"
    },  
    {
      product_name: "red_riding",
      product_id: "6539082924098",
      product_text: "Here is Little Red Riding, without her hood and the not-so-big bad wolf curled upon her shoulder. Between her shining luscious lips and the unicorn horn from the docile wolf pup’s head, the theme of red is everywhere."
    },
    {
      product_name: "autumn_sun",
      product_id: "6539085938754",
      product_text: "Everything here speaks of autumn to the viewer, from the golden-orange hues of the warm autumn sun to the falling leaves, incessant breeze, and curling and fading petals of the sunflowers. Yes, please!"
    },
    {
      product_name: "gerbera_bouquet",
      product_id: "6539078795330",
      product_text: "Framed by gently opening roses and lilies that are delicately holding their own sits a vibrant and bold Gerbera, face wide open to the world. The brighter pink of the Gerbera is complemented nicely by the deeper reds, soft purples, and natural whites of the entire bouquet, sending your eyes around the canvas before you again marvel at the impressive Gerbera on display."
    },
    {
      product_name: "blonde_cleopatra",
      product_id: "6539086233666",
      product_text: "Her eyeliner-defined eyes bore straight into yours. Adorned with jewels and complete with an owl perched upon one stately finger, this blonde Cleopatra is sure to leave a lasting impression."
    },
    {
      product_name: "symphony",
      product_id: "6539083251778",
      product_text: "These two unicorn babes are a harmonious symphony of bubblegum colors and feathery fragility. Both girl and pony have vibrant eyes that pop out at the viewer, and the choice of jewelry is a well-thought match to the severity of their horns."
    },
    {
      product_name: "the_autumn_farm",
      product_id: "6539084595266",
      product_text: "Welcome to the autumn farm, where pumpkins for sale sit at the gate and muddy tracks lead you toward the traditional barn and farmhouse beyond. Standing in your way is a shining Massey Harris, and as the sky purples into dusk, the final show of floral colors and fading leaves before winter takes grip can be seen."
    },
    {
      product_name: "wrasse_appeal",
      product_id: "6539080597570",
      product_text: "Nearly neon in color, these vibrant varieties of fish pop out of the picture and into your heart. With several species angled toward the viewer, there is a depth in this picture that really emphasizes the vastness of the ocean."
    },
    {
      product_name: "radiant_rainbow",
      product_id: "6539081842754",
      product_text: "Enjoy the eye-popping splendor that is this Radiant Rainbow. This doll of all colors cradles one of her own, her bright yellow hair barely contained behind a bow and a band of rainbow skulls. Even her eyes are an assortment of colors, sharply contrasting against the dark background."
    },
    {
      product_name: "victorian_evening",
      product_id: "6620550037570",
      product_text: "This painting depicts a cool and crisp Victorian evening with a pale blue Victorian villa and sharp pinks of a blossoming tree contrasting with the glowing lights in the windows. A meandering path leads you past a white picket fence overgrown with flowers and saddled horses awaiting passengers to their carriage."
    },
    {
      product_name: "double_trouble",
      product_id: "6620557246530",
      product_text: "Uh-oh! Double trouble! These two cute pups undoubtedly spell mischief among the flower pots. An innocent enough game of ball has spelled disaster as a potted plant has fallen victim to their boisterous game."
    },
    {
      product_name: "lakeside_cottage",
      product_id: "6620560195650",
      product_text: "The cool, crisp colors of this scene contrast with the warmth exuding from the lakeside house through the traditional windows. A table and chairs sit outside on the flower ringed lawn, overlooking a calm and still lake."
    },
    {
      product_name: "waterlilies_of_summer",
      product_id: "6620563144770",
      product_text: "Little specks of white create the illusion of sparkles on a deep, blue expanse of water graced by waterlilies of summer. The strong colors here provide energy and make for an uplifting and enjoyable scene."
    },
    {
      product_name: "spring_stream",
      product_id: "6620552462402",
      product_text: "This spring stream setting simply shouts joy with every fiber as color bursts from everywhere you look. Ducks, deer, swans, and even a squirrel adorn a scene that’s dominated by a variety of springtime flowers and blossoms. A log cabin is warm and inviting against the fresher colors found outside."
    },
    {
      product_name: "joyful_chapel",
      product_id: "6620551479362",
      product_text: "A joyful chapel is composed of crisp, clean white lines, standing proudly in front of a lake teeming with life. A spirited river feeds this lake from a distance, with a farming village seen in the background."
    },
    {
      product_name: "new_generation",
      product_id: "6620554559554",
      product_text: "It’s springtime and the new generation is out in the warm sun, basking on rocks among blossoming mountain flowers. Five wolf pups keep close to the safety of their mother as she surveys the land, perhaps searching for her next hunt target."
    },
    {
      product_name: "serenity_cottage",
      product_id: "6620558655554",
      product_text: "A sturdy brick bridge leads you over a rumbling stream and toward this serene cottage. Bright lights stream out from the large bay windows, inviting you out of the cool springtime dusk and into warmth and comfort."
    },
    {
      product_name: "the_jaguar",
      product_id: "6620555935810",
      product_text: "This mighty and mysterious cat sits comfortably atop a branch, hidden in the darker depths of the jungle. A cascading waterfall is in the background, and splashes of green within the scene reflect the same color in the eyes of the jaguar."
    },
    {
      product_name: "hibiscus_and_hummingbird",
      product_id: "6620562358338",
      product_text: "Splashes of color in the background complement the lines of detail found in both the bold orange hibiscus and the brilliant blues and greens of the sweet and delicate hummingbirds."
    },
    {
      product_name: "the_guiding_light",
      product_id: "6620544991298",
      product_text: "Powerful messages are brought to the fore, with the main focal point of this scene being an eagle illuminated by the setting sun behind it. The guiding glow of a lighthouse can also be seen, with an undoubtedly grateful ship in the distance navigating through rough seas as an imminent storm brews on the horizon."
    },
    {
      product_name: "country_cottage",
      product_id: "6620560490562",
      product_text: "This country cottage is in an idyllic setting, with snowy mountains in the background and horses roaming the lush green pastures that reach a traditional rocky fence. A thatched roof and the blue detailing of the house match the blooming lupins, adding a charming touch."
    },
    {
      product_name: "fairytale_cottage",
      product_id: "6620551053378",
      product_text: "A misty scene allows you to take in much more detail, as this fairytale cottage is certainly a magical place to be. A gentle path from distant hills leads over a bridge, where a horse and carriage awaits on a cobblestone path."
    },
    {
      product_name: "star_birth",
      product_id: "6620553740354",
      product_text: "This whimsical scene of a star birth is set in a pine forest with a floor of field flowers. It also hosts a magnificent white lion with an extravagant mane, along with a somewhat aloof fairy perched on the lion’s back, her hair sporting the same fiery color of the field."
    },
    {
      product_name: "fish_and_jellies",
      product_id: "6620561866818",
      product_text: "The bright orange hues of these fish and jellies are perfectly contrasted by the stunning and abstract background of the deep blue ocean. Cartoon-like elements make this scene fun and bubbly."
    },
    {
      product_name: "english_tudor",
      product_id: "6620561211458",
      product_text: "This stately old manor holds precedence, capturing the last of the evening sun as the cool shadows hit the spring flowers on the grounds. An archway adorned with white flowers brings you up to the door of this elegant English Tudor."
    },
    {
      product_name: "early_snowfall",
      product_id: "6620555313218",
      product_text: "It is an early snowfall, and autumn leaves still cling to the trees while soft snow cascades down to settle on the ground. Two magnificent wolves stand side by side, eyes locked onto something in the distance."
    },
    {
      product_name: "victorian_days",
      product_id: "6620559802434",
      product_text: "This bed and breakfast, built like a castle of the Victorian days, has been kept immaculate. A tree looms up from behind the building with vast grounds opening up into the misty distance. A path, brightly decorated with an assortment of flowers, leads you up the steps to the front door."
    },
    {
      product_name: "sea_turtle_mosaic",
      product_id: "6620562587714",
      product_text: "The interesting abstract design of this sea turtle mosaic graces this underwater spectacle. The multitude of colors found on this magnificent being is broken up by thick lines of white, creating texture and depth."
    },
    {
      product_name: "summertime_mill",
      product_id: "6620551905346",
      product_text: "Cascading water is surrounded by large boulders at this summertime mill. With few open spaces, the close trees, colorful flowers, and blooming bushes all vie for available space, giving the distinct feeling that you’re well away from civilization, where the water flows fresh and clean."
    },
    {
      product_name: "woodland_church",
      product_id: "6620543483970",
      product_text: "A vibrant and elaborate scene bursts with color, a woodland church nestled in a rich autumn landscape. The stained glass window detail of the cottage-esque church is almost seen to reflect the surrounding beauty. There sure is plenty to be thankful for."
    },
    {
      product_name: "noel",
      product_id: "6620555051074",
      product_text: "It’s Christmas time, and the ribbons and tinsel are just too much to bear in this Noel tale. The stunning green eyes of this playful gray cat rolling around underneath the Christmas tree simply captivate us all."
    },
    {
      product_name: "perfect_spring_day",
      product_id: "6620556656706",
      product_text: "This perfect spring day is bursting with the pinks and yellows of blossoming trees and wild field flowers. Galloping through this brilliant landscape are a mare and her foal, heralded by three beautiful doves that complete the softness and innocence of this piece."
    },
    {
      product_name: "autumn_village",
      product_id: "6620549185602",
      product_text: "A roaring campfire, cozy seats and blankets, deep purple sunset skies, a plentiful pumpkin harvest…this autumn village scene exudes warmth and comfort, the houses in the distance all glowing as smoke rises merrily from their chimneys."
    },
    {
      product_name: "boo",
      product_id: "6646700179522",
      product_text: "Standing out from a background of spiderwebs, bordered by candy, is our skeletal main character, coupled with some of his adorable friends. Driving the point home, the word ‘BOO’ is held up on a plaque – because really, these charming characters are anything but scary."
    },
    {
      product_name: "my_secret_brew",
      product_id: "6646702702658",
      product_text: "The love potion you’ve all been waiting for! Here it is, my secret brew. There is an element of magic in the night air as this doe-eyed witch stirs a bubbling concoction and abstract flames lick the cauldron’s side. Don’t forget her trusty companion hanging from the tip of her hat!"
    },
    {
      product_name: "salem",
      product_id: "6646704635970",
      product_text: "As innocent as her heart-shaped face may appear, there’s more than meets the eye with this raven-haired beauty. Her bright golden eyes, popping out of the gloom, are mirrored by her cat’s, as well as by the few objects she possesses that set her apart from the rest."
    },
    {
      product_name: "guiding_lights",
      product_id: "6646706143298",
      product_text: "As warm light spills out from the windows of a church, you wouldn’t be wrong in thinking that many are inside, celebrating a very special moment in the Christian calendar. Snow on the ground glitters in the bright moonlight as unwavering guiding lights, whether it be for sailors or wise men, can be seen from afar."
    },
    {
      product_name: "the_christmas_house",
      product_id: "6646707912770",
      product_text: "Welcome to the Christmas house. The gate is ajar and lights are on inside. Can you glimpse moments of seasonal gathering and joy through the windows? This majestic stone building is a composed sight against a background of snow-touched trees."
    },
    {
      product_name: "tweet_dreams",
      product_id: "6646709747778",
      product_text: "Illuminated by the glow of the candle, this snowman conveys such warmth in its posture and expression that it’s difficult not to melt at the sight of it. Perched upon its outstretched hand sits a bird, another having made a nest right upon this snowman’s merry head."
    },
    {
      product_name: "gingerbread_lighthouse",
      product_id: "6646710730818",
      product_text: "A gingerbread lighthouse is what childhood dreams are made of. A candy-strewn path through the snow toward the delicious-looking dwelling bypasses a towering Christmas tree, adorned with lights that could very well shine brighter than even the lighthouse’s lamp."
    },
    {
      product_name: "sweet_snowman",
      product_id: "6646712369218",
      product_text: "This sweet snowman looks overjoyed at this moment with his busy and curious companions. Several small songbirds flit around his face and body, with one even singing a merry melody perched on the tip of his carrot nose!"
    },
    {
      product_name: "new_friends",
      product_id: "6646713253954",
      product_text: "It’s Christmas at this log house as two brightly lit Christmas trees flank the stairs up to the front door. In the snow out front, there seems to be a gathering of new friends. Sweet young deer and several species of bird are enjoying the overcast day."
    },
    {
      product_name: "cosy_christmas",
      product_id: "6646718529602",
      product_text: "This cosy Christmas room conveys comfort and warmth, from the purple drapes just exposing the snowy blue hues outside to the roaring open fire. Picturesque Christmas decorations are seen everywhere – that is, everywhere that hasn’t been taken up by the adorable litter of puppies."
    },
    {
      product_name: "snowman",
      product_id: "6646720069698",
      product_text: "This snowman certainly looks pleased with his mad juggling skills, a smug grin plastered underneath his carrot nose. His delightful attire matches the mistletoe border encompassing this delightful scene. "
    },
    {
      product_name: "upon_the_night",
      product_id: "6646722297922",
      product_text: "Bows adorn the wooden fence and an elaborately lit Christmas tree to add color to this otherwise white Christmas. A brilliant full moon is suspended in the night, rising above the waters of the open ocean where a lone sailboat floats by."
    },
    {
      product_name: "winter_fence",
      product_id: "6646723412034",
      product_text: "Oh, how this winter fence honors the sweet sights and sounds of Christmas! Perched upon each post and nestled in the foliage of the partially visible wreath hanging in the wintery scene are many different species of songbird."
    },
    {
      product_name: "diamond_greeting_cards_12_pack",
      product_id: "6646724526146",
      product_text: ""
    },
    {
      product_name: "lighthouse_overlook",
      product_id: "6620559147074",
      product_text: "A pale pink sky in the horizon is an eloquent backdrop to this lighthouse overlook. Storm clouds are brewing through and the gulls are flying low around the crashing waves seen in the distance. The keeper’s cottage is swamped in an array of colour; the flowers are out and the fire seems to be gently ticking over inside."
    },
    {
      product_name: "peaceful_jaguar",
      product_id: "6620557148226",
      product_text: "A close_up portrait of this peaceful jaguar really allows us to see the fine details that make this large cat so spectacular. The depth of the jaguar’s green eyes as it rests its chin on those massive paws leaves the viewer awestruck."
    },
    {
      product_name: "spring_bunny",
      product_id: "6620534472770",
      product_text: "This spring bunny sits gently among the calming colors of the long and wandering meadow flowers. The misty setting adds an element of charm, softening the scene and bringing the small rabbit into sharper focus."
    },
    {
      product_name: "waterside_tea",
      product_id: "6620552822850",
      product_text: "A stately villa looks down over this waterside tea party that awaits on a bright and warm spring day. The fresh and clear pool of water is fed by a distant stream that bubbles over rocks as it approaches and wanders away again under a bridge and out of sight. Choice flowers from the many that have bloomed sit on a small table alongside a teapot and cups."
    },
    {
      product_name: "balcony_overlooking_vineyards",
      product_id: "6654041260098",
      product_text: "Foregoing the shade of the umbrella, a table for two has been set, ready and waiting with two glasses of wine freshly poured. Sit at this balcony overlooking the vineyards and enjoy the peaceful scene on this warm, clear day."
    },
    {
      product_name: "moon_lily",
      product_id: "6654044274754",
      product_text: "Wearing a wide-brimmed hat of moon and stars, the somewhat surprised, multicolored stare of this moon lily bores into you as you take in this curious portrait. A cat’s eyes mirror her own as it perches atop her shock of pink and blue hair."
    },
    {
      product_name: "rhapsody_in_rose",
      product_id: "6654034739266",
      product_text: "This quaint garden shed shelving is packed full of pots, watering cans, buckets, and birdhouses. It is a rhapsody in rose, with soft pinkish hues accentuating the simple innocence of this collection of objects."
    },
    {
      product_name: "il_lungolago",
      product_id: "6654022058050",
      product_text: "Here at il lungolago, the lakefront, you can walk along the flower and tree_dotted white concrete path and into the shelter of a large structure created in times past. The lake and distant hills beyond can be seen on this bright and blue sunny day."
    },
    {
      product_name: "fun_day_ahead",
      product_id: "6654009540674",
      product_text: "It certainly looks to be a fun day ahead in this design! You can see the white caps in the ocean between the two beach houses and wind-blown palm trees all around. It’s a perfect day for a spot of surfing, so it’s no surprise to see a person running toward the sea with a surfboard in hand."
    },
    {
      product_name: "mixed_bouquet",
      product_id: "6653999611970",
      product_text: "This mixed bouquet is set in a small glass vase with an assortment of summer blooms bursting out like a display of fireworks. Gently embraced by purple and red gladioli among other glorious flower heads is a striking sunflower, its black seeded face pointing directly at the viewer."
    },
    {
      product_name: "remembrance",
      product_id: "6654031822914",
      product_text: "As the sun sets on this moody day, the colors of the sky are fierce. There is fresh growth on a lone tree, symbolic of new life. Hundreds of red poppies are bursting open in a tribute of remembrance for those who are now as free as the birds we see soaring off into the sunset."
    },
    {
      product_name: "memories",
      product_id: "6654030643266",
      product_text: "The dark and brooding sky, the fading autumn colors in the trees, and the thousands of poppies spread across every piece of available land all invoke memories of a time that lest we forget. The calm waters encroached upon by the poppy-laden fields add an element of peace."
    },
    {
      product_name: "tis_the_season",
      product_id: "6654015864898",
      product_text: "‘Tis the season for magic and wonder – and don’t forget the presents! This fairy is rugged up tight against the fierce winter winds as she sits crossed-legged on the snow, hugging some gifts. Even her pet black cat is protected against the elements, adorned with a cute scarf."
    },
    {
      product_name: "snow_queen",
      product_id: "6654046961730",
      product_text: "A snow queen with a crown and collar of icicles looks down on the rest from under her eyelashes. Her white-blonde hair falls in a braid as the harsh winter winds whip and curl around the frozen forest behind her."
    },
    {
      product_name: "daffodil_bouquet",
      product_id: "6654038933570",
      product_text: "This daffodil bouquet, with bulbs and large, flaring trumpets, heralds the bright fresh days of spring. Placed in a glass vase alongside other delicate blooms indoors, one can view a clear and brilliant day through the window."
    },
    {
      product_name: "the_grand_illusion",
      product_id: "6654037917762",
      product_text: "Leaving a different impression on everyone who views it, with more to see each time you look, this grand illusion is just waiting to marvel and astound the viewer. There is a galaxy above, through clouds to waters below, as a young girl stands holding offerings of wonder."
    },
    {
      product_name: "old_winter_cottage",
      product_id: "6654006394946",
      product_text: "This old winter cottage has stood the test of time and is weathering yet another hard winter. Snow is piled thick on the thatched roof, and although ducks are swimming in the pond, it looks near-frozen over. Can you spot the children building a snowman on this crisp evening?"
    },
    {
      product_name: "autumn_oasis",
      product_id: "6654018224194",
      product_text: "The colors are just starting to turn in this autumn oasis, and there is abundance everywhere you look. A white bench with a small cushion is positioned among the many pots bursting with late summertime blooms, while pumpkins litter the surrounding areas. Butterflies, squirrels, and birds are making the most of this plentiful bounty."
    },
    {
      product_name: "la_fattoria",
      product_id: "6654024089666",
      product_text: "There is plenty of activity here at la fattoria, the farm. Vehicles from past generations are kept well maintained and tidy, and the grand farmhouse itself is a sight to behold. Farm animals are scattered around the foreground, while hot air balloons provide a pop of color in the sky."
    },
    {
      product_name: "breeze_off_the_ocean",
      product_id: "6654041882690",
      product_text: "As this white paneled window has been left ajar, you can feel the breeze off the ocean stirring life into the world outside. Small vases of flowers, a seashell, and some books litter the window sill inside, while a choppy ocean mirrors the blue sky outside, with a luscious forest scene set beyond."
    },
    {
      product_name: "blue_lagoon",
      product_id: "6654029398082",
      product_text: "Sparkling in the bright sunshine are the many cascading waterfalls that all find their way into the blue lagoon. This too shimmers and sparkles in the bright light of day, delicately contrasted by the deep pinks, purples, and greens of trees bursting into bloom at the top of the cliffs."
    },
    {
      product_name: "monastery_gardens",
      product_id: "6654011244610",
      product_text: "These monastery gardens provide some much-needed shade, as you can see that the sun is beating down on this seaside environment. In the distance, tall mountains from behind and across the water loom, giving the impression that this holy space is an oasis of diversity with its many flowering shrubs and trees."
    },
    {
      product_name: "princess_strawberry",
      product_id: "6654044799042",
      product_text: "This princess strawberry is all freckles and flounce, in nearly every hue of pink imaginable. Her piercingly bright green eyes gaze out from behind thick lashes. Her floppy hat, with its skull-shaped strawberry, and her morose cat teddy, add the slightest element of goth to this scene."
    },
    {
      product_name: "winter_angel",
      product_id: "6654004559938",
      product_text: "This winter angel is set apart from a patterned background of blue, allowing the gentle and carved_like features of its face, wings, and body to stand out. The angel has a serene and smooth face in contrast to the detail present within the rest of the image. You might notice a source of light in one hand down by the navel, while the other hand is positioned in a sign of blessing."
    },
    {
      product_name: "the_visitor",
      product_id: "6654036213826",
      product_text: "A sunbeam through this dense and magical woodland has made a spotlight on this white unicorn, which takes a drink in a sparkling pool of water fed by a many-layered waterfall. Thick green undergrowth gives way to small hints of life, whether that be the colorful wildflowers or inquisitive forest friends."
    },
    {
      product_name: "duchess",
      product_id: "6654013833282",
      product_text: "Make way, the duchess is here! With her thick, fluttering eyelashes and a fan that of course matches the rest of her ensemble, this prim and proper darling balances decorum and style with ease. No duchess is complete without a cute kitten, and you’ll find one here curled up on her lap."
    },
    {
      product_name: "orange_crush",
      product_id: "6653997973570",
      product_text: "A bouquet of flowers and foliage is placed in a rounded glass vase, complementing the main attraction of blooms that boast large, soft petals. Many other smaller daisies and lilies can be found in a variety of reds, peaches, and yellows that combine to create this gorgeous orange crush."
    },
    {
      product_name: "alice",
      product_id: "6654046437442",
      product_text: "One for the fans of Lewis Carrol, this Alice tribute has subtle nods toward many of your favorite characters set in an eerie winter woodland scene. Blue and pink contrast wonderfully here to capture both the mystery and beauty of the story."
    },
    {
      product_name: "tribal_heart",
      product_id: "6654038179906",
      product_text: "Against a trending background of large flowers, a woman stares resiliently forward as she holds a three-eyed and winged cub in her arms. Her tribal heart and tattooed form are brilliantly depicted in this moving scene."
    },
    {
      product_name: "gazebo_by_the_sea",
      product_id: "6654020321346",
      product_text: "This gazebo by the sea provides a much-needed shelter from the elements experienced on the coast. Today is a pleasant day, with a chair positioned out to enjoy the sunshine and flowers alongside the butterflies and birds. You can see a lighthouse in the distance, as well as a small yacht holding people who are clearly enjoying the beautiful day."
    },
    {
      product_name: "olive_a_taormina",
      product_id: "6654025662530",
      product_text: "A breathtaking scene of early spring blossoms cascading down white pillars frames the picturesque landscape beyond. The ancient village and Roman theater of Taormina can be seen down below, all with a spectacular vantage point of the snow-topped Mount Etna in the distance as it smokes away."
    },
    {
      product_name: "still_life_with_wines",
      product_id: "6654042603586",
      product_text: "Three very different bottles of wines, two poured out into their appropriate glasses, are scattered artfully among a varied assortment of delectable accompaniments. This is all placed on a white cloth atop a wooden table with the outdoor view in sight."
    },
    {
      product_name: "lotus_lake",
      product_id: "6654040145986",
      product_text: "Soft pinks and yellows set the tone for this calming and mystical lotus lake scene. As dragonflies and butterflies hover above the murky water, lotus flowers have fallen open, providing refuge for these gentle creatures."
    },
    {
      product_name: "endless_days",
      product_id: "6654029987906",
      product_text: "This is a sunset scene over a tranquil beach, where the gentle waves tickle at your toes and the golden sand is rivaled only by the sun still shining on these endless days. The colorful clouds are reflected in the water, creating many depths of luxurious color to soak up and enjoy."
    },
    {
      product_name: "stormy_weather",
      product_id: "6654001971266",
      product_text: "It’s stormy weather on the surface of this underwater scene, with deep, rumbling thunderheads that can be seen overhead. Under the waves, life carries on as tropical fish and coral ride the tide. A large turtle dominates the underwater space here, its captivating eye speaking volumes of wisdom."
    },
    {
      product_name: "carnival",
      product_id: "6654003806274",
      product_text: "This Venetian-style mask with its recognizable white face and richly decorated eyes is adorned by a jester’s hat, thick with bells and streamers. The whole image conveys the excited movement and color that says nothing else but carnival time!"
    },
    {
      product_name: "we_re_all_mad_here",
      product_id: "6654017896514",
      product_text: "A nod to the Alice in Wonderland marvel, an unhappy ‘Alice’ is seen glaring out through teary eyes while clinging to the Cheshire cat with its mischievous grin. “We’re all mad here” is the story being told in this scene, with skull-face flowers crowding around and a wild tattoo on this girl's arm."
    },
    {
      product_name: "blueberry",
      product_id: "6654046666818",
      product_text: "This majestic woman exudes power and importance as she gazes out with soft blue eyes. Her head is tipped slightly upward, allowing her blue hair to be swept free to one side behind her wings. This ‘Blueberry’ sits with a small creature at her shoulder as the story in your imagination begins to unfold."
    },
    {
      product_name: "morning_rush",
      product_id: "6654035787842",
      product_text: "A misty dawn breaks over towering trees and a majestic waterfall. The water flows down under an arched bridge that’s nearly engulfed by a purple creeper, all in the frenzy of the morning rush."
    },
    {
      product_name: "caribbean_cottage",
      product_id: "6654007410754",
      product_text: "This Caribbean cottage is a white-washed little home with blue detailing around the eaves and window sills. Spilling out of the white picket fence are numerous shrubs and bushes, with two palm trees stretching up toward the bright blue sky."
    },
    {
      product_name: "lost_in_the_daisies",
      product_id: "6653996335170",
      product_text: "Get lost in the daisies with this bright collection of beautiful blooms that are thickly amassed among their springtime leaves. Dark and light greens are superbly contrasted by the pinks, reds, and oranges of the daisies, with one flower in particular turned directly to face the foreground. "
    },
    {
      product_name: "japan_garden",
      product_id: "6654005641282",
      product_text: "There is something to see anywhere you look in this Japanese garden. It is bursting with color, from the bright red bridge leading you away out to the snow-tipped mountains to the colorful koi in the lily pad-filled pond. Enjoy the blossoms of spring, the details of unique Japanese architecture, and the vibrant life scattered throughout this design."
    },
    {
      product_name: "dream_landscape",
      product_id: "6654019797058",
      product_text: "This dream landscape consists of an immaculately kept cottage bordering a lively spring that gushes down a series of rocks to create a small yet impactful waterfall. Life mills around the water, where ducks, butterflies, birds, and dragonflies can be watched and enjoyed."
    },
    {
      product_name: "le_arcate",
      product_id: "6654023696450",
      product_text: "A deep, still blue lake sits below a sky thick with gray clouds that can be seen through le arcate, the arches. These arches are adorned with creepers, while many potted flowers are enjoying the cooler space made available to them out of the elements. We look out from the shade of a building, through the ornate, golden arches out to the water and trees beyond."
    },
    {
      product_name: "happy_hour",
      product_id: "6654000922690",
      product_text: "It’s happy hour for these three cheeky parrots as the sun goes down, delivering a brilliant display of color on the horizon. Perched in the branches in the foreground, these parrots seem to be investigating the numerous and colorful tropical plants that surround the scene."
    },
    {
      product_name: "sending_love",
      product_id: "6654040932418",
      product_text: "A very thoughtful card-like scene, here you can send love, and lots of it. Cartoon flowers are dotted throughout, and a large red love heart is centrally placed in the design. The colors pop against a deep blue background."
    },
    {
      product_name: "mountain_stream",
      product_id: "6654031626306",
      product_text: "The detail in this landscape, from the distant frozen mountainscape to the individual blades of grass in the meadow, set this scene above the rest. A mountain stream cascades down into the distance, through rock and forest and out to the water."
    },
    {
      product_name: "rhine_wine_moment",
      product_id: "6654043881538",
      product_text: "Seen through the frame of a traditional building window, the Rhine river weaves its way through mountainscapes into a small European village. Set on the window ledge are a clear white wine and an assortment of delicious accompaniments, making this the perfect Rhine wine moment."
    },
    {
      product_name: "repunzel",
      product_id: "6654048305218",
      product_text: "Oh my, does our Rapunzel look bored as she stares out from her tower with her head (and hair) in her hands. At least she has some company in the form of a few feathered friends, but by the look of her elaborately painted eyes, she couldn’t care less."
    },
    {
      product_name: "sugar_and_spice",
      product_id: "6654016389186",
      product_text: "It’s sugar and spice and all things nice! An abstract heart pattern in the background sets the scene for this sugar plum fairy. In a bright pink dress with puffed sleeves, she cradles a sweet of her own, with many more scattered around her as she sits up on her knees to gaze out dreamily toward the viewer."
    },
    {
      product_name: "summer_bouquet",
      product_id: "6654038638658",
      product_text: "A summer bouquet of brilliantly colored blooms towers up into the light blue sky. An intricately patterned blue morpho butterfly flitters past, drawing your eye to some abstract, transparent leaf detail toward the top of the scene."
    },
    {
      product_name: "sarah",
      product_id: "6654047453250",
      product_text: "One for the Labyrinth fans, this ode to Sarah is unmistakable to those who know the story. She holds a small Bowie doll in her hands, while her hair and dress are reminiscent of the ball attire she wore in the film. The portrait fades to a blur, with Sarah’s hair blending into the smoky background."
    },
    {
      product_name: "manor_on_the_water",
      product_id: "6654042865730",
      product_text: "A juxtaposition of curved archways and sharp, pointed lines can be seen here on this manor on the water. Half entombed by the ever-encroaching foliage, the steps to this impressive building lead right down into the water, which gently laps at all sides."
    },
    {
      product_name: "puppy_love",
      product_id: "6654014292034",
      product_text: "Is this puppy love, or love at first sight? This sweet fairy with thick blue braids is kneeling to snuggle a sweet and small puppy that looks ever so pleased with the attention. The abstract background of a floral design complements the polka dots of her dress and contrasts with the fine line detailing in her wings."
    },
    {
      product_name: "beautiful_blossoms",
      product_id: "6654019338306",
      product_text: "It must be spring, as the beautiful blossoms are bursting from every tree, bush, and plant – and what a welcome sight it is! The sky is bustling with busy birds and butterflies as the warm sun shines down in this park-like garden. A bench and wishing well are both close by, with stone steps leading you up onto more grass and toward a gazebo that stands next to a brilliant display of pink cherry tree blossoms."
    },
    {
      product_name: "a_spasso_per_venezia",
      product_id: "6654021599298",
      product_text: "If you feel like a spasso per Venezia (or in English, a walk around Venice), you’ve come to the right place. A traditional scene of tall buildings with narrow alleyways allows us to recognize the memorable cityscape, but here, we’re also treated to steps leading up to a door over the canal. Baskets litter the ground, making the moment feel more relaxed and lived-in."
    },
    {
      product_name: "country_reflections",
      product_id: "6654034247746",
      product_text: "The breathtaking tree that is the centerpiece of these country reflections stands at the gateway to a farming village, just across the stream at the water’s edge. The path looks well used and a little worse for wear, but the houses in the distance appear neat, orderly, and welcoming."
    },
    {
      product_name: "private_collection",
      product_id: "6654036770882",
      product_text: "The woman’s cold, steely sights are set upon you as she holds her rifle proudly before her private collection. Not what you might have first assumed, however – a vast selection of prized butterflies are hung on the wall. Her fox is nestled around her shoulders, looking very much alive."
    },
    {
      product_name: "provence_blue_door",
      product_id: "6654042308674",
      product_text: "This Provence blue door is a statement just as bold, in this cobblestoned courtyard and dwelling, as the tall blue wildflowers that spray like fireworks alongside. In pleasing contrast are the cascading deep red and pink blooms hanging from the balcony above."
    },
    {
      product_name: "colorful_garden",
      product_id: "6654040539202",
      product_text: "This sure is a colorful garden scene, and not only for the tall and towering summertime foxgloves and hyacinths that fade away into the distance. Perched on a white picket fence, a diverse array of boldly colored birds grace this glorious garden."
    },
    {
      product_name: "colours_of_spring",
      product_id: "6654029725762",
      product_text: "Incredible detail can be found in this soothing scene that pops with the colors of spring. A small squirrel, relishing in the warmth of the day, sits before the trunk of a tree in full bloom. As your eye wanders out over the meadow, water, and hills beyond, the energy of new life is everywhere."
    },
    {
      product_name: "forest_friends",
      product_id: "6654017142850",
      product_text: "This calming and gentle fairy is surrounded by her forest friends. A deer and a squirrel nestle in close as she curls down on a bed of meadow flowers, all purple, pink, and white. The darker, earthy color choices make the scene feel even more mysterious and wondrous."
    },
    {
      product_name: "spirit",
      product_id: "6654047780930",
      product_text: "The spirit is strong with this blue-haired witch who owns this Halloween theme. She clutches a hairless Sphynx cat, a star at its third eye, which she matches with three tattooed stars of her own under her eye."
    },
    {
      product_name: "the_road_less_traveled",
      product_id: "6654012391490",
      product_text: "It’s as if time has stopped here in this quiet seaside village. Each small summertime cottage has been well maintained and is perfectly presented with a rich array of greenery to soften the salty spray of the sea. Although clearly much loved, here is the road less traveled, with not a soul in sight."
    },
    {
      product_name: "lo_steccato_sul_fiume",
      product_id: "6654024548418",
      product_text: "A beautiful villa of grand proportions fits right into the landscape, creating a welcoming and comfortable scene. A path tightly hugged by purple and pink shrubs meanders past lo steccato sul fiume, the fence on the river, out to the autumnal forest beyond. The fires are alight inside – come on in and make yourself cozy!"
    },
    {
      product_name: "beach_days",
      product_id: "6654019076162",
      product_text: "There’s nothing like lazy beach days where the chairs are stationed high in the sand for you to watch the tide crash closer and closer to your toes. Numerous flowers to feast your eyes upon are scattered along the path down to the beach, and a spectacular lighthouse can be glimpsed out in the distance."
    },
    {
      product_name: "garden_path",
      product_id: "6654035591234",
      product_text: "Come up the garden path and you will be met by an assortment of trailing creepers, potted blooms, and wild and unkempt cottage oddities. The sun breaks through the haze and shines down through the gnarly trees and onto the white garden shed in the distance."
    },
    {
      product_name: "arctic_fox",
      product_id: "6654037688386",
      product_text: "The arctic fox that this otherworldly woman is holding looks as cute and cuddly as a teddy bear. Its large, round eyes are smiling as a kitty mask it wears sits askew. In stark contrast, with ornamental spikes coming from her elaborate hairstyle, this three-eyed woman calmly observes her surroundings."
    },
    {
      product_name: "happy_hummers",
      product_id: "6654039720002",
      product_text: "These two busy hummingbirds sure look to be happy hummers as they flit around this richly colored and diverse garden. A small, spotted white butterfly gently caresses newly-opened bluebells, while bold yellow daisies and fiery poppies and gladioli warm the scene."
    },
    {
      product_name: "smell_the_roses",
      product_id: "6653998465090",
      product_text: "Immediately, the viewer is hit by a sight of beauty so powerful that you can almost smell the roses. The blooming flowers have been captured at the moment of their perfection, open and radiating their brilliance. Little leaves can be seen as the image simply pops with purples, reds, and pinks."
    },
    {
      product_name: "sweetie_bunny",
      product_id: "6654048010306",
      product_text: "Hi there, sweetie bunny, with your candy hat and ice cream earrings! Her posture is somewhat coy as she holds a pink bunny to her body, her blue hair fanning out behind her."
    },
    {
      product_name: "barche_a_varenna",
      product_id: "6654025269314",
      product_text: "The lakeside commune of Varenna sits proudly nestled between Lake Como and the richly diverse hills that are thick with trees and growth. The barche a Varenna, the boats in Varenna, are lined up haphazardly along both the beach and village side, waiting to be of use the next day."
    },
    {
      product_name: "summer_escape",
      product_id: "6654021107778",
      product_text: "In search of a summer escape? Look no further than this scene, where you can sit on the balcony and look directly out to the sea and wash your worries away. A stroll along the beach at some other time has clearly delivered some treasures, which are placed on the table between the chairs, while many summertime blooms welcome birds and butterflies to your door."
    },
    {
      product_name: "dahlia",
      product_id: "6737048731714",
      product_text: "Dahlia and her winged sphinx cat sport matching markings that can be seen as they face one another. She is an amethyst-eyed girl with amethysts in her lime-green and pink hair, a splash of brightness against her black witch hat."
    },
    {
      product_name: "lilac",
      product_id: "6737049092162",
      product_text: "Keeping herself warm with a fur muff, stole, and jewel-adorned headpiece, this lilac-eyed beauty stands composed in this wintery scene. Snowflake patterns adorn her skin, and her hair is a striking blend of black and white."
    },
    {
      product_name: "moon_and_star",
      product_id: "6737046962242",
      product_text: "Moon and Star are twins of subtle differences. The hair of one is teal, the other purple, and they are adorned by symbols of their respective names. They both stand entwined in black clothing and sporting witch hats atop their heads."
    },
    {
      product_name: "daydreamer",
      product_id: "6737047912514",
      product_text: "Head and shoulders above the waters, this mermaid daydreamer contemplates what she sees. Her long, pointed fingers are held against her sparkling face, and orcas complete this fantasy scene."
    },
    {
      product_name: "venice_terrace",
      product_id: "6737014947906",
      product_text: "This Venetian terrace view looks out over the calm and still canal waters, where several gondolas bob gently against the flower-laden paths and patios. Just a stone wall away laps the wide ocean expanse, the sun setting in the distance."
    },
    {
      product_name: "we_re_alright",
      product_id: "6737017798722",
      product_text: "A moving image of motherly protection that can be spoken and understood in any language. A mother bear embraces her young cub in a foreboding forest setting. As they sit together, you can almost hear her saying, “We’re alright.”"
    },
    {
      product_name: "biological_key",
      product_id: "6737048305730",
      product_text: "Nude makeup softens this beauty’s face, her blonde hair electrified like lightning against the stormy night backdrop. She sits with a swan, a locket around its neck, while she holds the biological key in her hand."
    },
    {
      product_name: "blanca",
      product_id: "6737047158850",
      product_text: "Blanca holds a phone to her ear while her mesmerizing eyes stare straight into the depths of your soul. Her white hair cascades down to her hips, past a black cat perched on her shoulder that sports a star on its forehead."
    },
    {
      product_name: "aries",
      product_id: "6738568937538",
      product_text: "Aries, her hair in the shape of horns, wears a dress that mirrors this arrangement. The motif, seen as the amulet she wears, appears everywhere you look, while sheep perch as flowers among the leaves in the background."
    },
    {
      product_name: "taurus",
      product_id: "6738572345410",
      product_text: "Taurus is both strong and delicate. Her bull-horned crown is held strong, yet she wears a soft poppy-pink dress. The leafless trees behind her contrast with her soft brown curls and fur cape."
    },
    {
      product_name: "gemini",
      product_id: "6738569953346",
      product_text: "The twins represent day and night, their hair connecting them, as one is upside down. The Gemini symbol is seen on both of their arms and as a crown."
    },
    {
      product_name: "cancer",
      product_id: "6738569101378",
      product_text: "Cancer sits at the beach, her symbolic crab sitting alongside her before a castle of sand. She wears a crab shell dress, the pinchers like a cape over her shoulders and shells as a collar."
    },
    {
      product_name: "scorpio",
      product_id: "6738571821122",
      product_text: "As lightning strikes and rain falls, Scorpio looks over her shoulder and offers a small smile. Holding a scorpion in her hand and wearing her auburn locks in a similar fashion, this woman can clearly sting."
    },
    {
      product_name: "libra",
      product_id: "6738570838082",
      product_text: "Libra stands with her hands on her hips, her hair in divided yet unified plaits, balancing a crown of scales on her head. Wearing a royal blue dress and with a lizard perched on her shoulder, her piercing eyes look fair in every way."
    },
    {
      product_name: "virgo",
      product_id: "6738572771394",
      product_text: "Virgo stands with long flowing locks against a myriad of swirls and curling flowers. Her hazel eyes are the same color as the pendant around her neck, and she wears a soft dress of pink that matches the sunset."
    },
    {
      product_name: "leo",
      product_id: "6738570313794",
      product_text: "Leo, our freckled lion with a mane of fire, stands among sunflowers with a cub by her side. She wears a simple crown, a collar of leaves, and a symbolic pendant around her neck."
    },
    {
      product_name: "shadow alice",
      product_id: "6737047552066",
      product_text: "Shadow Alice, with her Cheshire cat bag, holds a skull and crossbones teacup in her hands. From her artfully ripped attire to her one button-eyed bunny, everything about this wonderland beauty is anything but proper."
    },
    {
      product_name: "Peppermint",
      product_id: "6737049157698",
      product_text: "A peppermint crown of spikes and thorns sits atop this figure’s winter-white hair. Ice-blue eyes look out from underneath incredibly long lashes as she sits poised in a stunning gown."
    },
    {
      product_name: "Rock Island Lighthouse",
      product_id: "6737015341122",
      product_text: "A sunset lights up this scene like fire. As the playful ocean sparkles and trees are bathed in gold, the proud American Rock Island lighthouse stands tall and strong. Its light is already shining as numerous flocks of seabirds are seen heading in for the evening."
    },
    {
      product_name: "Coastal Living",
      product_id: "6737017307202",
      product_text: "If you are enticed by coastal living, this peaceful village is all you could wish for. In the cool light of dawn, a path can be seen leading down to the lively water’s edge. This is surrounded by tidy homes with neat gardens, all exuding life and warmth from behind their windows."
    },
    {
      product_name: "Como Sunset",
      product_id: "6737015177282",
      product_text: "This Como sunset of blues and pinks begins to cast shadows on the seaside township. The warm glow from a restaurant beckons, steps leading directly from the water’s edge to colorful boats that rest anchored to the shore."
    },
    {
      product_name: "Horse Valley Farm",
      product_id: "6737016913986",
      product_text: "You have arrived at Horse Valley Farm. Two sleek and shining horses canter up to a fence bordering the road to meet you. Look past the show of autumnal colors to the classic big red barn, the farmhouse, and beyond, where the rolling hills stretch up into a moody sky."
    },  
    {
      product_name: "Crimson",
      product_id: "6737048830018",
      product_text: "A wintery background sets the scene for this regal sweetheart. Her crimson lips, blush-pink cheeks, and flaming eyes are complemented by her red and black attire and jewels."
    },  
    {
      product_name: "Miss Macaroon",
      product_id: "6737048666178",
      product_text: "Miss Macaroon is an ethereal creature, combining food and fantasy to create a stunning visual piece. As a mermaid, she floats close to her ocean-born pet, yet adorning her body and hair that cascades around her are the flavorsome French delicacy, macaroons."
    },
    {
      product_name: "Sagittarius",
      product_id: "6738571493442",
      product_text: "Sagittarius sports a quiver and bow at her back, wearing warrior clothing and fur at her shoulders. Crisp, autumn oak leaves wind around behind her against a fierce sunset."
    },
    {
      product_name: "Capricorn",
      product_id: "6738569658434",
      product_text: "Capricorn curls in close to a friendly-looking goat with the tail of a mermaid. Ivy and pansies decorate this starry night scene, and the blonde-haired woman wears a symbolic crown."
    },
    {
      product_name: "Aquarius",
      product_id: "6738568478786",
      product_text: "Aquarius sits pouring water from a vessel, gazing knowingly at her viewers. She sports a drop-bejeweled vest as orchids and birds surround her. Mysterious symbols can be seen on her arm."
    },
    {
      product_name: "Pisces",
      product_id: "6738571264066",
      product_text: "Pisces looks freshly pulled from the water, her curls hanging wet among the bubble-like jewels. Fish swim around her head and the water beckons in the background, a beautiful lily sitting atop the blue."
    },
    {
      product_name: "Love Song",
      product_id: "6737049452610",
      product_text: "With sugar skull makeup and skeleton paint designs over her arms and legs, this young rocker plays a love song on her guitar that we might all know the tune to. Her crown of soft lilies and sharp thorns and spikes complete her look."
    },
    {
      product_name: "The Twins",
      product_id: "6737047453762",
      product_text: "The twins stand, mirroring one another in their bedroom. One holds a bear, the other a bunny, but both animals are oozing stuffing and stare with lost eyes. Their expressionless faces give more life to their knowing eyes that you cannot look away from."
    },
    {
      product_name: "Cottage Way Lane",
      product_id: "6737015701570",
      product_text: "A black and white cat sits on the cottage way lane, glancing toward a pair of swans that glide along serenely in a natural pond. A thatched roof cottage is half-swallowed by the encroaching shrubbery, looking comfortable and inviting as it sees out the passing years."
    },
    {
      product_name: "Sunset Serenity",
      product_id: "6737017241666",
      product_text: "A roaring campfire mimics the colors of this sunset serenity as the sun dips below the grasses beyond the water. A well-built cabin sits in quiet solitude, staving off the cool air of the autumn dusk."
    },
    {
      product_name: "Mountain Village",
      product_id: "6737017995330",
      product_text: "Ducks fly overhead, scarcely seen amid the smoke and mist that has settled in the air of this mountain village. With the setting sun and encroaching cool, fires are stoked within the homes and the village boats are left tied up and unmanned in the water."
    },
    {
      product_name: "Silent Night",
      product_id: "6737017634882",
      product_text: "Horses and carriages wait calmly in the fallen snow for those in the humble church to exit. As a train rolls by, a full moon shines above, encompassed by the beautiful show of the northern lights. This silent night scene exudes a feeling of calm and peaceful season’s greetings."
    },
    {
      product_name: "Jessie",
      product_id: "6737047289922",
      product_text: "Jessie is young and vibrant, her green and purple hair spraying out and over her shoulders, where a purple and green-eyed cat perches. Headphones on her ears that are connected to a tape deck, Jessie also sports a quirky pumpkin skull bag in matching colors."
    },
    {
      product_name: "Never Leave Home",
      product_id: "6737048109122",
      product_text: "This mesmerizing beauty tells two tales: one of soft, innocent pinks and the other of sultry black. Her candy-pink hair and matching bow frame her figure, which is enrobed in black lace. As she applies black lipstick, she admires the tattoos on her neck."
    },
    {
      product_name: "Summer Celebration",
      product_id: "6766589902914",
      product_text: "Oooh, Aaah. A summer celebration of American independence is in full swing as fireworks light up the night sky. Butterflies and fireflies flit around the warm air of the cottage garden, where a log cabin stands on the edge of a small lake."
    },
    {
      product_name: "Fourth Friends",
      product_id: "6766592950338",
      product_text: "Patriotism shows no boundaries as evening celebrations are enjoyed by these ‘Fourth friends’. A small child dressed in red, white and blue holds a sparkler as she stands with her golden cat and dog companions, admiring the fireworks in the distance."
    },
    {
      product_name: "Blooming Backyard",
      product_id: "6766587904066",
      product_text: "This blooming backyard is well kept and vast. Neat lawns are surrounded by ornamental shrubs, a flowing fountain, and delicate spring flowers that have burst open, to the delight of many butterflies and birds."
    },
    {
      product_name: "Nature Haven",
      product_id: "6766589542466",
      product_text: "Do you desire an escape to the wilderness? This nature haven welcomes you. Blossoms pop all around the traditional log cabin, and as you look out to the sharp peaks of a mountain top in the distance, an eagle flies overhead."
    },
    {
      product_name: "Happiness Ice Cream Shop",
      product_id: "6766593507394",
      product_text: "Welcome to the Happiness Ice Cream shop, where every day is ‘sundae!’ A young girl sits out in front of the shop’s signage, sharing her ice cream cone with a piglet. Kittens peek out of the basket on her small bike, and happiness can be seen all around."
    },
    {
      product_name: "Thinking of You",
      product_id: "6766590722114",
      product_text: "Two girls have been thinking of you and stand waiting at a red door with flowers hidden behind their backs. Vases and planters are brimming with blooms of all kinds, and a kitten is curled up asleep in the dappled shade of the porch."
    },
    {
      product_name: "Floral Fantasy",
      product_id: "6766588133442",
      product_text: "A small wooden gazebo overlooks a lone swan that drifts calmly along a peaceful lake. Before it lies a floral fantasy of potted and planted spring bulbs and blossoms. Take a seat, pick up a book, and dream the day away."
    },  
    {
      product_name: "Lakeside Retreat",
      product_id: "6766589345858",
      product_text: "Welcome to your lakeside retreat, where a quaint log cabin rests nestled among an explosion of color and life. A yacht can be seen bobbling along the rippling water that lies behind the house, set before a rolling hill of green forest."
    },
    {
      product_name: "Happy Birthday",
      product_id: "6766591213634",
      product_text: "In the windows of the ‘Happy Birthday shop,’ cakes, presents, and all things party can be seen. A gaggle of children, puppies, and kittens crowd the pavement outside, staring adoringly in at the scenes of delight."
    },
    {
      product_name: "Stop and Smell the Roses",
      product_id: "6766591082562",
      product_text: "On her way out the gate from her quaint cottage home, a small girl takes the time to stop and smell the roses. A welcoming archway is covered with purple wisteria, and many other blooms can be seen leading up the pathway."
    },
    {
      product_name: "Mystery Kit #1",
      product_id: "6766590132290",
      product_text: "The muted sky is kindred to the stately and traditional house yet opposes the brilliant displays of color in this lakeside garden setting. Birds and butterflies all prepare for their twilight flight as the lights come on inside."
    },
    {
      product_name: "Mystery Kit #2",
      product_id: "6766592622658",
      product_text: "Two young sisters hold hands outside a girl’s clothing store named ‘My Sister’s Closet.’ A kitten sits before a sign, and looking at the shopping bags next to the girls, what it says is true: a girl can never have too many shoes!"
    },
    {
      product_name: "Autumn Well Wishes",
      product_id: "6766587543618",
      product_text: "A black cat sits at the window of a large house made of stone and wooden shingles. The bright blue autumn sky is teeming with birds  and butterflies as leaves  turn to red and yellow all around."
    },
    {
      product_name: "Tea for Two",
      product_id: "6766593376322",
      product_text: "Two beautifully dressed young girls chink their cups as they sit down for tea for two. The pink flowers on their hats match both those creeping over a fence and their small table and chairs. Teddy has been invited, as has a dog and a cat that sit dutifully alongside."
    },
    {
      product_name: "Harvest Moon",
      product_id: "6766588887106",
      product_text: "The harvest moon hangs full in the night sky, casting a bright light onto the farmyard scene below. A large red barn complements the deep hues of autumn in the trees, and a scarecrow beams merrily from a lantern pole."
    },
    {
      product_name: "The Doctor is in",
      product_id: "6766592163906",
      product_text: "Out in the garden and among the flowers lies the hugs and kisses ambulance. The doctor is in and tending to a puppy. His assistant is ready with bandages while the next patient, a kitten, awaits her turn."
    },
    {
      product_name: "Castle of Dreams",
      product_id: "6799283880002",
      product_text: "A Saint Bernard stands before a small arch bridge that leads the way over a swan-filled lake. Beyond this and rising from the ground like the mountains behind it is a castle of dreams. Spires, embrasures, crenellations, even a glasshouse – this castle has it all."
    },
    {
      product_name: "A New Day",
      product_id: "6799288041538",
      product_text: "Delicate violas jostle for space in this dreamy close-up scene. The feathery brush strokes add a multidimensional touch to the petals and leaves."
    },
    {
      product_name: "Reflection",
      product_id: "6799290204226",
      product_text: "Neon pink, burnt orange, and canary yellow all burst from the limbs of trees in this dense forest, the reflection of it all seen in the gently stirred waters of a lake lying between them."
    },
    {
      product_name: "Cutest of Them All",
      product_id: "6799293743170",
      product_text: "A white cat with blue eyes sits low with its feet hanging over a ledge. The deep blue fabric it sits on looks as soft as its fur. This purebred charmer has to be the cutest of them all."
    },
    {
      product_name: "Autumn Wolf Family",
      product_id: "6799306686530",
      product_text: "This autumn wolf family is a sight to behold. Four small pups sit with two adults, their fur shining as the setting sun casts a soft light on the picturesque forest setting."
    },
    {
      product_name: "Tarot Town",
      product_id: "6799334211650",
      product_text: "Suspended in mid-air, Tarot Town is a magical fantasy full of symbolism and wonder. A castle sits under the arch of a rainbow that cuts through a wheel of constellations, fish pulling boats through the sky."
    },
    {
      product_name: "Mutiny",
      product_id: "6799347220546",
      product_text: "This pirate girl has mutiny on her mind as she stands with her eyes narrowed, arms crossed and a dagger in hand. The scar across her cheek hints that she isn’t someone you want to cross."
    },
    {
      product_name: "Loving Zebras",
      product_id: "6799364751426",
      product_text: "Two loving zebras stand with their heads together as behind them, the herd busies itself with eating and drinking. This grassland scene is rich in life, with birds in the air and trees growing tall."
    },
    {
      product_name: "Bride of Frankenstein",
      product_id: "6799368486978",
      product_text: "The bride of Frankenstein strikes an elegant pose, a lace-edged Bardot collar curling up around her patchwork-stitched skin. A shock of white hair streaks through the black, which cascades upward."
    },
    {
      product_name: "Eternal",
      product_id: "6799368880194",
      product_text: "From one peaceful pond, a small, delicate waterfall feeds another. Separating the two bodies of water stands a tree, thick with blossoms of neon pink. In the distance, an eternal light glows bright and warm."
    },
    {
      product_name: "Daisy Meadow",
      product_id: "6799369961538",
      product_text: "The yellow orbs surrounded by petals of white are intermingled with splashes of color from other field flowers in this daisy meadow. Hues of purple and dark blue in the sky make the blooms pop that much more."
    },
    {
      product_name: "Playing with Fire",
      product_id: "6799370715202",
      product_text: "This blue-eyed Wiccan beauty is playing with fire with candles perched atop her pointed hat. A similarly blue-eyed black cat swings from her arm, and yet another eye hangs from her neck."
    },
    {
      product_name: "Pumpkin Time",
      product_id: "6766590787650",
      product_text: "It’s pumpkin time at the great pumpkin festival. Held at the country store, children can be seen inside bobbing for apples, while others peek through the window at the abundance of candy apples on display. Outside, fallen leaves cover the ground, and of course, there are pumpkins galore!"
    },
    {
      product_name: "Scary Hall",
      product_id: "6799372812354",
      product_text: "Heed the signs and get away from this scary hall. The wrought-iron gates are ajar, and rats and spiders creep around the entrance. Although the lights are glowing from inside this villa, it appears that only ghosts and other terrors remain."
    },
    {
      product_name: "Sombra",
      product_id: "6799377236034",
      product_text: "With her collar of calla lilies and a scowling owl perched on her shoulder, Sombra is a vision of elegant despair. Holding a single candle in front of her, her calavera makeup speaks of her purpose."
    },
    {
      product_name: "Pumpkins for Sale",
      product_id: "6799373795394",
      product_text: "Pumpkins for sale are stacked so high that they reach the tip of an autumnally-dressed gnome. His oversized button nose hides two soft brown eyes as he stands next to his fair crop."
    },
    {
      product_name: "Luella’s Halloween",
      product_id: "6799374417986",
      product_text: "A brightly lit treehouse home is a beacon for these wild trick-or-treaters. Luella’s Halloween is all she ever wanted, the princess mouse holding her candy bag next to her Superman squirrel friend."
    },
    {
      product_name: "Halloween Kittens",
      product_id: "6799378219074",
      product_text: "These three Halloween kittens are dressed up and ready for their treats. A little ginger wizard meows, while a black and white pirate is perched atop a carved pumpkin. Can you see the third kitten peeking out from the pumpkin’s smile?"
    },
    {
      product_name: "Viridescent",
      product_id: "6799376252994",
      product_text: "This strawberry blonde enchantress oozes a formidable power. Her hat holds bottles of potions and viridescent spines, and the same viridescent color diffuses from her eyes and streaks through her braided hair. A small green-eyed and scruffy cat perches on her shoulder."
    },
    {
      product_name: "Elvanna and Cinder",
      product_id: "6807236640834",
      product_text: "With her long hair in a side-swept braid underneath a crumpled witch’s hat, Elvanna and Cinder, her black cat, stand together against a backdrop of a city at night. Three Halloween pumpkins add to the autumnal decor."
    },
    {
      product_name: "Witchy Halloween",
      product_id: "6807248961602",
      product_text: "This cute, witchy Halloween dragon has sparkles in its eyes underneath a pointed hat. Curled up inside a pumpkin that is steaming green, there are symbols of both trick and treat in this Halloween scene."
    },
    {
      product_name: "Witch Broom Shop",
      product_id: "6766593179714",
      product_text: "Little witches line up outside the witch broom shop, looking at the array of magical wares on display. The hauntingly spooky colors of purple and bright green dominate the scene, with Halloween pumpkin orange splashed throughout."
    },
    {
      product_name: "Mariposa",
      product_id: "6807264919618",
      product_text: "Mariposa is about to take flight with her butterfly wings and hair clips. Dressed in a skeletal slip and donning traditional Los Muertos makeup, is this her dream or a nightmare?"
    },
    {
      product_name: "Halloween Cupcake",
      product_id: "6807288348738",
      product_text: "The two cartoon ghosts that flank this perfectly presented Halloween cupcake show what we are all thinking: Oooh! Adorned with all the classic creepy tokens, this delicious treat is finished with a perfect black bow."
    },
    {
      product_name: "Halloween Night in the Pumpkins",
      product_id: "6807303880770",
      product_text: "As the bare arms of a tree reach up toward a vibrant galaxy swirling in the night sky, you prepare for your Halloween night in the pumpkins. A relaxed-looking skeleton sits atop an iconic Volkswagen Beetle, which is surrounded by carved and cropped pumpkins."
    },
    {
      product_name: "Indigo",
      product_id: "6807274651714",
      product_text: "Both Indigo and her black cat have the same distinctive eye quirk, the moody colors throwing a ghostly hue onto her skin. Between her pointed witch hat to the skull she rests her arm on, star and moon symbolism can be seen."
    },
    {
      product_name: "Cool Cat",
      product_id: "6807316299842",
      product_text: "Check out this cool cat in his oversized orange glasses; oh, how they bring out his eyes! This headshot shows hints of a blue jumper underneath a matching scarf, complementing this cat’s dark gray fur."
    },
    {
      product_name: "Neon Capital Vegas",
      product_id: "6807325999170",
      product_text: "From a penthouse balcony, complete with a pool, the view of the neon capital of Vegas is a sight to behold. The shimmering lights and glowing fountains set against the fading daylight spark one’s imagination for the night to come."
    },
    {
      product_name: "Remember When",
      product_id: "6807345987650",
      product_text: "Remember when there was a single gas and grocery store that stood at the edge of the lake? Remember dirt roads, lemonade stands, and fishing off the pier? This is a glimpse back to simpler times."
    },
    {
      product_name: "Sabine and Joy",
      product_id: "6807351853122",
      product_text: "Sabine and Joy are both puff and fluff – one with curls piled high on her head, the hoop skirt of her Victorian dress matching the color of the roses, the other a fluffy poodle sitting upon her throne."
    },
    {
      product_name: "Alice’s World",
      product_id: "6819678683202",
      product_text: "Welcome to Alice’s world, where broken hearts, playing cards, and pots of tea fly around the girl’s head as she stands composed and sure. One bright blue eye gazes ahead as she holds a striped cup, a white rabbit perched on her shoulder."
    },
    {
      product_name: "Red Riding Rasta",
      product_id: "6819678847042",
      product_text: "It's a little red riding hood, Rasta-style. Her multi-colored locks are hidden behind a swathe of red fabric. Her hand comes up to pull a piece of it aside, revealing floral arm tattoos and a pair of large, kind eyes."
    },
    {
      product_name: "Shining Grace",
      product_id: "6819678912578",
      product_text: "A soft, glowing light radiates from behind this shining grace of a woman, her soft gray eyes and heart-shaped face surrounded by bright butterflies and beautiful blooms."
    },
    {
      product_name: "Goddess in Green",
      product_id: "6819679240258",
      product_text: "A goddess in green stands with roses in her hands in an elegant emerald dress. The same roses are made into a headdress, accentuating her heart-shaped face."
    },
    {
      product_name: "Rabbit in Red",
      product_id: "6819680124994",
      product_text: "She is a rabbit in red, her ears poking out through her shock of knee-length blonde hair. She is dressed in red and a checkerboard corset, a chess piece tied into her hair."
    },
    {
      product_name: "Regal Feline",
      product_id: "6819679371330",
      product_text: "This is a male lion, his hooded yellow eyes piercing the dusty savanna that his coat blends in so perfectly with. The headshot of this regal feline is truly breathtaking."
    },
    {
      product_name: "Summer Night",
      product_id: "6819679469634",
      product_text: "All manner of wildlife sits nestled among a brilliant display of flowers in this summer night scene. From fox and fawn to bunny and bee, there is something to treasure everywhere you look."
    },
    {
      product_name: "Late Summer",
      product_id: "6819679502402",
      product_text: "It’s late summer, and the blossoms in this bouquet hold the warmth of the sun in their petals. Pinks, yellows, and earthy oranges are complemented by the rich green of their leaves."
    },
    {
      product_name: "Beyond The Sunrise",
      product_id: "6819679633474",
      product_text: "Look over the water’s edge, past the three naked, wintering trees to beyond the sunrise. Hazy blues and purples are set in an ice-cold scene, while the rising sun attempts to break through the multicolored mist."
    },
    {
      product_name: "Farmers' Market",
      product_id: "6819680026690",
      product_text: "The farmers’ market is open. Fresh fruit and flower stalls line a paved street that leads to a large, pinstriped open top. A few people peruse the offerings as balloons, both large and small, decorate the sky."
    },
    {
      product_name: "Backyard Retreat",
      product_id: "6819680092226",
      product_text: "The fire is roaring in the pit and the drinks are served. Welcome to your backyard retreat, a peaceful courtyard adorned with numerous blooms and birdlife."
    },
    {
      product_name: "Victoria Christmas Village",
      product_id: "6819680813122",
      product_text: "Horse-drawn carriages and people singing carols in front of a Christmas tree are enjoying this sunny, winter day in a Victorian Christmas village. Tall buildings line the streets that are lit and decorated for the season."
    },
    {
      product_name: "Come On In",
      product_id: "6819680944194",
      product_text: "A close-up of a townhouse’s front door is festively and elaborately decorated in tasteful checkerboard and pinstripe trimmings. Although a toy guard stands at the red door, the presents lining the steps say, “Come on in!”"
    },
    {
      product_name: "A Golden Christmas",
      product_id: "6766592426050",
      product_text: "A small boy lifts the lid on one special present that is sure to make this a Christmas to remember. Out pops a puppy, its golden fur shining like all the other gifts and ornaments that adorn this festive scene."
    },
    {
      product_name: "Cozy Christmas Evening",
      product_id: "6819683369026",
      product_text: "It’s a cozy Christmas evening – the stockings are hung in front of a roaring fire, the cat is snoozing on its favorite chair, and the presents are all stacked neatly underneath the tree."
    },
    {
      product_name: "Christmas Cindy",
      product_id: "6819683926082",
      product_text: "This blue-eyed elven cutie has earmuffs with a headband of candy and a cat a curious color of green. The vibrant festive colors of red, green, and white are playful and fun."
    },
    {
      product_name: "Suzy Snowflake",
      product_id: "6819684253762",
      product_text: "Suzy Snowflake’s dress melts into the snow, making this winged beauty appear as if she rises out from the cold. Her lilac hair cascades down to reach the two small snowfolk that huddle at her legs."
    },
    {
      product_name: "Checking His List",
      product_id: "6819684450370",
      product_text: "Santa stands in a festive living room, the fire sparkling and the trees aglow. With a candy cane in his pocket and a quill in his hand, he is checking his list of good kids, as he knows who is naughty or nice."
    },
    {
      product_name: "Festive Lantern",
      product_id: "6819684778050",
      product_text: "A festive lantern keeps a lit candle safe from winter’s cold breath. A glow of warmth against a backdrop of night blue and snow, two birds perch among it and the decorative poinsettia and mistletoe."
    },
    {
      product_name: "Christmas Eve Dreams",
      product_id: "6766592852034",
      product_text: "With milk and cookies having sent this young man off on Christmas Eve dreams, his loyal friend watches by his side. With a teddy bear in arm and the sparkle of lights on the tree, this dreamer will soon awake to the presents by his side."
    },
    {
      product_name: "Feeling Festive",
      product_id: "6819686023234",
      product_text: "You can’t help but start feeling festive when you lay your eyes on this laden Christmas tree. No branch is bare as ornaments of all colors jostle for space. Gifts spill out from underneath the tree and onto the rug and chair."
    },
    {
      product_name: "Happy Holidays",
      product_id: "6819687891010",
      product_text: "Delicate detailing adds character to these snow and light-laced trees. Reindeer reflections stand in the woods, a wreath hangs on a lighthouse window, and Santa’s sleigh can be seen riding through the moonlight."
    },
    {
      product_name: "Christmas Village Glow",
      product_id: "6819688153154",
      product_text: "The people are out and about this wintery eve, the snow is falling, and warm lights in the buildings proffer a Christmas village glow. Flocking toward the church in the distance, one man drags a Christmas tree while another rides in his very own horse-drawn carriage."
    },
    {
      product_name: "Dragon and Fairy Swing",
      product_id: "6819688841282",
      product_text: "Swinging from a chain of flowers, a fairy with prismatic wings smiles into the light and looks to not have a care in the world. Behind her, a dragon, its mouth bursting with fire, crawls closer."
    },
    {
      product_name: "Berry Sweet",
      product_id: "6819689070658",
      product_text: "With her freckles and auburn locks, this hazel-eyed darling, dressed in strawberry pink, is just so berry sweet. A plush toy cat draped over her arm completes her innocent look as she stands among the strawberry fields."
    },
    {
      product_name: "Golden Sun",
      product_id: "6819689300034",
      product_text: "A large sunflower in a bouquet has opened fully, looking much like the golden sun as its petals radiate outward. Other gracefully-colored blooms add to the warmth this flower gives."
    },
    {
      product_name: "The Hum of Summer",
      product_id: "6819690315842",
      product_text: "The hum of summer, as dragonflies and bees buzz about, making the most of the last rays of warm sun, is enjoyed by a small rabbit that sits in front of a pond and takes in its surroundings."
    },
    {
      product_name: "Traditional Charms",
      product_id: "6819689463874",
      product_text: "A South American beauty showcases some traditional charms, wearing an impressive head wrap, adorned in roses, and holding a cup of yerba mate to her lips."
    },
    {
      product_name: "Happy Hippiewagon",
      product_id: "6819689726018",
      product_text: "This ‘64 VW Beetle is the ultimate happy hippiewagon. Set against a backdrop of floral mandala patterns, this radical rainbow ride is a picture of color."
    },
    {
      product_name: "Hummingbird and Butterfly",
      product_id: "6819689922626",
      product_text: "The hummingbird and butterfly dance between the foxgloves and hydrangeas. Three of each can be seen against the bright blue sky."
    },
    {
      product_name: "Bringing Home the Christmas Tree",
      product_id: "6819691167810",
      product_text: "A red pickup is bringing home the Christmas tree on a snowy winter’s afternoon. Many houses along the lane have decorated trees adorning their front yards, one also with two snowmen smiling their pebbled smiles."
    },
    {
      product_name: "Snowman with Gold and Silver Presents",
      product_id: "6819693396034",
      product_text: "This adorably cute snowman with gold and silver presents is all wrapped up in a red striped hat and scarf underneath an elegantly decorated Christmas tree."
    },
    {
      product_name: "Patriotic Christmas",
      product_id: "6819690971202",
      product_text: "Birds of several species all dine together on some seed that has been kindly left out in this birdfeeder. Boldly painted with stars and stripes and decorated with a Christmas wreath, this is a patriotic Christmas."
    },
    {
      product_name: "Birthday Snowman",
      product_id: "6766593409090",
      product_text: "A young girl holds a cupcake and candle in her hands as she kneels down to a birthday snowman. With balloons tied to its stick arms and the horn sticking out of its mouth, its smile is matched only by the small crowned dog at its side."
    },
    {
      product_name: "Doe",
      product_id: "6819691626562",
      product_text: "A red jay sits upon antlers that emerge from her ribbons of red hair, where two bells are fixed by a bow. This doe stands with her fingers wrapped around a ribbon, from which a bell swings."
    },
    {
      product_name: "Happy Christmas",
      product_id: "6819691823170",
      product_text: "The cotton candy-colored house and decorations make this snowy winter sight a warm and inviting happy Christmas. The setting sun adds to the pink-tinged scene in which festive lights adorn everything."
    },
    {
      product_name: "Christmas Eve",
      product_id: "6819692445762",
      product_text: "It’s Christmas Eve, and Santa has crept into the living room, his sack full of presents spilling open for yearning eyes to peep. A tree, peppered with candy canes and bows, has many surprises beneath it, including a teddy on a rocking horse."
    },
    {
      product_name: "Golfer's Paradise",
      product_id: "6819679305794",
      product_text: "Long shadows drape over an immaculate lawn that rolls up toward a stunning villa in the distance. This golfer’s paradise also features a stone arch bridge that leads over a pond, burgeoning gardens, and wildlife aplenty."
    },
    {
      product_name: "Sammy’s Summer Day",
      product_id: "6819680223298",
      product_text: "As the sun rises on the horizon, Sammy’s summer day in the meadow of flowers, where a peaceful pond and barren barn sit, has begun. This little goat looks eager to play, while two others graze in the distance."
    },
    {
      product_name: "Santa has Arrived",
      product_id: "6819691429954",
      product_text: "Santa has arrived, and he’s filling the stockings that were hung in front of the roaring fire under the watchful eye of a gray house cat."
    },
    {
      product_name: "Strange Dreams",
      product_id: "6819680682050",
      product_text: "This young girl, holding her patchwork cat, is having some strange dreams. Giant candy canes, cupcakes with faces, and several skulls all dance on a bed of clouds."
    },
    {
      product_name: "Unicorn Waterfall",
      product_id: "6819680354370",
      product_text: "Splashing in the shoals, making the water sparkle in the setting sun, is a unicorn mother and her foal. A waterfall cascades into the sea and across the water, while a castle stands high and dry."
    },
    {
      product_name: "Season of Love",
      product_id: "6766591770690",
      product_text: "It is the season of love, and snow lines the streets outside the toy store. Children are feasting their eyes on the delights inside while others make snow angels, pull each other on sleds, and make snowmen. Can you spot the festive pair on the doorstep?"
    },
    {
      product_name: "Orca Fun",
      product_id: "6819680616514",
      product_text: "Join the orca fun in this colorful underwater sea. Brimming with everything from coral and turtles to schools of fish, there’s something to see wherever you look."
    },
    {
      product_name: "Peaceful Tie Dye",
      product_id: "6819680256066",
      product_text: "The scales of this wide-eyed baby dragon are a kaleidoscope of pastel colors set against a backdrop of peaceful tie-dye patterns."
    },
    {
      product_name: "Ho Ho Ho",
      product_id: "6819692118082",
      product_text: "A close-up of a Christmas tea party, complete with cupcakes and cookies, is set against the backdrop of a cutely decorated Christmas tree. The words “Ho Ho Ho” can be seen as one of the many ornaments."
    },
    {
      product_name: "Wrapped with Love",
      product_id: "6766593278018",
      product_text: "In front of the Christmas tree, gifts are being wrapped with love by a pair of small hands. Two mischievous kittens are pretending to help the golden-haired girl as she works on tying a bow around a wrapped box."
    },
    {
      product_name: "A Magical View to Christmas",
      product_id: "6819692675138",
      product_text: "Full of bright, festive lights and presents piled high, this surely is a magical view of Christmas. Penguins march on the snow outside as a puppy is curled up by the roaring fire inside. There is warmth everywhere despite the blanket of snow."
    },
    {
      product_name: "Trip to the Toy Shop",
      product_id: "6819692838978",
      product_text: "In this trip to the toy shop, there’s more fun to be had outside in this Christmas scene. Loaded in the back of a red pickup parked out front are dozens of dogs wearing Christmas hats. Catch the kittens in the Christmas tree and the basket of puppies in the snow."
    },
    {
      product_name: "Christmas Gnome and Friends",
      product_id: "6819693101122",
      product_text: "This Christmas gnome and friends stand behind a presentation of gifts, from presents stacked high to candy canes and sweets. Smiling sweetly, these three friends emanate an air of gentle kindness and love."
    },
    {
      product_name: "Sweet Candy Apple",
      product_id: "6850029387842",
      product_text: "A modern-day Snow White stands before the magic mirror on the wall, holding a sweet candy apple and wearing a Rolling Stones t-shirt. The hats of the seven dwarfs can be seen surrounding her."
    },
    {
      product_name: "Starlight",
      product_id: "6850030075970",
      product_text: "With her waves of blue and purple hair and a panda bear earring dangling above her painted shoulder, Starlight poses in an off-the-shoulder top, her burgundy eyes the same color as her lips."
    },
    {
      product_name: "Autumn’s Gift",
      product_id: "6850029518914",
      product_text: "Wild meadow flowers bloom abundantly on the banks of a meandering lake, autumn’s gift offering a variety of deep crimsons and golds from the strong trees nearby."
    },
    {
      product_name: "Magic in the Moonlight",
      product_id: "6850029584450",
      product_text: "A miniature winged kitten looks down from its perch on an iris into the eyes of another cat, its golden green eyes glowing as brightly as magic in the moonlight."
    },
    {
      product_name: "Unicorn Mother and Foal",
      product_id: "6850030141506",
      product_text: "A unicorn mother and her foal are resting on a flower-filled meadow before a brick archway that leads to an ocean and a world beyond. Another young foal can be seen in the distance next to a small colony of rabbits."
    },
    {
      product_name: "It’s Party Time",
      product_id: "6850030370882",
      product_text: "It’s party time in the garden and everyone has come out to play. From pink to purple, peach to pastel, the blooms emit vibrancy and warmth."
    },
    {
      product_name: "Rainbow Dreams",
      product_id: "6850030436418",
      product_text: "In a colorful and childlike cartoon scene of rainbow dreams, a blonde girl dressed in rainbow clothing kneels next to a toy, bright streaks of colors and stars dotted around her."
    },
    {
      product_name: "Bear Salmon Fishing",
      product_id: "6850031190082",
      product_text: "In the rushing rapids of a river, a bear salmon fishing for his family tastes success. Three cubs and his mate watch on in this expansive wilderness."
    },
    {
      product_name: "Neon Love",
      product_id: "6850031124546",
      product_text: "This girl’s electric-green hair is accentuated by a similar colored background and softened by a rainbow hair clip and starry earrings. However, we know there’s a dark side to this neon love, as suggested by her black slip and arrows sticking out of her doll’s heart."
    },
    {
      product_name: "Blossom Falls",
      product_id: "6850031353922",
      product_text: "The rushing water cascades down an unseen waterfall, yet the spray sparkles high, mingling with the pink blossoms of trees that are thriving so close to the cliff edge. These blossom falls showcase the diverse beauty of nature."
    },
    {
      product_name: "Serene Emperor",
      product_id: "6850030633026",
      product_text: "This very realistic depiction of a white tiger profile features the same color background as this powerful beast's eye. This serene emperor gazes out with a calm, almost bored expression on his face."
    },
    {
      product_name: "Bohemian Bonita",
      product_id: "6850030927938",
      product_text: "A bohemian bonita with her rasta dreadlocks adorned with feathers and charms stands draped in a purple poncho and wearing a crescent moon necklace."
    },
    {
      product_name: "Kitty Love",
      product_id: "6850031386690",
      product_text: "A chubby-cheeked fairy girl in strawberry-pink braids is showing some kitty love by cuddling her black cat as it sits on her lap. Pink flowers and butterflies create a pleasant background."
    },
    {
      product_name: "Tiger from the Embers",
      product_id: "6850032336962",
      product_text: "A vicious-looking tiger from the embers emerges, snarling and baring its yellow teeth as fires behind it rage on. Its large feet and pointed claws are close and portray the true power and size of this beast."
    },
    {
      product_name: "Tulips Galore",
      product_id: "6850031517762",
      product_text: "Tulips galore are spilling out from the blue jar they’ve been placed in. Butterflies and other blue flowers are also present as the pink, yellow, and orange flowers are on display."
    },
    {
      product_name: "Lakeside View",
      product_id: "6850031812674",
      product_text: "Sitting inside a timber-built room, one can look out to enjoy this lakeside view. Homely items are dotted all around the space, including two cats, a dog, and a book on how to paint. Looks like someone has gone fishing for the day."
    },
    {
      product_name: "Flurry",
      product_id: "6850032173122",
      product_text: "Tiny winged baby unicorns are in a flurry over a woman, her eyes as striking as the markings on their backs. The woman herself has a horn coming from her head, encompassed by a kind of crown."
    },
    {
      product_name: "Dolphin Bay",
      product_id: "6850031550530",
      product_text: "As the sun sets at Dolphin Bay, these frisky marine mammals marry the worlds both above and below the water. Explore the shore’s edge and forest beyond and dive deep to where sea turtles play among the coral."
    },
    {
      product_name: "Ace of Alice",
      product_id: "6850032369730",
      product_text: "This playing card comes right out of a deck from a fairytale. The Ace of Alice features our wonderland heroine sitting atop a toadstool, with the eyes of the Cheshire cat and mad hatter glowing from either side."
    },
    {
      product_name: "Jewels of the Lake",
      product_id: "6850032500802",
      product_text: "Water lilies sit atop an inky blue as the jewels of the lake. Three dragonflies hover around the pink blooms, and more delicate flowers add further beauty and color."
    },
    {
      product_name: "Lost in the Right Direction",
      product_id: "6850032533570",
      product_text: "It feels good to be lost in the right direction. These wise and uplifting words are printed among brightly colored doodles set against a pleasing pattern of black and white triangles."
    },
    {
      product_name: "Unicorn Family",
      product_id: "6850032664642",
      product_text: "A unicorn family is prancing around a field bursting with blossoms. As the baby relaxes, flowers and fairies can be seen in the foreground, and a lake shimmers pink in the magical glow behind them."
    },
    {
      product_name: "Sweet Koala",
      product_id: "6850032926786",
      product_text: "A sweet koala is smiling in the branches of a tree, surrounded by wildflowers that are reaching up from the ground and blossoms coming down from above. A yellow and white butterfly hovers nearby."
    },
    {
      product_name: "A Moment in Time",
      product_id: "6850033254466",
      product_text: "It is a rare moment in time when a lake lies so smooth that the trees in the distance and the vibrant hues in the sky can be marveled at twice."
    },
    {
      product_name: "Queen of Hearts",
      product_id: "6850033418306",
      product_text: "The queen of hearts wears a crown atop a shock of red and white hair that has been scraped off her heavily painted face. A small white rabbit plays the trumpet in the crook of her arm as the queen’s red-gloved hands hold her perfect face."
    },
    {
      product_name: "Dahlia Dance",
      product_id: "6850033451074",
      product_text: "The distinct globes of perfectly curved petals create this gentle and soft dahlia dance. Two large flower heads stand out from a backdrop of blurred lines as the flowers seemingly frolic with one another."
    },
    {
      product_name: "Valentine Bridge",
      product_id: "6850034532418",
      product_text: "Behind a deep pink blossoming tree that is hanging over a smooth lake is the valentine bridge, the arch mirrored perfectly in the water to create a circle. Two swans touch heads to create a heart between them."
    },
    {
      product_name: "Lovegarden",
      product_id: "6850033713218",
      product_text: "A digitally enhanced lovegarden sits bright, where flowers bloom in the shape of hearts and butterflies flit in the bright summer’s day. Look hard and you’ll see a rainbow in the distance."
    },
    {
      product_name: "A Memorable Afternoon",
      product_id: "6850033549378",
      product_text: "A memorable afternoon is spent sitting in this sun-kissed coastal scene. There is tea for two atop a table surrounded by roses and two white wicker chairs."
    },
    {
      product_name: "True Love",
      product_id: "6850033320002",
      product_text: "True love may be within this girl’s grasp as a red and white-haired angel clasps a sparkling heart-shaped gem in her gloved hand. Her eyes are ruby-red, but another bright blue eye can be seen clipped in her hair."
    },
    {
      product_name: "Blooming Bonnet",
      product_id: "6850034171970",
      product_text: "A bouquet of blossoms creates this blooming bonnet atop the head of a sweet girl whose head rests comfortably in her hands. One eye is covered by a butterfly, the other shines a dazzling blue."
    },
    {
      product_name: "Fragility",
      product_id: "6850034303042",
      product_text: "There is fragility in a single rose as the petals slowly drip away into nothingness. The delicacy in this watercolor image is augmented by the bold choice of vivid pinks and yellows."
    },
    {
      product_name: "Purple Passion",
      product_id: "6850034827330",
      product_text: "Picked fresh from the garden and placed in a glass jar on a table is a bountiful selection of foliage and blooms – a moment of purple passion to be taken in and enjoyed."
    },
    {
      product_name: "Peacock’s Lagoon",
      product_id: "6850035056706",
      product_text: "Within this peacock’s lagoon which is hugged by tall trees and even taller mountains is a golden structure holding orbs of beautiful flowers. Two peacocks perch here in front of an otherworldly sky."
    },
    {
      product_name: "The Most Curious of Them All",
      product_id: "6850035318850",
      product_text: "Alice sits on top of a mushroom holding a cupcake that says ‘eat me.’ Is she the most curious of them all? The caterpillar and the Cheshire cat both want to know."
    },
    {
      product_name: "Midnight Call",
      product_id: "6850035777602",
      product_text: "As the clouds part to reveal the bright moon, a wolf stands on a stone in the middle of a river to make his midnight call. Two other wolves can be seen in the distance as eagles soar in the air of this natural wild scene."
    },
    {
      product_name: "One Love",
      product_id: "6850035482690",
      product_text: "There is but one love around the world, as this young girl with flowers in her hair knows. She wears a rainbow and hearts t-shirt and is standing before an image of the world with trees, flowers, mountains, and more all lying around it."
    },
    {
      product_name: "Best Friends",
      product_id: "6850035679298",
      product_text: "In this colorful and happy scene, these best friends – three kittens and a puppy – are happily sitting in a garden of wisteria and pansies as butterflies delight in their youthful desire to play."
    },
    {
      product_name: "Sunday Morning in Spring",
      product_id: "6877095395394",
      product_text: "It is Sunday morning in spring, and the villagers are flocking to the local church. Set in a romantic period of horse and cart, the houses are few but beautifully designed, and life in the village is plentiful."
    },
    {
      product_name: "Little Owl",
      product_id: "6850035843138",
      product_text: "A little owl sits on a branch outside his tree stump home, several round windows traveling up the stump glowing brightly. The teetering tree curves over a winding stream that is hugged by wildflowers."
    },
    {
      product_name: "Mystical King",
      product_id: "6877093658690",
      product_text: "A snow-white lion with piercing blue eyes is surely a mystical king from unknown places. This close and personal portrait shows exquisite detail, from his soft fur and mane to the imperfections on his nose."
    },
    {
      product_name: "Meet Me At The Diner",
      product_id: "6877094608962",
      product_text: "Blood-red pinned-up curls, held in place by a posy of purple flowers, are perched on the head of this luscious-lipped beauty. Her bright green eyes say, “come meet me at the diner,” which she stands in front of."
    },
    {
      product_name: "Have I Gone Mad",
      product_id: "6877094117442",
      product_text: "“Have I gone mad?” asks Alice as she stands before piles of teacups, clasping one of her own while cradling a small mouse in her other hand. The Mad Hatter’s hat rests upon her own head."
    },
    {
      product_name: "Stargazer",
      product_id: "6877094903874",
      product_text: "Beautiful deep pink daylilies have been picked and brought inside for every stargazer to enjoy. There are speckles on the petals and the stamens emerging haphazardly from the flowers, emphasizing the beauty in each bloom."
    },
    {
      product_name: "Family at The Jungle",
      product_id: "6877898276930",
      product_text: "A cascading waterfall far in the distance flows forward to reach the family at the jungle pool. These stately tigers and cubs relax around and in the pool as other jungle favorites add color and life."
    },
    {
      product_name: "Alice’s Bunnyguards",
      product_id: "6877898539074",
      product_text: "Alice’s bunnyguards are keeping a watchful eye over their blonde-haired master, their soft red eyes the same color as the roses that brighten this sepia scene."
    },
    {
      product_name: "Lakeside Paradise",
      product_id: "6877898801218",
      product_text: "Evening settles in at this lakeside paradise, where houses are dotted along the edge of the calm expanse of water. A stone footbridge rises over a narrow section of the lake, and a rowboat is anchored close by."
    },
    {
      product_name: "Butterfly Daisy Heart",
      product_id: "6877899128898",
      product_text: "A stunning canary-yellow butterfly sits peacefully in the middle of a blue heart. Daisies surround this and are superimposed on top of a purple flower pattern, forming a digitally enhanced butterfly daisy heart that delights."
    },
    {
      product_name: "It’s in the Detail",
      product_id: "6877899784258",
      product_text: "It’s in the detail of each dahlia petal that you can find perfection in the nature that is all around us. Every segment plays its part to create the perfect globe-like flower in every shade imaginable."
    },
    {
      product_name: "Wolf Wilderness",
      product_id: "6877900079170",
      product_text: "The snowy wolf wilderness is a cold and icy place, with ice cliffs rising high and the lights from above shining down on the frozen water below. A huge wolf’s head is superimposed in the sky with light shining strongly from behind it."
    },
    {
      product_name: "Waiting for Wonderland",
      product_id: "6877900406850",
      product_text: "Alice is waiting for wonderland, a key wrapped in the ribbons of her hair and the Cheshire cat smiling as he perches on her shoulder. She wears a blue puff-sleeve dress underneath an apron, as well as a choker necklace with a lock on the front."
    },
    {
      product_name: "Lady Luck",
      product_id: "6877900668994",
      product_text: "Wearing a national color of good luck, happiness, and success, this lady luck is dressed modestly in red Chinese attire and stands before a bold pattern of vibrant gold. Her dark hair and the backdrop make these colors pop even more."
    },
    {
      product_name: "Mystic Garden",
      product_id: "6877900931138",
      product_text: "Welcome to the mystic garden. A fountain splashes water into a man-made pool, before which lounge two white tigers. Two peacocks and other birds perch on a strange ornament ahead of steps that lead to the unknown."
    },
    {
      product_name: "Flora and Fable",
      product_id: "6877901226050",
      product_text: "Sitting in a field of flowers, a fairy sits and reads a book to a baby dragon, her deep purple eyes the same color as her hair. A scene of flora and fable transports you to an enchanting space."
    },
    {
      product_name: "Unicorn Keeper",
      product_id: "6881675444290",
      product_text: "The unicorn keeper holds her clawed fingers up to her mouth as she cradles a baby unicorn in her arms. She wears a unicorn crown and a spiked heart in her white hair. Her almond-shaped eyes are a soft, deep blue."
    },
    {
      product_name: "Wonderland Potion",
      product_id: "6877901488194",
      product_text: "Alice holds a teacup loosely in her hand, inside of which a wonderland potion can be seen. She holds a white rabbit close to her chest and wears another on a locket at her throat. Time is ticking by – does she have the key?"
    },
    {
      product_name: "Lion",
      product_id: "6877901062210",
      product_text: "A lion and a cub sit together in the forefront of this safari grassland. Flamingos mill nearby, as well as a lone giraffe and some antelope in the background. A snowy, flat-topped mountain stands in the distance."
    },
    {
      product_name: "Spring is Here",
      product_id: "6881675903042",
      product_text: "Can you see that spring is here from this bouquet of blooms simply bursting with color and life? Tulips in red, yellow, and pink are bunched together with daffodils and more in a beautiful display."
    },
    {
      product_name: "Spring Owlets",
      product_id: "6881676165186",
      product_text: "Two spring owlets look completely shocked as a couple of bright butterflies flit past their blossoming perch. Mother owl watches on from behind in this colorful and character-filled scene."
    },
    {
      product_name: "Magnolia Spring",
      product_id: "6881676394562",
      product_text: "An archway of blossoms guides you to a body of water, the magnolia spring a delight of strikingly bright pinks and deep, moody blues. A stand of trees can be seen on the other side of the water."
    },
    {
      product_name: "Pretty in Pastel",
      product_id: "6881676886082",
      product_text: "Dressed in a sage-green shirt and wearing soft pink roses in her hair, this brown-haired and freckled beauty is so pretty in pastel. The exquisite shading of the roses adds a depth that is only rivaled by the huge pools that are this woman’s eyes."
    },
    {
      product_name: "Sweet Dreams Candy Store",
      product_id: "6896268542018",
      product_text: "Glistening donuts, swirling candy and frosting covered cakes, ‘Candies Sweet Dreams Bakery’ is a treat to behold.  The air is filled with the smell of freshly baked goods, as sweet as sugar. Just in time for Valentine's Day."
    },
    {
      product_name: "Fat Cat",
      product_id: "6896268804162",
      product_text: "A dapper gentleman tabby gazes out from a perfectly perched monocle. He has not yet eaten the bird on his hat, because he knew it would accentuate his style. Emphasis on the ‘not yet’."
    },
    {
      product_name: "Flower Froggie",
      product_id: "6896269197378",
      product_text: "This psychedelic froggie is brimming with flower power. Intertwined with vines and floral blooms, this frog is at one with nature. Surrounding him are flashes of colour, that have attracted some curious dragonflies."
    },
    {
      product_name: "City of Wands",
      product_id: "6896267427906",
      product_text: "Hidden within a lush rainforest, is the City of Wands. Two knights, mounted on fearsome gilded dragons, guard the gates. The City’s golden turrets glisten into the sky and the air fizzes with magic."
    },
    {
      product_name: "Bunny Bouquet",
      product_id: "6881677475906",
      product_text: "This bunny bouquet is a springtime delight, with daffodils and daisies bundled together and three busy bunnies, all with purple bows around their necks. As they sit on an outside table, birds and butterflies come to join the fun."
    },
    {
      product_name: "Easter Cupcake",
      product_id: "6896268902466",
      product_text: "Framed by lush tulips and colourful Easter eggs, this cupcake looks good enough to eat. Topped with a swirl of frosting and sprinkles, this makes the perfect Easter treat."
    },
    {
      product_name: "Easter Egg Hunt",
      product_id: "6896269131842",
      product_text: "Follow the path from the cottage to the meadow. In-between the daffodils and the daisies, the crocuses and the violets, are bundles of sweet eggs. The blue birds and the butterflies have already found some."
    },
    {
      product_name: "One’s Enough",
      product_id: "6896269000770",
      product_text: "This adorable bundle of fluff is all you need. You found this friendly critter nestled beneath the floral table cloths. How did he get here? One bunny is enough."
    },
    {
      product_name: "City of Swords",
      product_id: "6896267526210",
      product_text: "High above the clouds, the City of Swords pierces the sky. Its heavenly turrets are crested with emblems of Pegasus. Soldiers mounted on these flying horses, guard the angelic realm of the City, weaving between clouds, doves and rainbows."
    },
    {
      product_name: "Rainbow Ranger",
      product_id: "6896267001922",
      product_text: "The rainbow ranger is technicoloured. He holds a rainbow studded guitar, which plays streaks of light into the atmosphere. Peace and love fills the air in electric bursts of colour."
    },
    {
      product_name: "Cosmic Tree of Life",
      product_id: "6896267100226",
      product_text: "At the gate of eternity, lie the roots of an ancient tree. It spirals into the heavens with green, blue and pink sparks. Its branches hold the secrets of life within its leaves."
    },
    {
      product_name: "Teddy Bear",
      product_id: "6896270671938",
      product_text: "Elegant, Rococo curls frame the face of this damsel. She wears a black ruffle dress and black bow. In her hair, she wears two teddy bear accessories. One bear is of the rain and the other is of the night."
    },
    {
      product_name: "1950s Hollywood Street",
      product_id: "6896268705858",
      product_text: "Everyone is inside listening to rock n’ roll while the Hollywood sign blooms on the hill behind. Two dogs wait patiently in the back of a truck, while the sun sets in the sky."
    },
    {
      product_name: "Ye Old Stitching Room",
      product_id: "6896268312642",
      product_text: "While away the hours between the yarn and the patchwork in this cosy stitching room. A fresh pot of tea is waiting for you. The cat is already purring in the corner, on this lazy afternoon."
    },
    {
      product_name: "World Thinker",
      product_id: "6896266707010",
      product_text: "A celestial figure gazes down from the heavens. He is peaceful and as his thoughts drift, small planets and hummingbirds orbit his mind. The Earth is at peace."
    },
    {
      product_name: "Kitten in a Mug",
      product_id: "6896269164610",
      product_text: "Well, some cats must like water! This curious kitten is cosied up inside a mug. She is surrounded by floral details and brilliant, bright colours. She is letting the stress melt away."
    },
    {
      product_name: "Lily",
      product_id: "6896268771394",
      product_text: "Lily is a southern belle and miniature schnauzer, confidently holding her fan in her paw. In her lace and pearl embroidered clothes, she’s a woman of style as well as class."
    },
    {
      product_name: "Humpty Dumpty Smile",
      product_id: "6896266969154",
      product_text: "Humpty Dumpty is smiling on top of his wall. The sun is a rainbow blaze. There is tea at hand and no falls to be had."
    },
    {
      product_name: "Cinderella’s Castle",
      product_id: "6896267231298",
      product_text: "The moon has just risen, as Cinderella’s carriage dashes through the castle gardens.  The cherry blossoms are singing their sweet scent into the night, yet all she can think of is the ball."
    },
    {
      product_name: "Autumn Church Frame",
      product_id: "6896267493442",
      product_text: "The last summer breeze is drifting in through this open window. It carries the scent of late blooms and the ring of church bells. The river rushes by and all is calm on this Sunday afternoon."
    },
    {
      product_name: "Koi Fish Puzzle",
      product_id: "6896268214338",
      product_text: "Koi drift elegantly by, in a shimmering blue pond, dotted with water lilies. Below the surface, a mirage of koi coalesce in white, red, copper and gold by the riverbed."
    },
    {
      product_name: "Wolf Shaman",
      product_id: "6896269328450",
      product_text: "Brilliant streaks of blue, pink and purple adorn this regal wolf. The details that decorate his face, belie his spiritual prowess. His eyes are watchful, almost as though he is gazing into your soul."
    },
    {
      product_name: "Secret Heart",
      product_id: "6896270573634",
      product_text: "On the Dias de los Meurtos, an undead beauty rises from the night. Her sugar skull makeup is still fresh on her face. A golden, clockwork heart beats on her chest. Alive once more."
    },
    {
      product_name: "Psychedelic Lion",
      product_id: "6896266936386",
      product_text: "Above the Earth, a miracle of light is blossoming. From the crystals of the aurora borealis, a lion gazes out into the galaxy."
    },
    {
      product_name: "Magical Moment in Time",
      product_id: "6896267460674",
      product_text: "Allow the hours to slip away, in this tropical paradise. Two gleaming white tigers dwell in this galactic jungle. Ripe mangoes hang from green canopies, above a pool of golden koi. The sun rises below the temple clock, which beats to the turn of the stars."
    },
    {
      product_name: "Mason",
      product_id: "6896269361218",
      product_text: "A refined Labrador, with a coat of gold, Mason is a charming young dog. He wears a dashing coat with gold buttons, a matching top hat and cane. Perfect for an up-and-coming gentleman such as he."
    },
    {
      product_name: "Let Them Eat Cake",
      product_id: "6896269885506",
      product_text: "The lady Marie Antoinette, poses for a royal portrait. Her sweeping white gown and signature white hair are decorated with roses and a swallow.  The sky behind her is ominous and her cake, might just be filled with poison."
    },
    {
      product_name: "Bike Sunset",
      product_id: "6896268738626",
      product_text: "Soak up the last of the pastel sky, as the sunsets over this carefree scene. A blue bike waits among sand and seashells. Inside a Labrador puppy, peeks out from freshly cut flowers, waiting for the ride home."
    },
    {
      product_name: "The Palace",
      product_id: "6896269099074",
      product_text: "The bells of Big Ben are chiming, as the London fog creeps over Westminster. The streets light up with red double-decker buses and pedestrians walking home in the rain."
    },
    {
      product_name: "Fall Fairy",
      product_id: "6896267132994",
      product_text: "The summer has faded, and the Fall fairy must turn the colours of the leaves. Her magic transforms green into a flurry of amber and gold. Hidden between the trees and toadstools, tiny fairies watch her work."
    },
    {
      product_name: "Tiki Beach Sunset",
      product_id: "6896268640322",
      product_text: "The sun is just setting on this beach front paradise. The day has drifted away, but the Tiki bar is awash with lanterns. A tropical aquarium bubbles away, and a ukulele waits to be played. Stay for a while, the piña colada is on the house."
    },
    {
      product_name: "Supernova",
      product_id: "6896269262914",
      product_text: "Beautiful rays of light, beam out from the sun’s smiling face. They reach out across the galaxy in celestial bursts of colour, illuminating the planets, stars and moons."
    },
    {
      product_name: "The Conservatory",
      product_id: "6896267690050",
      product_text: "The sweet mountain air drifts in through the open conservatory doors. From the English walled garden, the fountain is trickling gently. There are colourful blooms collecting in the flower beds. Enjoy the spring glory, with a fresh cup of tea."
    },
    {
      product_name: "Bird House Garden",
      product_id: "6896268083266",
      product_text: "In a flurry of feathers, a flock of birds rest on multicoloured bird houses. Bumblebees buzz lazily by in this vibrant garden, while the birds chatter amongst themselves."
    },
    {
      product_name: "Ashley",
      product_id: "6896268869698",
      product_text: "Her royal highness, Princess Ashley, is first in line for the throne. Her tiara and her gown are still a little too big for her, but she already has the grace of a princess."
    },
    {
      product_name: "Clora",
      product_id: "6896269623362",
      product_text: "Clora’s gothic style turns the world on its head. Her long grey hair, frames her youthful face and her striking spider-webbed gown features an eerie brooch, filled with sharp teeth."
    },
    {
      product_name: "Moonlight Magic",
      product_id: "6909572284482",
      product_text: "The moon shines a mystical haze over this fantasy oasis, bathing everything in lilac. A beautiful pegasus with dragonfly wings bathes in the soothing waters between an abundance of flowers and butterflies."
    },
    {
      product_name: "Insane in the Membrane",
      product_id: "6909573234754",
      product_text: "Springing out of a psychedelic dream, this vibrant puppy is a kaleidoscope of colors. From its serene blue eyes to its fluffy coat, this pup is a spirit of the rainbow in green, yellow, orange, pink, purple, and blue."
    },
    {
      product_name: "Rose Fairy",
      product_id: "6909576872002",
      product_text: "A lady of the roses, this dignified fairy brings the petals of the garden to life. Each bloom is embroidered in her beautiful pink ball gown. She fills the air with her magic, which sparkles in her eyes."
    },
    {
      product_name: "Kim’s Garden",
      product_id: "6909577134146",
      product_text: "Take a moment to rest beside the flowers. Leave the world behind the garden walls and nestle down between the roses and the snapdragons. The air is filled with a sweet scent, and this cozy bench is the perfect reading nook."
    },
    {
      product_name: "Summer in Tuscany",
      product_id: "6909577363522",
      product_text: "Dazzling heat and fine Italian cuisine await you in this Tuscan holiday dream. Enjoy a glass of wine and good conversation, al fresco, at this charming restaurant overlooking the rolling countryside."
    },
    {
      product_name: "Hummingbird Pink",
      product_id: "6909577887810",
      product_text: "A green hummingbird stumbles upon a bundle of pink columbines. The petals are delicate and touched with a sweet fragrance that fills the air. The spring morning is brimming with bird song and sunlight."
    },
    {
      product_name: "Spring at The Cabin",
      product_id: "6909577986114",
      product_text: "Deep in the woods, smoke rises from the chimney of a cozy cabin. Over the brook beneath the trees, a host of animal friends welcome in the spring. The fawn gazes out at the woods while the others stop to smell the flowers."
    },
    {
      product_name: "Aunt Teaks Antique Store",
      product_id: "6909573988418",
      product_text: "Anything you can imagine, you can find at Aunt Teak’s antique store – vintage teapots, odds and ends, cozy cushions, and rocking chairs. Each item has a story to tell, and Aunt Teak knows them all, so come on in and stay a while."
    },
    {
      product_name: "Emanate",
      product_id: "6896269721666",
      product_text: "Dazzling beneath the waves, a shimmering mermaid sings softly through the night. Her turquoise and chestnut hair, is dotted with pearls. Her narwhal friends keep her company in the dark."
    },
    {
      product_name: "Zang Tigers",
      product_id: "6909577560130",
      product_text: "A powerful mother tiger rests on a canyon cliff. Towering mountains stretch into the sky behind her. An eagle screeches into the wind. The mother’s tiny cubs play around her, unaware of the natural wonders behind them."
    },
    {
      product_name: "Psychedelic Sea Turtle",
      product_id: "6896269295682",
      product_text: "This psychedelic sea turtle, is drifting without a care in the world between the coral and the angelfish. His kaleidoscopic colours, radiate out from the blue ocean."
    },
    {
      product_name: "Firebird Panorama",
      product_id: "6896268378178",
      product_text: "In this ancient temple, the Firebird spreads its wings of flames and ignites the scene. Between the opulent gold ornaments, peacocks wait patiently by its side, preventing two knights from combat."
    },
    {
      product_name: "Majestic Mansion",
      product_id: "6909572218946",
      product_text: "Get away from it all in this beautiful mansion. The wide acres of well-groomed gardens have bloomed just in time for spring. It truly is the perfect escape to the countryside among all the butterflies, flowers, and hedgerows."
    },
    {
      product_name: "Aloha",
      product_id: "6909574578242",
      product_text: "This island beauty is a picture of serenity in the tropical jungle. Her hair is adorned with flowers, and garland blooms decorate her neck and wrists. Her grass skirt blows in the paradise breeze as blue and green parrots chirp around her, welcoming the last of the evening sun."
    },
    {
      product_name: "Out of this World",
      product_id: "6909573857346",
      product_text: "Join this adventurous astronaut in the depths of space. There is no need for gravity. Float by in the brilliant blue and purple glow of the stars – there are galaxies out there waiting for you."
    },
    {
      product_name: "Villa Angelica",
      product_id: "6909574611010",
      product_text: "While away a sunny afternoon relaxing on this plush velvet chaise lounge. Before you is exquisite Renaissance artwork adorning the cloister. In the distance are the equally picturesque hills of the Tuscan countryside."
    },
    {
      product_name: "Magical Community Garden",
      product_id: "6909574774850",
      product_text: "Between their rainbow-colored houses, the villagers work joyfully to grow their garden. Up the hill to the orange tree are patches of carrots, potatoes, and wheat. Love and friendship are the magic of the garden."
    },
    {
      product_name: "Ember",
      product_id: "6896269754434",
      product_text: "This mysterious girl, in a black lace gown, doesn’t seem quite human. Her copper hair, weaves into the vines and thorns of the roses.  They seem to come to life too, must be her magic."
    },
    {
      product_name: "Tree of Wisdom",
      product_id: "6909574938690",
      product_text: "On a lone hill, piercing into the blue sky, stands the Tree of Wisdom. Persevering through the centuries, you can’t help but wonder what secrets it must know. Listen closely – you might hear them in the whispers of the leaves."
    },
    {
      product_name: "Coral Reef Island",
      product_id: "6909577429058",
      product_text: "This rainbow coral reef is teeming with life. Swim through the warm ocean with shoals of tropical fish. Explore the treasure of a sunken shipwreck with friendly dolphins. There is a whole world to explore under the sea."
    },
    {
      product_name: "Wizards Workshop",
      product_id: "6896268443714",
      product_text: "Something is brewing between the relics and spell books in the Wizard’s workshop. Fire shoots from a container and blends with a shock of lightning that has unsettled the owl. The cat sleeps, none the wiser, until his master’s return."
    },
    {
      product_name: "Fairy Song",
      product_id: "6909577003074",
      product_text: "This beautiful nymph plays her flute to beckon the sun from the night. The sweet, unearthly music fills the fresh morning air. The notes awaken the flowers and the trees before this fairy must take flight."
    },
    {
      product_name: "Bluebirds of Summer",
      product_id: "6909577658434",
      product_text: "Dappled sunlight washes over this charming summer scene. Two bluebirds rest atop echinacea flowers, surrounded by forget-me-nots. They are mesmerized by the vitality that summer brings to the garden."
    },
    {
      product_name: "Canada Cupcakes",
      product_id: "6929789419586",
      product_text: "Celebrate Canada day with these patriotic cupcakes. Topped with mini Canadian flags and bursting with national pride in red and white, these sweet treats will make everyone’s day at this year's local Canada day celebrations."
    },
    {
      product_name: "Happy Canada Day",
      product_id: "6929789255746",
      product_text: "O Canada! Our home and native land! As the Canada Day festival comes to an end, fireworks erupt through the sky. Beneath it all, a family of patriotic Canadians gazes up at the sun setting over their homeland."
    },
    {
      product_name: "Scenic Steamer",
      product_id: "6909574479938",
      product_text: "Watch the world go by from the carriage of this charming old steam train. As it chugs through the winding countryside, smoke billows into the sky. It travels by the mountains, over a quaint brook, and past the woodland critters through the trees."
    },
    {
      product_name: "Extinct",
      product_id: "6896269787202",
      product_text: "This figure’s billowing purple gown and cascading hair, blows through the winds of time. A young triceratops rests in her lap. Time has warped and history has opened."
    },
    {
      product_name: "Time to Relax",
      product_id: "6909573169218",
      product_text: "This pocket of serenity is the perfect place to relax and unwind. The woodland cabin is surrounded by blooming spring flowers, birds, butterflies, and newborn bunnies. Dance over the stepping stones and let the world slip away."
    },
    {
      product_name: "Blueberry Lunch",
      product_id: "6909574709314",
      product_text: "Hidden between the lush leaves of their woodland home, the tiniest bunnies share ripe blueberries with their field mouse friends. The berries are tart and sweet like candy. Moments of joy are best shared with furry friends."
    },
    {
      product_name: "A Peaceful Celebration",
      product_id: "6909572907074",
      product_text: "Color fills the sky on this Fourth of July night. Hues of red, white, and blue reflect on the serene waters of the lake. Above, the Stars and Stripes flag waves proudly, symbolizing the spirit of the United States."
    },
    {
      product_name: "Old Town USA",
      product_id: "6929789059138",
      product_text: "The town is lined with red, white, and blue in this darling old-time scene. Stars and Stripes flags pepper the cobbled streets filled with charming stores, where the townsfolk prepare for the big day ahead."
    },
    {
      product_name: "Sunrise Salute",
      product_id: "6929789583426",
      product_text: "Three brave soldiers stand to attention as the sun rises over the proud and free American nation. Everything they serve to protect stretches out before them. Above them, the mirage of a Stars and Stripes flag fills the sky with red, white, and blue."
    },
    {
      product_name: "Fourth Family",
      product_id: "6929790107714",
      product_text: "Perched by the bandstand under the firework-filled sky is a family of patriotic critters. Puppies, kittens, a hamster, and a budgie make up this unlikely group of Fourth of July friends – a reminder that the land of the free is a home for everyone."
    },
    {
      product_name: "Colorful Amsterdam",
      product_id: "6909574807618",
      product_text: "The streets of Amsterdam explode with color in this technicolor scene. The rooftops vibrate with sparks of yellow, pink, and blue. Behind the rainbow buildings, the sun sets in an orange frenzy, lighting the sky and the canal on fire."
    },
    {
      product_name: "Iris",
      product_id: "6896269852738",
      product_text: "Iris is a striking young witch, with untold powers. She waits, with her familiar Star, for the moon to rise. Secrets of the night, blow through her hair, magic is about to begin."
    },
    {
      product_name: "Oh, Wise One",
      product_id: "6909573300290",
      product_text: "The mysteries of the universe unfold in the piercing amber gaze of the owl. This wise spirit exudes a glowing pink, purple, and blue aura. Its feathers flicker with sacred flames from the other realm."
    },
    {
      product_name: "The Cabin in the Woods",
      product_id: "6909577756738",
      product_text: "Between the fall leaves, a family of birds prepares for winter. A cabin birdhouse, hand-built with care, provides the bluebirds, great tits, and cardinals with shelter from the cold."
    },
    {
      product_name: "Headlights on the Lake",
      product_id: "6909573922882",
      product_text: "Nothing is more enticing than the rustic charm of a simple life in the great outdoors. Life here is slow, and you can enjoy the sweeping scenery of the forest filled with wildlife and the blue waters of the lake. A rugged truck has stopped by to enjoy this vision of bliss."
    },
    {
      product_name: "Amusing",
      product_id: "6909575823426",
      product_text: "A beautiful ice queen stands tall in the snow-covered palace gardens. Embellished in midnight blue, she wears a billowing ball gown and a top hat with steampunk gears. Between the folds of her dress is a carousel that sings softly with music."
    },
    {
      product_name: "Wings of Wonder",
      product_id: "6909573201986",
      product_text: "Somewhere over the rainbow is a dazzling meadow filled with pink flowers and quartz crystals. This is the home of a beautiful pegasus. With its shining coat and monarch butterfly wings, it can fly faster than any bird."
    },
    {
      product_name: "A Different View",
      product_id: "6909577068610",
      product_text: "Enjoy the view of the rolling Tuscan countryside from this cozy balcony. Fresh wine and cheese have been brought over from the farmhouse. It’s time to enjoy lunch in the sunshine with friends."
    },
    {
      product_name: "Pink Valenstein",
      product_id: "6896270475330",
      product_text: "Pink Valenstein is love struck. As soon as she came to life, she knew she had to find her love. Deep in the woods, the sky is turning pink, and she must wait for Frankenstein to arrive."
    },
    {
      product_name: "Morning Walk",
      product_id: "6909574381634",
      product_text: "A couple walks hand in hand along a romantic, winding road. Beside them, the sun is rising behind the cliffs over crashing waves. It fills the sky with golden light. Love is in the air and home is just a moment away."
    },
    {
      product_name: "Glowing Snow Leopard",
      product_id: "6909573529666",
      product_text: "Embodying fire and ice, this majestic snow leopard is fierce yet cool and collected. Its fur flickers with glacial tones yet sparks with embers. Its eyes reflect this dual power, one an icy blue and the other a fiery red."
    },
    {
      product_name: "Garden Flower Monarchs",
      product_id: "6909577920578",
      product_text: "Within this sage-green garden, two monarch butterflies nestle among the flowers. They have landed on two purple echinacea to take a drink. Around them, snapdragons and forget-me-nots brim with life."
    },
    {
      product_name: "The Edge of Fantasy",
      product_id: "6909573136450",
      product_text: "Take in the sea air and the scent of forest leaves to the sound of the sea crashing. The sunset washes over the rugged coastline as the lighthouse guides a newly sailed ship over the sea. There are new beginnings in sight."
    },
    {
      product_name: "Theodore",
      product_id: "6909577166914",
      product_text: "The perfect sailing pal, Theodore loves the sea. This sweet-natured teddy waits patiently in a baby blue living room with his toy boat, ready for his next trip."
    },
    {
      product_name: "Clouded Yin Yang",
      product_id: "6909573726274",
      product_text: "High in the atmosphere, celestial powers convene in rich purple and blue hues. Billowing clouds flood the starlit sky. These opposite yet interconnected forces create balance in the chaos of the universe."
    },
    {
      product_name: "Dragonfly Kiss",
      product_id: "6909576937538",
      product_text: "The fairy of the forest lights up with joy. Through the leaves and dappled sunlight is a visitor. She greets her dragonfly friend with a kiss – it has been far too long."
    },
    {
      product_name: "Dragonfly Kiss",
      product_id: "6943517671490",
      product_text: "Nestled deep within a snowy forest, is your own festive holiday cottage. Like a life-sized gingerbread house, this Christmas cottage is covered in snow. Outside the warm glow of fairy lights, carefully wrapped around the forest trees, welcome reindeer and snowmen friends home for the holidays."
    },
    {
      product_name: "Ye Old Christmas Shoppe",
      product_id: "6943519342658",
      product_text: "Step inside this cosy Christmas Shop, brimming with holiday ornaments and trinkets. The air is filled with cinnamon as you enter and a Christmas puppy comes to greet you. The shelves are adorned with nutcrackers and garlands, teddy bears and toy trains, there are many surprises to be found."
    },
    {
      product_name: "Santa’s Secret",
      product_id: "6943520653378",
      product_text: "Shhhhh! Santa Claus has just arrived. It’s Christmas Eve and he’s delivering beautifully wrapped gifts to children far and wide. New toys overflow from Santa’s sack; teddy bears, toy drums, soldiers and trains, bringing smiles to children’s faces on Christmas morning."
    },
    {
      product_name: "White Christmas",
      product_id: "6943521308738",
      product_text: "An abundance of gifts are waiting for you on this pristine Christmas morning. Gather round the roaring fire, and share the Christmas cheer with family and loved ones. Decorated with gold ornaments and green garlands, Christmas spirit radiates from every corner of this elegant, white home."
    },
    {
      product_name: "Snowman and Birds",
      product_id: "6943522160706",
      product_text: "Bathed in the glow of a flickering streetlight, a smiling snowman waits for Santa Claus to arrive. His bird friends keep him company, perched on his outstretched arms and on perfect bird houses beside him. This winter snowman is surrounded by joy and friendship on Christmas Eve."
    },
    {
      product_name: "Christmas Parade",
      product_id: "6943522717762",
      product_text: "Dashing through the snow, Santa’s sleigh races through a winter wonderland. Join this jolly old fellow and his team of reindeer as they deliver gifts to the children of the world. As they race by, the crisp night air is filled with the sound of jingle bells, captivating the hearts of woodland creatures."
    },
    {
      product_name: "Mountain View",
      product_id: "6909574447170",
      product_text: "A charming cottage nestled in the midst of majestic mountains stands as a haven of tranquility. Adorned with blooming flowers, exudes a rustic charm that perfectly complements the natural beauty of the surrounding landscape. Such a breathtaking view that reminds us of the beauty and serenity found in the heart of nature."
    },
    {
      product_name: "Floral La Femme",
      product_id: "6909575004226",
      product_text: "A mesmerizing blend of artistry and nature unveils a woman of exquisite grace. Her elegant gown crafted entirely from a rich tapestry of flowers, captures a harmonious fusion of human grace and the wonders of nature, evoking a sense of wonder and appreciation for the artistic beauty that can be found in both the cultivated and wild realms."
    },
    {
      product_name: "Purple Princess",
      product_id: "6909577035842",
      product_text: "In a distant purple world, there lived a majestic Purple Princess. Her unrivaled style radiated a distinctive charm that set her apart. As she left her mark on the realm with style, step into her mesmerizing domain and let her royal purple tones enchant your heart."
    },
    {
      product_name: "Aegean Sea",
      product_id: "6909577265218",
      product_text: "In the heart of the village, the streets wind between charming white buildings adorned with splashes of cobalt blue. Sit, enjoy a glass of wine, and observe the beauty of the Aegean Sea, where every wave whispers tales of ancient myths and distant adventures."
    },
    {
      product_name: "Viola",
      product_id: "6896270803010",
      product_text: "Viola embodies both the allure of the arcane and the enigma of hidden depths. She wears a dramatic witch hat that casts a shadow over her expressive eyes, and a feline companion perched on her neck hinting at her arcane powers and mystique. Her ombre hair, transitioned seamlessly from shades of purple at the roots to vivid blues that dance like ethereal flames toward the tips, adding to the aura of enchantment and intrigue."
    },
    {
      product_name: "Autumn Treasures",
      product_id: "6909572644930",
      product_text: "A charming farm scene adorned with a weathered wooden cart brimming with pumpkins, a cascade of fall leaves, and delicate wildflowers. A symphony of warm hues captures the essence of the season's bountiful embrace."
    },
    {
      product_name: "Whitetail Dawn",
      product_id: "6909577822274",
      product_text: "Surrounded by a lush and serene forest, two deer gazes ahead with a mix of curiosity and caution, their senses attuned to every rustle and whisper of the wilderness. Dew-kissed grasses and fallen leaves beneath its hooves bear witness to the quiet beauty of the dawn."
    },
    {
      product_name: "Route 66",
      product_id: "6909574873154",
      product_text: "A scene straight out of yesteryears unfolds, offering a captivating glimpse into the past. The iconic Route 66, a highway that once symbolized the promise of cross-country adventure, becomes a canvas for the vivid hues of history."
    },
    {
      product_name: "The Special Gift",
      product_id: "6943528714306",
      product_text: "Step into the enchanting world of Santa's workspace, where holiday wonders come to life. As Santa continues his work, one can almost hear the distant jingle of bells and the soft padding of reindeer hooves. The anticipation of Christmas Eve hangs in the air, and the reindeer toy begins to embody not only Santa's artistry but also the spirit of giving, wonder, and the joy of the holiday season."
    },
    {
      product_name: "Holiday Treasures",
      product_id: "6943529467970",
      product_text: "A beautiful moment of seasonal delights, showcasing an array of twinkling lights, ornate ornaments, and whimsical decorations. Each item seems to have a story to tell, and even from the other side of the glass, the cozy ambiance radiates joy and comfort, making it an irresistible haven for all who pass by."
    },
    {
      product_name: "Reindeer Lights",
      product_id: "6943530352706",
      product_text: "A majestic reindeer adorned with a breathtaking display of glowing lights. Against the backdrop of the night, the reindeer's form is outlined in a mesmerizing dance of colors, evoking a sense of enchantment and holiday magic."
    },
    {
      product_name: "Winter Gathering",
      product_id: "6943527665730",
      product_text: "In the heart of a winter wonderland, a heartwarming scene unfolds—a gathering of Santa Claus and his forest friends amidst a pristine blanket of snow, embodying the essence of companionship, kindness, and the joy of shared moments."
    },
    {
      product_name: "Back to School",
      product_id: "6939420786754",
      product_text: "A lively tableau of kids with their furry friends gazes at the window of a back-to-school supplies store with fascination. The glass becomes a canvas, offering a glimpse into a world where anticipation, wonder, and youthful curiosity merge in a symphony of vibrant energy."
    },
    {
      product_name: "Springtime Hideaway",
      product_id: "6939423375426",
      product_text: "A tranquil springtime hideaway where nature takes center stage. A symphony of colors, textures, and fragrances dances through the air. As the sun's gentle rays kiss the earth, the garden becomes a canvas of life, where every corner blooms with the promise of renewal and growth."
    },
    {
      product_name: "Ahyoka",
      product_id: "6939563491394",
      product_text: "A soft embrace of natural light casts a gentle glow on Ahyoka and her furry friend. The leaves filter the sunlight, creating a play of shadows that dance across their forms, adding an almost ethereal quality to their interaction."
    },
    {
      product_name: "Charlie",
      product_id: "6939571290178",
      product_text: "Surrounded by a profusion of flowers in various shades of pink, green, and purple hues, Charlie becomes a part of the symphony of color and life. The blossoms seem to dance with delight as they frame his antics, creating a scene brimming with springtime charm."
    },
    {
      product_name: "Pink Mushroom Cottage",
      product_id: "6939585052738",
      product_text: "Nestled among a forest of towering trees, this charming abode stands as an enchanting testament to the whimsy of the natural world. Resembling a giant pink mushroom beckons all who stumble upon it to enter a realm of fairy tales and dreams."
    },
    {
      product_name: "Wild World",
      product_id: "6939557953602",
      product_text: "A vibrant world where the wild and the delicate coexist in perfect harmony. Against a backdrop of lush foliage and blossoms, a diverse cast of wild animals emerges from their natural habitat, creating a mesmerizing tableau of life and color."
    },
    {
      product_name: "Sea Turtle",
      product_id: "6939587477570",
      product_text: "An enchanting journey into the ethereal world where the ocean and nature's beauty converge. At its heart, a majestic sea turtle emerges from the depths, carrying a woman who seems to ride the waves of the ocean and the currents of her imagination."
    },
    {
      product_name: "Spirit of a Lion",
      product_id: "6939580072002",
      product_text: "The king of the savannah—in a kaleidoscope of vivid hues. Its majestic mane, thick and luxurious, frames its noble face, which is adorned with piercing eyes that seem to hold the wisdom of ages."
    },
    {
      product_name: "Claudia",
      product_id: "6896269426754",
      product_text: "A mix of longing and melancholy, as if caught between the innocence of her past and the vampiric existence she now embraces. The juxtaposition of the teddy bear and the glass of blood encapsulates the complexity of Claudia’s character –a haunting blend of beauty and the supernatural."
    },
    {
      product_name: "Stairway to Serenity",
      product_id: "6909573103682",
      product_text: "A flight of sturdy stone stairs adorned with a vibrant tapestry of flowers unfolds before your eyes, leading you on a delightful journey. Each step is a visual treat, as colorful blooms cascade gracefully, draping the edges of the steps like a floral waterfall."
    },
    {
      product_name: "Everything’s Better With Ice Cream",
      product_id: "6939415314498",
      product_text: "A charming ice cream cart adorned with bright, pastel colors, stands on a sandy beach serving a delightful assortment of ice cream cones, cups, and popsicles. A scene of pure joy and summertime happiness, capturing the essence of a perfect sunny day filled with sweet moments and childhood wonder."
    },
    {
      product_name: "Balloons Over Cottage Cove",
      product_id: "6939424063554",
      product_text: "A breathtaking coastal scene where a majestic fleet of hot air balloons takes flight. Each balloon is a radiant burst of color against the sky, showcasing a variety of designs and patterns. They rise gracefully into the air, creating a captivating contrast with the tranquil seascape below."
    },
    {
      product_name: "Gnome Home Glow",
      product_id: "6939580825666",
      product_text: "A tranquil beauty of the gnome's abode. A place where the whimsy of the forest blends seamlessly with the charm of pastel colors, creating a delightful and inviting home for its gnome inhabitants."
    },
    {
      product_name: "Rainbow Dragon",
      product_id: "6939587969090",
      product_text: "A majestic dragon, resplendent in its iridescent glory. Its scales are like glistening gemstones, each one capturing a different color of the rainbow. As the light plays upon them, they emit a radiant and prismatic display, evoking a sense of wonder and magic."
    },
    {
      product_name: "Buca Di Francesco",
      product_id: "6939573026882",
      product_text: "The colorful flowers, the tranquil canal, and the inviting restaurant setting encapsulate the essence of Assisi's beauty and the rich culinary traditions of Italy. A place where nature and gastronomy converge to create an unforgettable dining experience."
    },
    {
      product_name: "Petra",
      product_id: "6939567423554",
      product_text: "Petra is depicted in a regal pose. Its plumage is a breathtaking fusion of vivid colors that create a mesmerizing scene capturing the essence of the bird's natural beauty and radiating a sense of vibrancy and life."
    },
    {
      product_name: "Silent Night",
      product_id: "6943525404738",
      product_text: "Amidst the tranquil embrace of a pristine winter's day, a quaint chapel emerges as a beacon of solace and hope. Nestled within a majestic grove of snow-capped trees, this sacred haven stands as a testament to unwavering faith and the enduring splendor of the natural world."
    },
    {
      product_name: "Welcome To Christmas",
      product_id: "6943526158402",
      product_text: "A tranquil Christmas scene near the lighthouse, where the world is hushed, and hearts are aglow with the magic of the holiday season. A moment of serene beauty and timeless joy, where the spirit of Christmas envelops all who behold it, reminding them of the boundless love and goodwill that this special time of year brings."
    },
    {
      product_name: "Dogs Watching Santa",
      product_id: "6943526748226",
      product_text: "High in the night sky, Santa Claus is depicted in his white suit, driving his sleigh filled with gifts. A beautiful moment that fills our furry companions with wonder as they watch Santa and his reindeer on their magical journey mirroring the delight and excitement that fills our hearts during the holiday season."
    },
    {
      product_name: "Christmas Mailbox",
      product_id: "6943527239746",
      product_text: "A timeless beauty and nostalgic charm of a winter's day during the Christmas season, where the mansion and its Christmas mailbox are adorned with vibrant red bows and a lush evergreen tree entwined with shimmering fairy lights, embodying the warmth, love, and festive excitement that this holiday season brings."
    },
    {
      product_name: "Our Madness",
      product_id: "6896270377026",
      product_text: "Dive into the world of whimsical madness, where Alice takes a wild journey alongside her enigmatic companion, the Purple Cheshire Cat. Get ready to unravel the secrets of Wonderland and embrace the magic that lies beyond the looking glass."
    },
    {
      product_name: "Dream Home",
      product_id: "6939588264002",
      product_text: "Step into the magical allure of this breathtaking house nestled deep within the forest and let your imagination take flight. Captivating, whimsical, and straight out of a storybook, this hidden gem is sure to leave you spellbound. Dare to dream and get lost in the wonder of it all."
    },
    {
      product_name: "October Skies",
      product_id: "6909572939842",
      product_text: "A splendid autumn day where a magnificent mansion becomes a picturesque backdrop to a delightful display of pumpkins and the vibrant beauty of fall flowers, creating a scene of warmth, charm, and seasonal wonder."
    },
    {
      product_name: "A Mother’s Love",
      product_id: "6939408924738",
      product_text: "A heartwarming scene of a charming little girl and her feline companion at the edge of a serene, flower-fringed pond. Captivated by the beauty of nature, they watch a family of ducks with unbridled delight as they glide gracefully across the water's surface."
    },
    {
      product_name: "Spooky Sunset",
      product_id: "6961283792962",
      product_text: "In the eerie glow of a spooky sunset, the sky is ablaze with fiery hues of deep orange and purple. A rusty, weathered truck sits abandoned in a field adorned with a cluster of sunflowers and pumpkins. Some are carved into eerie Jack-o'-lanterns, their wicked grins flickering with candles from within, while others remain untouched, waiting to be transformed into spooky decorations."
    },
    {
      product_name: "A Spooky Night",
      product_id: "6960054829122",
      product_text: "A foreboding sense of dread permeates the air as a spooky house looms in the distance, casting eerie shadows in the chilling breeze. Tombstones, weathered and crooked, jut out of the ground like jagged teeth, bearing the names of long-forgotten souls. The night is alive with the whispers of the unknown, a place where fear and mystery intertwine, and where the line between the living and the spectral blurs."
    },
    {
      product_name: "Eeries Coven",
      product_id: "6960029859906",
      product_text: "A whimsical and enchanting tableau of a mysterious witch, dressed in a traditional black pointed hat and elegant ball gown. Surrounded by a circle of luminescent jack-o'-lanterns, their carved faces illuminated by flickering candlelight. Each pumpkin seems to possess a unique personality, with grinning, sinister, or goofy expressions, casting eerie and playful shadows with the deep, inky darkness of the night."
    },
    {
      product_name: "Haunted Farmyard",
      product_id: "6961283268674",
      product_text: "In the moonlight's eerie glow, a Haunted Farmyard comes to life, shrouded in an aura of unsettling mystery. An old, weather-beaten farmhouse where windows emit a ghostly glow. The farmyard is silent, save for the occasional creaking of the dilapidated structures and the distant hoot of an owl, as if the very air is charged with the weight of forgotten memories and restless spirits."
    },
    {
      product_name: "Little Tricksters",
      product_id: "6961289920578",
      product_text: "A bewitching autumn night, where the realms of reality and fantasy intertwine. This feline trickster dons a pointed witch's hat, adding an element of whimsy to its mysterious presence beside a vigilant crow fixated on something in the distance, casting an aura of curiosity and foreboding over the scene."
    },
    {
      product_name: "Trick or Treating",
      product_id: "6960059613250",
      product_text: "In a quaint suburban neighborhood, under the shadow of the harvest moon, each furry trick-or-treater holds a miniature trick-or-treat bucket ready to collect some Halloween treats. A perfect fall night filled with warm, festive feeling, capturing the joy and magic of Halloween night in a world where even our furry friends get to join in the fun."
    },
    {
      product_name: "Moonlight Stroll",
      product_id: "6961269342274",
      product_text: "Get lost in the mesmerizing beauty of Moonlight Stroll. Against a backdrop of moonlight hues, her enigmatic figure strides through an ethereal setting, immersing us in a realm where beauty and malevolence dance hand in hand. In her arms, she cradles a Rushton doll, a vintage collectible known for its innocent and cherubic appearance –cherished and slightly eerie, evoking a sense of nostalgia and a connection to the uncanny."
    },
    {
      product_name: "All Hallow’s Eve",
      product_id: "6961278484546",
      product_text: "A spine-chilling tableau of a spooky night, where the supernatural seems to come alive, and the line between the living and the dead blurs into a haunting and atmospheric scene. An eerie sight of wicked witches, jack-o'-lanterns, tombstones, and ghosts are lurking in the shadows. Come explore the darkness if you dare!"
    },
    {
      product_name: "Halloween Gnome",
      product_id: "6960189931586",
      product_text: "Fringed with cobwebs and a sense of wonder, this charismatic Halloween Gnome dressed in a deep green cloak, a pointed starry hat, and striped stockings is ready to take us on a magical adventure. A night when the ordinary becomes extraordinary, and even a humble gnome can become a guardian of the mystical realm."
    },
    {
      product_name: "Graveyard Hill",
      product_id: "6960072261698",
      product_text: "In a dimly moonlit tableau, a foreboding hill rises in the distance, crowned with a haunted house. On the hillside, a centuries-old graveyard stretches with crooked tombstones, some leaning precariously. Sinister jack-o’-lanterns line the path leading to the house, casting eerie glows, invoking the magic and mystery of Halloween night, where the veil between the living and the dead is at its thinnest."
    },
    {
      product_name: "The Game is Afoot",
      product_id: "6960056008770",
      product_text: "The moon hung low in the inky sky, casting a silvery sheen upon the rolling hills of the English countryside. The air was cool and still, save for the occasional rustling of leaves in the gentle breeze. The Game is Afoot as Holmes and his loyal companion, Watson, are hot on the trail of another perplexing case, and the scene before them seemed to set the stage for the mystery that awaited."
    },
    {
      product_name: "Cornucopia",
      product_id: "6960185016386",
      product_text: "Bathed in the warm, golden glow of the setting sun, a beautifully woven cornucopia overflows with an abundant harvest of sunflowers, grapes, and pumpkins –a testament to the season's generosity, a reminder that the Earth's bounty is a gift to be celebrated."
    },
    {
      product_name: "Halloween Tricksters",
      product_id: "6961280811074",
      product_text: "Step into a world where the boundary between reality and fantasy blurs under the silvery glow of a full moon. A group of whimsical furry tricksters with their miniature trick-or-treat pumpkin buckets are gathered around a cluster of plump, beautifully carved pumpkins –embodying the playful and enigmatic spirit of the season."
    },
    {
      product_name: "Autumn Dreams",
      product_id: "6960063971394",
      product_text: "The sky above is a brilliant azure, unmarred by a single cloud. Casting a gentle, slanted light that gives everything a soft, almost magical quality. It’s as though this sleepy feline is lost in its own dreams while a curious mouse is making a stealthy approach towards atop the pumpkin, driven by the temptation of adventure or perhaps the hope of sharing the cozy pumpkin spot."
    },
    {
      product_name: "Moon Raven",
      product_id: "6960187080770",
      product_text: "Under the mesmerizing glow of a full moon, a raven, with feathers that gleam like polished obsidian, perches gracefully on a twisted pine branch. Its keen eyes, filled with age-old wisdom, seem to pierce the very heart of the night, while the rugged pines that stretch infinitely into the distance stand as silent sentinels, their needles catching the moonlight in a delicate dance of shadows and light."
    },
    {
      product_name: "Come Little Children",
      product_id: "6961275633730",
      product_text: "A whimsical witch hat adorned with a bewitching assortment of candies, appears as though it was plucked straight from the dreams of a playful sorceress –creating a delightful and almost tempting contrast with the dark, magical atmosphere of the scene."
    },
    {
      product_name: "Pumpkin Patch Farm",
      product_id: "6961282777154",
      product_text: "Take a step back from the bustling modern world and appreciate the simple, yet profound, pleasures of a Pumpkin Patch Farm in the heart of autumn. Capturing the essence of fall and the abundance it brings, making it an enduring symbol of the season's warmth, bounty, and the enduring beauty of rural life."
    },
    {
      product_name: "Haunted Halloween Library",
      product_id: "6960069509186",
      product_text: "An enchanting and eerie ambiance of the Haunted Library on a moonlit Halloween night. A lone girl sits on a creaky wooden chair, oblivious to the otherworldly horrors around her.. Amidst this spectral tableau, sinister jack-o'-lanterns cast flickering, malevolent glows. Their carved, sinister faces leered from the shadows, grinning with jagged, toothy smiles, and their wicked, triangular eyes seemed to follow your every move."
    },
    {
      product_name: "Moonlight Manor",
      product_id: "6960071409730",
      product_text: "A juxtaposition of childhood innocence and the mystery of Halloween night, where the allure of candy and adventure intertwines with the chilling tales of haunted houses. Moonlight Manor's dark facade, with its history of ghostly legends, creates a spine-tingling backdrop for the brave trick-or-treaters embarking on their spooky Halloween journey."
    },
    {
      product_name: "Happy Halloween",
      product_id: "6960390635586",
      product_text: "As the pale moon hung high in the midnight sky, casting its ethereal glow over an ancient cemetery, a bewitching scene unfolded beneath its watchful gaze. A feline enchanter adorned in a miniature witch's hat is perched upon its pumpkin throne as the guardian of the night, overseeing a world where magic reigns, and the spirits of the past come to life."
    },
    {
      product_name: "Halloween Night",
      product_id: "6961274093634",
      product_text: "In the moonlit graveyard, ancient tombstones and weathered mausoleums stand like silent sentinels in the mis, punctuated by the cackles of the witches and the soft, mournful wails of the ghosts. Among the graves, a congregation of menacing jack-o'-lanterns, each carved with a malevolent grin, casting ominous glows. Their candle flames flicker like malicious spirits."
    },
    {
      product_name: "Night Flight",
      product_id: "6961270489154",
      product_text: "In the dim light of a foggy cemetery, a lady dressed in an ethereal shade of pink clutches a grumpy, yet endearing pet standing in the midst of gravestones, her attire contrasting starkly with the eerie, mist-shrouded environment. Her presence is captivating, as she seems to blend into the hazy, dreamlike atmosphere."
    },
    {
      product_name: "Halloween House",
      product_id: "6961270849602",
      product_text: "In a moonlit October night, the sinister silhouette of a Halloween House looms against the inky sky, casting eerie shadows over the land – a beacon for all things spooky and supernatural. A ghastly scarecrow stands guard, its tattered and ragged clothes hanging from a twisted, gnarled frame while bats, winged phantoms of the night, swirl around the house, their ghostly forms outlined by the silvery glow of the moon."
    },
    {
      product_name: "Decorating the Haunted House",
      product_id: "6961282154562",
      product_text: "Nestled deep within a shadowy forest, a grand mansion bathed in moonlight stood as a beacon of Halloween enchantment. With intricate architecture and gleaming windows adorned by grinning jack-o'-lanterns, the house buzzed with ethereal spirits, mischievous skeletons, and spectral felines. Surrounding trees, skeletal in their autumn bareness, framed the mansion, while a slightly ajar wrought iron gate beckoned the adventurous closer."
    },
    {
      product_name: "Haunted Moon",
      product_id: "6960062627906",
      product_text: "Under a luminous moon, a splendid mansion with walls of lilac and rose stood proudly. Glowing pumpkins cast playful shadows, while a raven traced the sky, enhancing the realm's mystique. Two eager children, whispers of excitement in the air, approached the mansion, drawn by the promise of Halloween treats. Amid this bewitching tableau, two black cats held vigil, their watchful eyes capturing the spirit of the evening."
    },
    {
      product_name: "Witch is Mummy",
      product_id: "6960072949826",
      product_text: "In the midst of an eerie chamber, a family of mysterious creatures gathered, their presences magnified by the vibrant orange hue of the moon seeping through the window. Their figures, intertwined with whispers of ancient tales, formed a tableau of haunting beauty. High above, a silent owl kept vigil, encapsulating the room's otherworldly essence."
    },
    {
      product_name: "Boo’s Halloween",
      product_id: "6960054009922",
      product_text: "Beneath the vast expanse of a twilight sky, a curious feline adorned with a whimsical witch's hat gazes intently, its two-toned eyes mirroring the mysteries of the universe. Nestled below, a cheeky mouse perches atop a vibrant apple, seemingly ready to embark on a nocturnal adventure. Framing this scene, sunflowers and wildflowers stand tall, silently witnessing the enchanting interplay between the moon's golden embrace and the creatures of the night."
    },
    {
      product_name: "Harvest Helper",
      product_id: "6939560575042",
      product_text: "In this enchanting display of fall colors, a charming dog sits proudly atop a wooden bucket overflowing with freshly harvested apples and flowers in various shades of red, orange, and yellow bloom. His expressive eyes exude a sense of loyalty and contentment. The dog seems to be guarding the bountiful harvest of apples that have just been picked from the nearby orchard."
    },
    {
      product_name: "Cobblestone Fountain",
      product_id: "6939423768642",
      product_text: "Cascading water flows from the fountain's top into a circular pool below, creating a soothing melody that perfectly complements the visual masterpiece. The fragrance of the flowers seems to hang in the air, and the serene ambiance invites visitors to pause and reflect, creating a moment of tranquility in the heart of this elegant hotel's courtyard."
    },
    {
      product_name: "Coming up Roses",
      product_id: "6939411611714",
      product_text: "In a picturesque village corner, a sunlit cottage with weathered white walls stood adorned with blooming roses, geraniums, and morning glories. Nearby, three young girls played amidst roses, transforming petals into storytellers weaving tales of magical meadows and hidden gardens. In this serene setting, the cottage and its surroundings harmoniously whispered stories of eternal innocence and the allure of nature's beauty."
    },
    {
      product_name: "Honey",
      product_id: "6939561492546",
      product_text: "A beautiful fairy with delicate, gossamer wings alights upon a vibrant mushroom, its cap a brilliant shade of crimson, dotted with small, white speckles. A profusion of wildflowers surrounds her, their petals swaying in the gentle breeze. You can almost hear the faint hum of nature's magic and the distant song of woodland creatures celebrating the fairy's harmonious existence with the natural world."
    },
    {
      product_name: "Pretty Rose Princess",
      product_id: "6939585249346",
      product_text: "In a world where magic and reality intertwine, there exists a mystical Princess adorned in the pure elegance of the roses, where each bloom seems to whisper tales of forgotten magic and forgotten love. The castle, a grand and majestic structure, stands proudly in the background, its spires reaching toward the heavens."
    },
    {
      product_name: "Fore The Good Times",
      product_id: "6939577286722",
      product_text: "Welcome to the ultimate entertainment sanctuary – whether you're a golf enthusiast, a gaming aficionado, or simply looking for a luxurious space to relax and socialize, this arcade room offers the perfect blend of entertainment, sports, and indulgence. It's where you can swing your clubs, enjoy your favorite drinks, and create unforgettable memories fore the good times, all in one exquisite setting."
    },
    {
      product_name: "Rico",
      product_id: "6939570765890",
      product_text: "A tranquil symphony of colors that instantly transports you to a serene wetland oasis. Surrounding the enchanting flamingo are lush, tropical flowers in full bloom mirroring its posture with a natural grace of its own. A dreamlike fusion of nature's beauty, where the flamingo and flowers coexist in perfect, pastel harmony—a visual poem that captures the spirit of a tranquil wetland sanctuary."
    },
    {
      product_name: "Raptor",
      product_id: "6939578826818",
      product_text: "In the shadows, a radiant raptor glides, leaving a trail of sparkling energy that weaves an ephemeral tapestry mirroring its movements. The magical display evokes celestial constellations, as if stars have descended to accompany this enigmatic being on its nocturnal journey."
    },
    {
      product_name: "Wishing You a Rainbow",
      product_id: "6939422195778",
      product_text: "A charming garden comes alive with a symphony of colors and motion, as the girl carefully waters the plants, each drop seems to glisten like a tiny gem, catching the early morning sun's rays and creating a magical, shimmering rainbow effect. A serene moment where the essence of childhood wonder and the joys of nature converge in perfect harmony."
    },
    {
      product_name: "Parrot Priestess",
      product_id: "6939586625602",
      product_text: "Step into a world where every element sings with enchantment, and where the Parrot Priestess, a guardian of dreams and nature, reigns with a soft but unyielding power - a power that is gentle yet omnipotent, nurturing yet awe-inspiring. An embodiment of the earth's whispered secrets and the sky's boundless dreams."
    },
    {
      product_name: "Bay's Landing",
      product_id: "6939428880450",
      product_text: "A serene and nostalgic lakeside scene that will transport you to a bygone era, where time seems to slow, and life is savored one moment at a time - capturing the essence of a peaceful retreat, a place where the past and present merge in a harmonious dance of beauty and tranquility, inviting us to linger and find solace in the timeless embrace of nature and architecture."
    },
    {
      product_name: "The Rose Room",
      product_id: "6939576664130",
      product_text: "A charming living room, brimming with floral motifs that evoke a sense of warmth and whimsy. Adorned with intricate floral patterns, blossoms of various hues and sizes gracefully intertwining. The room exudes a warm, inviting aura, with soft lighting casting gentle shadows and creates a harmonious, garden-like tranquility within the space."
    },
    {
      product_name: "Bringing Joy And Happiness",
      product_id: "6962201788482",
      product_text: "In the heart of a serene winter's night, the iconic figure of Santa Claus stands atop a snow-kissed roof, a brimming sack of toys slung over his shoulder, poised to deliver joy. Below, the world sleeps under a blanket of snow, houses aglow with the warm spirit of Christmas, as a single child, face pressed to the cold glass, glimpses the magic of the season unfolding."
    },
    {
      product_name: "Toadstool Cottage",
      product_id: "6994994626626",
      product_text: "Under a velvet sky sprinkled with stars, a whimsical cottage nestles among gigantic, luminescent toadstools, its windows casting a warm, inviting glow amidst the cool blue of twilight. The air is thick with enchantment, as stone steps ascend through a lush carpet of grass and delicate flowers, leading to a door that promises entry to a realm of fantasy and wonder."
    },
    {
      product_name: "Joyous Crossing",
      product_id: "6964681277506",
      product_text: "As the winter sun casts a golden hue over the snow-clad village, life thrives in this idyllic scene where a vintage red pickup truck, carrying a freshly-cut Christmas tree, halts near a vibrant, wreath-adorned covered bridge. Skaters glide on a frozen pond, deer mingle with the local fauna, and the townsfolk revel in the joyous spirit of the season, encapsulating the essence of a festive winter's day."
    },
    {
      product_name: "Mountain Keep Castle",
      product_id: "6964328792130",
      product_text: "Amidst a whispering forest of frosted pines, a majestic castle stands resolute against the dusky sky, its spires reaching towards the heavens as if to capture the fading light. The scene is a tapestry of winter's elegance, with snowflakes dusting the castle's grand architecture and warm lights twinkling like stars, suggesting life and laughter within these ancient walls."
    },
    {
      product_name: "The Encounter",
      product_id: "6995008815170",
      product_text: "In the murky shadows of a forgotten chamber, a woman with the ethereal grace of a ghost confronts a creature of legend, her piercing gaze locked with that of a dragon whose scales shimmer with ancient secrets. The air is thick with tension and mystery, as skulls piled in the corner whisper of past encounters, and the dim light casts an otherworldly glow on this surreal and timeless confrontation."
    },
    {
      product_name: "Christmas Toys",
      product_id: "6964330561602",
      product_text: "Inside a cozy room warmed by the crackling hearth, the Christmas spirit comes alive with a richly adorned tree that sparkles with lights and baubles, while stockings hang eagerly from the mantelpiece. Outside the window lies a tranquil winter scene, but inside, toys and decorations tell tales of merriment, and a contented cat perches, a silent observer to the festive magic that fills the air."
    },
    {
      product_name: "Christmas At Dukes House",
      product_id: "6964527071298",
      product_text: "In a picturesque backyard blanketed with snow, a bevy of playful dogs and their feline friends celebrate the festive season, adorned in bright holiday attire. They congregate around a delightfully decorated Christmas tree, with the charming red doghouse named 'DUKE' serving as their backdrop, while a pair of cardinals add a splash of vibrant red to the wintry tableau."
    },
    {
      product_name: "Collective Consciousness",
      product_id: "7002118324290",
      product_text: "In a vivid dreamscape where the cosmos and nature converge, a serene face emerges, symbolizing the collective consciousness that intertwines all life. Suns, moons, and stars blend with verdant foliage, while butterflies dance around a mystical path leading to an enlightened city, embodying the unity and boundless creativity of the universe."
    },
    {
      product_name: "Church in Snow",
      product_id: "6964335181890",
      product_text: "Gentle snowflakes drift down upon a quaint chapel, where a radiant Christmas tree stands sentinel at the entrance, its lights a beacon of hope and celebration in the hushed winter landscape. The glow of a festive red door and a single lamppost adorned with a crimson bow warmly beckons to all, offering a haven of peace and reflection amidst the serene beauty of the season's first snow."
    },
    {
      product_name: "Pristine Nativity",
      product_id: "6962018287682",
      product_text: "In a rustic stable bathed in the gentle glow of lantern light, a timeless scene unfolds: the nativity, with figures in humble adoration around the newborn child. The peacefulness of the moment is shared by the surrounding animals, while beyond the wooden beams, a starry night blankets a distant city, symbolizing the birth of hope for all."
    },
    {
      product_name: "Lion Soul",
      product_id: "7002150731842",
      product_text: "Captured in a blaze of otherworldly hues, the lion's soulful visage emerges, eyes glowing with a fierce and mystical intelligence. Its mane, a vibrant tapestry of electric blues and purples, seems to crackle with the raw energy of the universe, framing a face that speaks to the untamed spirit that roars in the silence of the stars."
    },
    {
      product_name: "Christmas is Coming",
      product_id: "6961917100098",
      product_text: "Santa Claus, the beloved harbinger of holiday cheer, is depicted with a twinkle in his eye as he lovingly examines a toy train, a symbol of the timeless joy of Christmas. The workshop is abuzz with festive energy, surrounded by vibrant gifts and classic toys, while a picturesque window view reveals a snowy landscape where a snowman and forest creatures partake in the silent, wintry anticipation of the season's delights."
    },
    {
      product_name: "Christmas Cuties",
      product_id: "6961998266434",
      product_text: "A charming snowman adorned with a top hat and a red scarf stands amid a gentle snowfall, surrounded by an inquisitive group of woodland animals, with warmly lit Victorian houses nestled in the background, creating a picturesque winter scene."
    },
    {
      product_name: "Tamed",
      product_id: "7002166198338",
      product_text: "A girl with a wild mane of fiery curls stands boldly, her porcelain complexion a stark contrast to the dark backdrop. Clad in a gown of tulle and lace, she gently embraces a feral tiger that roars fiercely, an embodiment of untamed spirit and the delicate balance of ferocity and grace."
    },
    {
      product_name: "Cats In Christmas Hats",
      product_id: "6964331511874",
      product_text: "Five curious cats don whimsical Christmas hats, their eyes wide and expressive against the backdrop of a festively adorned tree. Perched upon an ornate rug, each feline exudes its own personality, together creating a charming and heartwarming tableau that celebrates the cozy delight of the holiday season."
    },
    {
      product_name: "A Spot for Christmas",
      product_id: "6964333379650",
      product_text: "Nestled in a charming nook, A Spot For Tea tea shop is a vision of festive allure, decked in vibrant holiday decor with a welcoming wreath and a joyful Santa greeting passersby. A quaint outdoor table, adorned with a crimson teapot, sits invitingly amongst potted blooms, while twinkling lights and a tastefully decorated Christmas tree add a sparkle of magic to the quaint setting."
    },
    {
      product_name: "Fiesta Chic",
      product_id: "7002168688706",
      product_text: "A vibrant representation of La Catrina, the elegant skull of Dia de los Muertos, adorned with a tapestry of flowers, patterns, and candles, exuding the rich cultural heritage and the celebratory essence of the Mexican tradition that honors the dearly departed."
    },
    {
      product_name: "Christmas Congregation",
      product_id: "6964336230466",
      product_text: "A quaint birdhouse church, nestled among snow-draped evergreens, becomes a gathering place for a colorful congregation of birds, creating a scene of peaceful winter camaraderie against a crisp, blue sky."
    },
    {
      product_name: "Santa's Christmas Cookies",
      product_id: "6964513013826",
      product_text: "Santa Claus enjoys a moment of respite, cookie in hand and a glass of milk at the ready, with a backdrop of a warmly lit fireplace and a richly decorated Christmas tree, encapsulating the cozy essence of the holiday season."
    },
    {
      product_name: "Earth Babies - Ozzy",
      product_id: "7002196901954",
      product_text: "A koala, adorned with a crown of vivid flora, gazes out with soulful eyes, its portrait a celebration of nature's gentle and whimsical beauty against a dark, star-speckled backdrop."
    },
    {
      product_name: "Around the World in a Night",
      product_id: "6961972019266",
      product_text: "In a stone-walled room bathed in soft light, Santa consults a grand globe before his night's journey, with a list in hand and elves at work, all set against the backdrop of a snowy landscape visible through a tall arched window."
    },
    {
      product_name: "Winter Wonderland Chapel",
      product_id: "6962200805442",
      product_text: "A picturesque snow-covered church, with its welcoming glow, stands as the focal point of a quaint village scene, adorned with holiday wreaths and lights. The peaceful winter night is aglow with a gentle luminescence from homes and street lamps, as snow blankets the landscape and a friendly snowman watches over the silent streets."
    },
    {
      product_name: "Ocean View Sunset",
      product_id: "7002201227330",
      product_text: "As the sun dips below the horizon, its fiery glow bathes a cascading hillside village by the sea in warm light, with the Mediterranean architecture glowing against the dramatic sky and tranquil waters, creating a picturesque moment of coastal serenity."
    },
    {
      product_name: "Gingerbread House",
      product_id: "6964658962498",
      product_text: "An enchanting gingerbread house sits at the heart of a candy-themed wonderland, surrounded by a festive assortment of sweets and treats, with playful gingerbread people adding to the cheerful holiday scene."
    },
    {
      product_name: "Let’s Get Together",
      product_id: "6962203263042",
      product_text: "In this cozy winter scene, a log cabin is warmly lit and inviting, its windows revealing a festive interior with a decorated Christmas tree. Outside, an unlikely gathering of forest animals, including birds, a deer, penguins, and a curious cat, come together in a magical display of holiday harmony."
    },
    {
      product_name: "Everything's Roses",
      product_id: "7002199425090",
      product_text: "Amidst a tranquil mountain backdrop under a star-dotted sky, lush roses in shades of deep purple and pink bloom vibrantly, accompanied by the delicate flutter of dragonflies, weaving a scene of natural elegance and serenity."
    },
    {
      product_name: "Christmas Birdhouse Gathering",
      product_id: "6964530282562",
      product_text: "A festive gathering of brightly colored birds, each donning whimsical winter hats, perch and flutter about a charming red birdhouse. Adorned with holiday wreaths and bows amidst a snowy setting, this scene captures the joyful spirit of a winter's day."
    },
    {
      product_name: "Celebrating Christmas",
      product_id: "6964334723138",
      product_text: "A cozy living room is decked out in festive decor, with a lush Christmas tree sparkling with ornaments and lights. The room is filled with the warmth of a crackling fireplace, comfortable patterned armchairs, and holiday accents like stockings, candles, and a welcoming Santa figure, all inviting a sense of joy and celebration."
    },
    {
      product_name: "Enchanted Cave",
      product_id: "7002194346050",
      product_text: "In an ethereal grotto, a gondola adorned with regal figures glides through luminescent waters, guided by elegant swans under the glow of ornate chandeliers and wrought-iron lamps, surrounded by flourishing flora and the gentle caress of an enchanted evening."
    },
    {
      product_name: "First Prayers",
      product_id: "6964492533826",
      product_text: "A child, bundled in winter's attire, offers a prayer, illuminated by the radiant colors of a stained glass window depicting the Nativity, with the Star of Bethlehem shining brightly above, creating an atmosphere of reverence and the peaceful spirit of the season."
    },
    {
      product_name: "Red Rose Manor",
      product_id: "6939585577026",
      product_text: "In a world where fantasy blooms, an opulent manor adorned with cascading roses stands amidst a mystical garden. The air is alive with the dance of petals in the gentle breeze, while a soft glow emanates from the elegant structure, inviting wonder and enchantment."
    },
    {
      product_name: "Autumn Beauty",
      product_id: "6939422949442",
      product_text: "An idyllic thatched cottage nestles within a tapestry of autumnal splendor. A stone bridge arches gracefully over a tranquil stream where ducks paddle leisurely, and the rich hues of changing leaves are mirrored in the water's surface, creating a scene of peaceful harmony with nature's seasonal rhythm."
    },
    {
      product_name: "Sunset Blaze",
      product_id: "6939574140994",
      product_text: "As the sun sets, casting a blaze of color across the sky, a quaint European bistro warmly welcomes with its open door and inviting table. The rustic charm of the old town is further illuminated by the soft light of the street lamp, inviting a sense of romantic tranquility."
    },
    {
      product_name: "Autumn",
      product_id: "6939565850690",
      product_text: "A stylized portrait emerges with autumnal charm: a figure with flowing red hair and a wide-brimmed hat, framed by twisting leaves, exudes a mystique reminiscent of fall's allure, with a warm, fiery backdrop complementing the theme."
    },
    {
      product_name: "Zinnia Bouquet",
      product_id: "7002183794754",
      product_text: "A lush bouquet of zinnias bursts with vibrant life, each petal painted in vivid hues that capture the dynamic essence of a flourishing garden, evoking the joy and exuberance of nature in full bloom."
    },
    {
      product_name: "A Berry Merry Christmas",
      product_id: "6961994039362",
      product_text: "A whimsical snowman dons a top hat, sharing a tender moment with a rosy-cheeked figure under a candy-spotted mushroom umbrella. Surrounded by festive holly and sweet treats, they bask in the glow of a twinkling light backdrop, embodying the playful joy of the holiday season."
    },
    {
      product_name: "Tulip Season",
      product_id: "7002189725762",
      product_text: "Vibrant tulips in a medley of colors burst from the canvas, their petals painted with exuberant strokes that evoke the lush freshness of spring and the vitality of blooming life."
    },
    {
      product_name: "Sweet Holiday Dreams",
      product_id: "6961995251778",
      product_text: "A charming snowman, outfitted with a fishing pole, sits beside a frozen creek in a serene winter landscape, while a festively lit Christmas tree and wildlife add a touch of magic to the tranquil cabin scene, under a starry night sky."
    },
    {
      product_name: "Christmas Joy",
      product_id: "6962201428034",
      product_text: "In this delightful Christmas scene, a richly decorated living room bursts with the holiday spirit. A towering tree, adorned with lights and ornaments, stands beside a jolly Santa with a sack of toys, while excited children peek from the staircase, surrounded by a colorful array of presents and timeless toys that await joyous celebration."
    },
    {
      product_name: "Cosmic Muse",
      product_id: "7002181369922",
      product_text: "This artwork portrays a cosmic muse with golden adornments, her thoughtful gaze surrounded by floating luminescent orbs against a starry backdrop. The scene captures the harmony between celestial elegance and the infinite universe."
    },
    {
      product_name: "Please Stop Here",
      product_id: "6962008129602",
      product_text: "A festive scene unfolds with Santa and his reindeer, ready to deliver gifts, standing in front of a snow-covered neighbourhood aglow with Christmas lights and decorations. A sign reading Santa, please stop here adds a charming request to the joyful tableau."
    },
    {
      product_name: "Little Baker's Christmas Cookies",
      product_id: "6964503052354",
      product_text: "The image captures a heartwarming moment of a young child deeply focused on rolling out dough for Christmas cookies, with a curious kitten watching on. The background offers a glimpse of a winter wonderland through the window, enhancing the festive atmosphere."
    },
    {
      product_name: "Breaking The Spell",
      product_id: "6995007537218",
      product_text: "In an enchanted forest where the flowers whisper secrets, a young woman in a rich velvet gown shares a serene moment with a majestic dragon, their bond breaking the spell of silence that once ruled this mystical realm. The dragon's protective gaze and the gentle touch of the woman's hand on its snout speak of an ancient friendship, undisturbed by the world beyond the thicket."
    },
    {
      product_name: "American Christmas Gnome",
      product_id: "6964545650754",
      product_text: "Amidst a wintry flurry, a festive gnome dons the stars and stripes, bringing a patriotic twist to the holiday cheer, while a curious cardinal perches nearby, adding a touch of natural wonder to this whimsical yuletide scene."
    },
    {
      product_name: "Greetings Christmas Morning",
      product_id: "6964665417794",
      product_text: "As dawn breaks on a Christmas morning, a cozy farmhouse aglow with festive lights stands amidst a snow-dusted landscape; a scene alive with holiday icons and friendly animals, each adding their own chapter to the storybook charm of this rural winter wonderland."
    },
    {
      product_name: "Heading Home",
      product_id: "6995004325954",
      product_text: "In the golden hour of a serene mountain valley, a couple walks hand-in-hand towards a quaint cottage nestled among lush, vibrant gardens, symbolizing a journey back to the heart's truest home amidst nature's splendid tapestry."
    },
    {
      product_name: "Parents Pray, Children Play",
      product_id: "6962202738754",
      product_text: "As the winter sun casts a soft glow over the snow-clad village, parishioners arrive by horse-drawn sleigh to a steepled church, while children, bundled in their festive best, build a snowman, their laughter echoing the joy of a spirited Christmas Eve."
    },
    {
      product_name: "A Joyful Night Ride",
      product_id: "6962002493506",
      product_text: "Under a moonlit sky, Santa’s Express steams across a snow-covered bridge, its vibrant red engine leading a train of joy, with Santa himself waving from the locomotive, ushering in a trail of magic and wonder through the heart of a wintry mountain pass."
    },
    {
      product_name: "Always Together in Spirit",
      product_id: "6994991185986",
      product_text: "A whimsical maiden with hair like autumn flames sits serenely, her straw hat adorned with a wreath of wildflowers, embodying the joyful spirit of nature and the enduring soul of the countryside that blooms within her gaze."
    },
    {
      product_name: "Cozy Kitten",
      product_id: "6964538474562",
      product_text: "Snuggled in a cozy scarf and festive hat, a curious kitten with eyes wide in wonder enjoys a sweet winter treat, adding a dash of innocent charm to the holiday season's snowy embrace."
    },
    {
      product_name: "Picturesque Covered Bridge",
      product_id: "6939425210434",
      product_text: "A serene countryside scene featuring a covered bridge and a church set in a lush, blooming landscape. A haven of tradition and natural beauty where the past and the present coexisted harmoniously, a place where the simple joys of life blossomed like the flowers that surrounded it."
    },
    {
      product_name: "Autumn Bouquet",
      product_id: "6939558936642",
      product_text: "In the midst of a vibrant autumn, a collection of pumpkins, squashes, and crisp apples lay gathered on a rustic wooden surface. Among the bounty, a whimsical arrangement of flowers bursts forth in a kaleidoscope of colors, accompanied by the gentle presence of wildlife, as birds and butterflies partake in the season's rich tapestry."
    },
    {
      product_name: "Barn Babies",
      product_id: "6939421933634",
      product_text: "In the warm embrace of a rustic farm, a young girl in cute puffy ponytails sits by a barn, lost in a tender moment with a chick in her hands. Around her are vibrant signs of farm life: a curious piglet, free-roaming chicks, a basket full of eggs, a rooster, and sunflowers, with a pair of cowboy boots placed nearby."
    },
    {
      product_name: "Pink Cloud Cottage",
      product_id: "6939584790594",
      product_text: "In a whimsical world where the sky is a soft pastel gradient, there exists a charming cottage nestled among fluffy snowdrifts. Its pastel pink façade is adorned with sugar-frosted windows, delicate icicles, and candy-like decorations, making it the centerpiece of a serene, magical winter landscape."
    },
    {
      product_name: "Barnstormer Hot Rods",
      product_id: "6939578138690",
      product_text: "A vibrant and colorful countryside scene where the romance of rural life meets the thrill of vintage automotive culture. Each car seems to tell a story, a frozen narrative in steel and paint, of races won, of sunsets chased, and of a community united by the roar of engines."
    },
    {
      product_name: "Rainbow Dreamer",
      product_id: "6939562573890",
      product_text: "In a realm where the sky blooms with nebulous pastels, a young girl with sun-kissed hair rides a majestic white horse through a sky painted with a rainbow. Accompanied by a cheerful clown doll, soaring gracefully among twinkling stars and fluffy clouds, embarking on a dreamy adventure."
    },
    {
      product_name: "Chosen",
      product_id: "7002162364482",
      product_text: "In a world tinged with monochrome shades, a solitary figure emerges as a testament to quiet resilience: a woman, her eyes reflecting an ocean's depth, commands attention amidst the whispering chaos of her flowing hair. Upon her brow, a butterfly perches—a glimmer of color and hope amidst the grey, a silent herald of change and the beauty of metamorphosis."
    },
    {
      product_name: "Bounty of Beauty",
      product_id: "6939588689986",
      product_text: "In a realm where fantasy and reality intertwine, a serene woman's visage emerges from the bounty of nature, her closed eyes whispering secrets of inner peace. Around her, a tapestry of vibrant flowers, lush foliage, and mystical butterflies weaves together with a distant, intricate cityscape."
    },
    {
      product_name: "Orchid Forest Glow",
      product_id: "7002182287426",
      product_text: "A magical gateway within an enchanted forest, where colossal, luminous leaves, in hues of amber and emerald, form a mystical arch. Twinkling lights and vibrant flowers embellish the scene, casting a spellbinding glow that whispers of untold secrets and ancient stories waiting just beyond the threshold."
    },
    {
      product_name: "Poseidon’s Treasures",
      product_id: "7002197655618",
      product_text: "In the depths of an enchanting underwater realm, a mermaid with a shimmering, multicolored tail and flowing golden locks extends her hand to a tiny, curious fish among the ruins of an ancient, coral-encrusted civilization. Sunlight pierces the water's surface, illuminating the scene with rays that dance across the mermaid's skin and the diverse marine life that flourishes in this hidden aquatic sanctuary."
    },
    {
      product_name: "Fox and Flower",
      product_id: "6994995019842",
      product_text: "In a fantastical world where the flora and fauna blur into shades of whimsy, a charming fox adorned with a crown of vibrant pink flowers sits amidst a magical glade. Its lush, fluffy tail gently brushes against the soft petals on the ground, while ethereal pink blossoms drift lazily in the tranquil, azure sky."
    },
    {
      product_name: "The Fairies Vale",
      product_id: "6995008028738",
      product_text: "In a serene, enchanted forest illuminated by a soft, golden light that filters through the tall trees, a gentle fairy sits and admires her small companions. Her iridescent wings shimmer with hues of gold, green, and amber, mirroring the vibrant life around her as delicate sprites dance in the air, celebrating the magic of their woodland realm."
    },
    {
      product_name: "Santa’s Sparkle Express",
      product_id: "6962011996226",
      product_text: "In a magical winter wonderland, Santa Claus, in his plush white suit, gleefully feeds a group of reindeer by a glistening, snow-covered train emblazoned with Santa's Express. The North Pole signpost and the joyous puppies peeking out of the train add to the festive charm as the starry night sky twinkles above, heralding the Christmas season."
    },
    {
      product_name: "Christmas Mountain View",
      product_id: "6961991483458",
      product_text: "A crisp winter scene unfolds outside a frosted window, where a quaint village nestles under a blanket of snow, embracing the holiday spirit with colorful decorations and a towering Christmas tree. Inside, the warmth of flickering candlelight and festive greetings on cards complement the chilly beauty, offering a silent ode to the season's joy and tranquility."
    },
    {
      product_name: "Santa’s Night Ride",
      product_id: "6961997480002",
      product_text: "In the still of the frosty Christmas Eve night, Santa and his reindeer soar high above a tranquil, snow-covered village, the moon casting a soft glow on the scene below. Gifts tumble gently from his magical, overflowing sleigh, promising joy and surprise to the slumbering village as the faint jingle of bells whispers through the crisp air."
    },
    {
      product_name: "Decking The Halls",
      product_id: "6964682883138",
      product_text: "In the warmth of a cozy living room, adorned with the festive cheer of Christmas, Santa Claus stands by the cracking fireplace as he holds a special gift. The room is aglow with vibrant holiday decor: a tree sparkling with ornaments, stockings hung with care, and gifts wrapped in cheerful colors waiting to be discovered."
    },
    {
      product_name: "Mary and Lamb",
      product_id: "6964332265538",
      product_text: "In a humble stable bathed in the celestial glow of the Christmas star, Mary adoringly watches over the newborn child, as a young lamb stands witness to the silent, sacred birth that illuminates the night with hope and peace."
    },
    {
      product_name: "Santa’s Night",
      product_id: "6961994498114",
      product_text: "In a tranquil winter woodland, Santa stands beside a brightly lit Christmas tree, his red suit a cheerful contrast to the snowy scene. Around him, a symphony of birds, adorned in their finest feathers, partake in the festive spirit, their chirps harmonizing with the soft whisper of the falling snow."
    },
    {
      product_name: "Three Winter Friends",
      product_id: "6964542701634",
      product_text: "A cheerful snowman adorned with a blue polka-dotted hat and a warm red scarf stands next to a tiny penguin wrapped in a cozy yellow beanie and scarf, clutching a tiny green gift. On their other side, a jolly Santa, with his classic hat topped with holly, shares in their frosty celebration under a gently snowing sky."
    },
    {
      product_name: "Getting Ready for Christmas",
      product_id: "6964550631490",
      product_text: "In a quaint village adorned with festive decorations, the townspeople joyously prepare for Christmas. Snow gently blankets the charming street as children play and neighbors exchange holiday greetings, with the warm glow of lights and the scent of pine in the crisp winter air."
    },
    {
      product_name: "Santa Clause",
      product_id: "6964533493826",
      product_text: "In the cosmic expanse of the winter night, Santa holds aloft a single candle, its flame casting a gentle glow against the swirling nebulas that cloak him. Each spark from the flame transforms into a twinkling star, with ethereal auroras weaving through his long, iridescent beard as he prepares to embark on his mystical journey."
    },
    {
      product_name: "Christmas Interior",
      product_id: "6961992663106",
      product_text: "On Christmas Eve, the room comes alive with the magic of the season, its every corner telling a story of Yuletide joy, from the meticulously decorated tree guarding the presents to the slumbering fury pets who dream of tomorrow's joys. Outside the frosted windows, the world awaits the merriment of morning, while inside, the crackling fire whispers tales of Christmases past to all who gather round."
    },
    {
      product_name: "Cafe de Paris",
      product_id: "6995009372226",
      product_text: "In the heart of a vibrant Parisian street, the sun casts golden hues on the quaint buildings, with the iconic Eiffel Tower looming in the backdrop. The scene is alive with the charm of a small café, where a lone scooter is parked and a friendly dog waits patiently by the door, embodying the leisurely spirit of the city."
    },
    {
      product_name: "Miss Muffet",
      product_id: "6896270311490",
      product_text: "In a twisted realm of gothic charm, Miss Muffet, with her hair as a cascade of turquoise and purple waves, holds court among her eerie subjects: spiders, hair bows adorned with skulls and eyes, and potions with eerie labels. The cobwebs glisten like silver threads around her, as she embraces the darkness with a beguiling gaze that mesmerizes all who dare to look."
    },
    {
      product_name: "Clouded Tree",
      product_id: "7002145685570",
      product_text: "Beneath a mesmerizing celestial dance of shooting stars and a glowing crescent moon, an ethereal tree with lush, cloud-like foliage in vibrant shades of pink, blue, and purple stands alone. Its twisting trunk and flowing branches seem to pulse with the lifeblood of the cosmos, as a gentle breeze carries whispers of ancient secrets through its leaves."
    },
    {
      product_name: "Moonlight Over Lombard",
      product_id: "6995006554178",
      product_text: "In the heart of a bustling nocturnal city, the moon casts a gentle glow over Lombard Street, illuminating a romantic scene where a couple pauses to revel in the enchanting ambiance. The night is a canvas of urban charm, where the past and present merge in the warm embrace of the city's luminescent dance."
    },
    {
      product_name: "Riverside Mushroom Cottage",
      product_id: "6994992955458",
      product_text: "In a whimsical realm where the blush of sunset never fades, a charming mushroom cottage stands by a tranquil lake, its pink and purple hues reflecting a perpetual twilight. An enchanted lantern illuminates the path, inviting weary travelers to rest within its dreamy walls, while the air whispers tales of magic and serenity."
    },
    {
      product_name: "I Have Found The One",
      product_id: "7002200506434",
      product_text: "In the soft hues of dawn, two swans nestle amidst a bed of tulips, their feathers as white as the blossoms surrounding them. As the world awakens, the gentle creatures share a moment of serene companionship, undisturbed by the waking life around them."
    },
    {
      product_name: "Rejuvenation",
      product_id: "7002183401538",
      product_text: "A vivid bouquet of roses and lilies comes to life in a whirlwind of colors, their petals capturing the soft glow of a serene morning. Nestled in an elegant vase, each bloom vies for the sun's affection, casting playful shadows upon the table that whispers tales of rejuvenation and spring's gentle kiss."
    },
    {
      product_name: "Euphoric Spectrum",
      product_id: "7002198147138",
      product_text: "In a colorful art studio, a joyous golden retriever becomes the artist's muse, embodying the vibrant chaos of creativity as splashes of colorful paint dance around it. Its bright eyes sparkle with delight, and its wagging tail flicks paint through the air, adding to the masterpiece of its joyful play."
    },
    {
      product_name: "Reach Towards The Stars",
      product_id: "7002136477762",
      product_text: "In the heart of an enchanted twilight, a fairy with translucent, iridescent wings that glimmer with a constellation of colors reaches out towards a cascade of twinkling stars. Her flowing gown, a tapestry of twilight hues, cascades like a river merging with the celestial horizon where day meets night in a symphony of sunset colors."
    },
    {
      product_name: "Empowered Elegance",
      product_id: "7002167083074",
      product_text: "In a world where art breathes life, a mystical figure with large, expressive eyes adorned with tribal markings stands as a guardian of dreams. Her headband, rich with geometric patterns, complements the cascade of feathers and beads that whisper tales of ancient wisdom."
    },
    {
      product_name: "Unicorn Forest",
      product_id: "7002198605890",
      product_text: "Bathed in the soft glow of a setting sun, a resplendent unicorn with a shimmering, multicolored mane and a singular spiraled horn stands amidst a burst of rich floral blooms. This serene creature, adorned with elegant golden jewelry, exudes an air of grace and magic in a vibrant, enchanted forest."
    },
    {
      product_name: "Tuscan View",
      product_id: "6995005440066",
      product_text: "In the warm embrace of a Tuscan sunset, the vineyard breathes life into the valley, its rows of grapevines standing as testament to the land's rich bounty. An old stone villa adorned with climbing ivy and blooming flowers whispers stories of the past, as the tranquil fountain echoes the serene beauty of the Italian countryside."
    },
    {
      product_name: "Sweetheart Gnomes",
      product_id: "7040616759362",
      product_text: "In a whimsical meadow bursting with the vibrancy of spring, two charming gnomes share a tender moment in a magical garden full of vibrant hearts, playful ladybugs, and flowering vines, celebrating love in an enchanting world of their own."
    },
    {
      product_name: "Teddy Bear in Wonderland",
      product_id: "7040621936706",
      product_text: "In a vibrant, enchanting street bursting with the hues of a perpetual spring, two teddy bears share a moment of joy, pedaling their bicycles side by side. The air is filled with the magic of floating balloons and petals, casting a magical glow on the bears' delightful adventure through this floral wonderland."
    },
    {
      product_name: "Autumn Roses",
      product_id: "7040632094786",
      product_text: "A bouquet of lush roses blooms in a symphony of autumnal hues, their petals a delicate dance of soft whites, pinks, and deep oranges, all set against a backdrop of swirling greens and hints of purple, as if celebrating the last warm notes of summer."
    },
    {
      product_name: "Garden Wolf",
      product_id: "7040640516162",
      product_text: "Nestled in a cherry blossom garden, a majestic adult wolf shares a tender moment alongside its youthful counterpart, a playful pup. The blossoms' embrace creates an enchanting atmosphere, encapsulating the beauty of nature and the unspoken bond between the two as the elder imparts wisdom to the younger under the soft caress of spring."
    },
    {
      product_name: "Scarlett",
      product_id: "7002162135106",
      product_text: "In a realm tinged with the macabre, a young girl with vibrant pink hair embodies an enigmatic fusion of innocence and mystery. Adorned with a hat featuring a hypnotic swirl and a companion creature with beady eyes, her gaze, framed by starry motifs, harbors untold stories of a whimsical yet shadowy universe."
    },
    {
      product_name: "Mystical Blue Rose",
      product_id: "6994993938498",
      product_text: "Under a twilight sparkle, a luminous blue rose reigns over a mystical glade, its light mirrored in the tranquil waters. Nearby, a golden teapot, cradling a crystal heart, whispers tales of enchantment beside blooming companions, with a castle of dreams standing sentinel in the distance."
    },
    {
      product_name: "Coffee at the Cabin",
      product_id: "6995010453570",
      product_text: "A serene dusk descends upon a rustic cabin porch overlooking a tranquil lake, where the soft glimmer of a lantern and the distant silhouette of a lone canoeist are mirrored in the calm waters. The vibrant hues of the setting sun bathe the majestic mountains in the background, completing a picturesque scene of peaceful solitude."
    },
    {
      product_name: "Alpine Bliss",
      product_id: "7046652461122",
      product_text: "In a tranquil alpine paradise, a charming stone cottage nestles among lush gardens, with the serene lake reflecting the majestic, snowy peaks beyond. A wooden picnic table invites restful contemplation, set upon a cobblestone path amid a riot of colorful blooms."
    },
    {
      product_name: "Woodland Panorama",
      product_id: "7049574613058",
      product_text: "In a vibrant tapestry of life, an enchanted forest unfolds, where animals, flora, and fantasy coexist. A medieval maiden, the guardian of this verdant realm, stands serene among mythical and woodland creatures, as nature's chorus weaves tales of magic and harmony."
    },
    {
      product_name: "Mad Props",
      product_id: "7049577070658",
      product_text: "A young adventurer with kaleidoscopic eyes peers through rose-tinted glasses, a universe of whimsy atop her head adorned with timeless trinkets; each a story, a memory, a dream caught in the vivid tapestry of her journey. A living mosaic, where each vibrant artifact whispers of worlds unseen and tales untold."
    },
    {
      product_name: "San Francisco Trolley",
      product_id: "7049578577986",
      product_text: "Under the twilight sky, the historic Powell Street cable car clangs along the vibrant, rain-kissed streets, passing by rows of charming Victorian homes that stand as timeless sentinels to the city's rich history. The city's iconic skyline looms in the distance, bridging past and present in a single, luminous tableau."
    },
    {
      product_name: "A Creative Paws Voyage",
      product_id: "7049579954242",
      product_text: "The curious Shih Tzu sits amid a riot of colorful art supplies, its eyes gleaming with a blend of mischief and inspiration as it contemplates its next masterpiece. Surrounded by brushes poised in a jar and a palette smeared with the spectrum, this little artist embodies the joyful chaos of creativity."
    },
    {
      product_name: "Pink Owl",
      product_id: "7052026544194",
      product_text: "Perched amongst blooming flowers, a majestic owl with a plumage in shades of lilac and soft pink gazes intently forward. Its golden eyes are a stark contrast to the delicate petals whispering secrets of the quiet forest."
    },
    {
      product_name: "Spring Blooms on the Lake",
      product_id: "7052052758594",
      product_text: "As the sunset paints the sky in hues of fire, the cozy cottage by the lake stands amidst a kaleidoscope of flowers, with animals frolicking in the embrace of spring’s bloom. The air is alive with the whispers of nature, weaving a tale of peace and harmony in this untouched paradise."
    },
    {
      product_name: "Into the Deep of Me",
      product_id: "7052034113602",
      product_text: "In the vibrant depths of an underwater paradise, a serene woman adorned with a crown of colorful blooms meditates among the coral gardens, her presence a harmonious bridge between the aquatic symphony of life and the dappled sunlight dancing from above."
    },
    {
      product_name: "Star Light, Star Bright",
      product_id: "7052046106690",
      product_text: "Under the celestial dance of a twinkling night sky, a pair of otters float serenely, their fur mingling with the gentle ripples of the sea. Behind them, a solitary lighthouse stands as a vigilant sentinel, its beacon a warm contrast to the cool embrace of the encroaching dusk."
    },
    {
      product_name: "Tiger on a Rock",
      product_id: "7052057051202",
      product_text: "In a lush jungle oasis, a majestic tiger lounges on a moss-covered rock, gazing serenely at the viewer, while vibrant flora and fauna, including a leopard, parrots, and butterflies, thrive in the harmonious wild."
    },
    {
      product_name: "Spring Dream",
      product_id: "7052061966402",
      product_text: "In a vibrant garden blooming with the full spectrum of nature's palette, a quaint stone house sits nestled among the lively hues of spring. Animals roam freely, enjoying the tranquil beauty of a pond that reflects the kaleidoscope of colors from the surrounding flora."
    },
    {
      product_name: "Pastel Dreams",
      product_id: "7052059050050",
      product_text: "A fantastical maiden with cascading blonde hair adorned with a crystal unicorn horn and skull hair piece cradles a miniature unicorn in a world tinted with shades of purple. Her attire, a blend of gothic and ethereal elements, whispers of a dreamlike realm where magic and reality intertwine."
    },
    {
      product_name: "Rockin Spring",
      product_id: "7052060753986",
      product_text: "A vibrant blue macaw basks in the glory of a floral paradise, its feathers a cascade of azure and turquoise, mirroring the flamboyance of the pink and orange blossoms that envelop it. In this vivid tableau, nature's palette is unrestrained, painting a scene of radiant life and color."
    },
    {
      product_name: "Cooking in Paradise",
      product_id: "7060068663362",
      product_text: "A rustic kitchen basks in the golden hues of twilight, its windows framing a stunning vista of distant mountains and lush valleys. The room is alive with the day's last light, dancing over a robust wooden table set for an intimate feast."
    },
    {
      product_name: "Feeling Blue",
      product_id: "7066027196482",
      product_text: "In the twilight of an enchanted forest, a melancholic fairy with delicate, luminescent wings finds solace atop a giant mushroom, her gaze lost in the soft glow of magical orbs dancing around her."
    },
    {
      product_name: "Tribal Rainbow Goddess",
      product_id: "7066406191170",
      product_text: "In the embrace of a sunset that whispers the lore of ancient times, the Tribal Rainbow Goddess stands as a vibrant sentinel of dreams and traditions, her gaze cast towards a future as bright and mysterious as the spectrum painted upon her face."
    },
    {
      product_name: "Toucan With Heliconia Flowers",
      product_id: "7066404880450",
      product_text: "Perched among the lush greenery, a vibrant toucan with a kaleidoscope of blue feathers gazes curiously at the world, its orange beak a stark contrast to the delicate heliconia flowers blooming nearby."
    },
    {
      product_name: "Sugar-Coated Dreams",
      product_id: "7070363713602",
      product_text: "A whimsical girl with candy-pink hair gazes out dreamily, her head adorned with a playful assortment of sweets, symbolizing a mind brimming with sugar-coated fantasies and the joyful spirit of indulgence and imagination."
    },
    {
      product_name: "Reclining Leopard",
      product_id: "7070975000642",
      product_text: "A majestic leopard reclines amidst a vibrant tapestry of jungle flora, its gaze piercing through the kaleidoscope of colors. The air seems to hum with the whispers of the wild, every hue and petal a testament to the untamed beauty that flourishes under its watchful eyes."
    },
    {
      product_name: "Nothing Happens Unless",
      product_id: "7070974181442",
      product_text: "In an ethereal realm of mist and gentle hues, a maiden with auburn locks and her majestic dragon companion, rests upon the cradle of nature, guardians of the arcane and the hidden wonders that dwell within the whispering forest."
    },
    {
      product_name: "Village Under the Moon",
      product_id: "7070977687618",
      product_text: "Under the luminous full moon, nestled between the whispering trees of autumn, lies a quaint village where each warmly lit window tells a tale of cozy secrets. The crisp evening air carries the promise of stories yet to be told, as the leaves rustle in hushed anticipation."
    },
    {
      product_name: "Evening in Vegas",
      product_id: "7075878469698",
      product_text: "The neon lights of Las Vegas come alive as dusk falls over the bustling Strip, the iconic fountains of Bellagio dancing in sync to the rhythms of the night while visitors wander in awe, caught in the spell of the city's vibrant pulse."
    },
    {
      product_name: "Tony",
      product_id: "7076703207490",
      product_text: "A regal tiger dons steampunk goggles, adorned with golden gears and mechanical ornaments. It exudes a noble aura, as if presiding over a fantastical realm where wild elegance and Victorian innovation converge."
    },
    {
      product_name: "Pink Anthurium",
      product_id: "7075895017538",
      product_text: "In a lush, vibrant jungle, dew-kissed pink anthuriums bloom boldly against the backdrop of rich green foliage. Their glossy heart-shaped petals glistening under the dappled sunlight,  creating a symphony of colors and life in this enchanting tropical haven."
    },
    {
      product_name: "Morning View",
      product_id: "7075890102338",
      product_text: "In an elegant study, rays of the golden sun pierce through scattered clouds, casting a warm glow over the mountains and water, marrying the peace of early morning with the promise of a day full of potential."
    },
    {
      product_name: "Last Day Of School",
      product_id: "7075885973570",
      product_text: "Children gleefully circle around the iconic Little Red Schoolhouse, their laughter mingling with the soft rustle of the green leaves in the warm breeze. Overhead, vibrant hot air balloons ascend into the cerulean sky, celebrating the joy and freedom of the last day of school."
    },
    {
      product_name: "Fairy and Unicorn",
      product_id: "7082056646722",
      product_text: "In a serene forest clearing, aglow with the magic of twilight, a gentle maiden shares a tender moment with a majestic unicorn, their bond whispering tales of ancient enchantments as woodland creatures gather in silent reverence."
    },
    {
      product_name: "Boho Dreamer",
      product_id: "7082065690690",
      product_text: "The bohemian dreamer gazes into the distance, her soulful eyes filled with the mysteries of a thousand untold stories. Wrapped in a tapestry of vibrant patterns, her thoughts weave through time, captured in the dream catcher that dances with whispered secrets of the night."
    },
    {
      product_name: "Man's Best Friend",
      product_id: "7082062938178",
      product_text: "Amidst a canvas of vibrant neon dreams, a soulful canine gazes outward, its eyes pools of wistful longing as the electric hues of an untamed imagination dance across its thoughtful expression."
    },
    {
      product_name: "Rainbow Flower Path",
      product_id: "7092204339266",
      product_text: "In a vibrant world where the sky swirls with psychedelic hues, a woman adorned with a crown of flowers strides gracefully along a path lined with an endless spectrum of blooming flowers, leading to a radiant, warm horizon."
    },
    {
      product_name: "Dark Forest Heart",
      product_id: "7082068115522",
      product_text: "In a mystical forest shrouded in mist, a woman with silver locks and a tree branch mask gazes intensely, her heart enigmatically intertwined with wooden tendrils –blurring the line between humanity and the ancient woods, as if she is the guardian of its arcane secrets."
    },
    {
      product_name: "The Crimson Village",
      product_id: "7092206141506",
      product_text: "In a vibrant village, a cobblestone path weaves through a tapestry of blooming gardens to flower-adorned cottages with curved roofs sheltering stories of joy, as the air is perfumed with the mingling scents of a thousand blooms."
    },
    {
      product_name: "Canyon Express",
      product_id: "7092207517762",
      product_text: "The vintage steam locomotive of the Canyon Express, resplendent in its gold and blue livery, chugs steadily along the tracks, ready to carry its passengers through the breathtaking vistas of the red rock canyons."
    },
    {
      product_name: "Easter Gnome",
      product_id: "7097561317442",
      product_text: "In a vibrant garden blooming with flowers and dotted with colorful Easter eggs, three whimsical gnomes are in the midst of their springtime festivities: tending to a basket of freshly picked carrots, while his companions are joyfully seeking Easter treasures."
    },
    {
      product_name: "Dreams Do Come True",
      product_id: "7097563611202",
      product_text: "In a realm where fantasy blends with the hues of a twilight sky, enchanted creatures gather by a magical castle for the grand nocturnal jubilee. As unicorns roam and wise owls observe, the air sparkles with tales of yore, whispering secrets to those who believe."
    },
    {
      product_name: "Fairy Glowflies",
      product_id: "7097568231490",
      product_text: "In a realm where the starry night whispers secrets through a gentle glow, a fairy, luminescent and alluring, perches atop an ancient stone pedestal with her wings fluttering slightly, aglow with a constellation of tiny, soft lights."
    },
    {
      product_name: "Starry Night Watch",
      product_id: "7097570099266",
      product_text: "Once upon a time in a colorful, swirling world, a fluffy golden dog found itself in the midst of a magical night.  It gazes with gentle eyes, an endearing sentinel against the backdrop of a quaint, angular village where the colorful houses seem to dance under the cosmic display."
    },
    {
      product_name: "Little Farmer Girl",
      product_id: "7109792399426",
      product_text: "A young girl clad in a denim dress feeds a flock of chickens and chicks in a vibrant farmyard, as curious farm animals watch from their red barn. A heartwarming glimpse of childhood innocence and the simple joys of rural life."
    },
    {
      product_name: "Lake House",
      product_id: "7109795414082",
      product_text: "A Victorian house stands proudly amidst a symphony of vibrant flowers, shimmering on the tranquil lake as willows weep and cherry blossoms promise the magic of spring. Ducks glide across the water, completing a picturesque scene that seems plucked from a dreamer’s canvas."
    },
    {
      product_name: "You Lift Me Up",
      product_id: "7109822382146",
      product_text: "Two bears cuddle on a mossy forest floor, a tender moment observed by chirping birds and a curious frog. Enchanted by the vibrant flora and buzzing bees, their silent exchange celebrates the peaceful coexistence of nature’s creatures."
    },
    {
      product_name: "Loneliest Night",
      product_id: "7109886935106",
      product_text: "In the neon-soaked streets of a futuristic city, reflections dance on the wet pavement under an otherworldly sky. A solitary figure stands, enveloped in a contemplative aura, amidst the vibrant hum of urban life."
    },
    {
      product_name: "Gaia Dreaming",
      product_id: "7124186300482",
      product_text: "In a realm where the earth's whispers become visible, Gaia dreams of a world in harmony, her breaths blooming with the beauty of creation as birds dance between the clouds and the horizon mirrors the lushness of life."
    },
    {
      product_name: "Lush",
      product_id: "7124187480130",
      product_text: "Amidst a dance of vibrant hues, the blooms vied for the sun's affection, casting a tapestry of petals across nature's canvas. The garden's whispered melody, a symphony of colors, swirled in the gentle embrace of the morning light."
    },
    {
      product_name: "The Vase",
      product_id: "7124256424002",
      product_text: "In a mystical garden where the moonlight shimmers through emerald leaves, a creature born of flora and dreams tenderly cradles the bloom that pulses with the beat of the earth, her vibrant pink locks flowing like petals on the wind."
    },
    {
      product_name: "Vermont Church Fall Fair",
      product_id: "7124256587842",
      product_text: "A gentle horse grazes near a white picket fence as a quaint village celebrates the bounty of fall; vibrant mums and plump pumpkins adorn a colorful fair beside an old-timey church, while a classic truck rests by a historic red barn, embodying the essence of an autumn harvest festival."
    },
    {
      product_name: "Panda and Bubbles",
      product_id: "7141307744322",
      product_text: "A curious panda finds itself in a whimsical wonderland, its innocent eyes wide with amazement as it gazes through a swirling dance of colorful, iridescent bubbles floating around, reflecting a vibrant world of wonder and delight."
    },
    {
      product_name: "Backyard Wishing Well",
      product_id: "7141312856130",
      product_text: "In a vibrant garden brimming with flowers and life, three playful kittens engage in a delightful discovery of fluttering butterflies and curious birds around an old wishing well, bringing a sense of whimsy and enchantment to the bright summer day."
    },
    {
      product_name: "Lakeshore Opulence",
      product_id: "7141314691138",
      product_text: "In the golden hour of early evening, the warm light bathes an elegant lakeside balcony, revealing an opulent view of an ancient castle across the still water where the gentle breeze whispers through the autumn leaves, carrying tales of yore from the forest."
    },
    {
      product_name: "Fruitful Elegance",
      product_id: "7141317836866",
      product_text: "In a world where thoughts and dreams manifest vividly, a woman's mind blooms with the fruits of imagination, her ideas as bright and abundant as oranges in an ever-flourishing orchard of creativity."
    },
    {
      product_name: "Norse Tree of Life",
      product_id: "7154927861826",
      product_text: "A cosmic tree bursts with ethereal lights, anchoring an astral dreamscape where stars and nebulas are cradled in its boughs. Fiery roots sink into the chaos, a dance of creation and destruction in the vast universe's embrace."
    },
    {
      product_name: "Table For Two",
      product_id: "7154965348418",
      product_text: "Under a moonlit sky, a cozy terrace overlooks a vibrant coastal town, its lights dancing on the water as a guitar awaits a serenade. The gentle sea breeze carries whispers of distant melodies and the promise of a romantic evening in the timeless town."
    },
    {
      product_name: "Aphelandra Zebra and Butterflies",
      product_id: "7155031965762",
      product_text: "Two vibrant butterflies dance amongst the tropical blooms, their wings echoing the wild rhythms of the jungle's palette, while confetti-like patterns celebrate the joy of nature's vivid canvas."
    },
    {
      product_name: "Rainbow Castle",
      product_id: "7155057131586",
      product_text: "Under the night sky, a mystical castle shimmers with rainbow hues, its towers reaching for the stars as magical waterfalls glow with ethereal light. In this enchanted kingdom, every night unfolds a new tale of wonder and dreams come to life."
    },
    {
      product_name: "Country Still Life",
      product_id: "7186226643010",
      product_text: "In a quaint countryside adorned with a cascade of flowers and vibrant greenery, a charming thatched cottage stands as a timeless haven. Amidst this picturesque setting, a lively assembly of animals and birds gathers, celebrating the serene beauty of their whimsical world."
    },
    {
      product_name: "Zen Garden",
      product_id: "7186241192002",
      product_text: "In a hidden village where time stands still, ancient waterfalls cascade through vibrant cherry blossoms, merging the past with an everlasting spring. Each serene doorstep and moss-covered roof silently narrates centuries of peaceful coexistence with nature."
    },
    {
      product_name: "Grandma's Garden",
      product_id: "7186237423682",
      product_text: "A young girl in a vibrant garden gently offers a flower to a curious puppy, while surrounded by butterflies and blooming flowers, capturing a moment of innocent joy and connection with nature."
    },
    {
      product_name: "Tiger Sanctuary",
      product_id: "7186247024706",
      product_text: "In a vibrant jungle, a majestic white tiger with striking blue eyes watches over its territory, accompanied by its curious cub nestled among lush, colorful flowers, embodying the serene beauty and strength of the wild."
    },
    {
      product_name: "Blissgazing",
      product_id: "7200893108290",
      product_text: "In the embrace of a vivid sunset, a woman sits by her open window, lost in the serene beauty of a distant mountain range bathed in the glow of the dipping sun. An enchanting moment of peaceful solitude and reflection."
    },
    {
      product_name: "Paris Memories",
      product_id: "7200633028674",
      product_text: "Under the golden glow of lamp posts, a couple strolls along the Seine in Paris, passing under the Alexander III Bridge as the Eiffel Tower sparkles in the twilight, encapsulating a moment of timeless romance."
    },
    {
      product_name: "Peace",
      product_id: "7200620511298",
      product_text: "In the heart of a mystical forest, a serene Buddha sits in deep meditation, embodying peace amidst the vibrant chaos of nature's palette. Each leaf and blossom glows with life, echoing the tranquil harmony that flows from the enlightened presence."
    },
    {
      product_name: "Olivia’s Rebirth",
      product_id: "7202136293442",
      product_text: "A young girl with large, expressive eyes and a whimsical striped bow in her hair sits perched in a giant porcelain teacup. Accompanied by a vividly pink owl wearing a small crown, sharing a serene moment, surrounded by floating petals and a dreamy backdrop."
    },
    {
      product_name: "Pier Dogs",
      product_id: "7212049989698",
      product_text: "A young woman sits serenely on a wooden pier, her gaze lost in the distance where vibrant sailboats dot the shimmering sea, while her loyal dogs keep her company, embodying a scene of peace and joyous freedom."
    },
    {
      product_name: "Birds and Blooms",
      product_id: "7212044550210",
      product_text: "In a vibrant display of nature's palette, a symphony of colorful birds perches merrily along the rustic wooden fence. Their cheerful chorus mingles with the rustle of petals and leaves, creating a symphony of life at the edge of day."
    },
    {
      product_name: "My Brightest Dreams",
      product_id: "7212052447298",
      product_text: "In a whimsical world of clouds and shining stars, a girl with pastel purple hair and sparkling eyes enjoys a cool drink while surrounded by adorable, plush creatures, each radiating a sense of magical joy and innocence."
    },
    {
      product_name: "Mushroom Cottage River",
      product_id: "6939582070850",
      product_text: "In a whimsical land where giant mushrooms tower over a serene river, a quaint cottage nestled among vibrant pink trees. A magical sanctuary amid blossoming flora, inviting all who wander into this enchanted realm to pause and savor the whimsical beauty of nature's imagination."
    },
        {
      product_name: "Turtle Magic",
      product_id: "7212098256962",
      product_text: "In the vibrant underwater realm, a majestic sea turtle glides gracefully among colorful coral reefs, surrounded by a symphony of marine life. Bubbles dance around as a playful dolphin joins the turtle, creating a magical and serene oceanic scene."
    },
    {
      product_name: "Sip of Elegance",
      product_id: "7213846790210",
      product_text: "In a vibrant and whimsical world, a young woman adorned with a crown of flowers sips from a striped teacup. Her eyes, large and expressive, mirror the colors and patterns of her kaleidoscopic dress, creating an enchanting aura of elegance and imagination."
    },
    {
      product_name: "Mystic Church",
      product_id: "7212104613954",
      product_text: "Nestled atop a lush, vibrant hill overlooking a serene valley, the quaint church stands as a beacon of tranquility against the majestic backdrop of snow-capped mountains. The surrounding meadow bursts with a kaleidoscope of colors, painting the landscape with nature's own brush."
    },
    {
      product_name: "Croton",
      product_id: "7213858947138",
      product_text: "Amidst the vibrant dance of colors, the croton leaves unfurled, each one telling a story of the tropical sunlight it had soaked in. Their rich, mosaic hues blended together, creating a living tapestry that captured the essence of a lush, sunlit paradise."
    },
    {
      product_name: "The Red Pill",
      product_id: "7224713740354",
      product_text: "In a dark, whimsical world, a stern-faced girl with crimson curls and striped attire stands firm, exuding an eerie charm. Her intense gaze matched the eerie, green-skinned creature by her side. Dark balloons and shadows frame the duo, hinting at a world where the whimsical meets the macabre."
    },
    {
      product_name: "Tropical Birds",
      product_id: "7224720490562",
      product_text: "In a lush tropical paradise, vibrant parrots and a graceful flamingo gather amidst blooming flowers. Hummingbirds and butterflies flutter around, creating a lively and colorful scene filled with the beauty of nature."
    },
    {
      product_name: "Welcome the Light",
      product_id: "7224716853314",
      product_text: "In a mystical forest illuminated by vibrant, colorful blooms and glowing candles, a serene woman cradles a radiant orb, embodying the spirit of the rainbow. Surrounded by an aura of light and warmth, she welcomes the dawn, symbolizing hope and new beginnings."
    },
    {
      product_name: "Summer Lake Landscape",
      product_id: "7224722325570",
      product_text: "In the tranquil landscape, vibrant wildflowers bloom at the water's edge, reflecting the serene beauty of the snow-capped mountains. A peaceful lake mirrors the majestic peaks, creating a harmonious blend of colors and nature's splendor."
    },
    {
      product_name: "Golden Crescent",
      product_id: "7225092964418",
      product_text: "In the embrace of a golden crescent, a regal woman adorned with a floral crown and intricate jewelry stands, her hair flowing seamlessly into the starry sky. Butterflies and celestial objects float around her, creating a mesmerizing blend of nature and cosmic elements in an ethereal composition."
    },
    {
      product_name: "3 Vases Amsterdam",
      product_id: "7225094733890",
      product_text: "Colorful flowers in ornate vases are arranged before a picturesque view of Amsterdam's canal houses, framed by an arched stone window. Butterflies, birds, and books bring the scene to life, infusing it with a lively and enchanting atmosphere that captures the essence of a charming day in the city."
    },
    {
      product_name: "Wolf Monarch",
      product_id: "7225096011842",
      product_text: "A majestic wolf, with piercing blue eyes, stands adorned in elaborate gold patterns and jewel-like elements. The intricate and ornate design exudes a regal and mystical aura, blending the noble essence of the wolf with luxurious embellishments that highlight its commanding presence."
    },
    {
      product_name: "Rowen and Elm",
      product_id: "7225100009538",
      product_text: "In a lush, enchanted forest, Rowen and Elm, two ethereal figures with braided hair and vibrant feathers, stand in harmony with their surroundings. Their bodies, decorated with intricate tattoos and leaf-like garments, blend seamlessly with the woodland backdrop, creating a scene of magical unity with nature."
    },
    {
      product_name: "Radiant Rose Fantasy",
      product_id: "7239396819010",
      product_text: "Two luminous roses, depicted in vivid reds and oranges, stand out against a dazzling backdrop of blue and green hues. The intricate and colorful design captures the eye, creating a fantastical atmosphere that evokes a sense of wonder and magic."
    },
    {
      product_name: "Mermaid of the Deep",
      product_id: "7239384006722",
      product_text: "In a lush, green underwater world teeming with vibrant sea life, a mermaid with flowing hair and shimmering green scales gracefully cradles a small fish. Surrounded by colorful coral, playful eels, and drifting jellyfish, evoking a sense of magical beauty beneath the ocean's surface."
    },
    {
      product_name: "Train to Tokyo",
      product_id: "7239405666370",
      product_text: "As the golden rays of the setting sun bathe the city in a warm glow, a train pulls into the bustling station, reflecting the vibrant colors of the evening sky. Commuters stroll along the platform, surrounded by illuminated buildings and lush greenery, chatting and taking in the beauty of the moment."
    },
    {
      product_name: "In Bloom",
      product_id: "7239412023362",
      product_text: "In the heart of a charming, sunlit street, a quaint café overflows with vibrant flowers cascading down its facade, inviting passersby to pause and savor the serene atmosphere. A lone patron enjoys a quiet moment, immersed in the serene beauty of the blooming facade and the picturesque European alleyway."
    },
    {
      product_name: "Little Fawn's Autumn",
      product_id: "7249338302530",
      product_text: "In the heart of an autumn forest, a curious fawn ventured through the golden leaves, encountering fluttering monarch butterflies, a playful mouse enjoying juicy berries, and a watchful bird perched on a branch. Together, they created a vibrant, harmonious moment, capturing the essence of nature’s beauty in a single, magical day."
    },
    {
      product_name: "Colorful Stag",
      product_id: "7249344954434",
      product_text: "The forest came alive with a riot of colors as a noble stag appeared, its antlers glowing with a myriad of shades. The stag’s serene expression and the colorful environment created a harmonious vision of nature’s splendor."
    },
    {
      product_name: "Aurora Magnolia",
      product_id: "7249373823042",
      product_text: "In a starlit night, a magnificent magnolia bloom unfurled its petals, casting a radiant glow that mirrored the northern lights dancing in the sky above. The flower's ethereal beauty seemed to bridge the heavens and the earth, creating a magical connection between nature and the cosmos."
    },
    {
      product_name: "Arctic Glow",
      product_id: "7245443858498",
      product_text: "Under a canopy of stars, the northern lights painted the Arctic sky with vibrant hues of pink, green, and blue, casting a magical glow over the snow-covered landscape. As the colors danced above, the serene river mirrored the celestial display, creating a breathtaking moment of natural wonder."
    },
    {
      product_name: "In Paradise",
      product_id: "7249353310274",
      product_text: "Nestled between verdant hills and under a sky painted with soft clouds, a sparkling stream meandered through colorful wildflowers, leading the eye towards towering mountains. This tranquil haven was a testament to the untouched beauty of nature, inviting all who saw it to pause and marvel."
    },
    {
      product_name: "Feathered Duet",
      product_id: "7245519159362",
      product_text: "Beneath an arch of vibrant blossoms, two bluebirds sat closely on a branch, bathed in the radiant hues of the stained glass backdrop. This enchanting scene captured a moment of quiet connection and the timeless elegance of nature's artistry."
    },
    {
      product_name: "Dressed to Kill",
      product_id: "7245495140418",
      product_text: "With eyes as captivating as the midnight sky, she stood poised, a swirl-adorned hat adding an air of mystery to her ethereal presence. Dressed in dark, intricate attire adorned with pearls and gems, she was a vision of gothic elegance, blending beauty with an enigmatic allure."
    },
    {
      product_name: "Garden Dahlias",
      product_id: "7249350852674",
      product_text: "In a sunlit garden, a vibrant bouquet of dahlias burst into bloom, their vivid hues of pink, yellow, and red creating a captivating display. The garden, alive with the energy of summer, offered a serene escape where every petal told a story of growth and renewal."
    },
    {
      product_name: "Koi Carp And Peach Flowers",
      product_id: "7245534363714",
      product_text: "In a tranquil pond adorned with blooming pink flowers, three koi fish glided gracefully, their vibrant scales reflecting the gentle light. Each movement and ripple told a story of harmony and elegance, creating a peaceful and mesmerizing underwater ballet."
    },
    {
      product_name: "Lakeside Solitude",
      product_id: "7245527908418",
      product_text: "As the sun set, casting a warm glow over the horizon, a brightly painted camper van rested by a peaceful lake. The vibrant sky was perfectly mirrored in the still waters, creating a scene that captured the essence of freedom and tranquility, where every hue told a story of endless adventures and serene moments."
    },
    {
      product_name: "Bird Sanctuary",
      product_id: "7242961125442",
      product_text: "A whimsical figure with flowing pastel pink hair adorned by a mechanical bird captivates with her striking green eyes and ruby red lips. Her intricate ruffled collar and bodice, along with the heart-shaped accessory she holds, evoke a dreamlike, ethereal atmosphere."
    },
    {
      product_name: "Panda Magic",
      product_id: "7239424573506",
      product_text: "A vibrant panda is surrounded by a lush, colorful jungle of flowers and leaves, with a spectrum of bright colors and a glowing rainbow in the background. The scene radiates a magical, enchanting atmosphere, with intricate details and a sense of whimsical wonder."
    },
    {
      product_name: "June Garden",
      product_id: "7242966237250",
      product_text: "A picturesque garden brims with a riot of colorful blooms, featuring vivid red lilies, cheerful white daisies, and an assortment of yellow, blue, and orange flowers. The lush foliage and gentle, hazy sky backdrop convey a peaceful, thriving summer landscape."
    },
    {
      product_name: "Autumn Snow Cardinal",
      product_id: "7242971021378",
      product_text: "A vivid cardinal perches among vibrant red and white poinsettias, with the warm glow of a rustic house in the background. The striking colors and cozy light evoke a festive, holiday spirit."
    },
    {
      product_name: "London Bridge",
      product_id: "7245507297346",
      product_text: "In the heart of the evening, London Bridge glowed softly, its lights reflecting in the tranquil waters of the Thames. The surrounding lampposts cast a warm, inviting light, making the historic bridge a beacon of history and elegance in the bustling city."
    },
    {
      product_name: "Flowering Window",
      product_id: "7245530988610",
      product_text: "In a small, forgotten village, an old cottage stood with its window adorned by blooming lilacs, filling the air with their sweet fragrance. Each morning, as the first light kissed the petals, it was as if the lilacs whispered secrets of the past to the gentle pottery and jugs that kept them company."
    },
    {
      product_name: "Snow Leopard Serenity",
      product_id: "7249372610626",
      product_text: "In the heart of a serene winter forest, a wide-eyed snow leopard cub sat amidst gently falling snowflakes, its deep blue eyes reflecting the twilight sky. The cub's innocent curiosity brought a touch of magic to the tranquil, snowy landscape, as if the forest itself was holding its breath in awe of the little creature's wonder."
    },
    {
      product_name: "Dainty Daisies",
      product_id: "7249352491074",
      product_text: "In a sunlit meadow, a cluster of cheerful daisies swayed gently in the breeze, their white petals glowing against the vibrant greenery. Each daisy seemed to whisper secrets of joy and renewal, creating a serene and uplifting scene of natural beauty."
    },
    {
      product_name: "Kawaii In The Clouds",
      product_id: "7249366089794",
      product_text: "Floating gently on a soft, glowing cloud, a girl with enchanting rainbow curls marveled at the beauty of the cosmos surrounding her. With each twinkle of the stars, she imagined herself on an interstellar adventure, spreading joy and wonder across the galaxy."
    },
    {
      product_name: "Blooms and Wings",
      product_id: "7249358880834",
      product_text: "In a vibrant garden teeming with life, colorful butterflies danced gracefully among the bright blooms of sunflowers, daisies, and bluebells. The air was filled with the sweet scent of flowers and the delicate flutter of wings, celebrating the enchanting beauty of spring."
    },
    {
      product_name: "Peaceful Parrot",
      product_id: "7245518340162",
      product_text: "In a vibrant jungle, a majestic parrot perched on a branch, its feathers glowing like stained glass against the lush greenery. The parrot's gaze met a brilliant hibiscus bloom, creating a scene of serene beauty and harmony in the heart of the tropical forest."
    },
    {
      product_name: "Living Color Wolf",
      product_id: "7249343905858",
      product_text: "In a world painted with every hue of the rainbow, a majestic wolf stood as a guardian of the forest, its vibrant fur glowing with the colors of the aurora. The wolf's piercing green eyes held a wisdom that transcended the kaleidoscope around it, symbolizing the harmony between wild spirit and natural beauty."
    },
    {
      product_name: "Coffee Sugar Cream",
      product_id: "7245540917314",
      product_text: "Indulge in the rich aroma of freshly brewed coffee and the sweetness of cookies, while basking in the cheerful ambiance created by an array of colorful tulips. This serene moment, promises a perfect start to your day, blending comfort and beauty seamlessly."
    },
    {
      product_name: "Coastal Serenity",
      product_id: "7245532725314",
      product_text: "As the sky turned a deep shade of purple, the lighthouse stood as a guardian of the coast, its light a comforting presence for sailors far from home. The keeper's cottage, nestled beneath the towering structure, echoed with tales of bravery and the enduring spirit of those who face the ocean's might."
    },
    {
      product_name: "Ocean Spirit",
      product_id: "7256443093058",
      product_text: "In the heart of the vibrant ocean, the Ocean Spirit watched over her realm with serene wisdom, her intricate adornments and vivid colors reflecting the beauty and power of the sea. Dolphins danced through the waves and turtles glided below, all in harmony under her protective gaze."
    },
    {
      product_name: "Creepy Cute Twins",
      product_id: "7256470061122",
      product_text: "In a whimsical yet eerie room adorned with skulls and floral patterns, two identical girls stand side by side, dressed in pale blue dresses with pink bows, each holding a plush toy. Their mysterious expressions and the contrasting backdrop blend childhood innocence with an intriguing dark twist."
    },
    {
      product_name: "Window of the World",
      product_id: "7256457150530",
      product_text: "An ornate, sunlit portal opens to a magical realm, revealing a fantasy cityscape bathed in the radiant hues of sunrise. Rich, glowing colors and intricate details bring to life the enchanting scene, where the play of light and shadow creates a mesmerizing, dreamlike atmosphere."
    },
    {
      product_name: "Unicornio",
      product_id: "7256484610114",
      product_text: "In a realm where fantasy comes alive, unicorns wandered through a garden of vibrant blooms and crystal-clear streams, their elegance unmatched in the mystical landscape. The grandeur of a castle in the distance spoke of royal lineage and fairy tales, enhancing the aura of magic that enveloped the serene valley."
    },
    {
      product_name: "Cobalt Macaw",
      product_id: "7245516472386",
      product_text: "In the vibrant heart of the rainforest, the cobalt macaw perched regally amidst a burst of colorful flowers, its brilliant blue feathers shimmering like precious gems. The bird's majestic presence and the dazzling array of flowers created a scene of unparalleled beauty and vibrant life."
    },
    {
      product_name: "American Star Welcome",
      product_id: "7245544259650",
      product_text: "With a warm embrace of patriotic colors and charming symbols, this cheerful welcome sign invites guests to step into a space filled with love and pride. The vibrant stars and hearts stitched together, create a heartfelt greeting that celebrates both unity and warmth."
    },
    {
      product_name: "Aurora Sunflower",
      product_id: "7249362190402",
      product_text: "In a galaxy of twinkling stars, a sunflower unfurls its vibrant petals, glowing with an ethereal light that mirrors the auroras dancing above. This mesmerizing fusion of floral elegance and cosmic wonder invites you to marvel at the interconnected beauty of earth and sky."
    },
    {
      product_name: "Begonia Maculata",
      product_id: "7249347412034",
      product_text: "In a burst of vibrant colors, the begonia maculata's spotted leaves and delicate blooms capture the eye, their unique patterns highlighted by the rich, colorful backdrop. This lively composition invites you to appreciate the intricate beauty and joyful vibrancy of nature's artistry."
    },
    {
      product_name: "Swallowtails and Hummingbird",
      product_id: "7257779765314",
      product_text: "In a garden brimming with life, a hummingbird hovers near vibrant pink lilies, while butterflies flutter gracefully among the blossoms. This enchanting scene captures the delicate dance of nature's beauty, celebrating the harmony and vitality of the blooming flowers and their winged visitors."
    },
    {
      product_name: "Pastel Visions",
      product_id: "7257891078210",
      product_text: "Under a sky painted with vibrant pastels, a magnificent tree flourishes, its multicolored foliage creating a breathtaking tapestry of nature's beauty. As the light filters through the branches, the tranquil waters below mirror the radiant scene, capturing the essence of a mystical, serene paradise."
    },
    {
      product_name: "Light Meets Light",
      product_id: "7257800212546",
      product_text: "In a state of deep meditation, a serene figure is enveloped by a vibrant explosion of colors and light that radiates from within, symbolizing inner peace and spiritual awakening. The vivid and intricate design brings to life a mystical, otherworldly experience."
    },
    {
      product_name: "Captain Jackitty",
      product_id: "7257854017602",
      product_text: "Captain Jackitty, the fierce feline pirate, stood proudly at the helm of his ship, his loyal parrot perched on his shoulder, both ready to embark on another daring adventure. As the golden sun set on the horizon, their eyes gleamed with the promise of untold treasures and legendary exploits on the high seas."
    },
    {
      product_name: "Halloween Gnome and Cat",
      product_id: "7245535772738",
      product_text: "Under the glowing full moon, a whimsical gnome with his trusty black cat perched among the carved pumpkins, each one glowing with a mischievous grin. They stood in the heart of the Halloween night, where magic and mystery danced in the air, surrounded by fluttering bats and falling autumn leaves."
    },
    {
      product_name: "Ladybug Lounge",
      product_id: "7245457522754",
      product_text: "In a serene garden, a ladybug embarked on its morning adventure, discovering a sea of delicate pink blossoms where it could rest its weary wings. Amidst the soft petals, the ladybug nestled into the floral embrace, finding a peaceful haven in the heart of the blooming paradise."
    },
    {
      product_name: "Nordic Christmas Village",
      product_id: "7245525450818",
      product_text: "In the heart of a snow-kissed village, quaint houses adorned with twinkling lights stand proudly amidst the frosty trees, each branch glistening with winter’s touch. The quiet, moonlit night whispers of cozy firesides and festive cheer, as the village comes alive with the magic of Christmas."
    },
    {
      product_name: "Monstrous",
      product_id: "7245503201346",
      product_text: "In the eerie glow of a moonlit night, she emerges with an aura of dark enchantment, her eyes piercing through the shadows. Adorned with twisted horns and gothic accessories, she exudes an otherworldly charm, embodying the essence of a bewitching night."
    },
    {
      product_name: "She Shed",
      product_id: "7275271749698",
      product_text: "Nestled in a vibrant garden, the enchanting She Shed glows with shades of pink and purple, inviting you into a cozy sanctuary. Surrounded by blooming flowers and butterflies, this whimsical retreat promises a world of relaxation and creativity, where every detail tells a story of tranquility and charm."
    },
    {
      product_name: "Spectrum Express",
      product_id: "7275275288642",
      product_text: "As the vintage steam train chugs along the tracks, the vibrant stained-glass sky bursts into a kaleidoscope of colors with the setting sun. The train's bright headlights pierce through the dusk, guiding it through the dazzling landscape."
    },
    {
      product_name: "Glimmer",
      product_id: "7275290591298",
      product_text: "In a realm where fantasy meets vibrancy, a mesmerizing figure stands out with a rainbow unicorn horn and intricate hair accessories. Cradling a small, multicolored unicorn, her intense gaze and bold attire weave a tale of enchantment and mystery, capturing the essence of a magical world."
    },
    {
      product_name: "Meadow Fairy",
      product_id: "7275279712322",
      product_text: "In a moonlit meadow, a gentle fairy with shimmering wings and a crown of blossoms sits amidst the flowers, her eyes sparkling with wonder. Butterflies dance around her, adding to the magic of the serene landscape as she radiates an enchanting aura."
    },
    {
      product_name: "Summer Splendor",
      product_id: "7249340006466",
      product_text: "A curious bunny gazes up at a delicate hummingbird amidst vibrant flowers, while butterflies flutter nearby. The soft light casts a gentle glow over the scene, adding a touch of enchantment to the serene meadow."
    },
    {
      product_name: "Spring Birds Flowers",
      product_id: "7249328504898",
      product_text: "As spring awakens, vibrant tulips and daffodils burst into bloom, filling the garden with a symphony of colors. Nearby, cheerful birds chirp and flutter around a quaint birdhouse, celebrating the season of renewal and life."
    },
    {
      product_name: "Look of the Wild",
      product_id: "7249341120578",
      product_text: "The owl's intense gaze, framed by a riot of vivid feathers, draws you into a realm of vibrant wonder. Every detail, from the brilliant eyes to the kaleidoscope of colors in its plumage, tells a story of nature's splendor and mystery."
    },
    {
      product_name: "Psychedelic Christmas",
      product_id: "7245526335554",
      product_text: "On a magical winter night, a joyful snowman with a rainbow scarf and hat stands under a swirling, colorful sky. The snow-covered landscape and twinkling lights from a cozy cabin create a whimsical scene filled with festive wonder."
    },
    {
      product_name: "Budapest",
      product_id: "7281333207106",
      product_text: "As twilight descends upon the city of Budapest, the lights of the grand Parliament building and the iconic Chain Bridge cast a golden glow over the Danube River. A romantic terrace, adorned with flowers and a candlelit table, invites you to savor the enchanting view of this historic and picturesque city."
    },
    {
      product_name: "Floral Nectar",
      product_id: "7275283251266",
      product_text: "In a vibrant garden, a hummingbird flits gracefully from flower to flower, its iridescent feathers glinting like jewels in the sunlight. The delicate flowers and lush greenery create a stunning backdrop for the bird's graceful dance, capturing the essence of nature's beauty and vitality."
    },
    {
      product_name: "Above the Coast",
      product_id: "7275269685314",
      product_text: "Above the rocky coast, vibrant patches of wildflowers burst into color, contrasting beautifully with the evergreen trees that frame the scene. The serene ocean in the distance and the vivid hues of the foliage create a breathtaking scene of nature's splendor."
    },
    {
      product_name: "Crystal Forest Leopard",
      product_id: "7281389043778",
      product_text: "Bathed in the light of a full moon, a majestic leopard lounges on a moss-covered rock, its sleek, spotted coat glistening in the night. Surrounded by towering trees and blooming flowers, the leopard gazes into the distance, embodying the silent, wild beauty of the enchanted forest."
    },
    {
      product_name: "Christmas Cupcake",
      product_id: "7249330765890",
      product_text: "In a cozy kitchen, a delightful Christmas cupcake takes center stage, adorned with a sparkling star and snowy white frosting. Candy canes and festive ornaments surround the scene, capturing the warmth and joy of holiday baking."
    },
    {
      product_name: "Blossom Unicorn",
      product_id: "7245514768450",
      product_text: "In a magical garden, a majestic unicorn with a flowing, pastel-colored mane stands amidst vibrant blooms, its horn gleaming in the sunlight. The stained-glass scene captures the moment where fantasy and nature unite, creating a tapestry of enchantment and beauty."
    },
    {
      product_name: "Pearl",
      product_id: "7245501595714",
      product_text: "In the shadowy depths of an enchanted forest, a mystical fairy cradles a tiny dragon, its emerald scales glistening in the dim light. Her delicate wings shimmer with iridescent hues, reflecting the ethereal bond between the two magical beings."
    },
    {
      product_name: "Layla",
      product_id: "7245524107330",
      product_text: "A charming leopard cub with striking blue eyes, nestled among a vibrant array of tropical flowers and lush foliage. Bathed in warm, golden light, the scene exudes a dreamy, enchanting atmosphere, with the delicate petals and leaves framing the cub's curious and innocent expression."
    },
    {
      product_name: "A Church for all Seasons",
      product_id: "7275291705410",
      product_text: "Across the seasons, a charming village church graces the landscape, its beauty evolving with time. Spring surrounds it with a burst of colorful flowers; summer bathes it in warm sunlight; autumn decorates it with rich, golden foliage; and winter wraps it in a serene layer of snow, illuminated by holiday lights."
    },
    {
      product_name: "Butterfly Birthday",
      product_id: "7275285577794",
      product_text: "A symphony of colors comes to life as butterflies dance among a sea of vibrant blooms. Sunflowers, daisies, and delicate pink blossoms create a joyful tapestry, celebrating the beauty and abundance of nature."
    },
    {
      product_name: "Forever Wonderland",
      product_id: "7275290329154",
      product_text: "In a fantastical world, a young woman with piercing eyes is encircled by a flamboyant array of flamingos. Her intricate outfit, embellished with enigmatic accessories, evokes a sense of wonder and mystery, as if she has stepped out of a dreamlike adventure."
    },
    {
      product_name: "Birthday Celebration",
      product_id: "7281324228674",
      product_text: "A joyful chimpanzee dressed for a celebration, donning a bright party hat and a festive lei. Surrounded by colorful balloons and confetti, the chimpanzee beams with happiness, holding a party blower in its mouth, creating a lively and cheerful atmosphere."
    },
    {
      product_name: "Waterfall Oasis",
      product_id: "7245488848962",
      product_text: "In a mystical realm where colors dance in harmony, a majestic tree stands proudly atop a serene waterfall, its leaves a vibrant mosaic shimmering under a radiant rainbow. Beneath its boughs, a tranquil stream flows through a lush, enchanted garden, where every blossom whispers secrets of nature's wonder and magic."
    },
    {
      product_name: "Sydney Opera House",
      product_id: "7245505462338",
      product_text: "As dusk settles over Sydney, the iconic Opera House glows with ethereal light, its sails shimmering against the twilight sky. Across the tranquil waters, the Harbour Bridge stands tall, its lights reflecting on the rippling surface, creating a scene of serene urban beauty framed by the gentle glow of vintage street lamps."
    },
    {
      product_name: "Mystic Raven",
      product_id: "7245529514050",
      product_text: "In a twilight realm painted with hues of lavender and pink, a regal raven stands watch over an expanse of blooming purple flowers. The landscape stretches into misty mountains, where the interplay of light and shadow weaves a tapestry of magic and mystery."
    },
    {
      product_name: "Toadstool Tales",
      product_id: "7245520764994",
      product_text: "In the heart of a magical forest, where giant dragonflies glide gracefully through the air, vibrant toadstools rise like fairy homes amidst a garden of delicate wildflowers. Here, the whisper of wings and the gentle hum of nature create a symphony of enchantment and serene beauty."
    },
    {
      product_name: "Frost Bunny",
      product_id: "7281420959810",
      product_text: "In an enchanted forest bathed in moonlight, a whimsical frost bunny glows with an ethereal blue radiance, its fur shimmering with intricate patterns of luminescent light. The delicate flora around it twinkles in harmony, creating a magical tableau where every leaf and petal seems to whisper the secrets of this mystical creature's world."
    },
    {
      product_name: "Garden Delight",
      product_id: "7275274174530",
      product_text: "In a lively garden filled with blooming tulips and rich foliage, a cheerful garden gnome waters the plants with a contented smile, while a Yorkshire Terrier with a red bow watches curiously. The scattered seeds and whimsical mushrooms add a touch of enchantment, creating a vibrant and joyful scene."
    },
    {
      product_name: "Radiant Sky Retreat",
      product_id: "7275282038850",
      product_text: "In the glow of a radiant sunset, a serene retreat by the water's edge invites tranquility and reflection, with its wooden structure bathed in warm, golden light. The sky, ablaze with vibrant hues and streaked with stars, mirrors in the peaceful stream below, creating a magical scene of natural beauty and serene elegance."
    },
    {
      product_name: "Country Life",
      product_id: "7281406017602",
      product_text: "On a sunny day in the countryside, a vintage truck parked by a charming farmhouse is filled with adorable Labrador puppies, eagerly exploring their surroundings. Bright sunflowers and colorful wildflowers bloom in the foreground, while butterflies flit around, adding to the joyful and serene atmosphere of this pastoral scene."
    },
    {
      product_name: "Sunset Serenity",
      product_id: "7245427376194",
      product_text: "As the sun sets over a breathtaking mountain landscape, two vibrant hot air balloons float gracefully through the sky, their colors reflecting in the serene waters below. The sky is ablaze with a stunning array of oranges, pinks, and purples, casting a warm glow over the autumnal trees and painting a scene of tranquility and wonder."
    },
    {
      product_name: "Signs of Spring",
      product_id: "7249334829122",
      product_text: "Perched on a branch adorned with delicate pink blossoms, a bright bluebird gazes serenely over a sunlit meadow, where a quaint red barn nestles in the distance. Nearby, a busy bee flits among the flowers, adding to the idyllic springtime scene filled with vibrant colors and the promise of new beginnings."
    },
    {
      product_name: "Tea and Friendship",
      product_id: "7249354948674",
      product_text: "In a cozy autumn scene, a charming teapot adorned with bright yellow flowers stands as the centerpiece, surrounded by colorful falling leaves. A friendly bird wearing a purple polka-dot scarf and a curious mouse share a moment together, embodying the warmth and camaraderie of the season."
    },
    {
      product_name: "Mosaic Monarch",
      product_id: "7245517619266",
      product_text: "A radiant butterfly unfurls its wings in a symphony of orange, yellow, and red, reminiscent of stained glass catching the morning sun. Nestled amidst a tapestry of lush, multicolored foliage, this exquisite creature becomes a vibrant beacon of nature's delicate artistry."
    },
    {
      product_name: "Majestic Cat",
      product_id: "7275281350722",
      product_text: "A majestic cat lounges on a luxurious, intricately designed throne, its calm yet commanding gaze accentuated by a dazzling, jewel-encrusted collar. The vivid colors and detailed patterns of the throne highlight the cat's royal demeanor, evoking a sense of grandeur and sophistication."
    },
    {
      product_name: "Chesapeake Bay",
      product_id: "7281345462338",
      product_text: "Under the soft glow of lampposts, a picturesque park in Chesapeake Bay comes alive at dusk, its pathways glistening from a recent rain. The serene waters reflect the twinkling lights and blooming cherry blossoms, while swans glide gracefully, adding to the enchanting ambiance of this tranquil urban oasis."
    },
    {
      product_name: "Hers",
      product_id: "7281376428098",
      product_text: "This chic bathroom features a clawfoot tub adorned with plush towels, an ornate chandelier casting a warm glow, and a vanity topped with fresh pink roses. The scene is completed with vintage high-heeled slippers, a cozy rug, and a tea set ready for a serene moment of relaxation, exuding elegance and comfort."
    },
    {
      product_name: "Lighthouse Haven",
      product_id: "7277703135298",
      product_text: "As the sun dips below the horizon, casting a golden glow over the sea, a stately lighthouse beams its light across the waves, while a charming cottage nestles amidst blooming flowers and lush greenery. The tranquil scene, with its mix of natural beauty and rustic charm, creates a perfect haven of serenity and warmth."
    },
    {
      product_name: "Sakura Season",
      product_id: "7245537902658",
      product_text: "In a serene scene of Sakura season, a young girl stands on a vibrant red bridge, her kimono adorned with delicate cherry blossoms. With a gentle smile and a red bow in her hair, she interacts with two tiny birds perched on the blooming branches, creating a heartwarming moment of harmony with nature."
    },
    {
      product_name: "Sleeping Beauty",
      product_id: "7245467615298",
      product_text: "In an enchanting forest nook, a white rabbit sleeps peacefully, cradling a delicately painted egg. Surrounded by lush, vibrant foliage and colorful, intricate patterns, the scene captures a moment of tranquil beauty and quiet wonder."
    },
    {
      product_name: "Wild Rainbow Flowers",
      product_id: "7249377984578",
      product_text: "In a vibrant, whimsical landscape, a brilliant rainbow arches over a field of colorful wildflowers, each blossom radiating with bold, cheerful hues. Butterflies flutter among the flowers, adding a sense of lively joy and magical serenity to this enchanting scene."
    },
    {
      product_name: "Twilight Fae",
      product_id: "7245479280706",
      product_text: "In the mystical twilight, a charming fairy with soulful, large eyes and flowing, golden hair crowned with vibrant flowers kneels beside a still pond. Surrounded by glowing fireflies and graceful butterflies, she gazes into the water, capturing the ethereal and magical essence of the enchanted woodland."
    },
    {
      product_name: "Wilderness Haven",
      product_id: "7275283415106",
      product_text: "In a picturesque wilderness, a cozy log cabin nestled beside a flowing river, surrounded by the vibrant colors of autumn. Majestic mountains loom in the background, while a bear, a deer, and various waterfowl create a lively scene, evoking the tranquil beauty of nature."
    },
    {
      product_name: "Gardens Of Varenna",
      product_id: "7281361616962",
      product_text: "A picturesque walkway under a vine-covered pergola guides the eye towards a serene lakeside, framed by towering, sunlit mountains. Elegant villas and vibrant gardens border the lake, their reflections dancing on the water, creating a scene of tranquil and timeless beauty."
    },
    {
      product_name: "Tiger Blossom",
      product_id: "7275278434370",
      product_text: "A young tiger peeks out from a lush jungle, its green eyes gleaming with curiosity amidst the vibrant foliage. Surrounded by colorful flowers and dense leaves, the scene captures the raw beauty and wonder of the wild."
    },
    {
      product_name: "Berry Voodoo",
      product_id: "7275290067010",
      product_text: "A whimsical, gothic-inspired doll with striking mismatched eyes and stitched seams, conveying a blend of playful charm and eerie mystery. The doll's dark hair and vibrant accessories add to its unique, captivating presence."
    },
    {
      product_name: "Shaggy Sweetness",
      product_id: "7245522763842",
      product_text: "In a lush garden brimming with colorful blooms, a Highland cow with a crown of flowers nestled in its shaggy fur gazes serenely ahead. The gentle giant, surrounded by vibrant petals, exudes a peaceful and whimsical charm that captivates the heart."
    },
    {
      product_name: "Yin-Yang Fusion",
      product_id: "7325792895042",
      product_text: "A celestial dance of Yin and Yang unfolds amidst swirling clouds of deep oceanic blues and fiery dawn hues, where opposing forces meld in perfect harmony. Vibrant reds, oranges, and soft pastels weave together in a cosmic embrace, evoking an eternal balance within the universe's ever-changing tides."
    },
    {
      product_name: "Summer Dreaming",
      product_id: "7325788962882",
      product_text: "A lush bouquet of summer blooms bursts forth in vibrant hues of pink, yellow, and soft pastels, each petal delicately rendered to capture the freshness of a garden in full bloom. The flowers, layered in a harmonious cascade of colors, seem to dance with the light, evoking the warmth and abundance of a sunlit day."
    },
    {
      product_name: "Twilight Howl",
      product_id: "7245513228354",
      product_text: "As the full moon rises, a wolf stands tall, its haunting howl piercing the twilight. The sky, painted in a stunning stained-glass mosaic of colors, mirrors the wild spirit of the wolf, capturing the magic and mystery of the nocturnal world."
    },
    {
      product_name: "Moody Beauty",
      product_id: "7275270996034",
      product_text: "A lush bouquet of vibrant flowers bursts forth with deep purples, rich reds, and soft pinks, creating a striking contrast against the delicate background. Each bloom seems to exude its own personality, combining to form a captivating display of natural beauty and intricate detail."
    },
    {
      product_name: "Rainbow Girl and Cat",
      product_id: "7281396383810",
      product_text: "Seated on a cloud in a fantastical sky, a girl with curly purple hair and a jeweled crown cuddles her charming white cat. Surrounded by rainbows and sparkling stars, the scene radiates enchantment and the pure delight of a whimsical dreamland."
    },
    {
      product_name: "Dockside Quilts",
      product_id: "7275293507650",
      product_text: "Colorful quilts sway gently in the breeze, drying in the sunlight against a backdrop of charming seaside cottages and anchored boats. The scene captures a peaceful moment of daily life, filled with warmth and the simple beauty of a quaint harbor town."
    },
    {
      product_name: "Lavender Majesty",
      product_id: "7281298243650",
      product_text: "Bathed in the soft glow of twilight, a beautiful elf adorned with a flower crown stands amidst a lavender woodland. Her shimmering wings and intricate jewelry catch the light, enhancing the magical and regal aura of this serene scene."
    },
    {
      product_name: "Be True To You",
      product_id: "7325800464450",
      product_text: "Amidst a vibrant explosion of rainbows, smiling flowers, and glittering stars, the words Be True to You! stand boldly, encouraging a joyful embrace of individuality and self-expression. The art is a lively celebration of positivity, radiating a sense of freedom and colorful optimism."
    },
    {
      product_name: "Vintage Christmas Kitten",
      product_id: "7325804429378",
      product_text: "Underneath a twinkling Christmas tree, a fluffy kitten with wide, curious eyes sits among beautifully wrapped presents, as if waiting to join in the holiday cheer. The scene is filled with warmth and festive joy, capturing a moment of pure innocence and wonder."
    },
    {
      product_name: "Seaside Serenity",
      product_id: "7325797482562",
      product_text: "Perched along a vibrant coastline, a cluster of colorful houses clings to the hillside, their warm tones glowing under a clear blue sky. The serene waves gently lap at the sandy shore, while sailboats dance in the distance, creating a picturesque seaside village that feels like a hidden paradise."
    },
    {
      product_name: "Clockwork Owl",
      product_id: "7325802758210",
      product_text: "A curious owl stands adorned in steampunk attire, complete with round goggles and a detailed vest. With its mechanical hat and sharp talons gripping the branch, the owl exudes a mix of wisdom and whimsy, as if it belongs to a world where nature meets machinery."
    },
    {
      product_name: "Alpine Serenity",
      product_id: "7275282726978",
      product_text: "A charming log cabin stands surrounded by blooming pink and purple flowers in a peaceful alpine valley. The crystal-clear stream and towering mountains in the background add to the idyllic and serene atmosphere of the scene."
    },
    {
      product_name: "Goldilocks",
      product_id: "7275290886210",
      product_text: "In a dark, magical landscape, a girl with blonde hair and smoky eyeshadow holds three adorable bear cubs. The contrast of her elegant attire and playful hair accessories creates a captivating blend of gothic charm and fantasy."
    },
    {
      product_name: "Mangrove",
      product_id: "7281416306754",
      product_text: "A luminous tree with sprawling roots and glowing branches rises above a serene, reflective pool in a magical forest. The interplay of light and shadow creates a mesmerizing atmosphere, highlighting the enchanting and mystical essence of this enchanted woodland."
    },
    {
      product_name: "Elephant Moonrise",
      product_id: "7275291476034",
      product_text: "A majestic black elephant, adorned with intricate gold and red patterns, stands gracefully amidst blooming white flowers, exuding an aura of timeless strength and wisdom. Under the soft glow of a crimson moon decorated with cherry blossoms, the scene radiates a serene, mystical beauty where nature and spirituality harmoniously intertwine."
    },
    {
      product_name: "Morning View Positano",
      product_id: "7281371512898",
      product_text: "Overlooking a vibrant coastal town, colorful buildings cascade down the hillside towards the sparkling blue sea. Boats drift lazily in the harbor, while lush greenery and blooming flowers add to the picturesque charm of this sunlit Mediterranean scene."
    },
    {
      product_name: "Starlit Stove",
      product_id: "7275276664898",
      product_text: "In a cozy, enchanting scene, a vintage stove sits under a starlit sky, surrounded by vibrant flowers and lush greenery. The warm glow of the full moon illuminates a serene landscape of rolling hills and distant mountains, where small cottages nestle, exuding a sense of peaceful rural life."
    },
    {
      product_name: "Rainbow Express",
      product_id: "7325802070082",
      product_text: "A burst of radiant colors fills the scene as a train glides through a fantastical world of overlapping rainbows and glowing hills. The sun shines brightly, casting light across the vivid landscape, making the entire journey feel like a dream in technicolor."
    },
    {
      product_name: "Schnauzer And Friends",
      product_id: "7325803544642",
      product_text: "On a bright and sunny spring day, a shaggy Schnauzer rests comfortably by a charming blue wooden door. The surrounding garden is alive with vibrant blooming daffodils and daisies, while two fluffy ducklings waddle curiously through the greenery."
    },
    {
      product_name: "Rainbow Tulips",
      product_id: "7325788569666",
      product_text: "A cluster of four tulips, their petals glowing with a mix of red, orange, and yellow hues, rises gracefully from lush green stems. The background is a swirl of soft blues and purples, providing a gentle contrast that highlights the vivid colors of the tulips."
    },
    {
      product_name: "Forest Family",
      product_id: "7325794107458",
      product_text: "In a sunlit forest clearing, a young fawn rests on a bed of grass and wildflowers, its gentle eyes meeting the curious gaze of a small rabbit. A bird perches on a nearby branch while a butterfly flutters among the vibrant blossoms, creating a peaceful woodland scene."
    },
    {
      product_name: "Spooky Street",
      product_id: "7289430147138",
      product_text: "On a moonlit Halloween night, children dressed in colorful costumes race past a haunted mansion, their laughter mixing with the rustling leaves. The eerie house, alive with glowing windows and playful ghosts, watches over the spooky street as the children revel in their trick-or-treating adventure."
    },
    {
      product_name: "Lady in Black",
      product_id: "7297325596738",
      product_text: "A mysterious young woman with piercing blue eyes and flowing silver hair stands elegantly, her black dress and wide-brimmed hat adorned with dark feathers, exuding an air of gothic allure. Wisps of ghostly figures seem to emerge from her hair, adding an eerie, otherworldly presence to her enigmatic beauty."
    },
    {
      product_name: "Friday Night",
      product_id: "7289462816834",
      product_text: "A haunted house looms in the distance, bathed in eerie moonlight and framed by twisted, gnarled trees with sinister, glowing eyes. Lightning crackles through the dark, stormy sky, illuminating grinning jack-o'-lanterns and shadowy figures lurking among crooked fences and grave markers, creating a chilling Halloween scene filled with suspense."
    },
    {
      product_name: "Halloween on Fire",
      product_id: "7289441976386",
      product_text: "On a moonlit Halloween night, a skeleton lounges atop a vintage fire truck, keeping watch over a group of glowing jack-o'-lanterns as black cats silently observe the scene. The truck, loaded with festive pumpkins, stands in a shadowy forest, where the spirits of the night come alive in playful mischief."
    },
    {
      product_name: "Panda Paradise",
      product_id: "7325790240834",
      product_text: "A wide-eyed panda cub sits on a mossy log in a sunlit forest, its tiny paws clasped together as it gazes at the butterflies fluttering around it. The soft light filtering through the leaves creates a magical atmosphere, highlighting the panda's fluffy fur and the vibrant colors of the butterflies."
    },
    {
      product_name: "Coffee Donuts",
      product_id: "7325801775170",
      product_text: "A vibrant assortment of donuts, covered in colorful icing and sprinkles, surrounds a steaming cup of coffee topped with whipped cream and more sprinkles. The scene is set against a lively background filled with bright, retro-style flowers, creating a fun and energetic composition."
    },
    {
      product_name: "Candy Corn Voodoo",
      product_id: "7334240518210",
      product_text: "A whimsical voodoo doll character, with vibrant purple hair and mismatched button eyes, stands confidently, adorned in a playful outfit featuring a candy corn hairpin and pumpkin-themed shoes. Stitched together with quirky details, she carries a heart-shaped pin cushion and a skull necklace, blending cuteness with a touch of spooky charm in a forest of teal hues."
    },
    {
      product_name: "Sunlit Serenity",
      product_id: "7334213681218",
      product_text: "A small wooden boat drifts peacefully on a vibrant river, surrounded by rolling hills and colorful trees that reflect the beauty of an autumn day. Above, the sky swirls with radiant hues, as a brilliant sun shines down, casting a warm, golden light over the tranquil landscape."
    },
    {
      product_name: "Mystery Kit #1 - Fantasy",
      product_id: "7326275436610",
      product_text: "A mysterious woman with flowing purple hair, illuminated by magical flames, gazes intensely with glowing, ethereal eyes. She wears intricate, dark jewelry, and skeletal birds hover above her, while sparks of light and mystical energy swirl around her, creating an enchanting and otherworldly atmosphere."
    },
    {
      product_name: "Mystery Kit #2 - Halloween",
      product_id: "7326276026434",
      product_text: "A grand, haunted mansion stands illuminated by a full moon, with glowing jack-o'-lanterns lining the brick path and front gate. Bats, ghosts, and a witch flying across the moon add to the eerie atmosphere, while a skeleton swings from a gnarled tree beside the house, creating a festive yet spooky Halloween scene."
    },
    {
      product_name: "An Eerie Welcome",
      product_id: "7298084896834",
      product_text: "On a spooky Halloween night, a haunted Victorian house comes alive with eerie characters welcoming all who dare to approach. A skeleton butler, a witch, and a ghostly figure gather among glowing jack-o'-lanterns and tombstones, setting the scene for a frightful yet festive celebration under a glowing full moon."
    },
    {
      product_name: "Skeleton Joyride",
      product_id: "7289452265538",
      product_text: "On a spooky Halloween night, three skeletons have taken over an old car, their bony hands raised in eerie excitement as they pose around the vintage vehicle. Surrounded by glowing jack-o'-lanterns and street lamps, they celebrate their ghostly joyride under the watchful eye of the full moon, with ancient ruins and bats adding to the hauntingly festive scene."
    },
    {
      product_name: "Witch's Room",
      product_id: "7289458262082",
      product_text: "In a dimly lit, cobweb-filled room, an old witch stirs a bubbling cauldron that glows with an eerie green light, casting strange shadows on the stone walls. Surrounded by potions, skulls, and mystical artifacts, she carefully prepares her brew, while a black cat and a rat lurk nearby, watching her every move."
    },
    {
      product_name: "Halloween Friends",
      product_id: "7298061303874",
      product_text: "On a lively Halloween night, a group of adorable dogs and cats gather in costume, ready for a night of fun. They pose together under a full moon, with bats flying overhead and a haunted house looming in the background, embodying the playful spirit of the season."
    },
    {
      product_name: "Bewitched Banquet",
      product_id: "7298074214466",
      product_text: "On a bewitching Halloween night, a lively gathering unfolds in front of a mysterious, haunted mansion. An owl with a monocle, a raven in a wizard hat, and a grinning jack-o'-lantern share the scene with colorful candies and playful decorations, creating a vibrant, magical feast under the eerie glow of the moon."
    },
    {
      product_name: "Thanksgiving",
      product_id: "7289434669122",
      product_text: "As the sun sets behind snow-capped mountains, a cozy farmhouse bustles with Thanksgiving preparations, its warm glow inviting visitors arriving by horse-drawn carriage. In the yard, children play in the autumn leaves while a proud turkey struts near a tranquil stream, completing the picturesque rural scene."
    },
    {
      product_name: "Midnight Whiskers",
      product_id: "7289427034178",
      product_text: "On a mystical Halloween night, two black cats sit among glowing jack-o'-lanterns, their golden eyes reflecting the full moon's eerie light. Surrounded by twisted branches holding more carved pumpkins and fluttering bats, they watch over this enchanted, pumpkin-filled world."
    },
    {
      product_name: "Absinthe",
      product_id: "7297320779842",
      product_text: "With vivid green hair cascading from beneath a wide-brimmed hat, a mysterious woman stares intently with glowing yellow eyes. Her face, pale and striking, is adorned with dark, intricate symbols, while eerie ornaments dangle from her hat, adding to her enchanting, otherworldly presence."
    },
    {
      product_name: "Mystic Bear",
      product_id: "7334256246850",
      product_text: "In a tranquil, enchanted forest, a majestic bear gently lowers its head to drink from a crystal-clear pond. Surrounded by soft, glowing flowers and bathed in ethereal light, the bear seems lost in a moment of peaceful reflection, adding to the magical beauty of the scene."
    },
    {
      product_name: "Vibrant Valley",
      product_id: "7334273777730",
      product_text: "A vibrant landscape unfolds like a living painting, with every hill and tree composed of vivid, swirling patterns. Framed by towering trees, a river winds like a ribbon of blue through the valley, as mountains stand tall in the distance, their peaks kissed by the warm hues of the setting sun."
    },
    {
      product_name: "Sunrise Lighthouse",
      product_id: "7334263488578",
      product_text: "As the sun rises over the ocean, casting a golden glow across the sky, a lighthouse stands tall on the cliff, guiding ships with its steady light. Below, a charming cottage nestled in a garden of vibrant flowers adds a touch of warmth and tranquility to the picturesque coastal scene, where the colors of dawn blend harmoniously with the beauty of nature."
    },
    {
      product_name: "Floral Frog Prince",
      product_id: "7334205456450",
      product_text: "Amidst a vibrant garden of colorful flowers, a regal frog sits proudly, adorned with a jeweled crown that glistens in the soft light. The frog's bright, golden eyes and shimmering skin contrast beautifully with the surrounding blooms, making it look every bit the enchanting prince of this floral kingdom."
    },
    {
      product_name: "The Magic Dragon",
      product_id: "7289432145986",
      product_text: "In a mystical marketplace, The Magic Dragon shop beckons with its vibrant displays of glowing potions, enchanted orbs, and magical talismans. The cobblestone streets are alive with the warm light of lanterns, while the air buzzes with the promise of spells and mysteries, inviting curious souls to explore the wonders within."
    },
    {
      product_name: "Autumn Apocalypse",
      product_id: "7289445613634",
      product_text: "Under a fiery, ominous sky, a group of mischievous skeletons takes over an old truck adorned with a carved pumpkin, surrounded by a sea of glowing jack-o'-lanterns. Bats swarm through the air as the skeletal crew prepares for a wild Halloween night, their sinister celebration set against the backdrop of a blazing full moon."
    },
    {
      product_name: "Halloween Haunted House",
      product_id: "7298064810050",
      product_text: "On a Halloween night, a group of excited children, dressed as skeletons, witches, and pirates, parade down the sidewalk, eagerly approaching a charming, spooky house adorned with glowing jack-o'-lanterns. Above them, bats flutter through the sky, and a witch flies past the full moon, adding to festive atmosphere of their trick-or-treating adventure."
    },
    {
      product_name: "Blue Valenstein",
      product_id: "7289468354626",
      product_text: "In a mysterious forest, a doll-like figure with blue and white hair stares ahead with wide, soulful eyes, her body stitched together like a patchwork quilt. Clutching a torn and mended heart-shaped pillow, she wears broken heart accessories and delicate chains, reflecting a mix of beauty and melancholy."
    },
    {
      product_name: "Witchy Whiskers",
      product_id: "7298751332418",
      product_text: "In an enchanting autumn forest, a tiny mouse sits atop a tree stump, donning a whimsical witch’s hat, its large eyes gleaming with curiosity. Surrounded by glowing jack-o'-lanterns and swirling fall leaves, the scene radiates a warm, magical glow, capturing the gentle charm of Halloween."
    },
    {
      product_name: "Spooky Halloween",
      product_id: "7298082046018",
      product_text: "As dusk falls on Halloween night, a haunted house comes to life, its windows glowing with eerie silhouettes and jack-o'-lanterns flickering on the porch. Nearby, costumed children gather excitedly, while a pumpkin-headed scarecrow watches over them and a ghostly figure drifts through the trees, completing the spooky, festive scene."
    },
    {
      product_name: "The Scarecrow",
      product_id: "7298057371714",
      product_text: "As the sun sets over a vibrant autumn farm, a scarecrow with button eyes stands watch amidst towering sunflowers and glowing jack-o'-lanterns. Crows circle overhead, casting eerie shadows over the rustic barn and weathered farmhouse, as the golden hues of dusk merge with the Halloween spirit settling over the fields."
    },
    {
      product_name: "Bewitched Buddies",
      product_id: "7289417531458",
      product_text: "Under a glowing orange sky filled with bats and a bright full moon, two young witches stand side by side, their large, innocent eyes shining with curiosity. Dressed in matching dark robes and holding a carved pumpkin, they appear ready for an exciting Halloween night."
    },
    {
      product_name: "Twilight Guardian",
      product_id: "7334220267586",
      product_text: "Under a vibrant sunset, a sleek black cat sits proudly atop a rock, its bright yellow eyes glowing with quiet intensity. Surrounded by a field of colorful flowers and framed by mountains in the distance, the cat seems to stand watch over the serene landscape as day turns to twilight."
    },
    {
      product_name: "The Prince",
      product_id: "7334250676290",
      product_text: "In a mystical pond, a regal frog sits majestically on a lily pad, adorned with intricate golden jewelry and a delicate crown. With wide, reflective eyes and an air of quiet nobility, this enchanting creature seems to be awaiting a magical moment, perfectly embodying the essence of a fairy tale prince."
    },
    {
      product_name: "Gemstone Guardian",
      product_id: "7334185041986",
      product_text: "In a lush, magical forest, a small dragon with shimmering golden scales sits proudly, its wide blue eyes sparkling with curiosity and wisdom. Adorned with a crown of colorful gemstones that catch the light, this enchanting creature appears as the guardian of the forest, radiating a gentle but powerful presence."
    },
    {
      product_name: "Ranch Drinks",
      product_id: "7334225870914",
      product_text: "Under a colorful sunset sky that fades into twilight, two refreshing drinks sit on a vibrant table, their bright citrus garnishes catching the last rays of sunlight. The scene, set against a backdrop of vast desert plains and distant mountains, evokes a sense of relaxation and enjoyment, inviting you to savor the moment."
    },
    {
      product_name: "Lunar Dreams",
      product_id: "7334209421378",
      product_text: "In the magical stillness of the night, a crescent moon adorned with delicate swirling patterns embraces the warmth of the sun, as if sharing a secret dream--creating a magical harmony between day and night in this enchanting celestial garden."
    },
    {
      product_name: "Royal Feathered Beauty",
      product_id: "7334268436546",
      product_text: "Amid a vibrant garden of blooming flowers, a majestic peacock perches gracefully on a branch, its feathers glistening in a cascade of rich blues, fiery oranges, and golds. The stained glass-inspired backdrop casts a radiant glow, turning this scene into a dazzling mosaic of color and elegance."
    },
    {
      product_name: "Whisker’s Halloween",
      product_id: "7289438208066",
      product_text: "Under the soft glow of a jack-o'-lantern, a group of festive mice in colorful hats enjoy a tiny feast of treats, while a watchful black cat crouches nearby, its curious eyes fixed on the gathering. String lights dangle above, casting a warm glow over the whimsical Halloween scene."
    },
    {
      product_name: "Halloween Party",
      product_id: "7298069233730",
      product_text: "As the full moon rises high, casting a silver glow over the eerie landscape, three jack-o'-lanterns stand proudly at the forefront, each wearing a playful hat. In the distance, the silhouettes of a mischievous witch and a fearless pirate dance beneath the glowing moon, while bats soar across the sky and autumn leaves twirl in the crisp Halloween air, signaling the start of a magical night."
    },
    {
      product_name: "Green Valenstein",
      product_id: "7289471828034",
      product_text: "A stitched figure with haunting golden eyes stands in the twilight, her gaze both captivating and mysterious as she holds a heart-shaped lollipop. Her dark hair, streaked with white, flows down her shoulders, hinting at untold secrets and hidden depths."
    },
    {
      product_name: "Autumn Treasures",
      product_id: "7298087944258",
      product_text: "On a chilly autumn evening, two children stand hand in hand, peering through a warmly lit shop window adorned with glowing lanterns and vibrant fall leaves.  Behind them, a black cat watches quietly as pumpkins and fallen leaves surround their feet, hinting at the magic of the season."
    },
    {
      product_name: "Halloween Birdhouse",
      product_id: "7298747400258",
      product_text: "As Halloween night falls, a charming birdhouse comes alive with festive activity, where colorful birds dressed in tiny costumes gather among vibrant flowers and glowing jack-o'-lanterns. Overhead, a witch and ghost glide through the moonlit sky, while bats flutter about, creating a whimsical and spooky scene that fills the air with Halloween magic."
    },
    {
      product_name: "Monster House Party",
      product_id: "7289428148290",
      product_text: "As the sun sets behind a towering haunted mansion, a lively monster party kicks into full gear. Every window reveals a different spooky creature, from mummies to ghosts, while glowing jack-o'-lanterns light up the yard, welcoming guests to this Halloween celebration."
    },
    {
      product_name: "The Prince",
      product_id: "7334250676290",
      product_text: "In a mystical pond, a regal frog sits majestically on a lily pad, adorned with intricate golden jewelry and a delicate crown. With wide, reflective eyes and an air of quiet nobility, this enchanting creature seems to be awaiting a magical moment, perfectly embodying the essence of a fairy tale prince."
    },
    {
      product_name: "Ranch Drinks",
      product_id: "7334225870914",
      product_text: "Under a colorful sunset sky that fades into twilight, two refreshing drinks sit on a vibrant table, their bright citrus garnishes catching the last rays of sunlight. The scene, set against a backdrop of vast desert plains and distant mountains, evokes a sense of relaxation and enjoyment, inviting you to savor the moment."
    },
    {
      product_name: "Serenity in Stripes",
      product_id: "7334261751874",
      product_text: "In the heart of a hidden jungle, a tiger quietly approaches a pond, its amber eyes scanning the water as soft ripples form where its tongue meets the surface. The air is filled with the sweet scent of blooming flowers, and the tiger's reflection shimmers alongside the floating petals, creating a moment of harmony between predator and nature's quiet beauty."
    },
    {
      product_name: "Rosy Retreat",
      product_id: "7334201851970",
      product_text: "Beneath a bright, cloud-dappled sky, a charming cottage peeks through a vibrant sea of roses and hydrangeas, their blooms spilling over a white picket fence. The winding stone path leads to the inviting blue door, where the peaceful beauty of nature has woven itself into every corner of the garden, creating a serene escape."
    },
    {
      product_name: "Warmth Of Autumn",
      product_id: "7298090729538",
      product_text: "In a cozy living room adorned with floral armchairs, a crackling fireplace casts a warm glow. The mantle is decorated with autumn leaves and pumpkins, as a cup of tea and an open book invite relaxation, creating a perfect scene for enjoying the gentle charm of the fall season."
    },
    {
      product_name: "Frightful Fireside",
      product_id: "7298054127682",
      product_text: "A spooky yet warm atmosphere fills the room as a skeleton rests in a chair by the crackling fire, surrounded by flickering candles, pumpkins, and autumn leaves. A black cat gazes into the flames, while cobwebs and bats frame the fireplace, where a glowing jack-o'-lantern and Halloween decorations complete the eerie yet inviting setting."
    },
    {
      product_name: "The Sight",
      product_id: "7297326874690",
      product_text: "A mysterious figure with fiery orange hair and glowing eyes stands in the twilight, her dark attire hinting hidden powers. With intricate tattoos adorning her pale skin and a shadowy hat framing her face, she exudes an aura of quiet, enigmatic strength."
    },
    {
      product_name: "Moo Magic",
      product_id: "7298749104194",
      product_text: "Two adorable calves stand side by side in a cozy autumn setting, surrounded by glowing jack-o'-lanterns and falling leaves. The warm golden light and soft, curious gazes of the calves create a heartwarming scene that perfectly captures the charm of the harvest season."
    },
    {
      product_name: "Halloween Treats",
      product_id: "7289436667970",
      product_text: "Under the light of a full moon, a kitten dressed as a witch and a little mouse in a wizard hat sit surrounded by colorful Halloween treats. A glowing jack-o'-lantern watches over them as they share their candy haul, creating a heartwarming scene of unlikely friendship on a magical night."
    },
    {
      product_name: "Pumpkin Garden",
      product_id: "7305518481474",
      product_text: "Amidst a vibrant garden of sunflowers and zinnias, two small birds perch on plump pumpkins, their soft feathers contrasting with the bright autumn colors. Butterflies flutter around the scene, adding a touch of whimsy to the peaceful, sunlit setting of a bountiful harvest."
    },
    {
      product_name: "Spooky Pumpkin Patch",
      product_id: "7289454133314",
      product_text: "A cozy pumpkin patch comes to life with glowing jack-o'-lanterns, cheerful scarecrows, and vibrant autumn flowers surrounding an old, weathered red tractor. A watchful owl, a curious black cat, and swirling ghostly figures add an enchanting air to the scene, where fall’s bounty meets a playful Halloween spirit."
    },
    {
      product_name: "Ghostly Manor",
      product_id: "7298748776514",
      product_text: "Under the glow of a full moon, a haunted manor stands tall, its windows glowing with an eerie orange light. Bats circle the sky as carved jack-o'-lanterns sit scattered across the front yard, casting flickering shadows over the twisted, leafless trees that seem to reach out toward the night."
    },
    {
      product_name: "Magic Mushroom Haven",
      product_id: "7334197493826",
      product_text: "Tucked deep within a fantastical forest, a quirky house with a wavy purple roof stands among towering mushrooms, its walls adorned with vines and blossoms. The soft glow of magical light spills from its windows, while a winding stone path invites wanderers to explore this surreal hideaway where nature and enchantment intertwine."
    },
    {
      product_name: "Viva Las Vegas",
      product_id: "7334234357826",
      product_text: "Under a vibrant neon sky, the iconic Welcome to Fabulous Las Vegas sign glows with electric energy, surrounded by bursts of colorful lights and stars. The glittering skyline of Las Vegas shimmers in the background, as swirling patterns and sparkling details capture the city’s spirit of excitement, glamour, and endless possibilities."
    },
    {
      product_name: "Christmas Rabbit With Scarf",
      product_id: "7353388204098",
      product_text: "In a frosty winter woodland, a little rabbit scurries through the snow, pausing to gather a bundle of pine branches and berries for its cozy burrow. Wrapped in a plaid scarf to keep warm,  the rabbit’s wide eyes gaze out with curiosity, embodying the warmth and spirit of the holiday season."
    },
    {
      product_name: "Stained Glass Snowman",
      product_id: "7353390923842",
      product_text: "As the winter sun sets, a cheerful snowman stands proudly in a snowy meadow, framed by frosted pine trees and glowing under the soft light of a stained glass sky. With arms outstretched and a top hat perched atop his head, he seems to invite the viewer into a timeless winter wonderland, where every hue of the sunset is captured in delicate, radiant glass."
    },
    {
      product_name: "Snow Family Photo",
      product_id: "7321814499394",
      product_text: "On a crisp winter morning, a cheerful snowman family stands tall by a red fence, bundled in their colorful scarves, as if posing for a family portrait. Nearby, playful puppies tumble through the snow, while cardinals flutter around, resting on the snowmen's hats and adding pops of red to the frosty landscape."
    },
    {
      product_name: "Holly",
      product_id: "7321815777346",
      product_text: "In a festive, snow-covered village, an enchanting elf stands beside a beautifully decorated Christmas tree, her emerald eyes sparkling with holiday magic. Dressed in a green and gold outfit adorned with holly, she gazes out with a serene expression, surrounded by ornaments, twinkling lights, and a sense of winter wonder."
    },
    {
      product_name: "Christmas Blessings",
      product_id: "7323845328962",
      product_text: "On a snowy winter day, three excited children peer through the frosty window of a Christmas shop, mesmerized by the festive decorations inside. Their wide-eyed wonder is captured as they point to twinkling lights, gingerbread houses, and holiday treasures, while a small puppy sits patiently by their side, wrapped in the magic of the season."
    },
    {
      product_name: "Christmas Lodge",
      product_id: "7321819119682",
      product_text: "In a cozy Christmas lodge, nestled beneath snow-capped mountains, Santa kneels by the crackling fireplace, carefully placing presents under the Christmas tree. The warm glow of festive lights dances off the richly decorated room, while outside, the serene winter night is illuminated by a bright, full moon, casting magic over the peaceful scene."
    },
    {
      product_name: "Christmas Eve Neighborhood",
      product_id: "7321821118530",
      product_text: "As dusk settles on a snow-covered village, the warm glow of street lamps and Christmas lights reflects on the icy streets, while horse-drawn carriages pass by elegant Victorian homes. The town bustles with holiday cheer, children laughing and playing in the snow, as the steeple of the local church stands tall, signaling the magic of Christmas Eve."
    },
    {
      product_name: "Waiting For Santa",
      product_id: "7322575470658",
      product_text: "As the fireplace crackles and the Christmas tree sparkles with festive ornaments, a group of curious pets eagerly gathers at the window. With tails wagging, they watch in wonder as Santa’s sleigh glides through the starry night sky, the magic of Christmas filling the cozy room around them."
    },
    {
      product_name: "North Pole Workshop",
      product_id: "7322489225282",
      product_text: "At Santa's bustling workshop, reindeer stand ready by the sleigh as elves loading gifts under the glow of warm lights. The snowy landscape is illuminated by a towering Christmas tree, adorned with sparkling lights and ornaments, as the magical night prepares for Santa's grand journey from the North Pole."
    },
    {
      product_name: "Christmas Cabin",
      product_id: "7322519076930",
      product_text: "Inside a cozy cabin adorned with Christmas decorations, a warm fire crackles in the stone fireplace, while a golden retriever naps peacefully on the rug. Outside, children laugh as they build a snowman in the soft, white snow, their cheerful energy mirrored by the vibrant holiday spirit indoors, where a glowing tree and festive garlands fill the space with joy."
    },
    {
      product_name: "Jolly Christmas Gnome",
      product_id: "7353384599618",
      product_text: "On a chilly Christmas Eve, a tiny gnome stands cheerfully surrounded by beautifully wrapped presents beneath a glowing tree. With his tiny hands clasped in joy, his red hat adorned with holly, the gnome embodies the warmth and magic of the holiday season, ready to share in the festive cheer."
    },
    {
      product_name: "Santa Pup Surprise",
      product_id: "7353384894530",
      product_text: "On Christmas morning, nestled beneath the twinkling tree,  a fluffy puppy sits surrounded by wrapped gifts, holding a festive red stocking in his mouth. Wearing a cozy Santa hat, the little pup’s eyes sparkled with the wonder of his first holiday, blending perfectly with the warmth and cheer of the Christmas scene."
    },
    {
      product_name: "Neon Holiday Glow",
      product_id: "7353387712578",
      product_text: "Under a vibrant night sky filled with stars and fireworks, Santa flies through the air in his sleigh pulled by colorful reindeer, above a bright, neon-lit house decorated for Christmas. The desert landscape is aglow with festively lit cacti, palm trees, and an eclectic Christmas tree, creating a joyful and lively holiday scene."
    },
    {
      product_name: "Santa and 2 Reindeers",
      product_id: "7353385943106",
      product_text: "In a snowy winter night, Santa stands cheerfully between two reindeer, holding a festive banner that reads Merry Christmas. With a warm lantern glowing beside him and snowflakes gently falling from the sky, Santa’s rosy cheeks and the playful expressions of his reindeer spread holiday joy in this heartwarming scene."
    },
    {
      product_name: "Santa's Helper",
      product_id: "7321818300482",
      product_text: "In a cozy, festive workshop, a cheerful elf sits by the crackling fireplace, surrounded by brightly wrapped presents. Dressed in her red and green outfit, complete with jingle bell earrings and a holly-adorned Santa hat, her eyes twinkle with holiday joy as she prepares for a magical Christmas Eve, ready to help Santa bring joy to children everywhere."
    },
    {
      product_name: "Santas Deliveries",
      product_id: "7321819742274",
      product_text: "On a snowy Christmas Eve, Santa pauses his sleigh in the heart of a charming village, the streets lined with twinkling lights and festive decorations. A reindeer patiently waits as Santa prepares to deliver brightly wrapped gifts to the cozy homes, where glowing windows and Christmas trees shine with warmth and anticipation of the holiday magic soon to come."
    },
    {
      product_name: "Christmas Magic",
      product_id: "7321820069954",
      product_text: "In a vibrant, magical workshop at the North Pole, Santa beams with joy as he holds a beautifully wrapped gift, ready to bring happiness to children around the world. An enchanting Christmas tree glows with colorful lights and ornaments, while an owl perches by Santa's side, watching over the room filled with toys, cheerful elves, and festive decorations, capturing the wonder and spirit of Christmas."
    },
    {
      product_name: "To Grandma’s House",
      product_id: "7321820659778",
      product_text: "In a picturesque winter wonderland, families gather for Christmas festivities as horse-drawn sleighs travel through the snow-covered village toward warmly lit homes. Children play around snowmen and twinkling Christmas trees, while deer wander near the icy stream, and the setting sun bathes the scene in a soft golden glow, capturing the magic of the holiday season."
    },
    {
      product_name: "Saint Patrick's Cathedral",
      product_id: "7321821872194",
      product_text: "St. Patrick’s Cathedral stands majestically on a serene winter evening, its snow-dusted gothic spires glowing warmly under the city lights, contrasting with the towering city skyscrapers in the background. Horse-drawn carriages wait outside as passersby gather near the grand entrance, where Christmas trees and festive lights create a timeless holiday scene in the heart of the city."
    },
    {
      product_name: "Golden Christmas",
      product_id: "7325804888130",
      product_text: "In a magical winter scene, golden candlelight flickers across ornate candlesticks, casting a warm glow on an intricately detailed model of a castle. Behind it, the snow-covered landscape stretches toward a grand castle on a hill, its towering spires illuminated under a dark, wintry sky, evoking an atmosphere of elegance and enchantment."
    },
    {
      product_name: "Santa’s Workshop",
      product_id: "7323859419202",
      product_text: "At Santa’s bustling workshop, the elves cheerfully prepare gifts while reindeer stand ready to embark on their journey through the snow. The workshop, illuminated by warm lights and surrounded by a glowing Christmas tree and festive candy canes, captures the enchanting magic of the North Pole on a crisp winter night."
    },
    {
      product_name: "My Hanukkah Wish",
      product_id: "7323848867906",
      product_text: "Through a frosted window, a young girl carefully lights the candles of the menorah, her pets watching nearby as the warm glow fills the room. The table is filled with traditional Hanukkah treats—latkes, sufganiyot, and dreidels—capturing the cozy, festive spirit of the holiday as it unfolds."
    },
    {
      product_name: "Quiet Snow",
      product_id: "7323854536770",
      product_text: "In a serene, wintry world, a mysterious figure stands wrapped in a luxurious coat of soft fur, her pale face framed by a cascade of snowy curls. Beside her, a gentle creature with silvery fur and horns nestles close, their presence exuding an ethereal calm amidst the snow-covered trees under a star-strewn sky."
    },
    {
      product_name: "Timeless Traditions",
      product_id: "7322544046146",
      product_text: "In a beautifully decorated living room, the warmth of the crackling fireplace complements the elegant Christmas tree adorned with blue, gold, and white ornaments. Garland and wreaths drape over the mantel, while neatly wrapped gifts and festive accents fill the cozy space, creating a serene holiday atmosphere steeped in timeless traditions."
    },
    {
      product_name: "Santa Pup Pickup",
      product_id: "7353388597314",
      product_text: "In a festive holiday scene, a scruffy little dog wearing a Santa hat peers out from the back of an old red pickup truck, its gaze warm and curious. A holly-adorned wreath hangs on the truck, while snowflakes gently fall, adding to the cozy, Christmas charm of the snow-covered house in the background, decorated with glowing lights and wreaths."
    },
    {
      product_name: "Starlit Snow Owl",
      product_id: "7353384763458",
      product_text: "Beneath a luminous full moon, a small owl sits quietly on a frosted branch, its large, curious eyes reflecting the starlit sky. Snowflakes gently fall around the scene, adding to the enchantment of the peaceful winter night, where the owl keeps watch under the glowing heavens."
    },
    {
      product_name: "Glittering Pink Tree",
      product_id: "7353390760002",
      product_text: "In a radiant holiday scene, a Christmas tree shimmers with colorful ornaments in hues of pink, teal, and gold, crowned with a glowing star at the top. Wrapped presents in matching vibrant colors surround the tree, while twinkling lights and festive decorations create an atmosphere of pure enchantment."
    },
    {
      product_name: "Stained Glass Deer",
      product_id: "7353390891074",
      product_text: "In this intricate stained-glass artwork, a regal deer rests peacefully, adorned with delicate patterns of pearls and gemstones. Surrounded by soft pink roses and framed in elegant gold, the deer exudes grace and serenity, creating a harmonious blend of nature and elegance in the radiant, jewel-toned design."
    },
    {
      product_name: "Breakfast with Goldilocks",
      product_id: "7325813932098",
      product_text: "In a dark, magical landscape, a girl with blonde hair and smoky eyeshadow holds three adorable bear cubs. The contrast of her elegant attire and playful hair accessories creates a captivating blend of gothic charm and fantasy."
    },
    {
      product_name: "Cosmic Spiral",
      product_id: "7325814292546",
      product_text: "A lone figure stands on a cliff's edge, gazing out at the sprawling city below as the sun sets, painting the skyline in vibrant orange hues. Above, a swirling cosmic spiral illuminates the sky, blending the vast universe with the beauty of a breathtaking sunset, creating a moment that feels both surreal and infinite."
    },
    {
      product_name: "Atlanticus",
      product_id: "7325807771714",
      product_text: "An enchanting underwater city emerges from the ocean floor, bathed in vibrant blues and purples that shimmer through the depths. Elegant jellyfish glide past with glowing tendrils, while a curious octopus moves among colorful coral reefs, creating a scene of mystery and magic beneath the sea."
    },
    {
      product_name: "Starry Coyote",
      product_id: "7326267113538",
      product_text: "A coyote stands confidently under a swirling, star-studded sky reminiscent of a classic painting, its eyes glowing with the reflection of the moonlight. The vibrant blue and golden hues of the night create a mysterious and dreamlike landscape, blending the beauty of nature with an artistic touch of magic."
    },
    {
      product_name: "Enchanted Realm",
      product_id: "7353384828994",
      product_text: "A lone wizard stands on the edge of an enchanted realm, casting a glowing orb into the twilight sky, with his silhouette framed by the vivid hues of an otherworldly sunset. Ancient towers and magical landscapes stretch out behind him, bathed in the radiant energy of the surrounding mystical barrier."
    },
    {
      product_name: "Enchanted Realm",
      product_id: "7353384828994",
      product_text: "The owl perches on a weathered tombstone, its bright amber eyes glowing against the massive full moon in the background. Silhouetted by an eerie sky, fallen leaves and distant gravestones add to the atmosphere of mystery and watchful solitude."
    },
    {
      product_name: "Pumpkin Pups",
      product_id: "7298749300802",
      product_text: "Two adorable puppies sit in a forest clearing, wearing playful witch hats as they pose beside glowing jack-o'-lanterns. The autumn leaves and soft glow of fireflies create a magical and cozy Halloween atmosphere."
    },
    {
      product_name: "My Ghost",
      product_id: "7289473794114",
      product_text: "A young woman with striking mismatched eyes, one green and one purple, stands with a mystical aura, her long white hair cascading beneath a dark witch's hat. She holds a planchette in her hand, while a fluffy white cat with similarly enchanting eyes perches on her shoulder, adding to the eerie and magical atmosphere."
    },
    {
      product_name: "Halloween Haven",
      product_id: "7289422676034",
      product_text: "A spooky yet charming Halloween village lies beneath a glowing full moon, with bats soaring through the sky and an eerie mansion casting warm light from its windows. The winding path is lined with carved jack-o'-lanterns, their mischievous grins illuminating the night, creating a whimsical and festive atmosphere."
    },
    {
      product_name: "Halloween Pranksters",
      product_id: "7298747957314",
      product_text: "A group of playful kittens, each dressed in festive Halloween costumes—ranging from a pirate to a devil—gather in a yard decorated with carved pumpkins and autumn leaves. Their joyful expressions and whimsical attire bring a lighthearted and humorous touch to the spooky season, making for a charming and delightful scene."
    },
    {
      product_name: "Violet Sorcery",
      product_id: "7305522020418",
      product_text: "A young witch with large, violet eyes and flowing purple hair sits behind a glowing jack-o'-lantern, her black hat adorned with vibrant orange roses. The eerie yet enchanting scene is set against a dark purple background with bats flying, adding a touch of whimsy and magic to her mysterious surroundings."
    },
    {
      product_name: "Golden Grizzly",
      product_id: "7326274322498",
      product_text: "A gentle grizzly bear sits peacefully in an autumn forest, surrounded by carved pumpkins and golden leaves falling around it. The warm hues of the scene and the bear's calm demeanor create a cozy and festive atmosphere, capturing the essence of the season."
    },
    {
      product_name: "Rainbow Enchantress",
      product_id: "7325807542338",
      product_text: "A beautiful forest elf with flowing blonde hair sits amidst the forest, her attire a vibrant array of rainbow hues that blend with the colors of the autumn leaves surrounding her. Her eyes sparkle with wonder, and her pointed ears are adorned with colorful feathers, creating an ethereal and magical atmosphere illuminated by the glow of mystical fireflies."
    },
    {
      product_name: "Candy Heaven",
      product_id: "7321811583042",
      product_text: "Three young children stand excitedly in front of a colorful display at an old-fashioned sweet shop, gazing at rows of candy jars filled with an assortment of treats. The scene captures the innocent wonder of childhood, with gumball machines, lollipops, and a cozy atmosphere that evokes a sense of nostalgia and delight."
    },
    {
      product_name: "Autumn Farmhouse",
      product_id: "7325810917442",
      product_text: "A picturesque farmhouse in a vibrant autumn setting is surrounded by colorful foliage, pumpkins, and a charming red barn. A vintage bicycle with a basket rests beside a white picket fence, while farm animals like chickens and sheep roam the yard, creating a warm, idyllic country scene filled with the beauty of the harvest season."
    },
    {
      product_name: "Thorn",
      product_id: "7326269210690",
      product_text: "A fairy-like figure with flowing blonde hair, decorated with large, soft pink roses and strands of coral beads intertwined. Her delicate wings and ornate dagger resting on her chest evoke a sense of both beauty and danger, while her intense gaze suggests a story filled with mystery and depth."
    },
    {
      product_name: "Cheshire Cat Wonderland",
      product_id: "7353390268482",
      product_text: "A vibrantly colored cat with hypnotic yellow eyes lounges on a checkered path, its pink and purple fur glowing against the deep blues of the surrounding mystical forest. Its enigmatic gaze hints at hidden secrets, blending seamlessly into the whimsical and slightly surreal setting."
    },
    {
      product_name: "Moonlit Reflection",
      product_id: "7353385025602",
      product_text: "A black cat sits quietly on the water's edge, gazing at the luminous full moon reflected in the lake. Autumn trees frame the scene, their vivid orange and red leaves adding warmth to the serene moonlit night."
    },
    {
      product_name: "Vision of the Past",
      product_id: "7326266294338",
      product_text: "Golden sunlight pours through the wide windows, illuminating the cozy room with a warm, dreamlike glow, as if the past and present coexist in this serene space. The untidy bed, surrounded by lush plants, colorful ornaments, and framed memories, faces a breathtaking view of a sprawling cityscape, where the sun sets in splendor, evoking a feeling of nostalgia mixed with hope for what lies ahead."
    },
    {
      product_name: "Tigers Heart",
      product_id: "7326270029890",
      product_text: "In this haunting yet enchanting scene, a solemn girl with piercing eyes holds a heart gently in her hands, her golden dress glowing against the dark backdrop. Beside her, a majestic white tiger adorned with an ornate jeweled headpiece gazes forward, their bond hinting at an untold story of courage, loyalty, and a shared mystical connection."
    },
    {
      product_name: "Twilight Chateau",
      product_id: "7325812719682",
      product_text: "The vibrant stained glass windows of the enchanting chateau glow with a warm, magical light, casting a kaleidoscope of colors across the twilight sky. The house stands like a dream, a place where stories of wonder unfold beneath the twinkling stars, inviting you to step into a world of endless imagination and beauty."
    },
    {
      product_name: "Downtown",
      product_id: "7325809180738",
      product_text: "A fantastical cityscape unfolds beneath a starry sky, where grand towers and domes rise above the water, their facades adorned with flags and intricate details. Hot air balloons drift lazily above, and colorful ships sail gently in the moonlit harbor, giving the impression of a magical celebration in a realm where imagination knows no bounds."
    },
    {
      product_name: "Whispering Waves Village",
      product_id: "7353384796226",
      product_text: "Nestled on the hillside, a cluster of charming houses glows warmly under the softening twilight sky, their colorful facades adding a sense of cheer to the lush landscape. Below, waves gently lap at the shore, while vibrant flowers sway in the breeze, creating an idyllic village scene where nature and community coexist in perfect harmony."
    },
    {
      product_name: "Tutti Frutti",
      product_id: "7353382993986",
      product_text: "A burst of colors blooms vibrantly in the sunlight, where soft pinks, radiant yellows, and lush greens come together in a harmonious dance. The roses, each petal brushed with gentle light, seem to whisper secrets of a warm spring morning, filling the air with the promise of renewal and joy."
    },
    {
      product_name: "Dreamy Hippo",
      product_id: "7353384337474",
      product_text: "A hippo's eyes peek serenely above the water, surrounded by glowing lotus blossoms that float gently on the surface, catching the soft hues of twilight. Bubbles shimmer in the air as the hippo gazes dreamily, creating a whimsical and magical atmosphere, where the water glistens with the colors of a perfect sunset."
    },
    {
      product_name: "Rainbow Catcher",
      product_id: "7353385844802",
      product_text: "A radiant dreamcatcher hangs against a vibrant backdrop, its intricate web glowing with hues of orange and gold, as if capturing the warmth of the sun. The feathers below, painted in a spectrum of colors, sway gently, evoking a sense of movement and magic, as if each one is catching and releasing colorful dreams into the air."
    },
    {
      product_name: "Crazy Cat Lady",
      product_id: "7325813178434",
      product_text: "A cozy scene comes to life with a stylish young woman lounging in her checkered armchair, surrounded by her beloved feline friends. Each cat finds its spot amidst bookshelves and yarn balls, while the woman's relaxed pose and playful expression capture the joy of a quiet day spent with her furry companions, celebrating the whimsical and comforting chaos of cat-filled life."
    },
    {
      product_name: "Sunrise King",
      product_id: "7326267801666",
      product_text: "Bathed in the gentle light of dawn, a majestic lion sits proudly, his mane flowing like a tapestry of pastel hues—pinks, blues, and soft golds blending into the sunrise. The regal expression on his face, framed by delicate flowers blooming at his feet, captures the essence of strength and tranquility, as if he were the guardian of this tranquil, early morning paradise."
    },
    {
      product_name: "Radiate",
      product_id: "7326268751938",
      product_text: "A mysterious mermaid gazes out with an enigmatic expression, her flowing hair a cascade of purples and golden highlights, like the waves of the ocean. Tiny whales emerge gracefully from her hair, blending the sea and her being, while her iridescent scales glimmer beneath the surface, creating an otherworldly scene that radiates beauty and an untamed, mystical power."
    },
    {
      product_name: "Flowers For You",
      product_id: "7323852439618",
      product_text: "Two young girls stand eagerly at the door of a quaint flower shop, their small hands clutching woven baskets, ready to gather the colorful blooms. The shop is filled with vibrant flowers of every hue, with a curious kitten nestled among the pots and a sleepy puppy resting nearby, creating a scene that exudes warmth, innocence, and the simple joys of childhood."
    },
    {
      product_name: "Grand Adventure",
      product_id: "7353388105794",
      product_text: "A whimsical forest unfolds in a rainbow of colors, each tree glowing in vibrant hues of pink, orange, green, and blue, creating a magical playground for the woodland creatures. A little girl, dressed in a colorful dress, wanders with her cat by her side, while an owl soars overhead and curious animals watch, turning this enchanting landscape into a joyful grand adventure full of wonder and possibility."
    },
    {
      product_name: "Spring Afternoon",
      product_id: "7353388826690",
      product_text: "A picturesque spring afternoon unfolds in vibrant colors, as two birds share a moment at a quaint red birdhouse surrounded by an explosion of blooming flowers. In the distance, a bright red barn stands against the rolling green fields, while a cardinal soars through the sky, adding to the scene's cheerful and idyllic charm, filled with the promise of warm days and nature's abundance."
    },
    {
      product_name: "You Got This",
      product_id: "7353387941954",
      product_text: "A burst of positivity fills this vibrant artwork, featuring the bold, encouraging words -You Got This- surrounded by a collage of playful icons—rainbows, smiley faces, daisies, and peace signs. The colorful mix of neon, glittery accents, and retro motifs against a checkered and animal print background exudes a cheerful, energetic vibe, making it a perfect reminder of optimism and confidence."
    },
    {
      product_name: "Starlight Wings",
      product_id: "7353384960066",
      product_text: "A luminous dragonfly spreads its iridescent wings, glowing like a constellation against the deep, star-filled sky, as if it were a celestial being among the vibrant flowers below. The enchanting colors of the scene—radiant yellows, rich blues, and soft purples—combine with a sparkling night to create a magical garden, where the dragonfly and its delicate companions seem to dance through a dreamlike world of starlight and wonder."
    },
    {
      product_name: "Aria",
      product_id: "7325807181890",
      product_text: "A young woman with flowing pink hair stands bathed in the golden glow of the setting sun, her eyes reflecting the beauty of the serene landscape around her. Delicate flowers bloom beside her, and the radiant sky frames her figure, evoking an ethereal aura as if she were a goddess of spring, embodying grace, warmth, and the promise of new beginnings."
    },
    {
      product_name: "Ocean Chill",
      product_id: "7326265344066",
      product_text: "Cherry blossoms in full bloom frame the tranquil seaside, their delicate petals glowing in the warm hues of the setting sun. A gentle stream reflects the colors of twilight as it winds along a rocky path by a serene traditional house, creating an enchanting moment where nature and serenity converge in a dreamlike landscape."
    },
    {
      product_name: "Sunbeam",
      product_id: "7342456373314",
      product_text: "A mystical fairy with striking eyes stands amidst an enchanting forest, her vibrant blue dress adorned with pearl details, giving her an air of elegance and magic. Surrounding her are luminous, fuzzy creatures that glow like fireflies, while her ethereal companions peer curiously, creating a scene that blends fantasy and mystery in a vivid, dreamlike realm."
    },
    {
      product_name: "Celestial Bloom",
      product_id: "7344946970690",
      product_text: "A vibrant figure emerges from the darkness, her skin adorned with radiant flowers and swirling galaxies that seem to glow with a life of their own. The colors of the rainbow flow seamlessly from her hair into the background, blending with the soft pink clouds, creating an ethereal and surreal portrait that embodies the beauty of nature, the universe, and the harmony between them."
    },
    {
      product_name: "Retro Pup",
      product_id: "7353388499010",
      product_text: "A dapper pup with an air of sophistication stares confidently ahead, sporting round vintage goggles and a charming polka-dot bow tie. The warm, retro backdrop of radiant sunburst hues perfectly complements his attire, making him look every bit the distinguished gentleman from a bygone era, ready for an adventure in style."
    },
    {
      product_name: "Cat and Chickadees",
      product_id: "7353388007490",
      product_text: "In a serene scene of nature, a gentle cat sits nestled among the branches of a tree in bloom, its soft fur blending with the delicate white flowers. Around the cat, playful chickadees flutter and perch nearby, their curious eyes watching, creating a peaceful moment of harmony between the feline and the lively birds."
    },
    {
      product_name: "Prism Cougar",
      product_id: "7353388630082",
      product_text: "A majestic cougar stands amid vibrant foliage, its form composed of colorful, prism-like facets that catch the light. Surrounded by lush tropical leaves and bold orange flowers, the cougar's sharp gaze creates a striking contrast with the intricate mosaic patterns, blending the beauty of wildlife with a modern artistic twist."
    },
    {
      product_name: "Summer Oriole",
      product_id: "7353387614274",
      product_text: "An oriole sits proudly atop a weathered white fence, its bold orange and black feathers contrasting beautifully with the delicate daisies and purple blooms surrounding it. The soft pastel background adds a serene touch, creating a tranquil snapshot of nature in full summer bloom."
    },
    {
      product_name: "Olivia",
      product_id: "7341598474306",
      product_text: "A young woman with glowing, golden mechanical elements is seamlessly integrated with nature, her futuristic design blending beautifully with the organic world around her. Framed by delicate butterfly wings adorned with vibrant gems, her bright, expressive eyes shine amidst soft greenery and dappled sunlight, creating a harmonious fusion of technology and natural beauty."
    },
    {
      product_name: "North Pole Express",
      product_id: "7351510794306",
      product_text: "In a snowy North Pole scene, Santa Claus warmly greets a group of penguins, polar bears, and other animals near the Santa's Express train, which is loaded with gifts and holiday cheer. The twinkling lights, festive decorations, and snow-capped mountains in the background create a magical Christmas atmosphere, as Santa spreads joy with his animal friends on this whimsical winter day."
    },
    {
      product_name: "Holiday Hugs",
      product_id: "7351512137794",
      product_text: "Two children sit by a warm fireplace, their arms wrapped around each other and their dog, as they gaze at the twinkling Christmas tree adorned with lights and ornaments. Stockings hang above the fire, a wreath glows on the wall, and outside the window, a snowman stands beneath a starry sky, completing the cozy and magical atmosphere of Christmas Eve."
    },
    {
      product_name: "Victorian Garden Path",
      product_id: "7341600669762",
      product_text: "A vibrant garden bursts with color as flowers in every hue line the stone path leading to a charming Victorian house. Birds flutter around a birdhouse while butterflies dance among the blossoms, and in the distance, a gazebo rests peacefully under the trees, creating a scene of serenity and natural beauty in this idyllic countryside setting."
    },
    {
      product_name: "Alpine Village",
      product_id: "7349978923074",
      product_text: "A cozy Alpine village glows warmly beneath a snowy twilight sky, with its cottages illuminated by soft golden lights. Snow-covered streets wind through the charming scene, leading past a decorated Christmas tree and a cheerful snowman, while smoke rises from chimneys, creating a sense of holiday magic and peaceful winter beauty in this picturesque setting."
    },
    {
      product_name: "Winter Wilderness",
      product_id: "7347265175618",
      product_text: "A serene winter scene featuring a rustic wooden mill, nestled beside a snow-covered stream surrounded by frosted trees and shrubs. Wildlife thrives in this peaceful setting, with deer, rabbits, raccoons, and a variety of vibrant birds like cardinals and blue jays adding life and color to the snowy landscape under a clear, crisp blue sky."
    },
    {
      product_name: "The Sweetest Friends",
      product_id: "7344939630658",
      product_text: "Two adorable characters, dressed in whimsical fruit-themed outfits, sit atop giant strawberries in a colorful, enchanted garden. With their rosy cheeks, bright smiles, and playful attire, they are surrounded by cheerful flowers and a curious ladybug, creating a scene full of sweetness, friendship, and vibrant charm."
    },
    {
      product_name: "Holiday Helper",
      product_id: "7349720154178",
      product_text: "A cheerful holiday gnome stands under a snow-covered archway, holding a glowing lantern in one hand and a basket of gifts in the other. Dressed in a red hat and warm winter clothes, he brings a touch of festive magic to the snowy forest scene, as holly and berries decorate the frame, adding to the warmth and charm of the holiday season."
    },
    {
      product_name: "Golden Castle",
      product_id: "7349988786242",
      product_text: "A grand castle glows warmly under the light of a full moon, nestled within a peaceful snow-covered landscape. The shimmering reflection of the castle's lights dances across the frozen river, while snow-laden trees and bridges create a serene and magical winter wonderland, where elegance and tranquility meet."
    },
    {
      product_name: "Armada",
      product_id: "7341628424258",
      product_text: "In a fantastical underwater world, a majestic golden fish, intricately designed with sails and rigging like a grand ship, glides through an ancient oceanic kingdom. Towering seahorse statues guard the mysterious ruins, while vibrant coral and a school of shimmering fish add life to this surreal, dreamlike aquatic adventure."
    },
    {
      product_name: "A Purr-fect Snowman",
      product_id: "7351517315138",
      product_text: "A joyful snowman stands surrounded by an adorable group of festive kittens, each wearing colorful hats and scarves, ready to celebrate the winter fun. Playful and curious, the kittens gather around, one even reaching up to adjust the snowman’s hat, creating a heartwarming and whimsical scene in a snowy woodland."
    },
    {
      product_name: "Noelle",
      product_id: "7347271172162",
      product_text: "This enchanting holiday scene features a beautifully detailed winter elf with long, flowing silver hair adorned in a festive green outfit trimmed with holly berries and evergreen sprigs. Her captivating blue eyes and soft blush cheeks exude warmth, while the twinkling Christmas tree in the background adds a magical glow, highlighting the joyful spirit of the season."
    },
    {
      product_name: "Yellow Escape",
      product_id: "7341629407298",
      product_text: "A multicolored cat peeks out from the window of a retro yellow vehicle, its vivid orange and pink fur glowing in the light. The cat’s large green eyes and playful expression radiate joy and adventure, while bold geometric patterns energize both the car and the background with vibrant color."
    },
    {
      product_name: "Santa's Little Helpers",
      product_id: "7349727789122",
      product_text: "Santa holds a cheerful puppy and a cute reindeer plush, surrounded by gifts and candy canes. Snowflakes gently fall around them, creating a warm and festive holiday atmosphere, with bright colors and soft textures adding to the joy of the scene."
    },
    {
      product_name: "Selene",
      product_id: "7341598146626",
      product_text: "A beautiful woman adorned in peacock feathers stands confidently in a lush, tropical environment. Her deep, emerald dress and intricate jewelry echo the vibrant blues and greens of the peacock by her side, creating a stunning harmony between the natural world and her elegant appearance."
    },
    {
      product_name: "Holiday Welcome",
      product_id: "7349708980290",
      product_text: "A warmly lit front porch is beautifully adorned for the holidays, framed by two twinkling Christmas trees decorated with colorful ornaments. Presents are scattered across the steps, while a friendly snowman stands off to the side, adding charm to the snowy scene."
    },
    {
      product_name: "Coastal Skies",
      product_id: "7341585956930",
      product_text: "The scene captures a serene coastal landscape with rolling hills fading into the distance, their soft hues blending into the sky. Vibrant greenery and wild grasses frame the view, while the ocean reflects the colors of the dramatic, cloud-filled sky."
    },
    {
      product_name: "Holiday Memories",
      product_id: "7351515021378",
      product_text: "Festive characters like Santa, snowmen, a gingerbread man, and animals in Christmas hats gather around a beautifully decorated tree and colorful gifts in this lively holiday scene. The cheerful expressions and vibrant colors capture the joyful spirit of the season, creating a warm and celebratory atmosphere."
    },
    {
      product_name: "Starlit Muse",
      product_id: "7344644882498",
      product_text: "A captivating celestial figure with ethereal, flowing silver hair and glowing blue eyes stands surrounded by cosmic elements. The shimmering light and intricate designs on her face, along with the dark starry background and birds, create a magical and otherworldly atmosphere."
    },
    {
      product_name: "Under The Tree",
      product_id: "7351514398786",
      product_text: "A young child sits beside a glowing Christmas tree, watching a toy train circle the base, while a puppy peacefully sleeps nearby, holding a Santa hat. The warmth of the fireplace and the twinkling tree lights add to the festive and serene atmosphere of this scene."
    },
    {
      product_name: "Christmas Stories",
      product_id: "7349729296450",
      product_text: "A girl sits reading The Night Before Christmas, surrounded by an adorable pink cat, a playful monkey, and a cheerful bunny. The glowing Christmas tree and sparkling lights in the background create a cozy and festive atmosphere, full of warmth and joy."
    },
    {
      product_name: "SuSu",
      product_id: "7344942579778",
      product_text: "A sweet panda dressed in a beautifully ornate outfit holds a delicate bouquet of colorful flowers, with leaves and blossoms adorning its head. The vibrant floral arrangement, combined with the panda's expressive eyes, creates a scene that is both enchanting and whimsical."
    },
    {
      product_name: "Winter Cottage Glow",
      product_id: "7349728837698",
      product_text: "A peaceful winter village is nestled under a blanket of snow, with glowing lights illuminating the charming cottages. Two joyful snowmen stand near one cottage, and a decorated Christmas tree adds a festive touch to the serene landscape."
    },
    {
      product_name: "Cosmic Mushroom Cottage",
      product_id: "7344944087106",
      product_text: "A whimsical cottage nestled in the grass, its walls and roof formed by oversized pink mushrooms, exudes a magical charm. Surrounded by smaller glowing mushrooms and soft greenery, the scene evokes a fairytale atmosphere under a cosmic night sky."
    },
    {
      product_name: "Festive Fawn",
      product_id: "7347268255810",
      product_text: "A cozy winter scene featuring an adorable fawn sitting in a wooden sleigh by a glowing fireplace adorned with stockings and festive garlands. The room is filled with warmth, as holiday decorations, a Christmas tree, and snow falling outside the window add to the magical atmosphere."
    },
    {
      product_name: "Sunflower Glory",
      product_id: "7342454014018",
      product_text: "A lively bluebird perches confidently atop a radiant sunflower, singing against a sky-blue backdrop, while a butterfly flutters nearby, drawn to the bloom’s vibrant energy. Amidst lush green leaves and golden flowers, each element harmonizes, creating a scene brimming with the warmth and serenity of a sunlit garden."
    },
    {
      product_name: "Spring Bridge",
      product_id: "7341627899970",
      product_text: "Nestled in a tranquil valley, a charming cottage glows warmly amid a colorful tapestry of spring blooms and towering evergreens. A stone bridge arches gracefully over a gentle stream, inviting you to wander into this serene mountain landscape where nature’s colors burst vibrantly under a soft, glowing sky."
    },
    {
      product_name: "Fae Sisters",
      product_id: "7344939171906",
      product_text: "In a mystical forest brimming with vibrant flowers and fluttering creatures, three enchanting fae sisters hold hands, their gazes filled with curiosity and wonder. Adorned with feathered crowns and surrounded by buzzing bees and delicate butterflies, they exude a magical charm that invites you into their whimsical world."
    },
    {
      product_name: "The Hostess",
      product_id: "7342459191362",
      product_text: "With a piercing gaze and a gothic flair, this enigmatic figure holds a dripping, jack-o'-lantern pie in one hand, exuding a haunting charm. Her voluminous mint-green hair contrasts with a blood-red dress, while the eerie forest background enhances her mysterious, otherworldly allure."
    },
    {
      product_name: "Elowen",
      product_id: "7341597130818",
      product_text: "With a dreamy gaze and a crown of vibrant flowers, this enchanting elf radiates warmth and wonder, her bright eyes filled with curiosity. Surrounded by blossoms and gentle, magical light, she embodies the beauty and mystery of a fairy-tale world."
    },
    {
      product_name: "Garden Bouquet",
      product_id: "7341589528642",
      product_text: "A vibrant bouquet of daisies, ranunculus, and wildflowers bursts with color and texture, arranged gracefully in a clear glass vase. The soft, painterly background highlights the flowers' delicate beauty, evoking the freshness of a blooming garden in springtime."
    },
    {
      product_name: "Verdell",
      product_id: "7344942907458",
      product_text: "A majestic parrot adorned in vibrant emerald and turquoise feathers gazes regally, its neck draped in ornate golden jewelry set with precious stones. Surrounded by lush tropical blooms, this artwork captures the exotic elegance and noble spirit of the bird against a mystical, glowing background."
    },
    {
      product_name: "The Three Sisters",
      product_id: "7344944644162",
      product_text: "Three ethereal sisters with wide, soulful eyes stand together in a dreamy woodland, their delicate features framed by floral crowns and butterfly companions. Dressed in flowing white lace, they exude an aura of innocence and mystery, each one seemingly lost in a world of quiet enchantment."
    },
    {
      product_name: "Pair Of White Herons",
      product_id: "7344641802306",
      product_text: "A pair of graceful white herons stand serenely by a tranquil waterfall, their elegant feathers ruffled against the misty backdrop. Surrounded by blooming pink lotuses and lush greenery, this scene captures the peaceful harmony of nature’s untouched beauty."
    },
    {
      product_name: "Queen of the Raptors",
      product_id: "7344636395586",
      product_text: "Bathed in the golden glow of a full moon, a regal figure adorned with intricate floral and feathered ornaments stands flanked by a fierce eagle and a watchful owl. Her serene expression exudes wisdom and power, embodying the mystique of the night and the guardianship of the raptors."
    },
    {
      product_name: "Seahorse Spectrum",
      product_id: "7342446936130",
      product_text: "A vibrant, multicolored seahorse floats gracefully through a lively coral reef, surrounded by a kaleidoscope of fish and marine plants. The underwater world bursts with rich hues of orange, purple, and teal, capturing the playful and enchanting beauty of ocean life."
    },
    {
      product_name: "Maylin",
      product_id: "7341597786178",
      product_text: "A serene young figure with teal hair adorned with pink blossoms gazes softly, embodying the freshness of spring. Surrounded by blooming flowers and sparkling droplets, she exudes a gentle, ethereal charm that feels both magical and calming."
    },
    {
      product_name: "Sunset Unicorn",
      product_id: "7341629112386",
      product_text: "A majestic unicorn adorned with a mane of flowing flowers gazes peacefully as the sun sets over distant mountains. Surrounded by vibrant blooms and intricate swirls, this mystical creature embodies grace and wonder against a dreamy twilight sky."
    },
    {
      product_name: "Whispering Woodland",
      product_id: "7344943792194",
      product_text: "A graceful maiden stands with hands crossed over her heart, her gaze calm and thoughtful, surrounded by birds nestled in a crown of branches adorned with berries. Her ornate dress and the dark woodland backdrop create a mystical aura, evoking a quiet connection with nature’s whispers."
    },
    {
      product_name: "My Furry Family",
      product_id: "7344940580930",
      product_text: "A gentle girl with deep, expressive eyes is surrounded by her cozy family of cats, each with its unique personality, lounging in various spots around a warm, plant-filled room. Embracing one of her feline companions, she radiates warmth and affection, capturing the tranquil joy of life with her furry friends."
    },
    {
      product_name: "Winter Wonderland Lane",
      product_id: "7351510532162",
      product_text: "Under a blanket of softly falling snow, Santa waves from his sleigh as reindeer eagerly pull him past cozy, warmly lit cottages adorned with festive decorations. Snow-covered trees and glowing holiday lights create a magical winter wonderland, capturing the joy and spirit of Christmas Eve."
    },
    {
      product_name: "Mystic Mushrooms",
      product_id: "7344944316482",
      product_text: "In an enchanted forest, towering mushrooms with vibrant caps create a whimsical village beside a quiet stream. Nestled among the trees, a cozy mushroom-capped cottage with a red door invites you into this magical world, where nature and fantasy intertwine in serene harmony."
    },
    {
      product_name: "Winter Village Glow",
      product_id: "7349983805506",
      product_text: "A festive winter scene unfolds in a quaint village where families gather to build snowmen and decorate under the warm glow of holiday lights. A grand Christmas tree adorned with colorful lights stands beside a charming chapel and cozy homes, embodying the spirit of togetherness in the holiday season."
    },
    {
      product_name: "Butterfly Blossoms",
      product_id: "7342453489730",
      product_text: "A delightful butterfly floats gracefully among a medley of vibrant blossoms and leafy sprigs, creating a joyful tapestry of color and nature. This floral composition exudes a light, whimsical charm, perfect for brightening any space with the beauty of spring."
    },
    {
      product_name: "Cupcake Delight",
      product_id: "7347267895362",
      product_text: "A cheerful Christmas elf, dressed in festive green and red with striped sleeves, presents a tray of delicious cupcakes by a glowing fireplace. Surrounded by twinkling lights, wrapped gifts, and holiday decor, she brings a touch of sweetness and warmth to the festive season."
    },
    {
      product_name: "Guardians of the Forest",
      product_id: "7342460436546",
      product_text: "In a mystical autumn forest, a powerful guardian figure draped in leaves and antlers sits surrounded by a gathering of woodland animals, including a stag, bear, owl, and wolf. Bathed in golden light and falling leaves, this scene exudes a sense of harmony and reverence for nature’s wild, ancient spirit."
    },
    {
      product_name: "Christmas Comfort",
      product_id: "7349983117378",
      product_text: "A cozy, festive living room is filled with holiday warmth, featuring a grand Christmas tree adorned with ornaments and surrounded by carefully wrapped gifts. The fireplace crackles beneath stockings, while a window reveals a snowy scene outside, inviting viewers into this elegant holiday haven filled with comfort and cheer."
    },
    {
      product_name: "Runaway",
      product_id: "7342456275010",
      product_text: "With haunting eyes and dramatic makeup, this gothic-inspired figure wears a dark, ruffled collar adorned with beads, evoking a sense of melancholy and mystery. The striking contrast between her pale face and intense black accents creates an eerie, captivating allure."
    },
    {
      product_name: "Grace",
      product_id: "7347270778946",
      product_text: "Dressed in festive red with a Santa hat atop her flowing blue hair, this cheerful girl holds a beautifully wrapped gift, her eyes sparkling with holiday cheer. Surrounded by a warmly lit, decorated village and twinkling Christmas tree, she brings an enchanting, magical touch to the winter season."
    },
    {
      product_name: "Positano Sogno",
      product_id: "7341627506754",
      product_text: "Overlooking the stunning cliffside village of Positano, a charming terrace is set for an evening meal, with tables adorned in blue linens and fresh flowers. As the sun sets over the sparkling sea, casting a golden glow across the colorful hillside homes, a sailboat glides peacefully along the coastline, capturing the idyllic beauty of the Italian Riviera."
    },
    {
      product_name: "Festive Barnyard",
      product_id: "7351517675586",
      product_text: "In a festive barnyard scene, animals gather around a cheerful snowman, each one dressed in colorful scarves and winter hats. From the playful puppy to the curious cow and cozy chickens, this snowy farmyard captures the warmth and whimsy of the holiday season."
    },
    {
      product_name: "Welcome Wonderland",
      product_id: "7349712224322",
      product_text: "A welcoming holiday scene unfolds with a festively decorated doorway, flanked by sparkling Christmas trees and a cheerful snowman. A cozy sleigh filled with gifts sits beside snow-covered benches, while twinkling lights and garlands complete the enchanting winter wonderland."
    },
    {
      product_name: "Angel of the Waters",
      product_id: "7344941563970",
      product_text: "In a misty twilight, the iconic Angel of the Waters fountain stands gracefully amid Central Park, framed by autumn trees and soft city lights. The surrounding staircase and tranquil fountain glow with a quiet elegance, while the distant city skyline adds a touch of urban mystique to this peaceful scene."
    },
    {
      product_name: "Aurora Reflections",
      product_id: "7349715370050",
      product_text: "Under a vivid aurora sky, a cozy lakeside cottage glows warmly, reflecting its light onto the tranquil, icy waters below. Snow-covered trees and a full moon create a magical winter scene, where the beauty of nature and the warmth of home harmoniously blend in the quiet night."
    },
    {
      product_name: "Viola Has A Secret",
      product_id: "7344945168450",
      product_text: "A young girl in a dark purple dress stands surrounded by a quirky ensemble of mysterious creatures, each with expressive, wide eyes and unique textures. The surreal gathering evokes an eerie charm, blending innocence with the strange and fantastical, as if revealing a hidden world of secrets."
    },
    {
      product_name: "Christmas Sleeping Puppies",
      product_id: "7349726609474",
      product_text: "A cozy Christmas scene unfolds with sleepy puppies nestled around a beautifully decorated tree and crackling fireplace. Stockings hang above the hearth, surrounded by festive garlands and ornaments, creating a warm, peaceful holiday setting perfect for snuggling up and celebrating."
    },
    {
      product_name: "Spiritual Bloom",
      product_id: "7344948183106",
      product_text: "Bathed in vibrant colors, a serene woman with closed eyes and hands in prayer radiates inner peace and spiritual energy. Surrounded by blooming flowers and adorned with intricate jewelry and a floral crown, she appears deeply connected to the natural and mystical realms, embodying harmony and enlightenment."
    },
    {
      product_name: "Cozy Farmhouse Christmas",
      product_id: "7349728444482",
      product_text: "A cozy farmhouse fireplace is decorated for Christmas with lush greenery, a festive wreath, and small rustic houses set among pinecones and candles. Stockings hang by the fire, while wrapped gifts and warm, inviting textures create a charming holiday ambiance perfect for gathering and celebrating."
    },
    {
      product_name: "Cozy Gnome",
      product_id: "7347267633218",
      product_text: "A charming gnome in a red, striped hat sits contentedly by a glowing fireplace, surrounded by festive decor and warm holiday lights. With a beautifully decorated Christmas tree and presents nearby, this cozy scene captures the magic and joy of a whimsical winter evening."
    },
    {
      product_name: "Yosemite Falls",
      product_id: "7344942186562",
      product_text: "In the heart of a serene valley, a cozy cabin glows warmly against the backdrop of towering Yosemite cliffs and cascading waterfalls. Canoes rest by the gently flowing river, while the majestic natural beauty of the scene invites a sense of tranquility and escape into the wilderness."
    },
    {
      product_name: "Harbor Haven",
      product_id: "7342446084162",
      product_text: "A picturesque lighthouse stands tall beside a charming coastal home, surrounded by vibrant gardens and a gently lapping shoreline. Sailboats glide across the glistening sea under a radiant sky, while seabirds soar above, adding to the idyllic harbor setting."
    },
    {
      product_name: "Faye",
      product_id: "7341597360194",
      product_text: "A striking character with luminous blue eyes gazes outward, framed by pastel pink and silver hair adorned with vibrant roses and intricate gothic accessories. The elaborate jewelry and delicate floral details combine to create a scene of enchanting beauty and bold individuality."
    },
    {
      product_name: "Babylon",
      product_id: "7341629571138",
      product_text: "A man overlooks a dazzling city bathed in golden light, with a magnificent, glowing crimson moon dominating the night sky. The ethereal blend of celestial and urban beauty evokes a sense of awe and boundless exploration."
    },
    {
      product_name: "Prism Lighthouse",
      product_id: "7353388728386",
      product_text: "A majestic lighthouse shines brightly against a stunning mosaic of vivid, angular shapes that depict a dynamic sunset sky. This contemporary interpretation captures the timeless beauty of the coast with a striking prism-like effect."
    },
    {
      product_name: "Aurora Roses",
      product_id: "7353388892226",
      product_text: "A vibrant rose blooms luminously against a captivating backdrop of the aurora borealis, blending nature's elegance with the ethereal glow of the night sky. This artwork harmonizes bold floral hues with the mystic allure of celestial light."
    },
    {
      product_name: "Cozy Christmas Fawn",
      product_id: "7353383911490",
      product_text: "In the cozy glow of a crackling fireplace, a charming fawn rests peacefully, wrapped in a festive sweater as snowflakes dance outside the window. Surrounded by the soft twinkle of Christmas lights and the vibrant hues of a decorated tree, this enchanting scene evokes the magic and comfort of a perfect holiday evening."
    },
    {
      product_name: "Dolly Valentine",
      product_id: "7382025764930",
      product_text: "In a whimsical world of chocolate-dipped hearts and candy-coated dreams, Dolly Valentine exudes a playful charm with her pink cascading curls, a golden bow nestled perfectly atop her head. Her warm, expressive eyes seem to tell a story of love, innocence, and the magic of Valentine's Day, set against a background dripping with delectable sweetness."
    },
    {
      product_name: "Tower of Pisa",
      product_id: "7341628653634",
      product_text: "Under the glow of a full moon, the iconic Leaning Tower of Pisa stands majestically amidst a lively Italian piazza. Surrounded by quaint shops, vibrant flowers, and glowing lights, this enchanting scene captures the romance of Italy as a couple strolls hand-in-hand, savoring the timeless beauty of this historic landmark."
    },
    {
      product_name: "Guardian of the Realm",
      product_id: "7342459715650",
      product_text: "In a world of glowing magic and mystique, a serene maiden stands gracefully beside an ethereal white dragon, its shimmering scales illuminated by a soft, golden light. The harmony between the maiden’s calm presence and the dragon’s fierce loyalty tells a tale of trust, courage, and guardianship, evoking the spirit of ancient legends."
    },
    {
      product_name: "Spring Morning",
      product_id: "7341596672066",
      product_text: "A radiant bouquet of tulips and ranunculus blooms in vibrant shades of pink, yellow, orange, and red, exuding the fresh energy of a spring morning. The soft brushstrokes and delicate interplay of light create a dreamy, uplifting atmosphere, capturing nature’s rebirth in every petal."
    },
    {
      product_name: "No Place Like Home",
      product_id: "7344642555970",
      product_text: "Nestled amidst vibrant autumnal foliage, this charming thatched cottage radiates warmth and serenity, its glowing windows reflecting the heart of home. A tranquil stream winds gently past, completing the picturesque scene of a cozy haven in nature's embrace."
    },
    {
      product_name: "Penguin Christmas Joy",
      product_id: "7353384665154",
      product_text: "An adorable penguin dressed in a festive Santa hat and cozy scarf, surrounded by beautifully wrapped gifts and a twinkling Christmas tree. With its enchanting snow-filled backdrop and cheerful holiday accents, this scene radiates pure seasonal joy."
    },
    {
      product_name: "Happiest Birthday",
      product_id: "7382030876738",
      product_text: "Celebrate the brightest birthdays with this vibrant artwork featuring a rainbow-layered cake topped with whimsical swirls of frosting and a single candle. Surrounded by shimmering golden stars, this cheerful piece radiates joy, making it a perfect centerpiece for any festive occasion."
    },
    {
      product_name: "The Apprentice",
      product_id: "7382039232578",
      product_text: "A mysterious black cat with piercing green eyes gazes intently from a table adorned with fantastical glass bottles containing miniature worlds, bizarre creatures, and arcane elixirs. Set in an eerie, magical ambiance, this captivating artwork is perfect for lovers of the mystical and peculiar."
    },
    {
      product_name: "Rainbow Dolphin",
      product_id: "7382034481218",
      product_text: "Dive into a magical scene where a radiant dolphin leaps gracefully beneath a luminous rainbow arching over a cascading waterfall and vibrant sunlit ocean. Framed by lush cliffs and a whimsical golden city, this artwork brings a touch of enchantment and serenity to any space."
    },
    {
      product_name: "Enchanted Watcher",
      product_id: "7347253542978",
      product_text: "In the heart of an enchanted forest, an ancient guardian owl watches over the glowing trees with eyes that have seen centuries pass. His vibrant feathers shimmer like flames in the darkness, a beacon of protection for all creatures who seek refuge beneath his watchful gaze."
    },
    {
      product_name: "Fiori Caffes",
      product_id: "7344642261058",
      product_text: "In a quaint European village, sunlight spills over cobblestone streets, where vibrant flowers cascade from balconies and cozy cafés hum with quiet charm. The aroma of fresh blooms and warm bread invites travelers to pause, sip wine, and let time slow to a gentle, dreamy pace."
    },
    {
      product_name: "Violet Lives Here",
      product_id: "7341628162114",
      product_text: "Nestled in a vibrant, flower filled paradise, this quaint purple cottage welcomes you with the charm of blooming gardens and the nostalgia of a classic violet hued car. A rainbow stretches across the golden sky, painting the scene with promise, as if whispering that every dream begins here."
    },
    {
      product_name: "Rainbow Wings",
      product_id: "7344638853186",
      product_text: "In the heart of an enchanted forest, a radiant fairy pauses by a glistening stream, her rainbow-hued wings shimmering like sunlight through a prism. Draped in a gown that flows into the vibrant forest floor, she carries the quiet magic of a guardian, bringing light and life to every corner of her realm."
    },
    {
      product_name: "Herborist Cat",
      product_id: "7382041985090",
      product_text: "A radiant ginger cat sits regally among a vibrant collection of potted plants and herbs, its emerald-green eyes mirroring the lush greenery around it. The cozy arrangement of foliage and jars creates a serene, botanical haven, with the cat as its charming centerpiece."
    },
    {
      product_name: "Bathing Bunny",
      product_id: "7382044835906",
      product_text: "A sweet little bunny peeks out from a bubbly bath surrounded by delicate pink tulips, its soft fur glistening in the gentle light. The pastel background and floating bubbles create a whimsical, serene moment of pure charm and joy."
    },
    {
      product_name: "Dreamland Dragon",
      product_id: "7353384108098",
      product_text: "In a magical garden bursting with colorful blooms, a playful baby dragon with shimmering rainbow scales sits beneath a radiant arc of colors. Its big, curious eyes and gentle smile invite you into a fantastical world filled with wonder and joy."
    },
    {
      product_name: "Christmas Bouquet",
      product_id: "7353382174786",
      product_text: "A stunning holiday bouquet showcases golden roses intertwined with vibrant red poinsettias, radiating seasonal elegance. The lush greenery and delicate details bring a festive warmth to this timeless composition."
    },
    {
      product_name: "Penguin Family",
      product_id: "7347273302082",
      product_text: "Three adorable penguins, bundled up in cheerful winter hats, gather amidst twinkling Christmas lights and festive decorations, sharing warm holiday joy. Set against a glowing Christmas tree and snowy backdrop, this enchanting artwork radiates seasonal charm, making it a perfect piece to brighten any space during the holidays."
    },
    {
      product_name: "Time For Christmas",
      product_id: "7349985443906",
      product_text: "Step into a picturesque winter evening where glowing lights, historic buildings, and a grand Christmas tree set the stage for timeless holiday charm. The bustling town square, adorned with American flags and festive wreaths, features vintage cars and a horse-drawn carriage, creating an inviting scene filled with nostalgia and joy."
    },
    {
      product_name: "Christmas Church Service",
      product_id: "7349697216578",
      product_text: "Experience the magic of a tranquil Christmas Eve with a beautifully lit church, glowing under the soft hues of a snowy sunset. A classic red telephone booth, a festive bench, and a glowing Christmas tree add timeless charm, while a horse-drawn carriage waits gracefully by the church’s arched entrance, creating a serene holiday masterpiece."
    },
    {
      product_name: "Festive Furries",
      product_id: "7351508336706",
      product_text: "Step into a warm and festive holiday haven where sleeping pets and glowing Christmas lights create the perfect cozy ambiance. A beautifully adorned tree, stockings hung on the mantle, and presents waiting to be opened surround a crackling fireplace, capturing the heart of a classic family Christmas."
    },
    {
      product_name: "Backyard Snow Family",
      product_id: "7351515414594",
      product_text: "Celebrate the joy of winter with this heartwarming scene featuring a cheerful snowman family, dressed in vibrant scarves and hats, surrounded by a playful dog, a curious cat, and charming cardinals perched nearby. This whimsical backyard gathering, complete with a rustic wooden fence and snowy accents, radiates festive cheer and togetherness."
    },
    {
      product_name: "Night Before Christmas",
      product_id: "7351506534466",
      product_text: "Step into a magical Christmas Eve with this enchanting artwork featuring a beautifully adorned living room aglow with festive lights, a grand Christmas tree, and a cozy fireplace. A charming angelic figure gazes at the scene, as Santa stands near the hearth, completing the idyllic holiday wonderland with gifts, treats, and the warmth of holiday cheer."
    },
    {
      product_name: "Celestial Flame",
      product_id: "7347252232258",
      product_text: "Witness the awe-inspiring majesty of a radiant dragon, its resplendent scales glowing in a fiery blend of golden and crimson tones. Surrounded by a cosmic aura, this magnificent creature commands attention with its piercing gaze and intricately detailed horns, embodying both strength and celestial beauty."
    },
    {
      product_name: "Autumn Hill",
      product_id: "7341626916930",
      product_text: "Stroll through this charming cityscape adorned with vibrant autumn hues, where golden leaves cascade over historic brownstones bathed in sunlight. A squirrel perches on a grand tree, while the scene invites you to explore the winding paths and cozy, colorful homes, capturing the enchanting spirit of fall."
    },
    {
      product_name: "Forbidden Wonders",
      product_id: "7341629931586",
      product_text: "Step into a tranquil world where majestic mountains rise above a serene temple garden, adorned with vibrant cherry blossoms and radiant wildflowers. Lanterns softly illuminate a shimmering stream, guiding you through this ethereal landscape, where tradition and nature harmoniously unite."
    },
    {
      product_name: "Wolf Spirit",
      product_id: "7344636854338",
      product_text: "This captivating artwork portrays the profound connection between a serene Native woman and a vigilant wolf, set against a vibrant desert sunset. Her intricate feathered headdress and painted face symbolize strength and unity, while the wolf’s piercing gaze evokes a timeless bond with nature."
    },
    {
      product_name: "Glamour Girl Leopard",
      product_id: "7382862659650",
      product_text: "This dazzling artwork features a majestic leopard, its sleek coat transformed into a spectrum of vibrant rainbow hues. With piercing golden eyes and an aura of elegance, this masterpiece celebrates the beauty of wildlife through a vivid and modern artistic lens."
    },
    {
      product_name: "Red White and Blue Ice Cream",
      product_id: "7382032384066",
      product_text: "Celebrate in sweet style with this cheerful artwork featuring a whimsical assortment of red, white, and blue ice cream treats. Against a sparkling navy backdrop, each cone and popsicle bursts with festive charm, evoking the joy of summer celebrations."
    },
    {
      product_name: "Vivid Voodoo",
      product_id: "7382023569474",
      product_text: "Dive into a world of electric neon and striking contrasts with this bold artwork. A captivating character with vibrant blue hair and glowing magenta eyes holds a quirky voodoo bunny doll, blending edgy charm with playful eccentricity."
    },
    {
      product_name: "Magical Madeline",
      product_id: "7382029467714",
      product_text: "Step into a spellbinding scene with Magical Madeline, a captivating witch adorned in a celestial blue and gold hat with whimsical crescent moon details. Her fiery red curls and twinkling backdrop bring a delightful blend of magic and charm to life, perfect for anyone who loves vibrant fantasy."
    },
    {
      product_name: "Traveling Manor of Mist",
      product_id: "7373828227138",
      product_text: "A majestic snail carries a gothic stone manor through a mysterious misty forest, its glowing windows casting an eerie yet inviting warmth. Surrounded by delicate roses and twisted trees, this whimsical scene perfectly blends fantasy and gothic charm, evoking a tale of magical travels."
    },
    {
      product_name: "Rainbow Realm",
      product_id: "7377874812994",
      product_text: "Step into a magical realm where a grand castle with sky-blue spires stands proudly against a backdrop of rugged mountains and a radiant rainbow. Framed by blooming flowers, elegant swans gliding across a serene pond, and fluttering butterflies, this enchanting artwork captures the essence of a fairytale paradise."
    },
    {
      product_name: "Cabin Comfort",
      product_id: "7374243954754",
      product_text: "High in the snowy mountains, a cozy alpine terrace comes alive with the warmth of a crackling fire, soft blankets, and the cheerful company of loyal dogs. Skis and snowboards rest by the railing, while glowing lanterns and vibrant drapes frame the breathtaking view of a winter village below."
    },
    {
      product_name: "Dream Weave",
      product_id: "7374257258562",
      product_text: "In a cosmic dreamscape filled with glowing orbs and shimmering crystals, a serene child adorned in tribal regalia shares a moment of quiet connection with a majestic white owl. Together, they weave a dreamcatcher under a kaleidoscope of celestial patterns, surrounded by an aura of harmony and magic."
    },
    {
      product_name: "Enchantment",
      product_id: "7382001123394",
      product_text: "A vibrant bouquet bursts to life on the canvas, with luscious peonies, delicate foxgloves, and soft blue blossoms intertwining in a dreamy cascade of color. The gentle brushstrokes and luminous petals create a harmonious celebration of nature's elegance and charm."
    },
    {
      product_name: "Snowberry Cardinal",
      product_id: "7382035071042",
      product_text: "Perched gracefully on a snow-dusted branch, a vibrant cardinal radiates warmth against the wintry backdrop, surrounded by crimson berries and frosted leaves. The soft snowfall adds a serene touch, highlighting the bird's fiery plumage in this tranquil winter scene."
    },
    {
      product_name: "Time To Chill",
      product_id: "7382047326274",
      product_text: "Two stylish cats sip fruity drinks through straws, lounging in a tropical paradise of lush greenery and vibrant flowers. With their sunglasses and laid-back vibes, they embody the perfect blend of cool and carefree under the summer sun."
    },
    {
      product_name: "Crafty Bliss",
      product_id: "7382022193218",
      product_text: "In a sunlit craft room brimming with colorful supplies, a bright-eyed creator sits at her workspace, sketching and designing with focused excitement. Surrounded by spools of thread, tools, and a snoozing cat, she brings her imaginative ideas to life in a cozy, inspiring setting."
    },
    {
      product_name: "Make A Wish",
      product_id: "7374235992130",
      product_text: "A delicate fairy with shimmering, iridescent wings leans gracefully over a dandelion, her intricate floral crown and glittering adornments glowing softly in the warm light. Surrounded by an ethereal meadow filled with dandelions and magical hues, her serene expression and radiant details create a mesmerizing and otherworldly scene."
    },
    {
      product_name: "Marilyn Candy",
      product_id: "7373825015874",
      product_text: "Amid a whirlwind of vibrant colors and retro nostalgia, Marilyn Monroe’s iconic face emerges, painted in bold strokes of electric pink, sunny yellow, and cobalt blue. She gazes out with timeless allure, surrounded by a collage of 1950s Americana—candy advertisements, neon lettering, dice rolling in the corner, and sparkling disco balls that feel alive with movement."
    },
    {
      product_name: "Toughy",
      product_id: "7374246314050",
      product_text: "Beneath sunlit waves, a serene sea turtle glides through a vibrant underwater garden teeming with life. Colorful corals bloom in shades of red, orange, and pink, while intricately patterned fish swim alongside, creating a scene of movement and wonder in the ocean’s depths."
    },
    {
      product_name: "Coloring Afternoon",
      product_id: "7373808959554",
      product_text: "A young artist sits at her cozy desk, surrounded by colorful pencils, bookshelves, and a steaming cup of coffee. Her blonde braid, tinged with purple, and oversized glasses give her a vibrant and creative energy, as the warm glow of a desk lamp contrasts with the wintery scene visible through the window behind her."
    },
    {
      product_name: "Glamour Girl Frenchie",
      product_id: "7382862037058",
      product_text: "A cheerful French bulldog bursts to life in a vivid explosion of color, with bold splashes of blue, yellow, pink, and green radiating around it. Its playful expression, perked ears, and shining eyes create a dynamic and energetic portrait that celebrates both the dog’s charm and the vibrancy of artistic expression."
    },
    {
      product_name: "Radiant Realm",
      product_id: "7382023143490",
      product_text: "An ancient tree rises like a guardian of time, its twisted branches reaching toward the heavens as it stands rooted in a realm of magic and wonder. Beneath its canopy, a quiet stream winds through a land of endless beauty, while the skies above dance with ethereal light, as though the universe itself is alive and breathing."
    },
    {
      product_name: "Dancing Unicorn Princess",
      product_id: "7404168347714",
      product_text: "A tiny unicorn stands adorned with delicate flowers and a shimmering bow, its wide, innocent eyes filled with wonder. Wrapped in an air of enchantment, it seems to dance softly among the clouds, a symbol of pure magic and childlike dreams."
    },
    {
      product_name: "Life is Beautiful",
      product_id: "7404157763650",
      product_text: "Beneath the watchful gaze of a lighthouse, pelicans and shorebirds gather along the tranquil coast, their forms framed by the glow of the moon and the dance of distant waves. The scene captures a quiet harmony between land, sea, and sky, where nature’s rhythm is illuminated by soft light and gentle motion."
    },
    {
      product_name: "Enchanted Teapot Cottage",
      product_id: "7368931737666",
      product_text: "A whimsical teapot-shaped cottage rests peacefully in a magical forest, its roof adorned with blooming flowers and its windows glowing warmly like tiny beacons of life. Surrounded by a lush garden of vibrant blossoms and a winding stone path, the air seems alive with twinkling fireflies and the gentle flutter of butterflies, evoking a fairytale charm that feels both serene and enchanting."
    },
    {
      product_name: "Excalibur",
      product_id: "7374233337922",
      product_text: "In a sunlit autumnal glade, a mighty tree stretches its branches skyward, its golden leaves cascading gently to the forest floor. Wolves, foxes, and a majestic white stag stand as silent guardians, while a sword rests embedded in stone, catching the light in a spectral arc. The scene whispers of ancient tales, where nature and legend intertwine, and the air hums with quiet power and forgotten secrets."
    },
    {
      product_name: "Fairy of the Forest",
      product_id: "7368269660226",
      product_text: "Deep within the shadowed forest, a fairy with luminous eyes and flowing silver hair adorned with a crown of wildflowers gazes with quiet intensity. Beside her, a watchful owl perches as her companion, their presence imbued with the ancient wisdom and enchantment of the woodland realm."
    },
    {
      product_name: "Above and Below",
      product_id: "7368254619714",
      product_text: "A tranquil island paradise comes to life, where sailboats drift gently near a lighthouse framed by vibrant blossoms and swaying palms. Below the crystal-clear water, a hidden world of colorful marine life flourishes, with fish, sea turtles, and rays gliding through a coral reef bathed in dappled sunlight, seamlessly merging two realms of beauty."
    },
    {
      product_name: "Mystic Elephant",
      product_id: "7404168478786",
      product_text: "An elephant emerges majestically from a lush jungle, its form adorned with intricate, vibrant patterns that seem to blend seamlessly with the surrounding foliage. The leaves frame its wise and powerful presence, creating an aura of mysticism and harmony between the creature and the vibrant energy of the forest."
    },
    {
      product_name: "Heartful Studio",
      product_id: "7404166873154",
      product_text: "A young artist sits peacefully at her sunlit desk, surrounded by brushes, pencils, and an unfinished canvas. The studio glows with warmth, its window revealing a tranquil seascape bathed in soft pastel hues, while heart-shaped decorations sway gently above, reflecting the creativity and love imbued in the space."
    },
    {
      product_name: "Cow's Glance",
      product_id: "7404151832642",
      product_text: "A quirky cow gazes confidently through oversized glasses, its personality amplified by a colorful bow tie. The playful expression and stylish accessories transform this farmyard resident into a character full of charm and whimsy."
    },
    {
      product_name: "Gemstone Owl",
      product_id: "7404153569346",
      product_text: "A radiant owl gazes with mesmerizing, jewel-like eyes, its feathers intricately adorned with patterns resembling precious gemstones and delicate beads. Surrounded by a celestial glow, it exudes an aura of wisdom and enchantment, as if it guards secrets of the night sky."
    },
    {
      product_name: "The Bride",
      product_id: "7374253129794",
      product_text: "A hauntingly beautiful bride stands in a gothic cathedral, her face a delicate balance between life and decay. Adorned with an ornate crown and clutching a bouquet of vibrant roses, she wears a veil that partially reveals the skeletal truth beneath, embodying the passage of time and the eternal dance between love and mortality."
    },
    {
      product_name: "Purrfect Wisdom",
      product_id: "7374232191042",
      product_text: "A regal cat, adorned in ornate robes, studies an ancient tome by the glow of candlelight, its emerald eyes brimming with wisdom. Amid towering castles and an enchanted night, the scene evokes a world where magic and knowledge intertwine."
    },
    {
      product_name: "A Good Spot",
      product_id: "7368925806658",
      product_text: "A well-worn station wagon, piled high with the treasures of adventure, rests in a serene mountain retreat where towering pines and cascading waterfalls whisper of untamed beauty. As laughter fills the crisp air and a loyal dog stands watch, the scene captures the timeless joy of escaping to nature’s embrace, where memories are woven beneath endless skies."
    },
    {
      product_name: "Magical Wolf Moons",
      product_id: "7375976398914",
      product_text: "A majestic wolf rises from the moonlit waters, its radiant fur shimmering like a tapestry woven from the colors of the cosmos. Beneath a celestial sky where the crescent moon whispers secrets to the glowing sun, the guardian of the forest watches in silent wisdom, a bridge between the earthly and the divine."
    },
    {
      product_name: "Glamour Girl Calico Cat",
      product_id: "7404165365826",
      product_text: "A captivating calico cat gazes into the distance, its emerald eyes filled with quiet curiosity and grace. Bathed in a swirl of vibrant hues, its fur becomes a canvas of color, embodying the perfect harmony of elegance and playfulness."
    },
    {
      product_name: "Eternal Glow",
      product_id: "7404131123266",
      product_text: "A majestic tree stands twisted and ancient, its branches framing a radiant light that seems to pulse with the energy of the cosmos. Beneath a sky painted with celestial swirls, the tranquil shore whispers of timeless wonders and the quiet magic woven into the fabric of nature."
    },
    {
      product_name: "Sunflower Lil Dragonz",
      product_id: "7404165070914",
      product_text: "A charming little dragon sits with a playful twinkle in its eyes, adorned with a crown of sunflowers and delicate blossoms that radiate warmth and joy. With its tiny wings and soft, vibrant hues, it embodies a whimsical blend of fantasy and nature’s cheerful beauty."
    },
    {
      product_name: "Guardians Of The Green",
      product_id: "7404163268674",
      product_text: "A majestic wolf gazes forward, adorned with intricate tribal markings and an ornate necklace that reflects the spirit of the wild. Surrounded by lush foliage and vibrant flowers, it stands as a guardian of nature, embodying wisdom, strength, and harmony with the earth."
    },
    {
      product_name: "Year of the Snake",
      product_id: "7368932753474",
      product_text: "A radiant serpent coils elegantly among glowing lanterns, its shimmering scales reflecting the festive spirit of Lunar New Year. Surrounded by delicate cherry blossoms and floating lights, the scene embodies prosperity, transformation, and the renewal that comes with the Year of the Snake."
    },
    {
      product_name: "Lantern Festival Dragon",
      product_id: "7373819412546",
      product_text: "A majestic dragon emerges from the swirling waves, its powerful form winding gracefully through a landscape of blooming cherry blossoms and ornate architecture. Lanterns sway gently in the breeze, casting a warm glow over the intricate pagoda, creating a scene rich with myth, beauty, and timeless wonder."
    },
    {
      product_name: "Archetti Rossi",
      product_id: "7368933310530",
      product_text: "Sunlight bathes a charming cobblestone alleyway, where vibrant flowers spill from window boxes and archways frame a distant glimpse of the sea. The warm hues of the rustic buildings, adorned with wooden shutters and climbing vines, create an atmosphere of timeless tranquility and Mediterranean charm."
    },
    {
      product_name: "Rainbow Forest Fairy",
      product_id: "7368269987906",
      product_text: "Amidst the lush depths of an enchanted forest, a mesmerizing woman adorned with vibrant blossoms and intricate patterns gazes with an ethereal charm. Her flowing hair and radiant attire seem to merge with the natural world around her, embodying the harmony and magic of the wilderness."
    },
    {
      product_name: "Groovy Getaway",
      product_id: "7373820592194",
      product_text: "A retro surf van, adorned with vibrant flowers, sits parked by the shore, basking in the glow of a breathtaking sunset. With palm trees swaying and the ocean stretching endlessly beyond, the scene captures the free-spirited essence of adventure, nostalgia, and the call of the open road."
    },
    {
      product_name: "The 9 Realms",
      product_id: "7375970762818",
      product_text: "A celestial tapestry unfolds, where luminous beings gather in reverence beneath a radiant Earth, suspended in a cosmic web of energy and light. Crystals, sacred geometry, and blooming celestial flowers intertwine, evoking a vision of harmony, enlightenment, and the infinite connection of the universe."
    },
    {
      product_name: "Pipkin",
      product_id: "7404164710466",
      product_text: "A delicate winter hare sits gracefully atop a snowy perch, its fur adorned with intricate golden accents that shimmer like hidden magic. Framed by elegant florals and swirling patterns, the scene blends nature and fantasy, capturing a moment of quiet wonder beneath a starlit forest sky."
    },
    {
      product_name: "The Starry Night",
      product_id: "7404161466434",
      product_text: "Swirling skies dance above a quiet village, where the night hums with movement and emotion beyond the visible world. The stars pulse like living dreams, their golden glow illuminating a landscape that feels both vast and intimately familiar."
    },
    {
      product_name: "Calf Cutie",
      product_id: "7404168282178",
      product_text: "Soft as a whispering breeze, the little calf nestles among blooming petals, its gentle eyes brimming with wonder. The sky above stretches wide and endless, cradling the innocence of a world untouched by time."
    },
    {
      product_name: "Sunshowers",
      product_id: "7404159762498",
      product_text: "A gentle rain falls, catching the light as it dances across a rainbow-streaked sky. Under the shelter of a bright umbrella, a girl and her pup bask in the magic of the moment, where sunshine and raindrops embrace."
    },
    {
      product_name: "Evelyn",
      product_id: "7373812170818",
      product_text: "With a mind as vast as the stars beyond her window, she pieces together the mysteries of the cosmos. Maps, minerals, and celestial charts weave a story of adventure, where science and wonder meet in perfect harmony."
    },
    {
      product_name: "Guardian of the Skies",
      product_id: "7377870651458",
      product_text: "Perched upon the ancient boughs of a skyward throne, the lion watches over his boundless kingdom. His mane, like the shifting winds, dances with the spirit of the heavens, whispering tales of strength and eternity."
    },
    {
      product_name: "Night of Whispering Winds",
      product_id: "7373814857794",
      product_text: "Beneath the neon glow and the delicate drift of cherry blossoms, time feels like a distant echo. A lone figure lingers in the hush of the night, where memories and dreams blur like petals carried by the wind."
    },
    {
      product_name: "Catatouille",
      product_id: "7373830193218",
      product_text: "In a kitchen brimming with spices and stories, a master chef with whiskers and wit reigns supreme. With Paris as his muse and a feast at his paws, he crafts a culinary masterpiece fit for the most discerning palate."
    },
    {
      product_name: "Kitten's Floral Ride",
      product_id: "7404152127554",
      product_text: "A feline adventurer pedals through a whirlwind of color, a basket of blooms adding charm to the ride. With eyes full of wonder and paws steady on the journey, it embraces the art of motion with effortless grace."
    },
    {
      product_name: "Glamour Girl Donkey",
      product_id: "7404166217794",
      product_text: "A spirited soul emerges from a whirlwind of color, its gaze both gentle and filled with quiet wisdom. Radiating resilience and charm, this vibrant being embodies strength, patience, and a touch of playful mischief woven into a tapestry of artistry."
    },
    {
      product_name: "Mystery Oyster Pearl",
      product_id: "7404165201986",
      product_text: "Cradled within the ocean’s gentle embrace, a radiant pearl glows like a secret whispered by the tides. Surrounded by the shimmer of festive wonder, it is a treasure of mystery and light, waiting to reveal its story to those who dare to dream."
    },
    {
      product_name: "Neon Iguana",
      product_id: "7404168511554",
      product_text: "Bathed in an electric glow, this ancient guardian watches with an unblinking gaze, its scales shimmering like a living tapestry of fire and light. A creature of both mystery and majesty, it moves through the shadows, carrying the wisdom of a world untamed."
    },
    {
      product_name: "Gnome Sweet Gnome",
      product_id: "7373818003522",
      product_text: "With a twinkle in his eyes and a heart full of cheer, this charming gnome spreads love and joy wherever he roams. Carrying roses and heart-shaped balloons, he brings a little magic to brighten even the sweetest of days."
    },
    {
      product_name: "Marry Me Someday",
      product_id: "7377859051586",
      product_text: "In a garden of dreams, where roses bloom and butterflies dance, two young hearts share a moment of innocent affection. With shy smiles and tiny hands intertwined, they whisper a promise of love that time may one day fulfill."
    },
    {
      product_name: "Always",
      product_id: "7374251262018",
      product_text: "A timeless embrace unites love and eternity, as the woman rests peacefully in the arms of what remains of devotion. Amidst blooming lilies and cascading red hair, a quiet beauty lingers, whispering of passion that defies the boundaries of life and death."
    },
    {
      product_name: "Thriving",
      product_id: "7368269365314",
      product_text: "A cascade of blooming roses bursts with life, their delicate petals kissed by soft light and rich color. This vibrant bouquet radiates warmth and beauty, capturing the fleeting elegance of nature in full flourish."
    },
    {
      product_name: "Valentines Treasure",
      product_id: "7377866227778",
      product_text: "Bathed in the warm glow of affection, two young hearts share a moment of sweet anticipation before a window brimming with Valentine's delights. The air is rich with the promise of love and friendship, as innocence and joy paint a timeless memory of childhood wonder."
    },
    {
      product_name: "Heartache",
      product_id: "7375975579714",
      product_text: "A siren of sorrow, she stands adorned in the hues of love and longing, her heart a crimson gem bound in delicate lace. The air around her hums with whispered confessions, each suspended in a fragile dance between devotion and despair."
    },
    {
      product_name: "Blossom Falls",
      product_id: "7377872584770",
      product_text: "A serene paradise unfolds in cascading waterfalls, where crystal-clear waters gently embrace lush greenery and blooming lotus flowers. With hues of pink and turquoise blending into the golden sunset, this tranquil escape feels like a dream come to life."
    },
    {
      product_name: "Timeless Tune-Up",
      product_id: "7368268677186",
      product_text: "In the warmth of an old garage, a seasoned mechanic tenderly restores a classic car, bringing history back to life with each careful polish. Surrounded by well-worn tools and vintage signs, this timeless scene embodies dedication, nostalgia, and the love of craftsmanship."
    },
    {
      product_name: "By The Falls",
      product_id: "7368268480578",
      product_text: "A gentle waterfall flows through a lush meadow, where colorful blossoms, fluttering butterflies, and lively wildlife create a scene of pure harmony. A graceful deer stands among the vibrant flora, soaking in the tranquil beauty of this flourishing sanctuary."
    },
    {
      product_name: "Mystical Colorful Wolf",
      product_id: "7436331876418",
      product_text: "A guardian of ancient wisdom, this mystical wolf watches with piercing eyes, its fur woven with nature’s beauty and celestial energy. Adorned with sacred symbols and vibrant flora, it stands as a bridge between the earthly and the divine."
    },
    {
      product_name: "Wandwhisker",
      product_id: "7404155338818",
      product_text: "In an enchanted autumn forest, a tiny mage stands ready, its cloak billowing with quiet magic. With a staff in paw and wisdom in its bright eyes, this squirrel sorcerer guards the secrets of the woodland realm."
    },
    {
      product_name: "Twilight Temple",
      product_id: "7404139937858",
      product_text: "Beneath the watchful glow of the full moon, a hidden temple stands in quiet reverence, its lanterns flickering like distant stars. The crimson leaves whisper in the night breeze, guiding travelers toward the mysteries that lie within."
    },
    {
      product_name: "Bluejay Spring",
      product_id: "7404164907074",
      product_text: "Perched amidst a cascade of delicate blue and white blossoms, the blue jay watches the world with keen eyes, its feathers a radiant contrast against the soft floral embrace. Sunlight filters through the trees, casting a golden glow over this serene springtime sanctuary."
    },
    {
      product_name: "Tiki Lizard",
      product_id: "7403914297410",
      product_text: "Nestled among vibrant seashells on a sun-kissed beach, the chameleon gazes curiously at its tropical drink, its wide eyes reflecting the crystal-clear waters. With a tiny umbrella casting shade over the refreshing beverage, the scene exudes a laid-back, island paradise charm."
    },
    {
      product_name: "My Home Sweet Home",
      product_id: "7374240710722",
      product_text: "Bathed in golden sunlight, this charming seaside porch welcomes visitors with a symphony of blooming flowers and the gentle sway of an American flag. The rocking chair, positioned for a perfect view of the tranquil waters beyond, invites moments of peaceful reflection and warm nostalgia."
    },
    {
      product_name: "Rainbow Rushmore",
      product_id: "7377867964482",
      product_text: "A vibrant reimagining of Mount Rushmore, this electrifying artwork bathes the iconic monument in a kaleidoscope of colors beneath a radiant rainbow. The fusion of bold hues and dynamic lighting transforms the historic landmark into a surreal, dreamlike vision of unity and celebration."
    },
    {
      product_name: "Carnival Magic",
      product_id: "7374245756994",
      product_text: "A vibrant and nostalgic scene, this artwork captures the magic of a bustling carnival with its dazzling Ferris wheel, colorful performers, and lively crowd. The joyful energy of the fairground, complete with games, food stalls, and festive decorations, evokes a timeless sense of wonder and celebration."
    },
    {
      product_name: "Patriotic Post",
      product_id: "7374230716482",
      product_text: "This vibrant countryside scene radiates American pride, with a patriotic mailbox adorned in stars and stripes. A blue jay perches proudly above as an American flag waves among colorful wildflowers, celebrating the beauty of the land of the free."
    },
    {
      product_name: "Cherry Bomb",
      product_id: "7439045394498",
      product_text: "With piercing crimson eyes and an aura of mystery, she sits adorned in deep red lace, her presence both enchanting and untamed. Flanked by two ghostly unicorns, she exudes an eerie elegance, like a dark queen reigning over a moonlit dream."
    },
    {
      product_name: "Ethereal Bloom",
      product_id: "7439044575298",
      product_text: "A luminous tree radiates energy at the heart of this dreamlike world, its pink branches reaching toward a cosmic sky ablaze with celestial hues. Twisting rivers of glowing blue weave through vibrant fields of surreal flowers, creating an enchanting harmony of color and light."
    },
    {
      product_name: "Compassion for Mother Earth",
      product_id: "7439046869058",
      product_text: "With ancient wisdom etched into its weathered shell, the colossal tortoise carries a thriving oasis upon its back, a symbol of resilience and harmony with nature. Under the boundless sky, it moves steadily, a guardian of life, carrying the weight of the world with quiet strength."
    },
    {
      product_name: "Ravenna",
      product_id: "7439048540226",
      product_text: "With fiery red hair cascading in waves, she stands adorned in gothic lace, her piercing gaze both mesmerizing and untamed. A raven soars in the candlelit cathedral behind her, echoing the mystery and power she effortlessly exudes."
    },
    {
      product_name: "In Gemma's Garden",
      product_id: "7403914952770",
      product_text: "Amid a garden of delicate blue pansies, a curious cat gazes up with mesmerizing sapphire eyes, its fur glowing in the soft light. Above, a vibrant hummingbird hovers gracefully, adding a touch of wonder to this tranquil meeting of nature and feline curiosity."
    },
    {
      product_name: "Shamrock Elf",
      product_id: "7404148424770",
      product_text: "Perched atop a whimsical toadstool, a charming shamrock elf gazes out with rainbow-kissed eyes, her emerald dress swirling like enchanted leaves. Surrounded by clovers and rolling green hills, she basks in the glow of twin rainbows, a guardian of luck and magic."
    },
    {
      product_name: "Glamour Girl Welsh Corgi",
      product_id: "7404166316098",
      product_text: "This vibrant Welsh Corgi bursts with a spectrum of colors, its expressive eyes radiating pure joy and boundless energy. Set against a swirling rainbow backdrop, this artwork captures the playful spirit and lovable charm of this beloved breed."
    },
    {
      product_name: "Dahlia Bliss",
      product_id: "7403914133570",
      product_text: "A breathtaking bouquet of dahlias blooms in a rich array of soft pastels and warm, fiery hues, exuding timeless elegance. The delicate brushstrokes and luminous background create a radiant, dreamy atmosphere, celebrating the beauty of nature in full bloom."
    },
    {
      product_name: "Book of Dreams",
      product_id: "7441997529154",
      product_text: "A storybook comes to life as its pages unfold into a whimsical forest village, where glowing cottages nestle beneath the canopy of an enchanted tree. Illuminated by the soft light of floating orbs, the magical realm is filled with cascading waterfalls, vibrant flowers, and winding pathways leading deeper into the dreamlike world."
    },
    {
      product_name: "All Night Burgers",
      product_id: "7442017321026",
      product_text: "Neon lights glow against the night sky as classic cars line up at the Skyline Diner, capturing the nostalgic charm of a bygone era. With a city skyline in the background and a jet soaring above, the scene evokes the thrill of late-night drives, rock ‘n’ roll tunes, and the irresistible aroma of burgers and fries."
    },
    {
      product_name: "Rainbow Lil Dragonz",
      product_id: "7442031673410",
      product_text: "A dazzling little dragon sparkles with magic, blending vibrant hues of purple, pink, and blue beneath a sky bursting with rainbows and stardust. Its playful charm, twinkling eyes, and shimmering wings create a whimsical world where fantasy and color collide in a mesmerizing dreamscape."
    },
    {
      product_name: "Wildflowers",
      product_id: "7442033147970",
      product_text: "A radiant fairy adorned with intricate butterfly wings stands gracefully amid a meadow bursting with wildflowers, her presence embodying the enchantment of nature. Her delicate gown shimmers with ethereal light, and a floral crown rests upon her flowing hair, as butterflies and dragonflies dance around her in a magical embrace."
    },
    {
      product_name: "Aurora Lion",
      product_id: "7404168446018",
      product_text: "A majestic lion gazes into the distance, its flowing mane ablaze with an electrifying fusion of fiery oranges, deep purples, and cosmic blues. Set against a dreamy sky of glowing clouds and distant mountains, this striking piece radiates power, wisdom, and untamed beauty."
    },
    {
      product_name: "Lunar Blossom",
      product_id: "7404137611330",
      product_text: "A majestic tree stands elegantly under the luminous glow of a full moon, its delicate branches adorned with soft petals that shimmer in the night. Surrounded by drifting clouds, celestial blues, and a gently flowing stream, this enchanting artwork evokes a sense of tranquility and dreamlike wonder."
    },
    {
      product_name: "Pug of the Blade",
      product_id: "7404134629442",
      product_text: "In an enchanted forest shrouded in mist, the pug warrior stands vigilant, its deep, expressive eyes reflecting ancient secrets. Clad in intricate emerald robes and wielding a gleaming blade, it guards the realm with courage and mystical charm."
    },
    {
      product_name: "Funky Frog",
      product_id: "7404152848450",
      product_text: "Surrounded by a burst of colorful flowers and whimsical mushrooms, the vibrant frog sits with wide, curious eyes. Its swirling, psychedelic patterns create a playful harmony with the lively jungle backdrop, radiating a sense of wonder and magic."
    },
    {
      product_name: "Spring Fields",
      product_id: "7445046263874",
      product_text: "Amidst a field of vibrant flowers and fluttering butterflies, the playful calf stands adorned with colorful bow, exuding a cheerful charm. Surrounded by a rainbow-kissed sky, this whimsical scene radiates pure delight and the magic of springtime wonder."
    },
    {
      product_name: "Mother Earth",
      product_id: "7445073788994",
      product_text: "In a lush paradise of blooming flowers and cascading waters, a gentle figure cradles the world, embodying life and creation.  Surrounded by the harmony of day and night, her flowing gown blends seamlessly with the land and water, embodying the beauty and balance of nature."
    },
    {
      product_name: "Old Town Charm",
      product_id: "7445078966338",
      product_text: "A burst of color brings life to this nostalgic street, where vibrant storefronts and vintage vehicles bask under a golden sky. Bathed in radiant hues, this lively scene transforms cherished memories into a vivid, dreamlike celebration of the past."
    },
    {
      product_name: "Wonder",
      product_id: "7445083062338",
      product_text: "In a celestial forest woven with cosmic vines, luminescent spirits tend to a mystical plant pulsing with radiant energy. Beneath a canopy of starlit branches, an ethereal owl soars above, guarding the harmony of this otherworldly realm."
    },
    {
      product_name: "Magic Sidekick",
      product_id: "7404167856194",
      product_text: "A mystical black cat with mesmerizing, starry eyes perches on an ancient book, exuding an air of mystery. Surrounded by shimmering potions and celestial swirls, the scene exudes magic and wonder."
    },
    {
      product_name: "Smiley",
      product_id: "7404156715074",
      product_text: "A bold and vibrant smiley face bursts to life in this electrifying artwork, painted with a dynamic mix of neon pink, yellow, blue, and green. The expressive brushstrokes and fluid, abstract background create an energetic, joyful atmosphere, radiating positivity and fun."
    },
    {
      product_name: "Hoppy Frog",
      product_id: "7404167004226",
      product_text: "A whimsical bunny with dazzling blue eyes sits in a serene pond, donning an adorable frog hat that adds a playful touch. Surrounded by lush greenery and blooming water lilies, this enchanting artwork blends fantasy and nature into a heartwarming, storybook-like scene."
    },
    {
      product_name: "Underwater Ballet",
      product_id: "7404155863106",
      product_text: "A breathtaking underwater scene comes to life with majestic orcas, playful dolphins, and a vibrant array of marine life gliding through a colorful coral reef. Sunlight filters through the crystal-clear water, illuminating the rich details of this aquatic paradise, where nature's beauty and harmony take center stage."
    },
    {
      product_name: "Mystery Kit #3 - Fantasy Pop",
      product_id: "7448873795650",
      product_text: "A cloaked wanderer moves through an enchanted forest, her emerald eyes sharp as she clutches a basket filled with unknown treasures. Shadows weave between the trees, watching in silence, as something unseen lingers just beyond the blossoms."
    },
    {
      product_name: "Mystery Kit #4 - Cities & Skyline",
      product_id: "7448876351554",
      product_text: "Beneath the glow of golden lights, an air of luxury lingers as elegant figures arrive in style, their secrets hidden behind grand facades. The moonlit sea whispers beyond the lavish promenade, where fortune and fate entwine in the night."
    },
    {
      product_name: "Irish Bakery",
      product_id: "7448941068354",
      product_text: "A charming Irish bakery bursts with festive delight as children press eagerly against the glass, mesmerized by a display of rainbow cakes and shamrock sweets. Dressed in cozy knits and plaid, they bask in the magic of the moment, while a lucky pot of gold glows beside a curious boy, completing the scene of enchantment and joy."
    },
    {
      product_name: "House of Tranquility",
      product_id: "7448943722562",
      product_text: "A seaside cottage nestles beneath blossoming magnolia trees, their soft pink petals swaying in the ocean breeze. Sunlight spills through the open shutters, filling the tranquil retreat with warmth and the sweet scent of spring."
    },
    {
      product_name: "Neverend",
      product_id: "7448946769986",
      product_text: "Two travelers walk hand in hand toward the golden horizon, their reflections shimmering on the water like a dream. Above them, the sky unfolds in a cosmic dance of twilight hues, where stars and clouds weave a path into the unknown."
    },
    {
      product_name: "Where Dreams Come True",
      product_id: "7448948375618",
      product_text: "A magical castle floats within a shimmering bubble, surrounded by lush gardens and vibrant butterflies. Beneath a cosmic sky, tropical fish and exotic flowers weave together a dreamlike world where land and sea exist in harmony."
    },
    {
      product_name: "Owlmates",
      product_id: "7404138037314",
      product_text: "Two vibrant owls perch closely on a branch, their feathers a mesmerizing blend of fiery reds, deep blues, and golden oranges. Surrounded by blooming roses and floating hearts, they gaze lovingly under the warm glow of a full moon."
    },
    {
      product_name: "Timeless Glow",
      product_id: "7403914494018",
      product_text: "A breathtaking mountain landscape unfolds beneath a golden sky, where the sun's warm glow highlights the rugged peaks. A crystal-clear lake mirrors the towering evergreens and autumn-hued grasses, creating a serene and timeless scene."
    },
    {
      product_name: "Blossoming Intellect",
      product_id: "7404151177282",
      product_text: "A stylish French Bulldog dons a dapper suit, a patterned bowtie, and round glasses, exuding an air of intelligence and charm. The vibrant background, adorned with floral accents and vintage text, adds a whimsical and artistic touch to the composition."
    },
    {
      product_name: "Neon Rainbow Tiger",
      product_id: "7404164972610",
      product_text: "Drenched in a vivid spectrum of neon hues, a majestic tiger gazes forward with piercing, multicolored eyes. Splashes of electric color and a delicate, rainbow-tinted rose contrast the raw power of the wild, blending strength with ethereal beauty."
    },
    {
      product_name: "Japan Spring Garden",
      product_id: "7453690986562",
      product_text: "Cherry blossoms drift through the air as a gentle breeze carries the scent of spring across a tranquil Japanese garden. A koi-filled pond reflects the vibrant hues of nature, while a lone figure in a flowing kimono strolls beneath the ornate pavilion, lost in quiet serenity."
    },
    {
      product_name: "Myst",
      product_id: "7453691805762",
      product_text: "In an icy, enchanted realm, a regal young woman stands with quiet strength, her silver hair adorned with a peacock feather. Beside her, two horned snow leopards with piercing blue eyes exude an aura of mystery and majesty. The frozen peaks behind them hint at untold adventures."
    },
    {
      product_name: "Pixie Painter",
      product_id: "7453692559426",
      product_text: "In a sunlit forest glade, a cheerful pixie paints a butterfly's wings with delicate strokes. Her golden curls peek from beneath a flower-adorned hat as she brings beauty to life, surrounded by towering blooms and a cozy cottage aglow with warmth."
    },
    {
      product_name: "Tre Archi",
      product_id: "7453692952642",
      product_text: "Sunlight spills through ancient stone arches, casting soft shadows on a quiet cobblestone street. Vibrant flowers spill from window boxes and clay pots, breathing life into the charming village. A sense of timeless tranquility lingers in the air, inviting wanderers to explore its hidden beauty."
    },
    {
      product_name: "Sunset Snuggles",
      product_id: "7404139053122",
      product_text: "A devoted mother squirrel cradles her baby on a sturdy tree branch, their bond illuminated by the golden hues of sunset. Framed by vibrant autumn foliage, this tender moment captures the warmth and serenity of nature’s embrace."
    },
    {
      product_name: "Cat Cowboy",
      product_id: "7404162383938",
      product_text: "With a confident smirk and a gleam in his eyes, a daring cowboy cat rules the Wild West in style. Clad in denim overalls, a bold red bandana, and embroidered boots, he stands tall against a glowing desert sky, ready for adventure."
    },
    {
      product_name: "Love Bandit",
      product_id: "7404158517314",
      product_text: "Bathed in a soft forest glow, a charming raccoon gazes with wide, adoring eyes, clutching a delicate rose in its tiny paws. Floating hearts and vibrant blooms create a whimsical scene, blending sweetness with a touch of playful mischief."
    },
    {
      product_name: "Cosmos",
      product_id: "7403913936962",
      product_text: "A vibrant bouquet of pink and white cosmos blooms with delicate brushstrokes, exuding elegance and charm. The soft, dreamy background enhances the flowers’ natural beauty, creating a serene and timeless composition."
    },
    {
      product_name: "Red Blossom Buddies",
      product_id: "7456179454018",
      product_text: "A charming black Labrador and a blissful kitten share a delightful moment amidst vibrant red blossoms and playful ladybugs. This heartwarming scene captures the essence of summer, radiating warmth, joy, and friendship."
    },
    {
      product_name: "Rainbow Phoenix",
      product_id: "7456180142146",
      product_text: "A mesmerizing phoenix rises in a blaze of vibrant colors, its fiery wings illuminating the mystical forest with an ethereal glow. Swirling plumes of red, orange, and blue intertwine like cosmic energy, embodying resilience, transformation, and the boundless spirit of renewal."
    },
    {
      product_name: "The Gothic Library",
      product_id: "7456182698050",
      product_text: "Under the golden embrace of twilight, an abandoned sanctuary stands, draped in ivy and mystery. Mermaids linger in the still waters, their tails entwined with drifting lily pads, while the air hums with silent echoes of forgotten lore."
    },
    {
      product_name: "Waters Of Nirvana",
      product_id: "7456185319490",
      product_text: "Bathed in the golden glow of a setting sun, a tranquil lake stretches between majestic peaks, reflecting the heavens above. Blossoms of every hue frame the water’s edge, their petals dancing in the breeze, while distant temples whisper of serenity and timeless wonder."
    },
    {
      product_name: "The Baby Elephant",
      product_id: "7403915051074",
      product_text: "A majestic guardian of the wild, adorned in a kaleidoscope of colors, steps forward with quiet wisdom. Patterns swirl like ancient stories upon its skin, a vibrant testament to strength, resilience, and the soulful spirit of nature."
    },
    {
      product_name: "Soulbound",
      product_id: "7404135710786",
      product_text: "Two souls entwined, their fiery eyes reflecting an unbreakable bond beyond time. Wrapped in luminous hues and adorned with fate’s intricate touch, they exist as mirrors of each other’s essence, bound by a connection deeper than words."
    },
    {
      product_name: "Bubble Squad",
      product_id: "7403914199106",
      product_text: "Gliding through a vibrant underwater paradise, a bright-eyed turtle explores the ocean’s wonders with boundless curiosity. Surrounded by playful dolphins and a rainbow of coral, it moves effortlessly, embodying the magic and serenity of the sea."
    },
    {
      product_name: "Dancing With Dragonflies",
      product_id: "7403914625090",
      product_text: "With boundless energy and a heart full of joy, a playful pup frolics through a sunlit meadow. Surrounded by fluttering dragonflies and blooming wildflowers, it basks in the simple magic of nature’s embrace."
    },
    {
      product_name: "Rainbow Roots",
      product_id: "7458049654850",
      product_text: "Standing as a symbol of unity and balance, the majestic tree stretches its multicolored branches toward the cosmos. Its roots, infused with flowing hues, weave into earth like streams of light, bridging realms of nature and imagination in a breathtaking dance of color."
    },
    {
      product_name: "Dining on the Terrace",
      product_id: "7458051194946",
      product_text: "Overlooking the sparkling sea, this enchanting terrace is alive with vibrant blooms and timeless charm. The soft glow of sunset casts a golden hue, inviting moments of peace and delight."
    },
    {
      product_name: "Autumn Scenery",
      product_id: "7458052341826",
      product_text: "Bask in the golden glow of an autumn sunset with this breathtaking scene. Two majestic white wolves rest on a rocky ledge, surrounded by warm fall hues. A waterfall flows into a clear pool, framed by pines and distant mountains, capturing the essence of wilderness."
    },
    {
      product_name: "Venetian Dream",
      product_id: "7458053423170",
      product_text: "As the sun sets over a tranquil Venetian canal, warm hues paint the sky, casting a golden glow on the colorful buildings adorned with cascading flowers. Laundry sways gently above the water, while an ornate bridge arches gracefully, inviting wanderers into this idyllic scene."
    },
    {
      product_name: "Fairy Paws",
      product_id: "7461035900994",
      product_text: "In a realm where dreams take flight, a tiny winged tiger cub flutters amidst shimmering bubbles, her flower crown glowing in the golden light. With each delicate pawstep, she sprinkles a touch of magic, leaving behind a trail of sparkling wonder in the pastel sky."
    },
    {
      product_name: "Starlit Retreat",
      product_id: "7461038850114",
      product_text: "Under a starlit sky, a glowing fairy twirls gracefully in front of a charming forest cottage, its windows radiating with golden light. Surrounded by vibrant flowers and watched over by a delicate winged spirit, the scene hums with gentle, magical serenity."
    },
    {
      product_name: "Colorwave Queen",
      product_id: "7461040980034",
      product_text: "With flowing rainbow hair and heart-shaped glasses reflecting a cosmic sky, she embodies a vibrant spirit of love and creativity. Her floral tattoo blooms with vivid hues, blending seamlessly into the swirling colors around her."
    },
    {
      product_name: "The Color Of Perfection",
      product_id: "7461043634242",
      product_text: "A radiant bird with dazzling plumage in turquoise, violet, and sunset orange perches gracefully among blooming flowers. The magenta, coral, and lavender petals create a vivid contrast, making the scene burst with life and elegance."
    },
    {
      product_name: "Summer Breeze",
      product_id: "7461021450306",
      product_text: "Feel the warmth of a seaside escape as the ocean breeze flows through this charming porch. With colorful flowers, cozy wicker chairs, and sailboats gliding across the water, this scene captures the essence of summer relaxation."
    },
    {
      product_name: "Blossom Fairy",
      product_id: "7461023842370",
      product_text: "A delicate fairy with golden wings and sparkling blue eyes rests among a meadow of pastel flowers. Her hair, adorned with wild blooms, dances in the gentle breeze as butterflies flutter nearby."
    },
    {
      product_name: "Dino Jungle",
      product_id: "7461030297666",
      product_text: "In a lush, prehistoric jungle, towering dinosaurs roam beneath the dappled sunlight. Pterosaurs glide through the misty canopy as vibrant flowers bloom along the river’s edge."
    },
    {
      product_name: "Rainbow Shaman",
      product_id: "7461032951874",
      product_text: "A mystical shaman with a radiant headdress meditates in harmony with the cosmos. Her flowing hair and aura shimmer with rainbow colors, symbolizing a connection to the spirit world."
    },
    {
      product_name: "Glamour Girl Black Lab",
      product_id: "7465563193410",
      product_text: "Basking in a cosmic swirl of vibrant hues, this black Labrador radiates elegance and charm. Its soulful amber eyes gaze with warmth, while flowing neon waves and stardust-like accents create a dazzling, dreamlike aura."
    },
    {
      product_name: "Spring Bouquet with Birds",
      product_id: "7465566240834",
      product_text: "Awash in a radiant burst of spring hues, a trio of birds flutters around a lush bouquet in full bloom. Vibrant petals and a rustic birdhouse create a serene garden scene, capturing the joyful essence of the season."
    },
    {
      product_name: "Blue Muse",
      product_id: "7465568829506",
      product_text: "A striking portrait of elegance and mystery, this artwork blends bold colors with captivating details. The woman's piercing blue eyes and intricate patterns create a mesmerizing fusion of beauty, artistry, and imagination."
    },
    {
      product_name: "Blue Forest",
      product_id: "7465570369602",
      product_text: "Beneath a canopy of lavender and indigo trees, a tranquil river winds through the forest. The soft glow of dawn filters through the foliage, casting a serene spell over the peaceful landscape."
    },
    {
      product_name: "Eggstra Cute",
      product_id: "7466120609858",
      product_text: "A fluffy chick stands in a flower-filled garden, holding a basket brimming with colorful Easter eggs. Surrounded by delicate pink blossoms, it captures the charm of springtime."
    },
    {
      product_name: "Some Bunny Loves You",
      product_id: "7466122641474",
      product_text: "Excited children gaze into a charming candy shop filled with colorful Easter treats and chocolate bunnies. Nearby, a young boy gathers eggs in a playful Easter egg hunt."
    },
    {
      product_name: "Harriet",
      product_id: "7466125328450",
      product_text: "A gentle rabbit with striking blue eyes peeks through a vibrant bed of colorful flowers. Her serene gaze and soft fur create a peaceful, enchanting scene."
    },
    {
      product_name: "Pink Blossom Buddies",
      product_id: "7466127949890",
      product_text: "A cheerful trio—a cat, dog, and bunny—relax among pink roses and cherry blossoms as a hummingbird flutters by, capturing the joy of springtime friendship."
    },
    {
      product_name: "Cosmic Companions",
      product_id: "7470133084226",
      product_text: "Under a swirling cosmic sky, a vibrant owl and a curious kitten share a magical bond. Their glowing feathers and fur shimmer with radiant hues, surrounded by neon flowers and sparkling stars."
    },
    {
      product_name: "Who Killed the Rabbit",
      product_id: "7470137638978",
      product_text: "Lost in a dreamy haze, a pensive girl sits atop a rabbit skull adorned with pink roses. A grinning ghostly cat floats in green mist as teacups and cards drift by, adding to the eerie whimsy."
    },
    {
      product_name: "Woodland Friends Rainbow Magic",
      product_id: "7470148616258",
      product_text: "A deer, bunny, and squirrel bask in a rainbow-lit forest, surrounded by butterflies and enchanted blooms. Their magical world radiates pure joy."
    },
    {
      product_name: "Twilight Castle",
      product_id: "7470213201986",
      product_text: "Golden light swirls around a towering castle, perched above cascading waterfalls and surrounded by vibrant trees. The enchanting scene blends fantasy and nature, inviting wonder."
    },
    {
      product_name: "Fluffy Whiskers",
      product_id: "7472587702338",
      product_text: "Nestled in a sunlit meadow, a fluffy bunny gazes curiously amidst vibrant wildflowers. Its soft fur and gentle expression capture the essence of springtime charm."
    },
    {
      product_name: "Gamer Girl",
      product_id: "7472590159938",
      product_text: "Bathed in neon hues, a gamer girl immerses herself in a vibrant virtual world. Her glowing headset and ponytail reflect the energy of the digital realm, while soft pink lights create a futuristic, cozy atmosphere."
    },
    {
      product_name: "Daisy Field Frolic",
      product_id: "7472606904386",
      product_text: "A joyful pup bounds through a vibrant field of daisies, its ears flying and smile wide with carefree delight. Bursting with color and energy, this playful scene captures the pure bliss of a sunny day in nature’s embrace."
    },
    {
      product_name: "Bluebird Post",
      product_id: "7472609165378",
      product_text: "Nestled beneath whimsical toadstools, two bluebirds exchange a tiny love letter amid a garden of soft pink blooms. This enchanting scene radiates warmth and wonder, like a secret message carried on a gentle woodland breeze."
    },
    {
      product_name: "At The Lodge",
      product_id: "7470542880834",
      product_text: "A sleek motorcycle rests outside a cozy lodge, surrounded by golden leaves and vibrant autumn trees. With wildlife nearby and mountains towering beyond, this scene blends rustic peace with a spirit of adventure."
    },
    {
      product_name: "Fableheart",
      product_id: "7471548465218",
      product_text: "In a starlit forest, a majestic white lion rests among vibrant blooms and enchanted trees. With a flowing mane and golden markings, it evokes a world of living legends and whispered tales."
    },
    {
      product_name: "Wings of Wonder 2025",
      product_id: "7471603712066",
      product_text: "In a sunlit forest, a delicate fairy with shimmering wings and a flower crown sketches in her open book. Her colorful dress and calm gaze capture the magic of the woods."
    },
    {
      product_name: "Tree of Seasons",
      product_id: "7471607283778",
      product_text: "A single tree blooms with petals of every color, capturing the spirit of all four seasons in one radiant scene. Around it, snowy forests, sunny meadows, and flower-filled fields blend in a harmony of nature’s shifting beauty."
    },
    {
      product_name: "Lilypond Cottage",
      product_id: "7473694310466",
      product_text: "A cottage nestles beneath blooming trees, its thatched roof glowing in the gentle light. Beside it, a lily-covered pond reflects the colors of spring in a scene of pure serenity."
    },
    {
      product_name: "Kitties And Flowers",
      product_id: "7473701683266",
      product_text: "Two curious kittens sit tucked among a burst of colorful blooms, their bright eyes full of wonder. Surrounded by sunflowers and zinnias, the scene radiates playful charm and sunny warmth."
    },
    {
      product_name: "Happy Garden",
      product_id: "7474634915906",
      product_text: "A vibrant burst of color fills the scene with cheerful flowers, playful butterflies, and busy bees dancing through the garden. Every inch overflows with energy, joy, and the magic of nature in full bloom."
    },
    {
      product_name: "Majestic Night",
      product_id: "7474636587074",
      product_text: "A luminous unicorn rises from a shimmering lake, its glowing mane and tail flowing like silk. Above, the northern lights swirl in vibrant waves, casting a magical glow over the serene landscape."
    },
    {
      product_name: "Nova Princess",
      product_id: "7472928129090",
      product_text: "A celestial girl with luminous violet eyes and twin ponytails stands surrounded by a dreamy cosmic swirl. Her futuristic armor glows with starlight, as if she herself was born from the heart of a galaxy."
    },
    {
      product_name: "Life In Color",
      product_id: "7472937861186",
      product_text: "This vibrant scene bursts with joyful symbols like rainbows, unicorns, and sweets, all outlined in bold, playful strokes. It’s a cheerful celebration of positivity, creativity, and all things colorful."
    },
    {
      product_name: "Cottage Bat",
      product_id: "7472944709698",
      product_text: "A wide-eyed bat with delicate lace wings hovers above a moody vintage scene of books, flowers, and flickering candles. The setting feels enchanted and mysterious, as if time itself has paused in this quiet, gothic corner."
    },
    {
      product_name: "Farmyard Quilt",
      product_id: "7472948412482",
      product_text: "A cheerful quilt hangs bright and bold, amid farm friends with stories untold.The sunny yard bursts with color and life, creating a warm and joyful countryside scene."
    },
    {
      product_name: "Purr-fect Roadtrip",
      product_id: "7474967478338",
      product_text: "A curious cat with a cool, calm stare rides in style through the vibrant air. With bursts of color and playful delight, this groovy adventure is pure feline hype."
    },
    {
      product_name: "Elven",
      product_id: "7478179070018",
      product_text: "Adorned in shimmer with an icy grace, she carries the calm of a timeless place. Every gem and braid reflects a tale, whispered softly through the silver veil."
    },
    {
      product_name: "Jungle Dragon Lord",
      product_id: "7474992480322",
      product_text: "A radiant dragon with electric hues emerges from vivid swirling foliage. Surrounded by bold, fantastical plants, it exudes power and otherworldly beauty."
    },
    {
      product_name: "Mystic Feather",
      product_id: "7475441664066",
      product_text: "Bathed in golden sunlight, a brilliantly colored bird perches among glowing, rainbow-hued leaves. Its vibrant feathers and watchful gaze create a magical moment frozen in time."
    },
    {
      product_name: "Camper's Paradise",
      product_id: "7475470106690",
      product_text: "A cozy retreat with a scenic view, where skies are wide and dreams feel true. With every detail both calm and bright, this camper’s haven is pure delight."
    },
    {
      product_name: "Romantic Madness",
      product_id: "7475477479490",
      product_text: "A vision of elegance with gears that gleam, where steampunk style meets a floral dream. With vintage clocks and petals that dance, this radiant portrait is bold romance."
    },
    {
      product_name: "Donut Cutie Hound",
      product_id: "7475492454466",
      product_text: "A playful pup with sprinkle-topped charm dives into a world of colorful, sugary bliss. Surrounded by frosted donuts and candy swirls, this sweet adventure is pure delight for the senses."
    },
    {
      product_name: "Sip",
      product_id: "7475466403906",
      product_text: "Glowing with light and radiant glow, she drinks the magic soft and slow. Each shimmer and sparkle tells a dream, flowing gently like a moonlit stream."
    },
    {
      product_name: "Colorful Cats",
      product_id: "7478826631234",
      product_text: "Two radiant cats with swirling rainbow fur sit in a vibrant sea of blooming flowers. Soft winds dance through the garden, filling the air with magic and wonder."
    },
    {
      product_name: "Spring Gnome Trio",
      product_id: "7478849175618",
      product_text: "Three cheerful gnomes rest among daisies and sunflowers, their colorful hats brightening the garden. A butterfly flutters nearby as a bluebird perches on a golden sunflower."
    },
    {
      product_name: "Flutter & Sip",
      product_id: "7478814441538",
      product_text: "Perched brightly in a floral teacup, a colorful songbird rests among blooming flowers. Playful butterflies dance nearby as a charming riverside cottage completes the scene."
    },
    {
      product_name: "Mystic Guardian",
      product_id: "7478863069250",
      product_text: "A powerful snow leopard strides along a rocky mountain trail, its piercing eyes locked ahead. Snowy peaks rise behind as golden grass and stones frame its silent majesty."
    },
    {
      product_name: "Terracotta Mansion",
      product_id: "7478880960578",
      product_text: "A grand brick manor stands by a peaceful pond, framed by blooming flowers and tall trees. A wooden bridge arches overhead as ducks glide past a resting canoe."
    },
    {
      product_name: "Snow White and Friends",
      product_id: "7478889939010",
      product_text: "A gentle girl rests in a forest clearing, surrounded by woodland animals and bright blooms. A deer nuzzles close as a fox, rabbit, and raccoon snuggle peacefully at her side."
    },
    {
      product_name: "Every Witch Way",
      product_id: "7479993532482",
      product_text: "A mysterious witch pedals through a foggy town, her black gown and crooked hat trailing behind. A cat rides in the basket as a raven perches on glowing spellbooks."
    },
    {
      product_name: "Fortune Teller",
      product_id: "7479999365186",
      product_text: "A wide-eyed mystic gazes into a glowing crystal ball, her fingers tracing its swirling light. Winged spirits hover nearby beneath deep red curtains, adding a touch of magic."
    },
    {
      product_name: "Mamba",
      product_id: "7480012275778",
      product_text: "A blue-scaled dragon with a unicorn horn rests among vibrant blossoms, its golden eye glowing with quiet magic. Flowers crown its head as lush leaves surround its graceful form."
    },
    {
      product_name: "Harvest Charm",
      product_id: "7480018403394",
      product_text: "A vibrant sunflower bouquet fills a teal pitcher, surrounded by pumpkins, honey jars, and corn. A rustic barn and golden trees complete the cozy autumn scene."
    },
    {
      product_name: "Flying Colors",
      product_id: "7480020926530",
      product_text: "Two vibrant parrots bring a tropical scene to life, one perched in lush foliage and the other soaring above palm trees. Bright flowers and a distant ocean add pops of color."
    },
    {
      product_name: "Panda Paradise",
      product_id: "7482543636546",
      product_text: "A mother panda lounges with her playful cub amid tall bamboo and blooming lilies. A colorful songbird perches nearby, bringing life to the tranquil forest scene."
    },
    {
      product_name: "Queenie's Quiltery",
      product_id: "7482550222914",
      product_text: "Colorful quilts and fabric rolls fill a cozy sewing room, where patterns burst with creativity. Sunlight streams in as chairs circle a vibrant quilt-in-progress."
    },
    {
      product_name: "Flower Market Girl",
      product_id: "7482552188994",
      product_text: "A sweet gardener with lavender braids holds a pail of flowers, surrounded by vibrant blooms and hanging berries. Sunlight pours through the window, warming her cozy greenhouse."
    },
    {
      product_name: "Adopt Us",
      product_id: "7483732852802",
      product_text: "Curious children gaze into a pet shop window filled with adorable dogs, cats, and birds. Nearby, playful kittens tangle in yarn as a pug waits patiently on a leash."
    },
    {
      product_name: "Cotswold Walk",
      product_id: "7483736948802",
      product_text: "Charming stone cottages line a flower-filled lane as a couple strolls toward a tall clock tower. A turquoise bike rests nearby, framed by colorful blooms and glowing windows."
    },
    {
      product_name: "Twilight Pagoda",
      product_id: "7483742584898",
      product_text: "A vibrant pagoda rests beside a peaceful lake, framed by blooming trees and glowing sunset skies. Snow-capped mountains rise in the distance as birds glide through the twilight air."
    },
    {
      product_name: "Prismatic Paws",
      product_id: "7483745697858",
      product_text: "Three stylized cats sit side by side, their sleek forms painted in bold, geometric blocks of vibrant color. Deep shadows and glowing highlights create a playful, modern charm."
    },
    {
      product_name: "Polar Family",
      product_id: "7483751301186",
      product_text: "A family of penguins stands close on icy shores, their feathers glowing in the warm hues of a setting sun. Waves shimmer behind them as colors dance across the frozen sea."
    },
    {
      product_name: "Little Magical Frog",
      product_id: "7483755364418",
      product_text: "A wide-eyed frog rests among golden blooms, its shimmering skin glowing with magical detail. Delicate petals and curling vines frame the scene in an enchanted forest glow."
    },
    {
      product_name: "Rainbow Rebel",
      product_id: "7484225749058",
      product_text: "A bold beauty with flowing rainbow hair and vibrant tattoos gazes with confidence and flair. Her edgy style glows under soft light, bursting with color and attitude."
    },
    {
      product_name: "Fall Splendor",
      product_id: "7484228763714",
      product_text: "Golden light reflects across a peaceful lake as swans glide near a quaint village tucked beneath snowy peaks. Autumn trees blaze with color while a boat drifts through the morning mist."
    },
    {
      product_name: "Skyfire Dragon",
      product_id: "7484236693570",
      product_text: "Luminous dragon twists through a starlit sky, its shimmering scales glowing in vibrant hues. Moons and constellations light the night as magic sparks in its wake."
    },
    {
      product_name: "Ice Palace",
      product_id: "7484244492354",
      product_text: "A regal queen sits in a shimmering icy hall, surrounded by loyal wolves and enchanted treasures. Armored knights and mythical beasts stand guard beneath ornate dragon arches."
    },
    {
      product_name: "Petalhorn",
      product_id: "7484904996930",
      product_text: "A baby unicorn with a rainbow mane rests in a glowing pond, surrounded by blooming flowers and soft magic. Light dances on the water as blossoms crown her head."
    },
    {
      product_name: "Books & Blooms",
      product_id: "7484906930242",
      product_text: "A bluebird perches on a tiny wooden library, surrounded by colorful flowers and golden light. Stories and petals fill the air with gentle wonder."
    },
    {
      product_name: "The Chorus Line",
      product_id: "7484907585602",
      product_text: "A row of rainbow-colored birds perches among bright blossoms, their feathers shimmering with joy. Music fills the air as they sing beneath a golden sky."
    },
    {
      product_name: "Paws & Patches",
      product_id: "7486832541762",
      product_text: "A cat with gentle eyes lounges in a cozy room, wrapped in a quilt of soft colors and playful charm. Surrounded by warmth and quiet comfort, she rests peacefully in her cozy corner."
    },
    {
      product_name: "Bees n Honey Bears",
      product_id: "7487333597250",
      product_text: "Playful bear cubs and curious squirrels gather in a meadow of honey, flowers, and bees. Surrounded by golden sweetness and blooming joy, they bask in a world of cheerful wonder."
    },
    {
      product_name: "Jewel of the Sea",
      product_id: "7487346540610",
      product_text: "A mermaid with purple hair drifts through a glowing coral reef, holding a precious pearl. Ocean light and sea creatures fill the scene, bringing magic to the deep blue."
    },
    {
      product_name: "Hidden Harmony",
      product_id: "7491439820866",
      product_text: "A peaceful cabin by a clear lake glows with warm light, surrounded by tall pines, gentle deer, and drifting ducks, capturing a moment of perfect stillness and natural beauty."
    },
    {
      product_name: "Think Pink",
      product_id: "7491449716802",
      product_text: "Two elegant flamingos rest among blooming lotuses and calm waters, their feathers soft and serene. Gentle hues and flowing lines create a peaceful moment of natural grace."
    },
    {
      product_name: "Berry Curious",
      product_id: "7493732204610",
      product_text: "A wide-eyed raccoon sits among autumn leaves and ripe berries, holding a curious treasure in tiny paws. Surrounded by golden light, it captures a moment of wonder and quiet joy."
    },
    {
      product_name: "Lunaria and the Watchers",
      product_id: "7493752946754",
      product_text: "Under a starlit sky, a dreamy girl with rainbow hair is flanked by two watchful owls. Flowers crown her head as magic stirs in their quiet bond."
    },
    {
      product_name: "Kindred Eyes",
      product_id: "7493762973762",
      product_text: "Bathed in autumn’s glow, a soulful girl and her fawn share a gaze that speaks of trust and tenderness. Wrapped in leaves and light, their bond whispers of wild, gentle hearts."
    },
    {
      product_name: "Lumen Stag",
      product_id: "7493770838082",
      product_text: "Illuminated by moonlit enchantment, a radiant stag glows with magic as tiny lights dance through the forest. His antlers shimmer like stars, guiding dreamers through the night."
    },
    {
      product_name: "Ocean View",
      product_id: "7499850842178",
      product_text: "By candlelight in a room lost to time, an elegant creature rests among velvet drapes and faded roses. As storm clouds gather beyond the lace-covered window, the sea seems to call her home."
    },
    
    {
      product_name: "Estrella",
      product_id: "7499860738114",
      product_text: "In a meadow overflowing with cheerful blooms, a bright-eyed pony peeks out with a heart full of wonder. Every petal and sparkle seems to dance just for her."
    },
    {
      product_name: "Westie Pups",
      product_id: "7499865718850",
      product_text: "Two fluffy companions tumble through a garden bursting with blooms, their playful energy as bright as the morning sun. One pauses just long enough to offer you a curious, heart-melting stare."
    },
    {
      product_name: "Fireside Whiskers",
      product_id: "7500768706626",
      product_text: "As soft candlelight flickers beneath a festive hearth, a crowned feline slumbers without a care in the world. Cozy, content, and curled like a comma in the poetry of winter."
    },
    {
      product_name: "Canadian Magic",
      product_id: "7501860044866",
      product_text: "A parade of wild eyes and proud paws gathers where mountains meet maple leaves. Nature’s northern magic is on full display—bold, beautiful, and undeniably Canadian."
    },
    {
      product_name: "Cheers, Eh?",
      product_id: "7500772966466",
      product_text: "With a frothy brew in paw and a proud flag waving high, someone’s clearly feeling the spirit of the North. A cheeky celebration is underway—cheers to maple leaves and mischief!"
    },
    {
      product_name: "Tribute",
      product_id: "7501871939650",
      product_text: "Beneath a sky of stars and stripes, three brave figures walk a path paved in purpose. Watchful eagles soar above, guardians of courage, honor, and unity."
    },
    {
      product_name: "Liberty Wings",
      product_id: "7501863911490",
      product_text: "With wings unfurled in stars and stripes, this radiant beauty flutters through a garden blooming in red, white, and blue. A bold emblem of freedom takes flight in the heart of summer’s glory."
    },
    {
      product_name: "Freedom Tower",
      product_id: "7501866074178",
      product_text: "As the sun rises behind a skyline of hope, golden light dances across the harbor’s rippling surface. A timeless symbol stands tall at the edge, watching over a city that never sleeps."
    },
    {
      product_name: "Cici’s Celebration",
      product_id: "7501869678658",
      product_text: "A pair of bright-eyed partygoers enjoy the sweetest slice of celebration under a burst of festive skies. Red, white, and blue light up the night as a tiny surprise steals the show."
    },
    {
      product_name: "Torio",
      product_id: "7501874561090",
      product_text: "Adorned in golden filigree and vibrant blooms, a parrot radiates elegance and mystery. Every feather tells a story, shimmering with color and ancient grace."
    },
    {
      product_name: "Vortex of Thoughts",
      product_id: "7501880852546",
      product_text: "A traveler stands before a swirling sky where vibrant worlds pour into one another. Bursting with energy and color, the scene blurs the line between thought and reality."
    },
    {
      product_name: "Celestia",
      product_id: "7501893926978",
      product_text: "She arrives in radiant silence, draped in ethereal glamour and ancient mystery. A single glance from this otherworldly unicorn enchantress could turn secrets into stardust."
    },
    {
      product_name: "Pups in the Pool",
      product_id: "7501895893058",
      product_text: "Sunshine, splashes, and squeaky toys—this crew knows how to throw the ultimate backyard bash. Join the puppy party where the water’s cool and the fun never ends."
    },
    {
      product_name: "Hippie Hamster",
      product_id: "7501910245442",
      product_text: "Radiating tie-dye vibes and flower power, this little hamster is dressed to dazzle. Somewhere between a dream and a groove, he’s ready to boogie through the cosmos."
    },
    {
      product_name: "Spring Lamb",
      product_id: "7501917323330",
      product_text: "A curious visitor peeks through the window, bringing the scent of sunlit meadows along with it. Amid a flurry of petals and porcelain, a quiet moment of countryside charm unfolds."
    },
    {
      product_name: "Lily Pad Love",
      product_id: "7503911518274",
      product_text: "Nestled in a bloom kissed by morning dew, two tiny companions share a moment of stillness and sparkle. Their wide-eyed wonder glows like the petals beneath them, hidden in a pastel dream."
    },
    {
      product_name: "Coral Cutie",
      product_id: "7503918399554",
      product_text: "With eyes full of wonder and fins aglow, this coral-colored wanderer glides through a garden of swaying secrets. The deeper you look, the more the reef begins to hum with quiet, curious magic."
    },
    {
      product_name: "Chameleon Jungle",
      product_id: "7503926427714",
      product_text: "Draped in dazzling armor, the chameleon moves secretly among blooms and butterflies. Its colors whisper a language only the jungle understands."
    },
    {
      product_name: "Mediterranean Terrace View",
      product_id: "7504582836290",
      product_text: "Sunlight drips like honey over a hillside dream where time forgets to pass. Beneath the terrace arch, life exhales softly between sea breezes and sleeping cats."
    },
    {
      product_name: "Golden Twilight",
      product_id: "7505879990338",
      product_text: "Bathed in the last light of day, she lingers at the edge of the wheat, where stories slip between shadow and shimmer. Her gaze holds the hush of a secret only dusk can carry."
    },
    {
      product_name: "Shipwreck Reef",
      product_id: "7505881825346",
      product_text: "Bathed in sunlight, the ship rests quietly beneath the waves, its story long surrendered to the sea. Life blooms in color as the ocean gently reclaims its forgotten dream."
    },
    {
      product_name: "Flower Licious",
      product_id: "7505884807234",
      product_text: "A black cat with rosy cheeks sits among potted blooms and lush leaves. It gazes ahead with calm, curious eyes as bright flowers blossom behind, adding charm to the peaceful scene."
    },
    {
      product_name: "Crystal Bloom",
      product_id: "7505887461442",
      product_text: "A radiant rainbow rose blooms from a bed of shimmering crystals. Light dances through each prism, creating a dazzling kaleidoscope of color and magic."
    },
    {
      product_name: "Parrot Palace",
      product_id: "7507582189634",
      product_text: "Bathed in golden sunlight, a proud parrot rests among blooming branches as petals drift softly around it. A majestic palace rises into the clear blue sky like a fairytale dream."
    },
    {
      product_name: "Fields of Grace",
      product_id: "7507585040450",
      product_text: "A gentle sheep stands with her lamb among bright spring daffodils. Beyond them, a peaceful stone church nestles in the lush countryside under a clear blue sky."
    },
    {
      product_name: "Lady Moth",
      product_id: "7507589103682",
      product_text: "Surrounded by blooming roses, a mysterious woman with fiery hair holds a silent secret. Vibrant moths flutter around her, their wings glowing like hidden jewels in the night."
    },
    {
      product_name: "Eltze",
      product_id: "7507592282178",
      product_text: "Bathed in moonlight, a grand castle glows against misty mountains and a shimmering river. Its towers rise like a dream, guarding secrets whispered by the midnight forest."
    },
    {
      product_name: "Red Chairs At Sunset",
      product_id: "7507602014274",
      product_text: "Under a glowing sunset sky, two red chairs sit facing a peaceful pond surrounded by vibrant flowers. A charming cottage with lit windows nestles among colorful autumn trees nearby."
    },
    {
      product_name: "Winter Wonderland",
      product_id: "7509415919682",
      product_text: "Surrounded by rainbow light, a mother polar bear stands strong as her cub gazes up with wonder. Stars twinkle around them, filling the icy world with magic and peaceful dreams."
    },
    {
      product_name: "Bee Happy",
      product_id: "7509505048642",
      product_text: "Nestled among golden blooms, a sweet fuzzy bee gazes up with wide, sparkling eyes. Its tiny wings glow softly as sunlight kisses the meadow in a warm, cheerful embrace."
    },
    {
      product_name: "Tide Traveler",
      product_id: "7509494104130",
      product_text: "Gliding through sunlit waters, a wise sea turtle swims among vivid coral and bubbles. Its shell shimmers with ocean secrets, carrying ancient dreams through a glowing reef kingdom."
    },
    {
      product_name: "Donkey & Robin",
      product_id: "7509477982274",
      product_text: "As gentle snow falls, a sweet donkey with a red halter stands peacefully in a frosty field. Soft sunrise colors paint the sky, filling the winter morning with calm and quiet beauty."
    },
    {
      product_name: "Brew & Bloom",
      product_id: "7509457862722",
      product_text: "Rising in fragrant steam, a golden teacup rests on old books adorned with blooming hibiscus. Their petals whisper secrets of stories and warmth in a timeless, peaceful haven."
    },
    {
      product_name: "Nerina",
      product_id: "7509522972738",
      product_text: "Bathed in celestial light, a graceful goddess with turquoise eyes glows in a swirl of lotus blooms and flowing silk. Her radiant beauty sparkles beneath a sky of stars and golden orbs."
    },
    {
      product_name: "Moonlit Gaze",
      product_id: "7511414767682",
      product_text: "Bathed in moonlight, a lone wolf lies by a still forest pool, its golden eyes lost in reflection. Fireflies shimmer as flowers bloom softly under the enchanted glow of the night."
    },
    {
      product_name: "Peacock Majesty",
      product_id: "7511411425346",
      product_text: "In a valley of blossoms and bridges, two regal peacocks bask in the golden sun. Their feathers gleam as butterflies dance and waterfalls whisper beneath snow-capped peaks."
    },
    {
      product_name: "Traveler",
      product_id: "7511418699842",
      product_text: "Perched atop a stone ledge, a wide-eyed baby dragon gazes into the misty valley below. Its silvery scales shimmer softly as autumn leaves drift through the enchanted forest air."
    },
    {
      product_name: "Polar Bear Bundle",
      product_id: "7511428988994",
      product_text: "Snuggled beneath a rainbow patchwork quilt, a sleepy polar bear peeks out with rosy cheeks and closed eyes. Cozy warmth and sweet dreams fill the air in this charming bedtime scene."
    },
    {
      product_name: "Butterfly Moo",
      product_id: "7515034058818",
      product_text: "With starry eyes and a playful grin, a fluffy calf gazes at a fluttering butterfly under a dreamy twilight sky. Glowing blossoms and twinkling lights surround this magical meadow moment."
    },
    {
      product_name: "Moonlit Watch",
      product_id: "7515038187586",
      product_text: "Beneath a glowing full moon, two majestic wolves stand watch beside a cascading stream. Their golden eyes gleam as moonlight bathes the forest in a calm, powerful stillness."
    },
    {
      product_name: "Starlit Family",
      product_id: "7515043790914",
      product_text: "Under a glowing moon, a trio of owls snuggles close on a quiet branch, their eyes sparkling with warmth. Stars twinkle above as they share a peaceful moment in the night’s embrace."
    },
    {
      product_name: "Whimsywood Castle",
      product_id: "7515127382082",
      product_text: "Bathed in golden light, a fairytale castle rises from a garden of blooming trees and fluttering wings. Its red turrets and glowing windows whisper tales of magic and wonder."
    },
    {
      product_name: "Starlit Whiskers",
      product_id: "7516866248770",
      product_text: "Glowing in cosmic light, a curious kitten gazes skyward from a dreamlike garden of glowing petals. Stars twinkle as colors bloom around it in a swirl of wonder and starlit magic."
    },
    {
      product_name: "Jungle Life",
      product_id: "7516870508610",
      product_text: "Surrounded by jungle magic, a healer sits beneath a glowing mandala as a jaguar watches and a serpent coils with power. Life pulses through every leaf, bloom, and breath of the wild."
    },
    {
      product_name: "A Little Bit Country",
      product_id: "7516873687106",
      product_text: "Dressed in boots and hats, two curious kids peer into a country shop filled with music and charm. With kittens nearby and hearts aglow, they dream of life that’s just a little bit country."
    },
    {
      product_name: "Petal Poetry",
      product_id: "7516877258818",
      product_text: "Nestled among lush petals, a vibrant bouquet glows with layers of color and light. Each bloom whispers softly, painting the air with poetry in every radiant brushstroke."
    },
    {
      product_name: "Galacat",
      product_id: "7516878569538",
      product_text: "Bathed in cosmic light, a radiant feline gazes ahead as galaxies swirl through its fur. Neon fish dance through stardust, casting ripples in a universe born of color and curiosity."
    },
    {
      product_name: "Scouty Skunk",
      product_id: "7516879519810",
      product_text: "Nestled in a meadow of daisies, a curious skunk clutches binoculars as butterflies dance in the glowing light. His wide eyes sparkle with wonder beneath the golden forest glow."
    },
    {
      product_name: "Fairy Chick",
      product_id: "7518388748354",
      product_text: "Cradled in a polka-dotted egg, a sparkly-winged chick glows with magic under a shower of petals and light. Adorned with gems and blossoms, it twinkles in a world of fairy-tale charm."
    },
    {
      product_name: "Duck Lake",
      product_id: "7518410309698",
      product_text: "The golden hush of evening settles over the lake, as the mother duck glides forward with her brood in tow. From his perch on the mossy rock, the drake watches in stillness, as if guarding a secret only the sunset knows."
    },
    {
      product_name: "Jacqueline",
      product_id: "7518461296706",
      product_text: "Amid swirling pink steam and clanking pipes, she stands fierce—goggles gleaming, eyes sharp, ready to command the chaos. Steampunk steel meets floral fire in this unapologetic blend of grit and glam."
    },
    {
      product_name: "Coldest Night",
      product_id: "7518439342146",
      product_text: "The sky ignites in a blaze of fire as the last light slips between frozen peaks, setting the silence ablaze. Beneath it, the lake holds its breath, reflecting a beauty too wild to tame and too fleeting to name."
    },
    {
      product_name: "Little Redwolfie",
      product_id: "7520393494594",
      product_text: "Bathed in moonlight, she gazes ahead—part girl, part mystery, flanked by loyal wolves and soft woodland whispers. In this enchanted twilight, innocence and wildness walk hand in hand."
    },
    {
      product_name: "Mini Diamond Canvas Kits - House Plants",
      product_id: "7524277223490",
      product_text: "Inspired by the serenity of nature, our House Plants Edition features classic indoor plants in rich color and detail. Create a peaceful retreat one sparkling diamond at a time."
    },   
    {
      product_name: "Rosaline",
      product_id: "7521622982722",
      product_text: "Framed by crimson roses and longing, she sits in quiet wonder with wide eyes that hold untold stories. Her gaze is tender and unflinching a portrait of beauty blooming against the dark."
    },
    {
      product_name: "Opal",
      product_id: "7521626849346",
      product_text: "Crowned in blossoms and cloaked in golden feathers this radiant bird glows with grace and quiet pride. Amid a garden of blooms it rises like a living jewel vibrant and serene."
    },
    {
      product_name: "Glimmergnome",
      product_id: "7521632550978",
      product_text: "Bathed in auroras and starlight, this whimsical gnome beams with joy. Adorned in blossoms and a rainbow hat, it radiates warmth like a tiny guardian of wonder."
    },
    {
      product_name: "Window Whiskers",
      product_id: "7521965932610",
      product_text: "A tabby cat basks in the sunshine at a cottage window, eyes closed in bliss. Surrounded by daisies and ruffled pink blooms, it enjoys a warm, peaceful day."
    },
    {
      product_name: "City of Coins",
      product_id: "7520392970306",
      product_text: "A golden city with emerald domes rises beyond the forest, hidden among the trees. Woodland creatures roam below, surrounded by mushrooms, berries, and blooms."
    },
    {
      product_name: "Moonflower Magic",
      product_id: "7520393429058",
      product_text: "Under a luminous full moon, a unicorn adorned with roses shares a magical moment with a baby skunk. Surrounded by glowing blooms, they rest in a dreamy twilight meadow."
    },
    {
      product_name: "Keeper of the Fire",
      product_id: "7520393461826",
      product_text: "Wreathed in smoke and flame, a mysterious sorceress gazes ahead with glowing eyes. Crowned in candles and clad in gold, she conjures a glowing pentagram with graceful hands."
    },
    {
      product_name: "Tavoli Dopo Tavoli E Altre Sedie",
      product_id: "7520393101378",
      product_text: "Sunlight spills onto an alley lined with wooden tables beneath blooming bougainvillea. Blue shutters and whitewashed walls complete this peaceful Mediterranean escape."
    },
    {
      product_name: "Catitude",
      product_id: "7521970815042",
      product_text: "Beneath bold pink shades, a dapper cat grins with flair and furry pride. Set against a backdrop bright with blooms, this cool kitty lets its charm and confidence collide."
    },
    {
      product_name: "Golden Bloom",
      product_id: "7521972879426",
      product_text: "Bathed in golden sunlight, a radiant bloom opens among lush green leaves. Gentle rays dance across its petals, filling the garden with warmth and quiet joy."
    },
    {
      product_name: "Dreamer and Her Pal",
      product_id: "7521974550594",
      product_text: "A bright-eyed girl with lavender hair cuddles her puppy close, both wrapped in soft pastels and love. A dreamy swirl of flowers and color reflects their gentle bond."
    },
    {
      product_name: "Winter Guardian",
      product_id: "7521976320066",
      product_text: "A white tiger with piercing blue eyes stares with quiet strength, framed by elegant blooms. Blue, gold, and rose florals weave a spell of beauty and mystique around its gaze."
    },
    {
      product_name: "Celestial Wolf Pack",
      product_id: "7520393527362",
      product_text: "Four luminous wolves emerge through cosmic clouds, their fur glowing with celestial hues. United under the stars, they stand as guardians of the infinite night sky."
    },
    {
      product_name: "The Spanish Steps",
      product_id: "7520393330754",
      product_text: "Golden lights glow against the evening sky, casting warmth over blooming flowers and elegant steps. The gentle sound of the fountain invites all to linger in timeless beauty."
    },
    {
      product_name: "Lotus",
      product_id: "7520393297986",
      product_text: "Bathed in golden light, a serene fairy kneels in tranquil waters, hands clasped in quiet prayer. Around her, lotus blooms and gentle cascades weave a scene of pure enchantment."
    },
    {
      product_name: "The Sewing Room",
      product_id: "7520393003074",
      product_text: "Curious cats explore a colorful sewing room, tangled in threads and fabrics. Sunlight streams through the window, filling the space with warmth, mischief, and playful charm."
    },
    {
      product_name: "Gothic Doll",
      product_id: "7523708010562",
      product_text: "With haunting violet eyes and an otherworldly gaze, she stands in eerie elegance. Dark lace, pentagrams, and skull accents weave a tale of beauty wrapped in mystery."
    },
    {
      product_name: "Jungle Gaze",
      product_id: "7523712172098",
      product_text: "Piercing green eyes emerge from a veil of lush leaves and vivid blooms. Butterflies dance nearby as the jungle’s vibrant beauty frames the silent power of its hidden predator."
    },
    {
      product_name: "Realm of Dreams",
      product_id: "7523713777730",
      product_text: "Under a glowing moon, vibrant trees and luminous waters weave a surreal landscape. Colors of twilight and dawn blend, inviting wanderers into a world born of dreams."
    },
    {
      product_name: "Barnyard Bond",
      product_id: "7523717840962",
      product_text: "Amid falling snow, a gentle donkey and a curious dog share a quiet gaze over the fence. Warmth and friendship bloom between them, even in the heart of winter’s chill."
    },
        {
      product_name: "Mini Kits - Ocean Edition",
      product_id: "7528438399042",
      product_text: "Life sways gently in the deep blue silence, where light dances and every creature moves with quiet purpose. It’s a world that hums with calm energy—unseen by most, yet endlessly alive."
    },
         {
      product_name: "Mini Kits - Landscapes Edition",
      product_id: "7528439742530",
      product_text: "A quiet journey unfolds in every piece, where nature's moods are captured in color and light. These landscapes invite you to pause, wander, and feel the world breathe."
    },   
         {
      product_name: "Mini Kits - Retro Edition",
      product_id: "7528440299586",
      product_text: "A burst of playful nostalgia radiates from every piece, echoing the vibrant pulse of simpler days. Retro joy invites you to rewind time and relive the magic of analog wonder."
    },     
         {
      product_name: "Mini Kits - Halloween Edition",
      product_id: "7528440627266",
      product_text: "A playful chill lingers in the air, where mystery meets mischief under a glowing moon. This collection invites you into a world of shadows and spells, where every detail hints at a story waiting to be told."
    },
         {
      product_name: "Mini Kits - Flowers Edition",
      product_id: "7528441315394",
      product_text: "Each bloom radiates a quiet strength, unfolding with elegance in every shade and curve. These florals speak without words—of seasons, stillness, and the enduring beauty found in nature’s simplest forms."
    },
         {
      product_name: "Mini Kits - Desserts Edition",
      product_id: "7528442888258",
      product_text: "Each sweet delight captures a moment of pure indulgence, where joy is measured in sprinkles, swirls, and ripe berries. These treats tempt the senses with cheerful charm, offering a taste of celebration in every bite."
    },    
         {
      product_name: "Mini Kits - Christmas Edition",
      product_id: "7528444002370",
      product_text: "Warmth, wonder, and a hint of magic sparkle through every detail, capturing the essence of holiday cheer. These joyful scenes celebrate the cozy traditions and timeless charm that make the season feel like home."
    },  
         {
      product_name: "Mini Kits - Beauty Edition",
      product_id: "7528446525506",
      product_text: "Soft glimmers of elegance and charm unfold in every detail, celebrating beauty as a daily ritual of joy. Explore the graceful rhythm of self-expression, where confidence begins with a brush, a scent, or a shade."
    }, 
         {
      product_name: "Mini Kits - Animals Edition",
      product_id: "7528448327746",
      product_text: "Each animal is captured in a moment of quiet strength or gentle wonder, honoring the wild spirit that lives within. Together, they reflect nature’s grace, power, and the stories we instinctively recognize in their eyes."
    }, 
    {
      product_name: "Village of Dreams",
      product_id: "7520393560130",
      product_text: "A rainbow arches over a fairytale village, where swans glide along a lily-dotted stream. Blossoms, birds, and butterflies frame this peaceful haven beneath sunlit skies."
    },
    {
      product_name: "Emmaline and Legend",
      product_id: "7520393134146",
      product_text: "Bathed in rainbow light, a golden-haired maiden stands beside her unicorn companion. Surrounded by flowers, they share a bond as magical as the enchanted land around them."
    },
    {
      product_name: "Iridessa",
      product_id: "7520393363522",
      product_text: "Glowing in warm golden light, a jeweled hummingbird perches among lush blossoms. Its shimmering feathers and delicate crown create a vision of grace in a garden of vivid colors."
    },
    {
      product_name: "Spectrum of Life",
      product_id: "7520393035842",
      product_text: "Radiating cosmic energy, a vibrant tree bursts with colors that mirror across still waters. Surrounded by galaxies and glowing clouds, it stands as a beacon of life’s infinite beauty."
    },
    {
      product_name: "Rosaluna",
      product_id: "7525456773186",
      product_text: "Surrounded by blooms and jewels, she gazes with eyes as bright as starlight. Painted in shimmering hues, her elegance glows against a meadow of roses and midnight mystery."
    },
    {
      product_name: "Ladycat",
      product_id: "7525805260866",
      product_text: "With sunflower shades and a bright red cape of bold black spots, this whimsical cat struts with playful pride. Tiny wings and dotted boots complete her sunny, stylish disguise."
    },
    {
      product_name: "Glimmewing",
      product_id: "7525813846082",
      product_text: "Shimmering in soft lavender light, a tiny winged creature clasps a glittering heart. Surrounded by twinkling magic, it glows with wonder in a meadow of dreams."
    },
    {
      product_name: "Tea Time Tilly",
      product_id: "7525823873090",
      product_text: "Wrapped in a floral shawl, a gentle turtle rocks softly with a warm cup of tea in hand. Golden light and blooming daisies surround her, creating a cozy haven of peace."
    },
    {
      product_name: "Calavera",
      product_id: "7520392806466",
      product_text: "She glides through the grove with a spectral glow, marigold ribbons in braids that flow. Her black cat guards with eyes so bright, as bones adorn her gown by night."
    },
    {
      product_name: "Hocus Gnome-us",
      product_id: "7520392773698",
      product_text: "Beneath the glow of a radiant full moon, a gnome with a crooked hat sits proudly among jack-o’-lanterns. With a watchful cat and bats above, the night brims with Halloween magic."
    },
    {
      product_name: "Nightmare at Halloween",
      product_id: "7520392544322",
      product_text: "Lit by the glow of jack-o’-lanterns, a haunted house looms under the full moon’s eerie light. Owls, bats, and shadows stir as the night awakens with Halloween’s chilling delight."
    },
    {
      product_name: "Autumn Light",
      product_id: "7520392577090",
      product_text: "Golden leaves drift gently as a lighthouse shines against the blue sky. Surrounded by bright blooms, pumpkins, and fluttering butterflies, the scene glows with autumn’s peaceful charm."
    },
    {
      product_name: "Sunlit Harvest",
      product_id: "7528483356738",
      product_text: "Radiant sunflowers stretch toward the glowing sky, their petals bright against the harvest scene. Pumpkins, mushrooms, and butterflies gather below, celebrating autumn’s embrace."
    },
    {
      product_name: "Potion Paws",
      product_id: "7528489484354",
      product_text: "Under the glow of the full moon, a wide-eyed kitten stirs a bubbling cauldron of magic. Surrounded by candles and potions, her witchy hat blooms with flowers in sparkling charm."
    },
    {
      product_name: "Hell’s Lantern",
      product_id: "7528495611970",
      product_text: "Burning with eerie fire, a carved pumpkin snarls with glowing eyes and jagged teeth. Twisting vines and falling leaves surround it, casting shadows in the haunting night."
    },
    {
      product_name: "Hocus Pupcus",
      product_id: "7528498856002",
      product_text: "Dressed in a purple cloak and hat, a sweet pup sits proudly with a glowing pumpkin pail of treats. Surrounded by autumn leaves, he brings a playful spark to Halloween night."
    },
    {
      product_name: "Pumpkin Porch",
      product_id: "7520392675394",
      product_text: "Lanterns glow softly as she rests on the porch, surrounded by pumpkins and festive autumn décor. With her black cat close by, the season’s magic fills the night with warmth."
    },
    {
      product_name: "Haunted Harvest",
      product_id: "7520392609858",
      product_text: "Under a moonlit sky, a scarecrow with fiery eyes clutches a pumpkin among gravestones. Ghosts, bats, and a haunted house rise behind, filling the night with eerie harvest dread."
    },
    {
      product_name: "Alchecoon",
      product_id: "7520392904770",
      product_text: "Beneath glowing lanterns in a mystical forest, a curious raccoon stirs a bubbling cauldron of shimmering potion. Surrounded by mushrooms and potions, he brews magic with charm."
    },
    {
      product_name: "Twilight Terror",
      product_id: "7520392872002",
      product_text: "Under a fiery twilight sky, spirits stir in a haunted graveyard where bats and ghosts roam. Amid pumpkins, skulls, and trees, eerie creatures awaken to spread terror through the night."
    },
    {
      product_name: "Spooky Snuggle",
      product_id: "7531035099202",
      product_text: "A cheerful ghost draped in a witch’s hat smiles sweetly, holding a pumpkin pail as autumn leaves swirl around. Bathed in cozy charm, it brings a playful glow to the Halloween night."
    },
    {
      product_name: "Moonlight Mischief",
      product_id: "7531037884482",
      product_text: "Bathed in the glow of a full moon, a black cat peeks out from a patch of pumpkins, its scarf wrapped in playful skulls. Mischief sparkles in its gaze, lighting up the night."
    },
    {
      product_name: "Candlelight Crafter",
      product_id: "7531039064130",
      product_text: "A cheerful ghost knits cozily by candlelight, wrapped in a soft hat as pumpkins and cobwebs glow around. Surrounded by warmth and charm, it crafts joy in a magical autumn night."
    },
    {
      product_name: "The Purrtector",
      product_id: "7531053219906",
      product_text: "Perched upon glowing pumpkins, a watchful cat guards the night with sapphire eyes. Cloaked in mystery beneath the moon, it stands as a steadfast protector of Halloween’s light."
    },
    {
      product_name: "Untamed Wilderness",
      product_id: "7520393166914",
      product_text: "Bathed in fiery twilight, mountains rise beyond a mirrored lake where a quiet cabin rests. Nature’s grandeur blazes in the sky, painting the wilderness with untamed wonder."
    },
    {
      product_name: "Feathers of Light",
      product_id: "7520393199682",
      product_text: "Perched in the forest, a peacock’s plumage flows in waves of shimmering blue and gold. Surrounded by blossoms and light, it stands as a radiant symbol of elegance and wonder."
    },
    {
      product_name: "Down the Rabbit Hole",
      product_id: "7520393265218",
      product_text: "Tumbling through a swirl of clocks, cards, and curious wonders, she drifts deeper into a dream. Whimsy and chaos entwine, guiding her journey into a world beyond reason."
    },
    {
      product_name: "Bloom Bunny",
      product_id: "7520393396290",
      product_text: "Nestled in a garden of blossoms, a bunny adorned with a crown of roses gazes with gentle wonder. Butterflies flutter around, weaving magic through the colorful blooms."
    },
    {
      product_name: "Moonlit Mermaid",
      product_id: "7533824540738",
      product_text: "Bathed in silver light, a mermaid drifts beneath the waves, her scales shimmering with ocean’s glow. With eyes that mirror the stars, she waits in silence where dreams flow."
    },
    {
      product_name: "Snow Much Cuteness",
      product_id: "7535400222786",
      product_text: "A pup with bright eyes sits bundled in winter’s embrace, his knit hat dusted with snowflakes. Wrapped in chilly quiet and frosty charm, he glows with warmth in the snowy scene."
    },
    {
      product_name: "Skullrose",
      product_id: "7535403794498",
      product_text: "Adorned with blossoms and mystery, a creature peers with eyes deep as twilight. Draped in petals and jewels, its presence glows with beauty entwined in secrets untold."
    },
    {
      product_name: "Frostfairy Squirrel",
      product_id: "7535413755970",
      product_text: "A squirrel with twinkling eyes glows with delight, its wings sparkling in winter’s embrace. Among crystals and blooms, it shares a quiet moment with a butterfly in enchanted light."
    },
    {
      product_name: "The Witch's Lair",
      product_id: "7520392642626",
      product_text: "A witch stirs glowing magic in her cauldron, surrounded by shelves of shimmering potions and spells. Amid the flicker of lanterns and candles, mystery and power fill the lair."
    },
    {
      product_name: "Wonderland Harvest",
      product_id: "7520392708162",
      product_text: "Within fields of pumpkins, a girl with golden curls carries a basket filled with sweets, fruits, and charms. Surrounded by harvest light, she dreams beneath a whimsical moonlit sky."
    },
    {
      product_name: "Mortician's Assistant",
      product_id: "7520392839234",
      product_text: "Amidst flickering candles and bottles of secrets, a white cat sits with eyes of quiet command. Surrounded by pumpkins and skulls, it keeps its watch in eerie calm."
    },
    {
      product_name: "Ghostly Tales",
      product_id: "7520392740930",
      product_text: "Beneath glowing pumpkins and falling autumn leaves, a ghost with bright eyes reads by moonlight. With a black cat at his side, the air hums with magic as stories come alive."
    },
    {
      product_name: "Spooky Scales",
      product_id: "7539360301122",
      product_text: "A baby dragon with glowing eyes sits wrapped in webs, its scales sparkling with vibrant hues. Surrounded by a pumpkin and candles, it gazes in wonder at a ghostly friend nearby."
    },
    {
      product_name: "Pumpkitty",
      product_id: "7537934827586",
      product_text: "Perched among glowing pumpkins, a mischievous kitty hides behind a jack-o’-lantern mask. With playful charm and bright eyes, it lights up the autumn night."
    },
    {
      product_name: "Midnight Meow",
      product_id: "7539362201666",
      product_text: "With golden eyes that gleam under the moon’s glow, a black cat sits proudly in her witchy hat. Surrounded by glowing pumpkins and fluttering bats, she radiates Halloween charm."
    },
    {
      product_name: "Halloween Herd",
      product_id: "7539363741762",
      product_text: "A calf with gentle eyes stands in a spooky scene, its bow bright against the eerie glow. Surrounded by pumpkins, skulls, and bats, it brings a touch of charm to the haunted theme."
    },
    {
      product_name: "Geisha's Glow",
      product_id: "7539366789186",
      product_text: "A graceful geisha stands beneath lanterns, her kimono blooming with color and light. Surrounded by petals and moonlit hues, she radiates quiet elegance and timeless charm."
    },
    {
      product_name: "Moonlit Majesty",
      product_id: "7539368919106",
      product_text: "A white cat with bright blue eyes sits gracefully by the water’s edge, its fur glowing in the moon’s gentle light. Surrounded by stars and blooms, it radiates quiet serenity."
    },
    {
      product_name: "The Dreaming Bloom",
      product_id: "7539370655810",
      product_text: "A woman adorned with a crown of blossoms gazes with serene grace, her hair a garden alive with color. With gentle poise and dreamy charm, she embodies blooming imagination."
    },
    {
      product_name: "Roots and Wings",
      product_id: "7551721799746",
      product_text: "An owl with soulful eyes sits among blossoms, its feathers glowing with soft detail. Surrounded by watchful companions, it brings a sense of wisdom and gentle beauty."
    },
    {
      product_name: "Nos Furratu",
      product_id: "7547133296706",
      product_text: "A mystical winged cat with emerald eyes and batlike wings soars above a misty city, its jeweled collar glinting with otherworldly light. The foggy towers and autumn trees below set a haunting stage for this enigmatic guardian of the skies."
    },
    {
      product_name: "Cosmic Violet",
      product_id: "7547136770114",
      product_text: "Vivid violet blossoms unfold across a cosmic sky where planets, stars, and a radiant rainbow illuminate the scene. The fusion of glowing petals and celestial wonders creates a dreamlike harmony between nature and the universe."
    },
    {
      product_name: "Nest in the Blossoms",
      product_id: "7547139915842",
      product_text: "A soft gray cat with piercing green eyes gazes curiously at a delicate hummingbird hovering among pink blossoms. Gentle sunlight filters through the pastel petals, bathing the scene in a dreamy glow of springtime harmony."
    },
    {
      product_name: "Bloommates",
      product_id: "7547143028802",
      product_text: "Two brightly colored birds sit close together on a blossoming branch, their yellow and blue feathers glowing in the soft sunlight. Surrounded by roses, cherry blossoms, and fluttering butterflies, the scene radiates warmth and the joy of spring."
    },
    {
      product_name: "Santa's Last Delivery",
      product_id: "7540819132482",
      product_text: "Santa's sleigh waits beneath twinkling lights, reindeer poised in the snowy lane. With gifts in hand, he makes his final stop, bringing warmth to the winter night."
    },
    {
      product_name: "Peppermint Candy Girl",
      product_id: "7540821983298",
      product_text: "A girl with sparkling eyes stands in a wonderland, her dress adorned with gingerbread and sweets. Surrounded by candy canes and gumdrops, she shines with festive delight."
    },
    {
      product_name: "Purrfectly Wrapped",
      product_id: "7540827062338",
      product_text: "A cat with bright green eyes rests atop festive gifts, wrapped in the magic of holiday cheer. Surrounded by ribbons, lights, and warmth, she embodies the spirit of Christmas coziness."
    },
    {
      product_name: "Christmas in Paris",
      product_id: "7540829978690",
      product_text: "A warm room glows with festive lights, where garlands frame the mantel while ornaments sparkle by the fire. Beyond the window, the Eiffel Tower shines against a snowy Paris night."
    },
    {
      product_name: "Polar Joyride",
      product_id: "7540838826050",
      product_text: "Two playful polar cubs share a joyful ride on a sled, bundled in colorful hats and scarves. Surrounded by snowy trees and a glowing rainbow sky, they shine with winter cheer."
    },
    {
      product_name: "Paws & Presents",
      product_id: "7541676408898",
      product_text: "Santa crafts toys in his workshop, surrounded by loyal pets and playful companions. Amid warmth and festive cheer, every paw and present adds to the magic of Christmas."
    },
    {
      product_name: "Caught in the Act",
      product_id: "7547146371138",
      product_text: "A playful pup with curious eyes is caught mid-mischief, surrounded by torn wrapping and festive sparkle. Beneath the tree and twinkling gifts, he brings laughter to Christmas joy."
    },
    {
      product_name: "Midnight Mass",
      product_id: "7547152400450",
      product_text: "A peaceful church stands beneath golden stars, its steeple glowing under the midnight sky. Surrounded by quiet hills and gentle doves, it radiates serenity and grace."
    },
    {
      product_name: "Santa's Sweet Donkey",
      product_id: "7547158265922",
      product_text: "A sweet donkey with sparkling eyes sits merry and bright, wrapped in a wreath of holly and glowing lights. Surrounded by trees and gifts, it brings joy to the holiday night."
    },
    {
      product_name: "Santa Express",
      product_id: "7541686796354",
      product_text: "Santa stands proudly by the gleaming Santa Express, ready to deliver joy. With snow falling softly and wreaths aglow, the spirit of Christmas is ready to depart."
    },
    {
      product_name: "Peppermint Gnome",
      product_id: "7541695512642",
      product_text: "A cheerful gnome with sparkling eyes stands bright, dressed in festive red and holiday delight. Surrounded by canes, gifts, and holiday cheer, he brings sweetness to the season."
    },
    {
      product_name: "Christmas At The Cabin",
      product_id: "7541699674178",
      product_text: "A cozy cabin glows with festive warmth, where twinkling lights and a sparkling tree brighten the room. By the crackling fire, pups rest peacefully amid the magic of Christmas."
    },
    {
      product_name: "Santa's Toy Chest",
      product_id: "7541701541954",
      product_text: "Santa smiles with joy as he prepares toys and cuddly bears, filling the room with Christmas spirit. Surrounded by gifts and sparkle, the magic of giving shines bright."
    },
    {
      product_name: "Christmas Conservatory",
      product_id: "7541705605186",
      product_text: "A cozy holiday room sparkles with festive cheer, where a glowing tree and warm fire create a peaceful retreat. Amid wrapped gifts, pets rest happily, soaking in the magic of Christmas."
    },
    {
      product_name: "Magic Of Christmas",
      product_id: "7541708292162",
      product_text: "A grand room glows with festive charm, where garlands and candles shimmer alongside a towering tree. Beyond the windows, reindeer await under a snowy, moonlit sky."
    },
    {
      product_name: "Winter's Pride",
      product_id: "7555152773186",
      product_text: "A majestic lion crowned with snow and a Santa hat stands tall, its mane glowing with winter’s shimmer. Surrounded by festive pines, it radiates strength and warmth."
    },
    {
      product_name: "Santa's Surprise",
      product_id: "7555165225026",
      product_text: "Santa glows with joy, holding a beautifully wrapped gift tied with a bright red bow. Beside the sparkling tree and glowing lights, his surprise brings festive delight."
    },
    {
      product_name: "Llama Love",
      product_id: "7555173482562",
      product_text: "Two llamas nuzzle sweetly beneath falling snow, their cozy hats and scarves glowing with festive warmth. Wrapped in holiday spirit, they share a tender moment of winter joy."
    },
    {
      product_name: "Holiday Hippo",
      product_id: "7555179839554",
      product_text: "A sweet holiday hippo dressed in Santa’s red rests on a plush cushion, holding a glowing candle. Surrounded by twinkling lights and gifts, he brings warmth to Christmas magic."
    },
    {
      product_name: "Dragonfly Darling",
      product_id: "7543385620546",
      product_text: "A radiant girl glides above sparkling waters, her pastel wings glowing in the light. Surrounded by blossoms and magic, she embodies the beauty and grace of nature’s wonder."
    },
    {
      product_name: "Electric Tiger Jungle",
      product_id: "7543391191106",
      product_text: "Beneath a radiant moon, a tiger and her cub rest amidst a burst of neon jungle life, their fur glowing with vivid hues. Color and energy intertwine, capturing wild beauty and strength."
    },
    {
      product_name: "Allure",
      product_id: "7543394467906",
      product_text: "Enigmatic beauty stands poised in a dreamy realm, her dragons coiled close in shimmering grace. With ethereal allure and strength, she embodies the captivating essence of fantasy."
    },
    {
      product_name: "Place to Rest",
      product_id: "7543396925506",
      product_text: "A peaceful cabin rests atop a cliff, aglow in the soft hues of sunset. Wrapped in golden light and gentle breeze, it offers a serene escape where time slows and hearts find calm."
    },
    {
      product_name: "Gemstone Gardens Violet",
      product_id: "7555184754754",
      product_text: "Soft petals unfold in luminous beauty, glowing with delicate shades of violet and jade. At its heart a gemstone shimmers in perfect harmony with the splendor of nature."
    },
    {
      product_name: "My Little Cupcake",
      product_id: "7555190554690",
      product_text: "Sweet little girl gazes longingly at a colorful display of cupcakes, her kitten by her side sharing the delight. Together they savor the joy of sugary dreams and childhood wonder."
    },
    {
      product_name: "Whiskers in Wonderland",
      product_id: "7555195764802",
      product_text: "A dapper cat dressed in elegant attire stands proudly beneath a golden glow, its eyes full of mystery and grace. Surrounded by soft light and whimsy, it embodies timeless wonder."
    },
    {
      product_name: "Moonlit Heron",
      product_id: "7555767992386",
      product_text: "Bathed in moonlight, a heron stands beside a glowing lake framed by pink blossoms. The tranquil night shimmers in hues of blue and violet, capturing nature’s serene beauty."
    },
    {
      product_name: "Kindred Spirits",
      product_id: "7543399678018",
      product_text: "A mysterious girl with piercing eyes cradles her feline companion beneath the glow of a moonlit sky. Bound by magic and emotion, their connection radiates quiet strength and unity."
    },
    {
      product_name: "Bark or Treat",
      product_id: "7543405838402",
      product_text: "Playful puppies dressed in Halloween costumes peek out from glowing pumpkins under a moonlit sky. Surrounded by ghosts and jack-o'-lanterns, they bring mischief to the night."
    },
    {
      product_name: "Ghostly Tours",
      product_id: "7543402299458",
      product_text: "Under the glow of a full moon, an eerie mansion looms amid whispering trees and drifting mist. Jack-o’-lanterns flicker through the shadows as unseen spirits stir the autumn night."
    },
    {
      product_name: "Moonlit Mischief",
      product_id: "7544043044930",
      product_text: "A tiny dragon in a crooked purple witch's hat sits proudly among glowing jack-o'-lanterns. Beneath a full moon and swirling autumn leaves, it casts a playful yet eerie charm over the haunted night."
    },
    {
      product_name: "The Watcher",
      product_id: "7544046747714",
      product_text: "An owl with glowing amber eyes stands guard among twisted trees and ancient stones. Silent and mysterious, it watches over the misty forest in timeless stillness."
    },
    {
      product_name: "Haunted Hatchling",
      product_id: "7544050253890",
      product_text: "A tiny dragon with shimmering scales peeks from a glowing pumpkin, its wide eyes filled with wonder. Surrounded by lantern light and playful spirits, it brings Halloween magic to life."
    },
    {
      product_name: "Cuckoo Clock Cottage",
      product_id: "7544054808642",
      product_text: "A charming woman stands beside her gentle calf, surrounded by blooming flowers and mountain air. Together, they embody the timeless beauty and peaceful charm of cottage life."
    },
    {
      product_name: "Fireside Dreams",
      product_id: "7544058216514",
      product_text: "A golden glow fills a cozy cabin, where flickering firelight and mountain views create a peaceful retreat. Wrapped in warmth and serenity, it's the perfect place to dream."
    },
    {
      product_name: "Cosmic Hummingbird",
      product_id: "7544061886530",
      product_text: "A dazzling bird of light soars through a cosmic sky, its feathers glowing with vibrant colors. Bathed in starlight and surrounded by swirling galaxies, it glides gracefully through the night."
    },
    {
      product_name: "Sunset Dreams",
      product_id: "7545028476994",
      product_text: "Golden skies paint the horizon as waves kiss the shore, where sailboats drift beneath a glowing lighthouse. Nestled in vibrant blooms, cottages glow with warmth and peace."
    },
    {
      product_name: "Cosmic Butterfly",
      product_id: "7557974884418",
      product_text: "Bathed in starlight, a radiant butterfly spreads its glowing wings over a field of vivid blooms. Each swirl of color shimmers with cosmic magic, illuminating the night with wonder."
    },
    {
      product_name: "Galactic Zen",
      product_id: "7557980487746",
      product_text: "Surrounded by cosmic light, an astronaut finds serenity among swirling galaxies and radiant planets. Floating between stars, they embody harmony in the vast expanse of the universe."
    },
    {
      product_name: "Moonlight Romance",
      product_id: "7557983010882",
      product_text: "Embraced by nature's gentle glow, a tender bond blooms between a curious kitten and a gentle mouse. Around them, hummingbirds dance over blossoms and cascading waters."
    },
    {
      product_name: "Aurora Wings",
      product_id: "7557989957698",
      product_text: "Perched upon frosted pine, a radiant bird shimmers in hues of violet, gold, and sapphire. Sparkling lights twinkle around it, echoing the ethereal glow of winter's magic."
    },
    {
      product_name: "Sassy in the Sun",
      product_id: "7545031393346",
      product_text: "Basking under golden rays, a woman radiates playful charm and bold spirit in a scene full of joy. Surrounded by vibrant hues and bursts of color, she embodies carefree elegance."
    },
    {
      product_name: "Sakura Swirl",
      product_id: "7545035325506",
      product_text: "Beneath a swirling cosmic sky, cherry blossoms bloom in vibrant shades. Surrounded by radiant energy and soft serenity, it captures nature's timeless wonder."
    },
    {
      product_name: "Gamer Girly",
      product_id: "7546687127618",
      product_text: "Immersed in a neon glow, a gamer dives into her virtual world with style and determination. Surrounded by snacks, gadgets, and vibrant energy, she embraces every pixel of play."
    },
    {
      product_name: "Golden Hour Express",
      product_id: "7546691387458",
      product_text: "Beneath a glowing autumn sky, a vintage car and playful pups bring warmth and nostalgia to a riverside scene. As a classic train passes, golden leaves and laughter fill the air."
    },
    {
      product_name: "Doorway to Dreams",
      product_id: "7557997232194",
      product_text: "Bathed in starlight, a mysterious gateway opens to endless wonders. With every step into this dreamlike realm, new adventures and infinite possibilities unfold."
    },
    {
      product_name: "Gemstone Gardens Amarillo",
      product_id: "7558001852482",
      product_text: "Golden petals bloom with radiant warmth, each layer unfolding like sunshine captured in floral form. Adorned with crystal shimmer, it glows as a celebration of nature's brilliance."
    },
    {
      product_name: "Berry Baby",
      product_id: "7590466977858",
      product_text: "Delighting in nature's sweetness, a tiny companion savors a ripe raspberry amid sweet delights. Bathed in soft light and playful charm, it captures pure, heartwarming joy."
    },
    {
      product_name: "Rainwatcher",
      product_id: "7590499549250",
      product_text: "Bathed in gentle rain, a vigilant owl watches over a blooming meadow, its golden eyes glowing with wisdom. Raindrops glisten on soft feathers, capturing nature’s calm."
    },
    {
      product_name: "Moonlit Bond",
      product_id: "7546695090242",
      product_text: "Under a soft moonlit sky, a majestic dragon shares a tender moment with its child, their bond glowing with gentle magic. Lavender fields sway around them, whispering love's strength."
    },
    {
      product_name: "Luna",
      product_id: "7546699579458",
      product_text: "Bathed in celestial light, a radiant goddess gazes into the cosmos, her eyes reflecting infinite dreams. Feathers of stardust and jewels crown her as a beacon of wonder."
    },
    {
      product_name: "Vatican",
      product_id: "7546711965762",
      product_text: "Illuminated by a serene sunset, the Vatican stands as a timeless masterpiece, its golden lights dancing across tranquil waters. History and faith intertwine beneath the evening sky."
    },
    {
      product_name: "Bohemian Beauty",
      product_id: "7561003728962",
      product_text: "Bathed in sunset hues, a bohemian woman radiates effortless charm, surrounded by vibrant plants and cozy treasures. Her colorful haven celebrates art, nature, and serenity."
    },
    {
      product_name: "Starlit Sanctuary",
      product_id: "7561009135682",
      product_text: "Cradled beneath a cosmic tree, new life glows softly amid roots woven with starlight and crystal. The universe embraces creation, nurturing existence in celestial harmony."
    },
    {
      product_name: "Chillax Cat",
      product_id: "7561018015810",
      product_text: "Soaking up seaside serenity, a cozy cat lounges under the sun, lost in the pages of a good book. Gentle waves and warm breezes create the perfect peaceful escape."
    },
    {
      product_name: "Harvest Glow",
      product_id: "7561026338882",
      product_text: "Bursting with radiant warmth, a vibrant bouquet of flowers dances, celebrating nature's bounty. Each petal glows with the joy and beauty of the harvest season."
    },
    {
      product_name: "Confetti Daydream",
      product_id: "7561036202050",
      product_text: "Bathed in a swirl of pastel rainbows, a dreamy girl gazes into endless possibilities, her spirit alive with wonder. Each hue dances like confetti in a world of imagination."
    },
    {
      product_name: "Mayhem",
      product_id: "7561038463042",
      product_text: "Bathed in shadowed radiance, a gothic woman commands the night with elegance and danger entwined. Her silver-eyed cats embody the haunting beauty of her crimson chaos."
    },
    {
      product_name: "Midnight Bloom",
      product_id: "7561669443650",
      product_text: "Emerging from a dream of twilight hues, a midnight flamingo curls gracefully among vivid blossoms. Its dark feathers and radiant blooms unite in a dance of elegance and mystery."
    },
    {
      product_name: "Secret Garden",
      product_id: "7561676259394",
      product_text: "Surrounded by blossoms in full bloom, a graceful woman sways upon her floral swing, lost in a tranquil daydream. Every color breathes romance and quiet grace."
    },
    {
      product_name: "Windy Mountains",
      product_id: "7561679962178",
      product_text: "Bathed in golden twilight, a winding path leads through a serene mountain village embraced by misty pines. Every glowing window whispers warmth against the cool alpine air."
    },
    {
      product_name: "Underwater Adventure",
      product_id: "7561682812994",
      product_text: "Playfully diving into a colorful reef, a curious cat explores a world of fish and coral treasures. Every bubble sparkles with the magic of underwater discovery."
    },
    {
      product_name: "Fire and Ice",
      product_id: "7563987451970",
      product_text: "A clash of elements ignites within her gaze, where flame meets frost in perfect harmony. Passion and serenity intertwine, revealing the balance between chaos and calm."
    },
    {
      product_name: "Boho King",
      product_id: "7563991908418",
      product_text: "Radiating effortless charm, the regal lion embodies confidence and creativity through his bohemian flair. Every detail celebrates the harmony of strength and energy."
    },
    {
      product_name: "Lucky Cat",
      product_id: "7563997675586",
      product_text: "Brimming with cheerful charm, a playful guardian of fortune beams with color and joy. Each symbol and hue weaves together a celebration of hope, happiness, and luck."
    },
    {
      product_name: "Midnight Surprise",
      product_id: "7566857896002",
      product_text: "Wrapped in the hush of a snowy night, Santa delivers gifts of joy beneath a sky of twinkling stars. Each sparkle whispers the timeless magic of Christmas giving."
    },
    {
      product_name: "Magical Christmas",
      product_id: "7566862188610",
      product_text: "Glowing with festive wonder, a dazzling scene unfolds in a swirl of color and cheer. Santa, gifts, and twinkling lights capture the heartwarming magic of Christmas Eve."
    },
    {
      product_name: "Christmas Glow",
      product_id: "7566866645058",
      product_text: "Wrapped in the warmth of holiday cheer, a cozy home sparkles with festive light. Snowflakes fall softly as gifts, laughter, and love fill this magical Christmas night."
    },
    {
      product_name: "Gingerbread Cottage",
      product_id: "7569042178114",
      product_text: "Sweet enchantment fills the air as a candy-covered cottage sparkles beneath the winter sky. Sugary dreams and gingerbread delights come alive in this festive wonderland."
    },
    {
      product_name: "Santa's Starlet",
      product_id: "7569053057090",
      product_text: "Bathed in a cozy holiday glow, a blue-haired beauty captures the heart of Christmas magic. Her radiant smile and festive charm illuminate the joyous winter season."
    },
    {
      product_name: "Deck The Dock",
      product_id: "7569074257986",
      product_text: "Twinkling lights and festive greens embrace the harbor's gentle calm, blending seaside serenity with holiday cheer. Every sparkle glows with warmth and coastal joy."
    },
    {
      product_name: "Workshop Wonders",
      product_id: "7569113841730",
      product_text: "Glowing with Christmas spirit, Santa lovingly crafts toys for eager children awaiting joy. Each creation shines with the warmth and wonder of holiday dreams."
    },
    {
      product_name: "Tails by the Tree",
      product_id: "7574451028034",
      product_text: "Gathered by the glowing tree, furry friends watch winter's magic unfold beyond frosted glass. Each wag and purr shines with the cozy joy of the Christmas season."
    },
    {
      product_name: "Curious Badger",
      product_id: "7574457450562",
      product_text: "Bathed in winter's hush, a curious badger peers into the shimmering pond, drawn by its rippling reflection. Snowy branches and soft lights cradle the quiet magic of Christmas time."
    },
    {
      product_name: "Coastal Christmas Eve",
      product_id: "7574461907010",
      product_text: "Bathed in a silvery glow, a coastal village sparkles with festive charm as boats rest beneath twinkling lights. The sea whispers softly, carrying the calm of Christmas joy."
    },
    {
      product_name: "Candy Cane Kisses",
      product_id: "7574468296770",
      product_text: "Glowing with festive cheer, Santa shares a tender moment by the fire as children shower him with love. The warmth of family and the magic of Christmas fill the air."
    },
    {
      product_name: "Snow Much Fun",
      product_id: "7574472556610",
      product_text: "Shimmering with holiday delight, a snowy village comes alive with laughter and light. Snowmen, animals, and twinkling trees capture the joyful wonder of Christmas."
    },
    {
      product_name: "Starlight Stag",
      product_id: "7574476423234",
      product_text: "Bathed in golden starlight, a majestic reindeer stands proudly over a snow-covered village. Shimmering ornaments and twinkling skies celebrate the wonder of Christmas."
    },
    {
      product_name: "Moonlight Santa",
      product_id: "7574485958722",
      product_text: "Glistening under the moonlight, a curious kitten gazes out the window as Santa's sleigh glides across the sky. Surrounded by gifts and poinsettias, it embodies Christmas wonder."
    },
    {
      product_name: "The Christmas Window",
      product_id: "7574492053570",
      product_text: "Framed by a cozy glow, a peaceful room awaits Christmas morning's joy. Through the frosted window, Santa’s sleigh glides past as gifts and dreams sparkle by the tree."
    },
    {
      product_name: "Girls Night In",
      product_id: "7574495625282",
      product_text: "Bathed in cozy light, two friends share laughter, snacks, and stories that warm the soul. Each sparkle in their eyes celebrates comfort, connection, and carefree joy."
    },
    {
      product_name: "Tree of the Universe",
      product_id: "7574498377794",
      product_text: "Radiating cosmic light, a celestial tree bridges earth and sky, its branches glowing with stardust. Each glowing leaf whispers the infinite harmony of the universe."
    },
    {
      product_name: "Under the Stars",
      product_id: "7574501720130",
      product_text: "Beneath a glittering sky, two dreamers share quiet wonder from their cozy camper. Each star above glows with promise, lighting the path of endless adventure."
    },
    {
      product_name: "Cat Nap Corner",
      product_id: "7575282188354",
      product_text: "Bathed in soft sunlight, two cats dream among rainbow pillows and blooms. The cozy room glows with warmth and harmony, capturing the gentle heart of home."
    },
    {
      product_name: "Whisperwood Buddies",
      product_id: "7575286972482",
      product_text: "Under a canopy of starlit magic, two forest friends share a tender moment amid glowing mushrooms. Their eyes shimmer with the pure joy of love and friendship."
    },
    {
      product_name: "Sugar Plum",
      product_id: "7575291920450",
      product_text: "Surrounded by shades of  violet, a young fairy radiates quiet mystery and grace. Her eyes and floral crown echo the beauty of dusk’s gentle enchantment."
    },
    {
      product_name: "Space Exploration",
      product_id: "7575296180290",
      product_text: "Amid swirling galaxies and stars, explorers journey beyond the bounds of Earth, seeking the unknown. Each mission shines with courage, wonder, and endless discovery."
    },
    {
      product_name: "Storybook Time",
      product_id: "7575303028802",
      product_text: "Wrapped in a world of color and dreams, a young girl dives into the pages of her favorite tale. Each word blooms like a flower, painting her imagination with wonder."
    },
    {
      product_name: "Painted Ladies",
      product_id: "7575320854594",
      product_text: "Adorned in vibrant hues, butterflies drift gracefully through golden and violet blooms. Each movement captures the breeze, celebrating the gentle rhythm of nature."
    },
    {
      product_name: "Alice in Graffitiland",
      product_id: "7575331897410",
      product_text: "A radiant fusion of color and imagination bursts with joyful energy. Each color-splashed detail celebrates creativity, wonder, and the magic of endless possibilities."
    },
    {
      product_name: "Snowlight Surprise",
      product_id: "7575339106370",
      product_text: "A fluffy baby dragon unwraps gifts beneath the dazzling northern lights. Lanterns glow warmly around it as snowy trees and icy mountains shimmer in the winter night."
    },
    {
      product_name: "Christmas Candle",
      product_id: "7578077986882",
      product_text: "A golden candle glows by a frosted window, surrounded by holly leaves, red berries, and pine branches. A plaid ribbon and winter nuts complete this cozy holiday scene."
    },
    {
      product_name: "Bubble Buck",
      product_id: "7578091388994",
      product_text: "A sweet young deer enjoys a bubbly bath surrounded by pine branches and festive ornaments. Its gentle eyes sparkle with warmth, adding charm to this cozy holiday moment."
    },
    {
      product_name: "Hedgehog & Cocoa",
      product_id: "7578106527810",
      product_text: "Nestled by the window, a cozy hedgehog warms up with a red mug of cocoa as snow falls outside. A rustic barn glows in the sunset, completing this peaceful winter moment."
    },
    {
      product_name: "Potting Shed",
      product_id: "7578111180866",
      product_text: "Tucked inside a worn garden boot, a curious kitten peeks out beside bright poinsettias and holly leaves. Sunlight filters through the window, filling the scene with warmth."
    },
    {
      product_name: "Gemstone Gardens Scarlet",
      product_id: "7578116259906",
      product_text: "Radiant crimson petals unfurl around a jeweled blossom core that glimmers with vivid colors. Deep green leaves encircle the bloom, adding depth and graceful elegance."
    },
    {
      product_name: "Harvest Bunny",
      product_id: "7578121601090",
      product_text: "Golden leaves swirl through a sunlit forest as a cheerful bunny stands holding a bouquet of autumn foliage. Warm hues of orange and gold fill the air with cozy seasonal charm."
    },
    {
      product_name: "Sir Hoots A Lot",
      product_id: "7578125729858",
      product_text: "Bundled in a cozy blue scarf, a wise owl perches atop a stack of weathered books. Its bright eyes gleam with curiosity, capturing the quiet charm of a scholar's retreat."
    },
    {
      product_name: "Starry Nightfall",
      product_id: "7585244807234",
      product_text: "Golden stars shimmer above a tranquil riverside village, their glow mirrored in gentle waters. Moonlit clouds swirl across the sky as flowers bloom quietly beneath the night."
    },
    {
      product_name: "Clover Cat",
      product_id: "7585246675010",
      product_text: "Bright golden eyes peek through a lush patch of clovers, blending curiosity with charm. Soft greens surround the playful feline, creating a scene full of whimsy and luck."
    },
    {
      product_name: "Steampunk Harriet",
      product_id: "7585252737090",
      product_text: "An elegant woman with teal hair and glasses lounges amid stacks of ornate books, candlelight flickering beside a curious striped cat and a delicate butterfly under glass."
    },
    {
      product_name: "Cozy Cat Corner",
      product_id: "7585300381762",
      product_text: "Sunlight spills through lace curtains onto a cozy armchair wrapped in a colorful quilt. A cat lounges peacefully among stacks of books, lush plants, and bright flowers."
    },
    {
      product_name: "Violette",
      product_id: "7585329446978",
      product_text: "Enchanting girl with shimmering blue eyes and pastel hair adorned in roses and gears gazes softly ahead. A small bird perches nearby amid delicate lace and jeweled adornments."
    },
    {
      product_name: "Springtime Bunnies",
      product_id: "7585331675202",
      product_text: "Playful kittens and bunnies gather among tulips, daisies, and daffodils, their curious faces bright with spring joy. Vibrant blossoms surround them in a meadow of color."
    },
    {
      product_name: "Bloombeard",
      product_id: "7585333641282",
      product_text: "Gentle gnome with a long silver beard carries a bright bouquet of spring flowers through a glowing forest. His colorful hat sparkles with blossoms beneath soft golden lights."
    },
    {
      product_name: "Floral Friends",
      product_id: "7585338490946",
      product_text: "Charming garden bursts with colorful blooms where birds flit and butterflies dance in the sunlight. Bunnies peek from the flowers as a cozy cottage nestles in the background."
    },
    {
      product_name: "Daisy Dreams",
      product_id: "7585341603906",
      product_text: "Whimsical girl with wide, soulful eyes wears a rainbow-striped dress surrounded by daisies. A vibrant butterfly rests across her face, blending beauty with dreamlike wonder."
    },
    {
      product_name: "Dory",
      product_id: "7585344946242",
      product_text: "Gentle donkey adorned with a crown of orange and red blossoms peeks through a jungle of vivid leaves. Warm sunlight highlights her soft fur amid a burst of tropical color."
    },
    {
      product_name: "Frosted Moon Hare",
      product_id: "7585346748482",
      product_text: "A gentle hare pauses in a snowy meadow, surrounded by frost-covered red berries. Snowflakes drift softly under the pale glow of the moon."
    },
    {
      product_name: "Flora and Fable",
      product_id: "7586117910594",
      product_text: "Bright teal curls frame a sweet girl holding her fluffy white pup close, surrounded by swirling floral patterns. Their wide eyes shine with warmth and gentle wonder."
    },
    {
      product_name: "Glacial Guardian",
      product_id: "7586119024706",
      product_text: "Icy blue eyes pierce through the misty jungle as a majestic white tiger stands watch among the shadows. Sunlight filters through the leaves, glinting off its sleek fur."
    },
    {
      product_name: "Bow Bridge Blossoms",
      product_id: "7586120368194",
      product_text: "Soft evening light glows over a graceful bridge surrounded by blooming trees and calm waters. Two swans glide peacefully beneath, reflecting the romance of spring."
    },
    {
      product_name: "Bee Cute",
      product_id: "7586122498114",
      product_text: "A curious bear cub peeks over a hollow tree stump, its nose tickled by friendly bees. Bright blooms, a bird, and a monarch butterfly fill the scene with warmth and cheer."
    },
    {
      product_name: "Wishkeeper",
      product_id: "7586125283394",
      product_text: "An enchanting ladybug with butterfly wings rests among dewy roses and lush greenery. Golden light glimmers on its shell, revealing delicate patterns and dark markings."
    },
    {
      product_name: "Festive Furball",
      product_id: "7586127151170",
      product_text: "Tucked inside a red gift box, a sleepy puppy wearing a Santa hat dozes by the fire. Twinkling lights, candy canes, and ribbons surround this heartwarming holiday scene."
    },
    {
      product_name: "Golden Winter Wishes",
      product_id: "7589879152706",
      product_text: "Santa in shimmering white and gold spreads Christmas cheer before a festive porch. Glittering garlands, twinkling lights, and a jolly snowman celebrate the holiday spirit."
    },
    {
      product_name: "Paws & Claus",
      product_id: "7590550405186",
      product_text: "Playful kittens and a cheerful dog in a Santa hat gather by the glowing tree. Twinkling lights and holiday gifts fill the cozy Christmas home."
    },
    {
      product_name: "Candy Cane Castle",
      product_id: "7590576521282",
      product_text: "Under a glowing moon, Santa rows through a sparkling river beside candy canes and pink castles. Polar bears, owls, and deer watch as snowflakes twinkle in the frosty night."
    },
    {
      product_name: "Letters to Santa",
      product_id: "7590598279234",
      product_text: "Three joyful snowmen mail a letter to Santa beneath a glowing garland. Cardinals perch nearby as snow falls softly, creating a cozy winter moment."
    },
    {
      product_name: "Home for the Holidays",
      product_id: "7591611891778",
      product_text: "Gentle deer gaze toward a Christmas tree, its glow warms the snowy night. Candlelight flickers softly, filling the forest with holiday delight."
    },
    {
      product_name: "Winter Wonderland Porch",
      product_id: "7591619788866",
      product_text: "Snow glistens around a cheerful snowman sharing treats to friendly forest animals. They gather near the glowing Christmas trees in peaceful harmony."
    },
    {
      product_name: "Countryside Christmas",
      product_id: "7591624147010",
      product_text: "Frosty magic fills the countryside where a cheerful snowman greets woodland friends. Twinkling lights adorn the Christmas tree as birds and squirrels gather in the snow."
    },
    {
      product_name: "Poinsettia Purr",
      product_id: "7595739775042",
      product_text: "Festive charm fills the room as the cat rests beside vibrant poinsettias. Festive dishes and holiday cards brighten the shelves, capturing the spirit of Christmas."
    },
    {
      product_name: "Fireside Delivery",
      product_id: "7595743838274",
      product_text: "Santa Claus stands by a glowing fireplace, holding a gift amid twinkling Christmas trees. Toys and sleepy pets fill the cozy room, while stockings hang above the fire."
    },
    {
      product_name: "Waterfall Retreat",
      product_id: "7595759534146",
      product_text: "A gentle waterfall cascades behind a white gazebo surrounded by colorful blooms. A deer stands among the flowers as butterflies and birds flutter through the tranquil garden."
    },
    {
      product_name: "Cactus Moonlight",
      product_id: "7595770282050",
      product_text: "A serene woman sits between the radiant sun and the gentle moon. Surrounded by blooming cacti, her calm gaze reflects harmony between light and night."
    },
    {
      product_name: "Aurelthorne",
      product_id: "7595789287490",
      product_text: "A majestic dragon with shimmering scales of gold and blue rests beneath the starlit sky. Autumn leaves and berries entwine around it, glowing softly in the night."
    },
    {
      product_name: "Lollipop Candy Shop",
      product_id: "7595806294082",
      product_text: "Children press their faces against a candy shop window, mesmerized by jars of colorful sweets. A dog sits patiently while a kitten plays with scattered gumballs nearby."
    },
    {
      product_name: "Blooming Bond",
      product_id: "7595808096322",
      product_text: "A serene girl gently cradles a kitten amid glowing flowers and fluttering butterflies. Warm light and soft petals swirl around them, creating a dreamlike harmony."
    },
    {
      product_name: "Dragon Studies",
      product_id: "7603977650242",
      product_text: "An intricate desk overflows with potions and gemstones, centered around open pages of dragon anatomy. A tiny crystal dragon with shimmering wings rests atop the book."
    },
    {
      product_name: "The Orange Treehouse",
      product_id: "7603982204994",
      product_text: "A cozy wooden house nestles high in an orange tree, its windows glowing with warm light. Blossoms and ripe fruit surround the path, creating a peaceful garden haven."
    },
    {
      product_name: "Water Lilies and Ducklings",
      product_id: "7603989708866",
      product_text: "Two fluffy ducklings glide through calm waters surrounded by blooming pink flowers and lush green leaves. Dragonflies shimmer above, catching the sunlight as they hover."
    },
    {
      product_name: "Blue Day Cuddles",
      product_id: "7604010549314",
      product_text: "Soft teal hair frames a tender face as she hugs her white kitten close, surrounded by blooming flowers. Hearts and colors swirl gently, radiating warmth and calm."
    },
    {
      product_name: "Glitterwing Owl",
      product_id: "7604038828098",
      product_text: "Bright-eyed owl sparkles amid golden butterflies and blooming daisies, clutching a shimmering teal potion bottle. Magic glows softly through the forest around it."
    },
    {
      product_name: "Journey to the Light",
      product_id: "7609126387778",
      product_text: "Glistening orcas leap through glowing waters, their sleek forms reflecting the dreamy colors of the sky. A quiet lighthouse watches over the scene as soft light ripples across the shore."
    },
    {
      product_name: "Teachers Pets",
      product_id: "7609127338050",
      product_text: "A pale woman with flowing white curls holds two fluffy pups, their wide eyes adding charm to her ornate, jeweled gown. Soft shadows give the scene a dreamy, ghostlike glow."
    },
    {
      product_name: "Firehowl",
      product_id: "7609138937922",
      product_text: "Fiery embers swirl around a majestic wolf, its glowing eyes burning with quiet strength. Flames and smoke ripple through its fur, creating a powerful, otherworldly aura."
    },
    {
      product_name: "Garden Aviary",
      product_id: "7609140510786",
      product_text: "Vibrant birds gather among lush flowers and greenery, filling the garden with color and energy. Sunlight filters through the window as parrots and finches flutter playfully."
    },
    {
      product_name: "Hello Sakura",
      product_id: "7609142575170",
      product_text: "A bright-eyed kitten nestles among blooming cherry blossoms, its soft fur glowing with pastel hues. Sparkling petals and shimmering branches surround it in a dreamy spring scene."
    },
    {
      product_name: "Magnolias and Moonscape",
      product_id: "7609144803394",
      product_text: "Moonlight glows over a serene lake as magnolia blossoms unfurl on winding branches. Soft clouds drift across the sky, casting gentle shadows on the shimmering water."
    },
    {
      product_name: "Starlight Clover",
      product_id: "7609146540098",
      product_text: "A glowing, pastel-hued flower smiles amid soft moss, its sparkling petals shimmering with tiny stars. Colorful lights drift around it, filling the scene with gentle magic."
    },
    {
      product_name: "Gemstone Garden Aqua",
      product_id: "7609146769474",
      product_text: "A radiant bloom unfurls layered petals in shades of aqua and lilac, each edged with delicate gold. At its heart, a jeweled centerpiece glows brightly, surrounded by elegant leaves."
    },
    {
      product_name: "Snowy Montana",
      product_id: "7616921272386",
      product_text: "A serene mountain stream winds through snow-dusted rocks, reflecting the fiery sunset. Tall pines frame the scene as clouds glow with golden light."
    },
    {
      product_name: "Colorburst Bouquet",
      product_id: "7616944046146",
      product_text: "Soft blossoms cluster together in a lush, overflowing arrangement. Gentle greens embrace the petals, giving the bouquet a fresh, painterly glow."
    },
    {
      product_name: "Uniquely Brilliant",
      product_id: "7616974684226",
      product_text: "A poised young woman gazes ahead beneath an ornate hat adorned with gears, flowers, and a gleaming clock. Soft colors swirl behind her, adding whimsy to her vintage charm."
    },
    {
      product_name: "Enchanted Twilight",
      product_id: "7617049559106",
      product_text: "Glowing petals shimmer along the water’s edge as a radiant tree lights up the twilight. Soft blues and fiery hues blend across the sky, creating a magical, dreamlike calm."
    },
    {
      product_name: "Winter Woodland Friends",
      product_id: "7617062568002",
      product_text: "A curious squirrel and a bright robin share a quiet moment beside a snow-dusted watering can. Pine branches, and scattered acorns add a cozy touch to the winter scene."
    },
    {
      product_name: "Flamingo Rosé",
      product_id: "7617103331394",
      product_text: "Soft pink roses surround a graceful flamingo, its bright blue eye shining with gentle charm. Lush petals and delicate feathers blend together in a dreamy, romantic scene."
    },
    {
      product_name: "Noel Night Watcher",
      product_id: "7617116635202",
      product_text: "A cozy owl in a Santa hat and scarf perches on a lit branch, its golden eyes glowing. Ornaments sparkle around it, brightening the wintry night."
    },
    {
      product_name: "Aurora Dragon",
      product_id: "7611412480066",
      product_text: "Brilliant scales shimmer in cool blues and vibrant purples as the dragon turns with a fierce, knowing gaze. Light dances along its sweeping mane, glowing like cosmic fire."
    },
    {
      product_name: "Deadly Stare",
      product_id: "7611413528642",
      product_text: "Vibrant blooms swirl through her midnight hair as her luminous eyes shimmer with quiet intensity. Intricate skull motifs and floral tattoos glow in rich, hypnotic color."
    },
    {
      product_name: "Garden Goddess",
      product_id: "7611415298114",
      product_text: "A dreamy woman gazes softly ahead as a crown of vivid blossoms frames her face. Bright petals and leafy tendrils swirl together, creating a whimsical burst of color."
    },
    {
      product_name: "Rockhopper",
      product_id: "7611416674370",
      product_text: "A tiny bunny sings boldly while holding his glowing guitar in an enchanted forest. Butterflies swirl nearby as fireflies glitter around his candle-lit stage."
    },
    {
      product_name: "Present Patrol",
      product_id: "7611420966978",
      product_text: "A wide-eyed creature in a glowing Santa hat stands in a snowy forest, clutching a stack of brightly wrapped gifts. Twinkling lights and sparkling trees shimmer warmly around it."
    },
    {
      product_name: "Jenni Cat",
      product_id: "7611426439234",
      product_text: "A radiant cat with swirling rainbow fur ur emerges from a burst of vivid blossoms. Bright flowers surround its wide blue eyes, creating a lively, enchanted garden scene."
    },
    {
      product_name: "Winter Robin",
      product_id: "7611427291202",
      product_text: "A robin perches on a snowy branch, its bright chest glowing against the winter chill. Red berries and green leaves add cheer to the frosted forest around it."
    },
    {
      product_name: "Pastel Portal",
      product_id: "7611430240322",
      product_text: "A patterned feline gazes ahead as pastel feathers and swirling shapes surround it. Soft light glows around the creature, creating a dreamy, enchanted scene."
    },
    {
      product_name: "Workshop Wonders",
      product_id: "7618726887490",
      product_text: "Glowing with Christmas spirit, Santa lovingly crafts toys for eager children awaiting joy. Each creation shines with the warmth and wonder of holiday dreams."
    },
    {
      product_name: "Season of Smiles",
      product_id: "7618765717570",
      product_text: "Santa and a joyful group of children raise their arms in celebration amid vibrant trees and cheerful patterns. Bright lights, gifts, and a soaring dove fill the scene with festive delight."
    },
    {
      product_name: "Santa's Cozy Break",
      product_id: "7618800025666",
      product_text: "Santa relaxes by a glowing fireplace, warm drink in hand and festive socks keeping his feet cozy. Gifts, greenery, and a twinkling tree surround him in peaceful holiday comfort."
    },
    {
      product_name: "A Purrfect Christmas",
      product_id: "7618815950914",
      product_text: "Playful kittens tumble through wrapping paper and ribbons as a warm fire glows nearby. Twinkling lights and festive décor fill the cozy room with holiday cheer."
    },
    {
      product_name: "North Pole Post",
      product_id: "7618827321410",
      product_text: "Santa leans toward a cheerful snowman beside a glowing mailbox as snowflakes fall softly around them. Forest animals, gifts, and twinkling lights fill the snowy scene with warmth."
    },
    {
      product_name: "Let Me In",
      product_id: "7618833088578",
      product_text: "Snow falls gently as two dogs sit by a festive front door, surrounded by garlands, gifts, and a cheerful snowman. Warm light glows from the windows where cozy pets watch from inside."
    },
    {
      product_name: "Queen of the Dead",
      product_id: "7618858647618",
      product_text: "A haunting figure with glowing eyes stands adorned in jeweled vines, her pale hair crowned with a skull and vivid flowers. Dark forest shadows swirl around her mysterious presence."
    },
    {
      product_name: "Alchemists Cabin",
      product_id: "7618870804546",
      product_text: "A radiant sunrise spills across a dreamy valley as swirling clouds light the sky with vibrant color. Along the rustic retreat, glowing bottles and quiet comforts shimmer in the warm glow."
    },
    {
      product_name: "Regent",
      product_id: "7626702487618",
      product_text: "Majestic bird adorned in jeweled plumage gazes proudly, its feathers glowing with rich color and golden detail. Flowers crown its head, adding elegance to its regal presence."
    },
    {
      product_name: "City at Dusk",
      product_id: "7626705698882",
      product_text: "A charming street glows under vintage lamps as classic cars roll past blooming trees. Soft twilight colors paint the sky, giving the city a dreamy, welcoming warmth."
    },
    {
      product_name: "Springtime Ensemble",
      product_id: "7627370594370",
      product_text: "Colorful songbirds line a rustic fence surrounded by blooming flowers in soft spring hues. Butterflies flutter nearby, adding graceful movement to the peaceful garden scene."
    },
    {
      product_name: "Flower Crown Kitty",
      product_id: "7627397333058",
      product_text: "A bright-eyed kitten peeks through a meadow of blooming flowers, its head crowned with vibrant petals. Soft colors and playful details create a dreamy, whimsical scene."
    },
    {
      product_name: "Purrfect Palette",
      product_id: "7627402346562",
      product_text: "A tiny kitten naps curled inside a painted bowl, surrounded by bright jars of color and scattered brushes. Flowers and palettes fill the workspace, creating a warm, artistic charm."
    },
    {
      product_name: "Blossom & Wings",
      product_id: "7627404345410",
      product_text: "A sweet bunny sits among blooming flowers, holding tiny binoculars as soft pink butterflies flutter around. Sparkling light fills the air, creating a gentle, magical moment."
    },
    {
      product_name: "Moonlit Castle",
      product_id: "7627406803010",
      product_text: "Glowing castle rises from misty cliffs, its towers lit warmly beneath a full moon. Forest shadows and winding paths create a quiet, storybook atmosphere."
    },
    {
      product_name: "Tweethearts",
      product_id: "7627409883202",
      product_text: "Two pastel birds face each other on leafy branches, surrounded by blooming flowers. Butterflies drift through the scene, adding a soft, romantic garden charm."
    },
    {
      product_name: "Bubble Muse",
      product_id: "7627410964546",
      product_text: "Luminous bubbles drift around a dreamy figure as glowing fish swim through soft, watery light. Floral details and shimmering colors create an ethereal, underwater fantasy."
    },
    {
      product_name: "Farmer's Helper",
      product_id: "7629750108226",
      product_text: "A small child in denim overalls offers apples to curious piglets in a sunny barnyard. Red doors, fresh grass, and gentle animals create a warm farm moment."
    },
    {
      product_name: "Miss Lalelei",
      product_id: "7629755154498",
      product_text: "A graceful woman emerges with jeweled blooms and flowing leaves framing her gaze. Rich colors and delicate forms create a serene, enchanting presence."
    },
    {
      product_name: "Petal",
      product_id: "7629891108930",
      product_text: "Delicate roses and soft chains weave through flowing silver hair, framing a woman’s calm, expressive gaze. Gentle contrasts of texture and light create a quiet, elegant atmosphere."
    },
    {
      product_name: "Colorburst Cutie",
      product_id: "7629886357570",
      product_text: "Vibrant artistry reveals a woman emerging from flowing color, surrounded by paintbrushes and palettes. A small bluebird flutters nearby, adding a touch of creative magic."
    },
    {
      product_name: "Curly Hues and Courage",
      product_id: "7629892157506",
      product_text: "A wide-eyed girl with vibrant curls stands beside a gentle lion, their bond calm and reassuring. Playful details and bold colors create a warm, imaginative sense of bravery."
    },
    {
      product_name: "Timeless",
      product_id: "7631841722434",
      product_text: "Golden sunlight reflects across a winding river between forested hills and distant mountains. Warm mist and glowing skies create a calm, endless horizon."
    },
    {
      product_name: "Nadia",
      product_id: "7631845130306",
      product_text: "A graceful woman with flowing dark curls gazes softly among blooming roses and swirling color. Butterflies drift around her, adding whimsy to the dreamy scene."
    },
    {
      product_name: "Off The Grid",
      product_id: "7635766149186",
      product_text: "A quiet cabin glows beneath vibrant autumn trees, surrounded by falling leaves and gentle forest light. A deer and calm waters complete the peaceful woodland scene."
    },
    {
      product_name: "Bliss",
      product_id: "7631850799170",
      product_text: "Vibrant blooms in yellow, pink, and red spill across lush greenery, creating a joyful display. Soft brushstrokes and glowing light capture a warm garden moment."
    },
    {
      product_name: "Curious Donkey Duo",
      product_id: "7631863316546",
      product_text: "Two fluffy donkeys peek over a snowy fence, watching a bright robin perched below. Soft winter colors and gentle fur details create a sweet countryside moment."
    },
    {
      product_name: "Wildflower Majesty",
      product_id: "7631882453058",
      product_text: "A charming creature gazes with bright blue eyes, nestled among bold purple and orange blossoms. Vibrant petals and lush leaves frame the scene in playful color and warmth."
    },
    {
      product_name: "Rainfeather",
      product_id: "7631880585282",
      product_text: "Raindrops cling to a bright-eyed owl perched on a branch, its feathers glowing with jewel-toned colors. Vibrant flowers bloom around it, adding magic to the misty forest air."
    },
    {
      product_name: "Garden of the Hearts",
      product_id: "7631872819266",
      product_text: "Soft purple tulips surround a fluffy cat as it gazes calmly at a vibrant butterfly nearby. Gentle greens and blues add a dreamy touch to this peaceful garden scene."
    },
    {
      product_name: "The Pond",
      product_id: "7631889072194",
      product_text: "Two playful kittens watch over a garden pond where ducklings glide through lily pads. Flowers bloom as a butterfly drifts above the water, bringing the scene to life."
    },
    {
      product_name: "Story Time",
      product_id: "7634413289538",
      product_text: "A curious girl reads from an old book as candlelight flickers across a shadowy room. Her watchful cat sits close while shelves of secrets glow softly around them."
    },
    {
      product_name: "Light Positano",
      product_id: "7634429313090",
      product_text: "Terraced homes glow along a seaside cliff as evening light settles over the coast. Sailboats drift below while palm-lined paths lead down to the shore."
    },
    {
      product_name: "Neon Howl",
      product_id: "7634462736450",
      product_text: "Vivid neon colors blaze as a lone wolf lifts its voice beneath a glowing moon. Paint splashes and cosmic shadows pulse with raw energy and untamed spirit."
    },
    {
      product_name: "Pink Guardians",
      product_id: "7634482724930",
      product_text: "Soft starlight surrounds a young warrior as a pinkl dragon rises protectively behind her. Blush tones and glowing scales create a scene of strength, magic, and quiet resolve."
    },
    {
      product_name: "Blue Beast",
      product_id: "7634487181378",
      product_text: "A vivid blue dragon stands framed by stained glass, its patterned wings spread amid curling vines and blooms. Jewel tones and bold lines give the scene a mythical, luminous glow."
    },
    {
      product_name: "Wings of Fire",
      product_id: "7634487607362",
      product_text: "Fiery wings flare behind a dark-haired girl as she cradles a glowing orb of flame. Sparks drift through the night, casting warmth and power into the stars."
    },
    {
      product_name: "Mermaid Sweetie",
      product_id: "7634488262722",
      product_text: "Rainbow-haired mermaid girl rests among coral and drifting bubbles, her shimmering tail sparkling with rainbow scales. Jellyfish float nearby as pastel reefs glow in calm waters."
    },
    {
      product_name: "Jungle Queen",
      product_id: "7635769327682",
      product_text: "A radiant girl crowned with lush blooms gazes forward as jeweled feathers glow at her throat. A toucan rests beside her amid deep jungle leaves and twilight florals."
    },
    {
      product_name: "Steps to the Harbor",
      product_id: "7635771490370",
      product_text: "Stone steps wind between sunlit homes overflowing with flowers, leading the eye toward a calm blue harbor. Sailboats drift below as warm evening light settles over hills and water."
    },
    {
      product_name: "Lotus Sunset",
      product_id: "7635776634946",
      product_text: "Pink lotus blooms float across water as the sun sinks behind distant mountains, painting the sky in warm golds and rose. Soft reflections ripple gently, creating a calm, glowing scene."
    },
    {
      product_name: "Winston",
      product_id: "7661681836098",
      product_text: "A gentle pup peeks through a lush frame of leaves and blooming flowers, its soft fur glowing with warmth. Lush greenery brings a warm, comforting charm to the scene."
    },
    {
      product_name: "Whisperfluff",
      product_id: "7661760643138",
      product_text: "Soft fur and hooves rest among blooming flowers as gentle light glows in the garden. Curled horns crowned with blossoms frame wide, dreamy eyes in a magical woodland scene."
    },
    {
      product_name: "Tee Frog",
      product_id: "7661829718082",
      product_text: "Wrapped in a cozy scarf, a wide-eyed frog sits by the window enjoying a cup of tea. Soft lantern light, gentle colors, and blooming plants create a calm, comforting evening scene."
    },
    {
      product_name: "Love Rosebear",
      product_id: "7661882081346",
      product_text: "Soft plush fur frames a smiling bear holding a heart filled with love and color. Paint brushes, roses, and sweet details surround this warm, creative scene."
    },
    {
      product_name: "Verdent Vida",
      product_id: "7661945847874",
      product_text: "Lush fur glows in shades of green and gold as a gentle capybara rests among blooming florals. Twisting leaves and layered petals create a rich, vibrant garden portrait."
    },
    {
      product_name: "Sunflower Barn",
      product_id: "7662016725058",
      product_text: "Bright sunflowers bloom before a red barn as colorful songbirds gather among the petals. Butterflies flutter through daisies and blossoms, filling the scene with cheerful country charm."
    },
    {
      product_name: "Midnight Service",
      product_id: "7662088847426",
      product_text: "Neon lights glow over a vintage gas station as classic cars gleam on rain-soaked streets. City towers rise behind fluttering flags, capturing late-night energy and nostalgia."
    },
    {
      product_name: "Blueberry Kiss",
      product_id: "7662191870018",
      product_text: "Glossy blue waves frame soft features, with berries and petals woven through flowing strands. Crystal-bright eyes and icy hues give the portrait a soft, enchanted elegance."
    },
    {
      product_name: "Stonewood Inn",
      product_id: "7662261305410",
      product_text: "Warm lights glow from a mystical woodland inn nestled among ancient trees and winding roots. Stone walls, wooden stairways, and misty cliffs create an enchanting forest retreat."
    },
    {
      product_name: "Her Own Little World",
      product_id: "7666722111554",
      product_text: "Soft-spoken calm surrounds a girl cuddling a white kitten, wrapped in rainbow stripes and gentle blooms. Twinkling lights and heart-shaped flowers create a cozy, dreamlike space."
    },
    {
      product_name: "Spring Birds",
      product_id: "7666747637826",
      product_text: "Cheerful birds gather around a blooming garden fence, fluttering daisies, baskets of flowers, and a cozy red birdhouse. Bright wings and spring blossoms fill the scene with lively charm."
    },
    {
      product_name: "New York City",
      product_id: "7672003395650",
      product_text: "City lights shimmer across the river as Manhattan’s skyline rises beneath a painted twilight sky. Boats glide past iconic bridges and busy piers, capturing the city that never sleeps."
    },
    {
      product_name: "Marigold",
      product_id: "7672024432706",
      product_text: "Soft forest light surrounds a fluffy bunny crowned with blooming roses and fresh greenery. Butterflies drift through the flowers, adding a gentle touch of spring magic."
    },
    {
      product_name: "Belle Famille",
      product_id: "7672047468610",
      product_text: "Gentle eyes meet the viewer as two owls rest close beside a girl crowned with flowers and wings. Soft colors and delicate details create a calm, protective bond."
    },
    {
      product_name: "The Pirates",
      product_id: "7672079089730",
      product_text: "Playful pups and kittens sail the open sea in pirate hats as waves splash around their ship. Bright sails, a leaping dolphin, and a colorful parrot add lively adventure."
    },
    {
      product_name: "Little Artist",
      product_id: "7672127193154",
      product_text: "Sweet chalk drawings fill the pavement as a little girl creates a rainbow message of love. A curious kitten watches nearby, surrounded by scattered colors and quiet joy."
    },
    {
      product_name: "Snow Day",
      product_id: "7683168010306",
      product_text: "Soft aurora lights shimmer across the icy sky as two polar bear cubs play on drifting snow. Sparkling frost and gentle motion capture a quiet moment of arctic wonder."
    },
    {
      product_name: "Pink Valentine Lil Gnomez",
      product_id: "7683170467906",
      product_text: "Sweet Valentine charm surrounds a blushing gnome dressed in pink and dotted with hearts. Roses, treats, and love notes fill the scene with cozy romance."
    },
    {
      product_name: "Bamboo Love",
      product_id: "7683174826050",
      product_text: "Soft bamboo light surrounds a cuddly panda forming a glowing heart with gentle paws. Pink blossoms and fluttering dragonflies create a peaceful moment of love."
    },
    {
      product_name: "Kitty Trio",
      product_id: "7683176169538",
      product_text: "Sweet charm shines as three stylish cats pose in heart-filled sweaters and rosy sunglasses. Floating hearts and soft pastels surround them in playful Valentine cheer."
    },
    {
      product_name: "Love is in the Air",
      product_id: "7686488916034",
      product_text: "Tender moments unfold as a puppy and kitten share a dessert beneath a glowing sky. Curious woodland friends and blooming roses surround the table with playful romance."
    },
    {
      product_name: "Petit Fleur",
      product_id: "7686518145090",
      product_text: "Gentle beauty shines from a wide-eyed girl framed by vibrant blossoms and swirling petals. Soft colors and playful florals create a dreamy, storybook charm."
    },
    {
      product_name: "Gia",
      product_id: "7690977902658",
      product_text: "Bold elegance emerges from a painted muse crowned with roses, holding a decadent cupcake. Swirling colors and heart accents blend sweetness with dramatic flair."
    },
    {
      product_name: "I Can Buy Myself Flowers",
      product_id: "7690980261954",
      product_text: "Vibrant confidence blooms as a woman gazes ahead, surrounded by bold florals and radiant color. Butterflies, hearts, and layered textures celebrate self-love and strength."
    },
    {
      product_name: "Sunflower Gold",
      product_id: "7690983407682",
      product_text: "Golden sunflowers bloom among soft white florals and lush greenery, painted in gentle brushstrokes. Warm tones and layered textures create a calm, radiant garden feel."
    },
    {
      product_name: "Silver Spirit",
      product_id: "7690987307074",
      product_text: "Mystical calm surrounds an elven maiden adorned with jewels as she communes with a glowing white wolf. Soft light and forest magic weave a bond of spirit and grace."
    },
    {
      product_name: "Whispers of the Dawn",
      product_id: "7699004227650",
      product_text: "Golden light spills across rugged cliffs as waves shimmer beneath a rising sun. Fiery clouds and distant horizons awaken the sea with quiet wonder."
    },
    {
      product_name: "Cottage Cats",
      product_id: "7699010420802",
      product_text: "Gentle sunlight fills a cozy window as two cats relax beside blooming flowers and birds. Soft curtains frame a charming cottage scene alive with peaceful warmth."
    },
    {
      product_name: "Blossom Fawn",
      product_id: "7699016679490",
      product_text: "Rain falls as a gentle fawn gazes up at a glowing blossom in a dreamlike garden. Dewy petals, fluttering insects, and warm light create a magical moment."
    },
    {
      product_name: "Bloomy Bear",
      product_id: "7699036241986",
      product_text: "Bright joy radiates as a cuddly panda peeks through a swirl of colorful blossoms. Lush petals and playful hues create a cheerful, dreamlike garden scene."
    },
    {
      product_name: "Snow Meadow Hare",
      product_id: "7701547614274",
      product_text: "Soft snowfall drifts across a quiet meadow as a watchful hare sits among winter berries and leaves. Pale moonlight and gentle colors create a calm, peaceful winter scene."
    },
    {
      product_name: "Aurorasaur",
      product_id: "7704875335746",
      product_text: "Magical light dances across the sky as a tiny dinosaur cuddles a ribboned gift in a glowing meadow. Fireflies, flowers, and aurora colors create pure enchantment."
    },
    {
      product_name: "Ripley",
      product_id: "7704877924418",
      product_text: "Colorful currents swirl as an orca glides through glowing waters surrounded by vibrant florals. Soft light and rich hues blend ocean calm with dreamy harmony."
    },
    {
      product_name: "Victra",
      product_id: "7704879661122",
      product_text: "Ivory unicorn rests beneath a midnight sky, its flowing hair adorned with warm autumn flowers. Golden horn glows softly as berries and leaves curl through the enchanted forest."
    },
    {
      product_name: "Leafy Owl at Night",
      product_id: "7704904400962",
      product_text: "Vibrant owl perches on a branch beneath a starlit sky, its feathers glowing like autumn leaves. Amber eyes watch quietly as color and night intertwine."
    },
    {
      product_name: "Starlight Daisy",
      product_id: "7704933466178",
      product_text: "Luminous daisy rises from still water as a rainbow arcs across a starry sky. Planets glow above while moonlight shimmers among dreamy blooms and reflections."
    },
    {
      product_name: "House",
      product_id: "7704937300034",
      product_text: "Pale-eyed girl stands in misty fields, her silver hair flowing beneath a towering house crowned with glowing windows. Soft light spills from above as quiet mystery lingers in the air."
    },
    {
      product_name: "When The Moon Calls",
      product_id: "7708133392450",
      product_text: "Moonlight glows over a golden dragon as it rises through churning waves beneath the night sky. Luminous scales and surging water evoke ancient power, motion, and mythic strength."
    },
    {
      product_name: "Glamour Girl Zebra",
      product_id: "7708138668098",
      product_text: "Bold stripes explode with vibrant color as a confident zebra gazes forward. Electric hues and graphic patterns turn wildlife into a striking, fashion-forward vision."
    },
    {
      product_name: "Beautiful Twilight",
      product_id: "7708145057858",
      product_text: "Vibrant feathers spread wide as a jewel-toned bird rests among swirling skies and blooming florals. Rich colors and delicate details create a magical twilight moment."
    },
    {
      product_name: "Galaxy Cat",
      product_id: "7708157640770",
      product_text: "Pastel fur shimmers with cosmic hues as a wide-eyed kitten gazes softly into the night. Starry textures and swirling colors give this feline a dreamy, celestial glow."
    },

  
];//Do not remove this ];
